
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire9f20"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire9f20"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("27Lyk", function(module, exports) {

$parcel$export(module.exports, "register", () => $18c11f3350a906ea$export$6503ec6e8aabbaf, (v) => $18c11f3350a906ea$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $18c11f3350a906ea$export$f7ad0328861e2f03, (v) => $18c11f3350a906ea$export$f7ad0328861e2f03 = v);
var $18c11f3350a906ea$export$6503ec6e8aabbaf;
var $18c11f3350a906ea$export$f7ad0328861e2f03;
"use strict";
var $18c11f3350a906ea$var$mapping = new Map();
function $18c11f3350a906ea$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$18c11f3350a906ea$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $18c11f3350a906ea$var$resolve(id) {
    var resolved = $18c11f3350a906ea$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$18c11f3350a906ea$export$6503ec6e8aabbaf = $18c11f3350a906ea$var$register;
$18c11f3350a906ea$export$f7ad0328861e2f03 = $18c11f3350a906ea$var$resolve;

});

parcelRegister("kL2Ep", function(module, exports) {


//     Backbone.js 1.6.0
//     (c) 2010-2024 Jeremy Ashkenas and DocumentCloud
//     Backbone may be freely distributed under the MIT license.
//     For all details and documentation:
//     http://backbonejs.org
(function(factory) {
    // Establish the root object, `window` (`self`) in the browser, or `global` on the server.
    // We use `self` instead of `window` for `WebWorker` support.
    var root = typeof self == "object" && self.self === self && self || typeof $parcel$global == "object" && $parcel$global.global === $parcel$global && $parcel$global;
    // Set up Backbone appropriately for the environment. Start with AMD.
    if (typeof define === "function" && define.amd) define([
        "underscore",
        "jquery",
        "exports"
    ], function(_, $, exports1) {
        // Export global even in AMD case in case this script is loaded with
        // others that may still expect a global Backbone.
        root.Backbone = factory(root, exports1, _, $);
    });
    else {
        var _ = (parcelRequire("2q7Wm")), $;
        try {
            $ = (parcelRequire("6KOho"));
        } catch (e) {}
        factory(root, module.exports, _, $);
    }
})(function(root, Backbone, _, $) {
    // Initial Setup
    // -------------
    // Save the previous value of the `Backbone` variable, so that it can be
    // restored later on, if `noConflict` is used.
    var previousBackbone = root.Backbone;
    // Create a local reference to a common array method we'll want to use later.
    var slice = Array.prototype.slice;
    // Current version of the library. Keep in sync with `package.json`.
    Backbone.VERSION = "1.6.0";
    // For Backbone's purposes, jQuery, Zepto, Ender, or My Library (kidding) owns
    // the `$` variable.
    Backbone.$ = $;
    // Runs Backbone.js in *noConflict* mode, returning the `Backbone` variable
    // to its previous owner. Returns a reference to this Backbone object.
    Backbone.noConflict = function() {
        root.Backbone = previousBackbone;
        return this;
    };
    // Turn on `emulateHTTP` to support legacy HTTP servers. Setting this option
    // will fake `"PATCH"`, `"PUT"` and `"DELETE"` requests via the `_method` parameter and
    // set a `X-Http-Method-Override` header.
    Backbone.emulateHTTP = false;
    // Turn on `emulateJSON` to support legacy servers that can't deal with direct
    // `application/json` requests ... this will encode the body as
    // `application/x-www-form-urlencoded` instead and will send the model in a
    // form param named `model`.
    Backbone.emulateJSON = false;
    // Backbone.Events
    // ---------------
    // A module that can be mixed in to *any object* in order to provide it with
    // a custom event channel. You may bind a callback to an event with `on` or
    // remove with `off`; `trigger`-ing an event fires all callbacks in
    // succession.
    //
    //     var object = {};
    //     _.extend(object, Backbone.Events);
    //     object.on('expand', function(){ alert('expanded'); });
    //     object.trigger('expand');
    //
    var Events = Backbone.Events = {};
    // Regular expression used to split event strings.
    var eventSplitter = /\s+/;
    // A private global variable to share between listeners and listenees.
    var _listening;
    // Iterates over the standard `event, callback` (as well as the fancy multiple
    // space-separated events `"change blur", callback` and jQuery-style event
    // maps `{event: callback}`).
    var eventsApi = function(iteratee, events, name, callback, opts) {
        var i = 0, names;
        if (name && typeof name === "object") {
            // Handle event maps.
            if (callback !== void 0 && "context" in opts && opts.context === void 0) opts.context = callback;
            for(names = _.keys(name); i < names.length; i++)events = eventsApi(iteratee, events, names[i], name[names[i]], opts);
        } else if (name && eventSplitter.test(name)) // Handle space-separated event names by delegating them individually.
        for(names = name.split(eventSplitter); i < names.length; i++)events = iteratee(events, names[i], callback, opts);
        else // Finally, standard events.
        events = iteratee(events, name, callback, opts);
        return events;
    };
    // Bind an event to a `callback` function. Passing `"all"` will bind
    // the callback to all events fired.
    Events.on = function(name, callback, context) {
        this._events = eventsApi(onApi, this._events || {}, name, callback, {
            context: context,
            ctx: this,
            listening: _listening
        });
        if (_listening) {
            var listeners = this._listeners || (this._listeners = {});
            listeners[_listening.id] = _listening;
            // Allow the listening to use a counter, instead of tracking
            // callbacks for library interop
            _listening.interop = false;
        }
        return this;
    };
    // Inversion-of-control versions of `on`. Tell *this* object to listen to
    // an event in another object... keeping track of what it's listening to
    // for easier unbinding later.
    Events.listenTo = function(obj, name, callback) {
        if (!obj) return this;
        var id = obj._listenId || (obj._listenId = _.uniqueId("l"));
        var listeningTo = this._listeningTo || (this._listeningTo = {});
        var listening = _listening = listeningTo[id];
        // This object is not listening to any other events on `obj` yet.
        // Setup the necessary references to track the listening callbacks.
        if (!listening) {
            this._listenId || (this._listenId = _.uniqueId("l"));
            listening = _listening = listeningTo[id] = new Listening(this, obj);
        }
        // Bind callbacks on obj.
        var error = tryCatchOn(obj, name, callback, this);
        _listening = void 0;
        if (error) throw error;
        // If the target obj is not Backbone.Events, track events manually.
        if (listening.interop) listening.on(name, callback);
        return this;
    };
    // The reducing API that adds a callback to the `events` object.
    var onApi = function(events, name, callback, options) {
        if (callback) {
            var handlers = events[name] || (events[name] = []);
            var context = options.context, ctx = options.ctx, listening = options.listening;
            if (listening) listening.count++;
            handlers.push({
                callback: callback,
                context: context,
                ctx: context || ctx,
                listening: listening
            });
        }
        return events;
    };
    // An try-catch guarded #on function, to prevent poisoning the global
    // `_listening` variable.
    var tryCatchOn = function(obj, name, callback, context) {
        try {
            obj.on(name, callback, context);
        } catch (e) {
            return e;
        }
    };
    // Remove one or many callbacks. If `context` is null, removes all
    // callbacks with that function. If `callback` is null, removes all
    // callbacks for the event. If `name` is null, removes all bound
    // callbacks for all events.
    Events.off = function(name, callback, context) {
        if (!this._events) return this;
        this._events = eventsApi(offApi, this._events, name, callback, {
            context: context,
            listeners: this._listeners
        });
        return this;
    };
    // Tell this object to stop listening to either specific events ... or
    // to every object it's currently listening to.
    Events.stopListening = function(obj, name, callback) {
        var listeningTo = this._listeningTo;
        if (!listeningTo) return this;
        var ids = obj ? [
            obj._listenId
        ] : _.keys(listeningTo);
        for(var i = 0; i < ids.length; i++){
            var listening = listeningTo[ids[i]];
            // If listening doesn't exist, this object is not currently
            // listening to obj. Break out early.
            if (!listening) break;
            listening.obj.off(name, callback, this);
            if (listening.interop) listening.off(name, callback);
        }
        if (_.isEmpty(listeningTo)) this._listeningTo = void 0;
        return this;
    };
    // The reducing API that removes a callback from the `events` object.
    var offApi = function(events, name, callback, options) {
        if (!events) return;
        var context = options.context, listeners = options.listeners;
        var i = 0, names;
        // Delete all event listeners and "drop" events.
        if (!name && !context && !callback) {
            for(names = _.keys(listeners); i < names.length; i++)listeners[names[i]].cleanup();
            return;
        }
        names = name ? [
            name
        ] : _.keys(events);
        for(; i < names.length; i++){
            name = names[i];
            var handlers = events[name];
            // Bail out if there are no events stored.
            if (!handlers) break;
            // Find any remaining events.
            var remaining = [];
            for(var j = 0; j < handlers.length; j++){
                var handler = handlers[j];
                if (callback && callback !== handler.callback && callback !== handler.callback._callback || context && context !== handler.context) remaining.push(handler);
                else {
                    var listening = handler.listening;
                    if (listening) listening.off(name, callback);
                }
            }
            // Replace events if there are any remaining.  Otherwise, clean up.
            if (remaining.length) events[name] = remaining;
            else delete events[name];
        }
        return events;
    };
    // Bind an event to only be triggered a single time. After the first time
    // the callback is invoked, its listener will be removed. If multiple events
    // are passed in using the space-separated syntax, the handler will fire
    // once for each event, not once for a combination of all events.
    Events.once = function(name, callback, context) {
        // Map the event into a `{event: once}` object.
        var events = eventsApi(onceMap, {}, name, callback, this.off.bind(this));
        if (typeof name === "string" && context == null) callback = void 0;
        return this.on(events, callback, context);
    };
    // Inversion-of-control versions of `once`.
    Events.listenToOnce = function(obj, name, callback) {
        // Map the event into a `{event: once}` object.
        var events = eventsApi(onceMap, {}, name, callback, this.stopListening.bind(this, obj));
        return this.listenTo(obj, events);
    };
    // Reduces the event callbacks into a map of `{event: onceWrapper}`.
    // `offer` unbinds the `onceWrapper` after it has been called.
    var onceMap = function(map, name, callback, offer) {
        if (callback) {
            var once = map[name] = _.once(function() {
                offer(name, once);
                callback.apply(this, arguments);
            });
            once._callback = callback;
        }
        return map;
    };
    // Trigger one or many events, firing all bound callbacks. Callbacks are
    // passed the same arguments as `trigger` is, apart from the event name
    // (unless you're listening on `"all"`, which will cause your callback to
    // receive the true name of the event as the first argument).
    Events.trigger = function(name) {
        if (!this._events) return this;
        var length = Math.max(0, arguments.length - 1);
        var args = Array(length);
        for(var i = 0; i < length; i++)args[i] = arguments[i + 1];
        eventsApi(triggerApi, this._events, name, void 0, args);
        return this;
    };
    // Handles triggering the appropriate event callbacks.
    var triggerApi = function(objEvents, name, callback, args) {
        if (objEvents) {
            var events = objEvents[name];
            var allEvents = objEvents.all;
            if (events && allEvents) allEvents = allEvents.slice();
            if (events) triggerEvents(events, args);
            if (allEvents) triggerEvents(allEvents, [
                name
            ].concat(args));
        }
        return objEvents;
    };
    // A difficult-to-believe, but optimized internal dispatch function for
    // triggering events. Tries to keep the usual cases speedy (most internal
    // Backbone events have 3 arguments).
    var triggerEvents = function(events, args) {
        var ev, i = -1, l = events.length, a1 = args[0], a2 = args[1], a3 = args[2];
        switch(args.length){
            case 0:
                while(++i < l)(ev = events[i]).callback.call(ev.ctx);
                return;
            case 1:
                while(++i < l)(ev = events[i]).callback.call(ev.ctx, a1);
                return;
            case 2:
                while(++i < l)(ev = events[i]).callback.call(ev.ctx, a1, a2);
                return;
            case 3:
                while(++i < l)(ev = events[i]).callback.call(ev.ctx, a1, a2, a3);
                return;
            default:
                while(++i < l)(ev = events[i]).callback.apply(ev.ctx, args);
                return;
        }
    };
    // A listening class that tracks and cleans up memory bindings
    // when all callbacks have been offed.
    var Listening = function(listener, obj) {
        this.id = listener._listenId;
        this.listener = listener;
        this.obj = obj;
        this.interop = true;
        this.count = 0;
        this._events = void 0;
    };
    Listening.prototype.on = Events.on;
    // Offs a callback (or several).
    // Uses an optimized counter if the listenee uses Backbone.Events.
    // Otherwise, falls back to manual tracking to support events
    // library interop.
    Listening.prototype.off = function(name, callback) {
        var cleanup;
        if (this.interop) {
            this._events = eventsApi(offApi, this._events, name, callback, {
                context: void 0,
                listeners: void 0
            });
            cleanup = !this._events;
        } else {
            this.count--;
            cleanup = this.count === 0;
        }
        if (cleanup) this.cleanup();
    };
    // Cleans up memory bindings between the listener and the listenee.
    Listening.prototype.cleanup = function() {
        delete this.listener._listeningTo[this.obj._listenId];
        if (!this.interop) delete this.obj._listeners[this.id];
    };
    // Aliases for backwards compatibility.
    Events.bind = Events.on;
    Events.unbind = Events.off;
    // Allow the `Backbone` object to serve as a global event bus, for folks who
    // want global "pubsub" in a convenient place.
    _.extend(Backbone, Events);
    // Backbone.Model
    // --------------
    // Backbone **Models** are the basic data object in the framework --
    // frequently representing a row in a table in a database on your server.
    // A discrete chunk of data and a bunch of useful, related methods for
    // performing computations and transformations on that data.
    // Create a new model with the specified attributes. A client id (`cid`)
    // is automatically generated and assigned for you.
    var Model = Backbone.Model = function(attributes, options) {
        var attrs = attributes || {};
        options || (options = {});
        this.preinitialize.apply(this, arguments);
        this.cid = _.uniqueId(this.cidPrefix);
        this.attributes = {};
        if (options.collection) this.collection = options.collection;
        if (options.parse) attrs = this.parse(attrs, options) || {};
        var defaults = _.result(this, "defaults");
        // Just _.defaults would work fine, but the additional _.extends
        // is in there for historical reasons. See #3843.
        attrs = _.defaults(_.extend({}, defaults, attrs), defaults);
        this.set(attrs, options);
        this.changed = {};
        this.initialize.apply(this, arguments);
    };
    // Attach all inheritable methods to the Model prototype.
    _.extend(Model.prototype, Events, {
        // A hash of attributes whose current and previous value differ.
        changed: null,
        // The value returned during the last failed validation.
        validationError: null,
        // The default name for the JSON `id` attribute is `"id"`. MongoDB and
        // CouchDB users may want to set this to `"_id"`.
        idAttribute: "id",
        // The prefix is used to create the client id which is used to identify models locally.
        // You may want to override this if you're experiencing name clashes with model ids.
        cidPrefix: "c",
        // preinitialize is an empty function by default. You can override it with a function
        // or object.  preinitialize will run before any instantiation logic is run in the Model.
        preinitialize: function() {},
        // Initialize is an empty function by default. Override it with your own
        // initialization logic.
        initialize: function() {},
        // Return a copy of the model's `attributes` object.
        toJSON: function(options) {
            return _.clone(this.attributes);
        },
        // Proxy `Backbone.sync` by default -- but override this if you need
        // custom syncing semantics for *this* particular model.
        sync: function() {
            return Backbone.sync.apply(this, arguments);
        },
        // Get the value of an attribute.
        get: function(attr) {
            return this.attributes[attr];
        },
        // Get the HTML-escaped value of an attribute.
        escape: function(attr) {
            return _.escape(this.get(attr));
        },
        // Returns `true` if the attribute contains a value that is not null
        // or undefined.
        has: function(attr) {
            return this.get(attr) != null;
        },
        // Special-cased proxy to underscore's `_.matches` method.
        matches: function(attrs) {
            return !!_.iteratee(attrs, this)(this.attributes);
        },
        // Set a hash of model attributes on the object, firing `"change"`. This is
        // the core primitive operation of a model, updating the data and notifying
        // anyone who needs to know about the change in state. The heart of the beast.
        set: function(key, val, options) {
            if (key == null) return this;
            // Handle both `"key", value` and `{key: value}` -style arguments.
            var attrs;
            if (typeof key === "object") {
                attrs = key;
                options = val;
            } else (attrs = {})[key] = val;
            options || (options = {});
            // Run validation.
            if (!this._validate(attrs, options)) return false;
            // Extract attributes and options.
            var unset = options.unset;
            var silent = options.silent;
            var changes = [];
            var changing = this._changing;
            this._changing = true;
            if (!changing) {
                this._previousAttributes = _.clone(this.attributes);
                this.changed = {};
            }
            var current = this.attributes;
            var changed = this.changed;
            var prev = this._previousAttributes;
            // For each `set` attribute, update or delete the current value.
            for(var attr in attrs){
                val = attrs[attr];
                if (!_.isEqual(current[attr], val)) changes.push(attr);
                if (!_.isEqual(prev[attr], val)) changed[attr] = val;
                else delete changed[attr];
                unset ? delete current[attr] : current[attr] = val;
            }
            // Update the `id`.
            if (this.idAttribute in attrs) {
                var prevId = this.id;
                this.id = this.get(this.idAttribute);
                this.trigger("changeId", this, prevId, options);
            }
            // Trigger all relevant attribute changes.
            if (!silent) {
                if (changes.length) this._pending = options;
                for(var i = 0; i < changes.length; i++)this.trigger("change:" + changes[i], this, current[changes[i]], options);
            }
            // You might be wondering why there's a `while` loop here. Changes can
            // be recursively nested within `"change"` events.
            if (changing) return this;
            if (!silent) while(this._pending){
                options = this._pending;
                this._pending = false;
                this.trigger("change", this, options);
            }
            this._pending = false;
            this._changing = false;
            return this;
        },
        // Remove an attribute from the model, firing `"change"`. `unset` is a noop
        // if the attribute doesn't exist.
        unset: function(attr, options) {
            return this.set(attr, void 0, _.extend({}, options, {
                unset: true
            }));
        },
        // Clear all attributes on the model, firing `"change"`.
        clear: function(options) {
            var attrs = {};
            for(var key in this.attributes)attrs[key] = void 0;
            return this.set(attrs, _.extend({}, options, {
                unset: true
            }));
        },
        // Determine if the model has changed since the last `"change"` event.
        // If you specify an attribute name, determine if that attribute has changed.
        hasChanged: function(attr) {
            if (attr == null) return !_.isEmpty(this.changed);
            return _.has(this.changed, attr);
        },
        // Return an object containing all the attributes that have changed, or
        // false if there are no changed attributes. Useful for determining what
        // parts of a view need to be updated and/or what attributes need to be
        // persisted to the server. Unset attributes will be set to undefined.
        // You can also pass an attributes object to diff against the model,
        // determining if there *would be* a change.
        changedAttributes: function(diff) {
            if (!diff) return this.hasChanged() ? _.clone(this.changed) : false;
            var old = this._changing ? this._previousAttributes : this.attributes;
            var changed = {};
            var hasChanged;
            for(var attr in diff){
                var val = diff[attr];
                if (_.isEqual(old[attr], val)) continue;
                changed[attr] = val;
                hasChanged = true;
            }
            return hasChanged ? changed : false;
        },
        // Get the previous value of an attribute, recorded at the time the last
        // `"change"` event was fired.
        previous: function(attr) {
            if (attr == null || !this._previousAttributes) return null;
            return this._previousAttributes[attr];
        },
        // Get all of the attributes of the model at the time of the previous
        // `"change"` event.
        previousAttributes: function() {
            return _.clone(this._previousAttributes);
        },
        // Fetch the model from the server, merging the response with the model's
        // local attributes. Any changed attributes will trigger a "change" event.
        fetch: function(options) {
            options = _.extend({
                parse: true
            }, options);
            var model = this;
            var success = options.success;
            options.success = function(resp) {
                var serverAttrs = options.parse ? model.parse(resp, options) : resp;
                if (!model.set(serverAttrs, options)) return false;
                if (success) success.call(options.context, model, resp, options);
                model.trigger("sync", model, resp, options);
            };
            wrapError(this, options);
            return this.sync("read", this, options);
        },
        // Set a hash of model attributes, and sync the model to the server.
        // If the server returns an attributes hash that differs, the model's
        // state will be `set` again.
        save: function(key, val, options) {
            // Handle both `"key", value` and `{key: value}` -style arguments.
            var attrs;
            if (key == null || typeof key === "object") {
                attrs = key;
                options = val;
            } else (attrs = {})[key] = val;
            options = _.extend({
                validate: true,
                parse: true
            }, options);
            var wait = options.wait;
            // If we're not waiting and attributes exist, save acts as
            // `set(attr).save(null, opts)` with validation. Otherwise, check if
            // the model will be valid when the attributes, if any, are set.
            if (attrs && !wait) {
                if (!this.set(attrs, options)) return false;
            } else if (!this._validate(attrs, options)) return false;
            // After a successful server-side save, the client is (optionally)
            // updated with the server-side state.
            var model = this;
            var success = options.success;
            var attributes = this.attributes;
            options.success = function(resp) {
                // Ensure attributes are restored during synchronous saves.
                model.attributes = attributes;
                var serverAttrs = options.parse ? model.parse(resp, options) : resp;
                if (wait) serverAttrs = _.extend({}, attrs, serverAttrs);
                if (serverAttrs && !model.set(serverAttrs, options)) return false;
                if (success) success.call(options.context, model, resp, options);
                model.trigger("sync", model, resp, options);
            };
            wrapError(this, options);
            // Set temporary attributes if `{wait: true}` to properly find new ids.
            if (attrs && wait) this.attributes = _.extend({}, attributes, attrs);
            var method = this.isNew() ? "create" : options.patch ? "patch" : "update";
            if (method === "patch" && !options.attrs) options.attrs = attrs;
            var xhr = this.sync(method, this, options);
            // Restore attributes.
            this.attributes = attributes;
            return xhr;
        },
        // Destroy this model on the server if it was already persisted.
        // Optimistically removes the model from its collection, if it has one.
        // If `wait: true` is passed, waits for the server to respond before removal.
        destroy: function(options) {
            options = options ? _.clone(options) : {};
            var model = this;
            var success = options.success;
            var wait = options.wait;
            var destroy = function() {
                model.stopListening();
                model.trigger("destroy", model, model.collection, options);
            };
            options.success = function(resp) {
                if (wait) destroy();
                if (success) success.call(options.context, model, resp, options);
                if (!model.isNew()) model.trigger("sync", model, resp, options);
            };
            var xhr = false;
            if (this.isNew()) _.defer(options.success);
            else {
                wrapError(this, options);
                xhr = this.sync("delete", this, options);
            }
            if (!wait) destroy();
            return xhr;
        },
        // Default URL for the model's representation on the server -- if you're
        // using Backbone's restful methods, override this to change the endpoint
        // that will be called.
        url: function() {
            var base = _.result(this, "urlRoot") || _.result(this.collection, "url") || urlError();
            if (this.isNew()) return base;
            var id = this.get(this.idAttribute);
            return base.replace(/[^\/]$/, "$&/") + encodeURIComponent(id);
        },
        // **parse** converts a response into the hash of attributes to be `set` on
        // the model. The default implementation is just to pass the response along.
        parse: function(resp, options) {
            return resp;
        },
        // Create a new model with identical attributes to this one.
        clone: function() {
            return new this.constructor(this.attributes);
        },
        // A model is new if it has never been saved to the server, and lacks an id.
        isNew: function() {
            return !this.has(this.idAttribute);
        },
        // Check if the model is currently in a valid state.
        isValid: function(options) {
            return this._validate({}, _.extend({}, options, {
                validate: true
            }));
        },
        // Run validation against the next complete set of model attributes,
        // returning `true` if all is well. Otherwise, fire an `"invalid"` event.
        _validate: function(attrs, options) {
            if (!options.validate || !this.validate) return true;
            attrs = _.extend({}, this.attributes, attrs);
            var error = this.validationError = this.validate(attrs, options) || null;
            if (!error) return true;
            this.trigger("invalid", this, error, _.extend(options, {
                validationError: error
            }));
            return false;
        }
    });
    // Backbone.Collection
    // -------------------
    // If models tend to represent a single row of data, a Backbone Collection is
    // more analogous to a table full of data ... or a small slice or page of that
    // table, or a collection of rows that belong together for a particular reason
    // -- all of the messages in this particular folder, all of the documents
    // belonging to this particular author, and so on. Collections maintain
    // indexes of their models, both in order, and for lookup by `id`.
    // Create a new **Collection**, perhaps to contain a specific type of `model`.
    // If a `comparator` is specified, the Collection will maintain
    // its models in sort order, as they're added and removed.
    var Collection = Backbone.Collection = function(models, options) {
        options || (options = {});
        this.preinitialize.apply(this, arguments);
        if (options.model) this.model = options.model;
        if (options.comparator !== void 0) this.comparator = options.comparator;
        this._reset();
        this.initialize.apply(this, arguments);
        if (models) this.reset(models, _.extend({
            silent: true
        }, options));
    };
    // Default options for `Collection#set`.
    var setOptions = {
        add: true,
        remove: true,
        merge: true
    };
    var addOptions = {
        add: true,
        remove: false
    };
    // Splices `insert` into `array` at index `at`.
    var splice = function(array, insert, at) {
        at = Math.min(Math.max(at, 0), array.length);
        var tail = Array(array.length - at);
        var length = insert.length;
        var i;
        for(i = 0; i < tail.length; i++)tail[i] = array[i + at];
        for(i = 0; i < length; i++)array[i + at] = insert[i];
        for(i = 0; i < tail.length; i++)array[i + length + at] = tail[i];
    };
    // Define the Collection's inheritable methods.
    _.extend(Collection.prototype, Events, {
        // The default model for a collection is just a **Backbone.Model**.
        // This should be overridden in most cases.
        model: Model,
        // preinitialize is an empty function by default. You can override it with a function
        // or object.  preinitialize will run before any instantiation logic is run in the Collection.
        preinitialize: function() {},
        // Initialize is an empty function by default. Override it with your own
        // initialization logic.
        initialize: function() {},
        // The JSON representation of a Collection is an array of the
        // models' attributes.
        toJSON: function(options) {
            return this.map(function(model) {
                return model.toJSON(options);
            });
        },
        // Proxy `Backbone.sync` by default.
        sync: function() {
            return Backbone.sync.apply(this, arguments);
        },
        // Add a model, or list of models to the set. `models` may be Backbone
        // Models or raw JavaScript objects to be converted to Models, or any
        // combination of the two.
        add: function(models, options) {
            return this.set(models, _.extend({
                merge: false
            }, options, addOptions));
        },
        // Remove a model, or a list of models from the set.
        remove: function(models, options) {
            options = _.extend({}, options);
            var singular = !_.isArray(models);
            models = singular ? [
                models
            ] : models.slice();
            var removed = this._removeModels(models, options);
            if (!options.silent && removed.length) {
                options.changes = {
                    added: [],
                    merged: [],
                    removed: removed
                };
                this.trigger("update", this, options);
            }
            return singular ? removed[0] : removed;
        },
        // Update a collection by `set`-ing a new list of models, adding new ones,
        // removing models that are no longer present, and merging models that
        // already exist in the collection, as necessary. Similar to **Model#set**,
        // the core operation for updating the data contained by the collection.
        set: function(models, options) {
            if (models == null) return;
            options = _.extend({}, setOptions, options);
            if (options.parse && !this._isModel(models)) models = this.parse(models, options) || [];
            var singular = !_.isArray(models);
            models = singular ? [
                models
            ] : models.slice();
            var at = options.at;
            if (at != null) at = +at;
            if (at > this.length) at = this.length;
            if (at < 0) at += this.length + 1;
            var set = [];
            var toAdd = [];
            var toMerge = [];
            var toRemove = [];
            var modelMap = {};
            var add = options.add;
            var merge = options.merge;
            var remove = options.remove;
            var sort = false;
            var sortable = this.comparator && at == null && options.sort !== false;
            var sortAttr = _.isString(this.comparator) ? this.comparator : null;
            // Turn bare objects into model references, and prevent invalid models
            // from being added.
            var model, i;
            for(i = 0; i < models.length; i++){
                model = models[i];
                // If a duplicate is found, prevent it from being added and
                // optionally merge it into the existing model.
                var existing = this.get(model);
                if (existing) {
                    if (merge && model !== existing) {
                        var attrs = this._isModel(model) ? model.attributes : model;
                        if (options.parse) attrs = existing.parse(attrs, options);
                        existing.set(attrs, options);
                        toMerge.push(existing);
                        if (sortable && !sort) sort = existing.hasChanged(sortAttr);
                    }
                    if (!modelMap[existing.cid]) {
                        modelMap[existing.cid] = true;
                        set.push(existing);
                    }
                    models[i] = existing;
                // If this is a new, valid model, push it to the `toAdd` list.
                } else if (add) {
                    model = models[i] = this._prepareModel(model, options);
                    if (model) {
                        toAdd.push(model);
                        this._addReference(model, options);
                        modelMap[model.cid] = true;
                        set.push(model);
                    }
                }
            }
            // Remove stale models.
            if (remove) {
                for(i = 0; i < this.length; i++){
                    model = this.models[i];
                    if (!modelMap[model.cid]) toRemove.push(model);
                }
                if (toRemove.length) this._removeModels(toRemove, options);
            }
            // See if sorting is needed, update `length` and splice in new models.
            var orderChanged = false;
            var replace = !sortable && add && remove;
            if (set.length && replace) {
                orderChanged = this.length !== set.length || _.some(this.models, function(m, index) {
                    return m !== set[index];
                });
                this.models.length = 0;
                splice(this.models, set, 0);
                this.length = this.models.length;
            } else if (toAdd.length) {
                if (sortable) sort = true;
                splice(this.models, toAdd, at == null ? this.length : at);
                this.length = this.models.length;
            }
            // Silently sort the collection if appropriate.
            if (sort) this.sort({
                silent: true
            });
            // Unless silenced, it's time to fire all appropriate add/sort/update events.
            if (!options.silent) {
                for(i = 0; i < toAdd.length; i++){
                    if (at != null) options.index = at + i;
                    model = toAdd[i];
                    model.trigger("add", model, this, options);
                }
                if (sort || orderChanged) this.trigger("sort", this, options);
                if (toAdd.length || toRemove.length || toMerge.length) {
                    options.changes = {
                        added: toAdd,
                        removed: toRemove,
                        merged: toMerge
                    };
                    this.trigger("update", this, options);
                }
            }
            // Return the added (or merged) model (or models).
            return singular ? models[0] : models;
        },
        // When you have more items than you want to add or remove individually,
        // you can reset the entire set with a new list of models, without firing
        // any granular `add` or `remove` events. Fires `reset` when finished.
        // Useful for bulk operations and optimizations.
        reset: function(models, options) {
            options = options ? _.clone(options) : {};
            for(var i = 0; i < this.models.length; i++)this._removeReference(this.models[i], options);
            options.previousModels = this.models;
            this._reset();
            models = this.add(models, _.extend({
                silent: true
            }, options));
            if (!options.silent) this.trigger("reset", this, options);
            return models;
        },
        // Add a model to the end of the collection.
        push: function(model, options) {
            return this.add(model, _.extend({
                at: this.length
            }, options));
        },
        // Remove a model from the end of the collection.
        pop: function(options) {
            var model = this.at(this.length - 1);
            return this.remove(model, options);
        },
        // Add a model to the beginning of the collection.
        unshift: function(model, options) {
            return this.add(model, _.extend({
                at: 0
            }, options));
        },
        // Remove a model from the beginning of the collection.
        shift: function(options) {
            var model = this.at(0);
            return this.remove(model, options);
        },
        // Slice out a sub-array of models from the collection.
        slice: function() {
            return slice.apply(this.models, arguments);
        },
        // Get a model from the set by id, cid, model object with id or cid
        // properties, or an attributes object that is transformed through modelId.
        get: function(obj) {
            if (obj == null) return void 0;
            return this._byId[obj] || this._byId[this.modelId(this._isModel(obj) ? obj.attributes : obj, obj.idAttribute)] || obj.cid && this._byId[obj.cid];
        },
        // Returns `true` if the model is in the collection.
        has: function(obj) {
            return this.get(obj) != null;
        },
        // Get the model at the given index.
        at: function(index) {
            if (index < 0) index += this.length;
            return this.models[index];
        },
        // Return models with matching attributes. Useful for simple cases of
        // `filter`.
        where: function(attrs, first) {
            return this[first ? "find" : "filter"](attrs);
        },
        // Return the first model with matching attributes. Useful for simple cases
        // of `find`.
        findWhere: function(attrs) {
            return this.where(attrs, true);
        },
        // Force the collection to re-sort itself. You don't need to call this under
        // normal circumstances, as the set will maintain sort order as each item
        // is added.
        sort: function(options) {
            var comparator = this.comparator;
            if (!comparator) throw new Error("Cannot sort a set without a comparator");
            options || (options = {});
            var length = comparator.length;
            if (_.isFunction(comparator)) comparator = comparator.bind(this);
            // Run sort based on type of `comparator`.
            if (length === 1 || _.isString(comparator)) this.models = this.sortBy(comparator);
            else this.models.sort(comparator);
            if (!options.silent) this.trigger("sort", this, options);
            return this;
        },
        // Pluck an attribute from each model in the collection.
        pluck: function(attr) {
            return this.map(attr + "");
        },
        // Fetch the default set of models for this collection, resetting the
        // collection when they arrive. If `reset: true` is passed, the response
        // data will be passed through the `reset` method instead of `set`.
        fetch: function(options) {
            options = _.extend({
                parse: true
            }, options);
            var success = options.success;
            var collection = this;
            options.success = function(resp) {
                var method = options.reset ? "reset" : "set";
                collection[method](resp, options);
                if (success) success.call(options.context, collection, resp, options);
                collection.trigger("sync", collection, resp, options);
            };
            wrapError(this, options);
            return this.sync("read", this, options);
        },
        // Create a new instance of a model in this collection. Add the model to the
        // collection immediately, unless `wait: true` is passed, in which case we
        // wait for the server to agree.
        create: function(model, options) {
            options = options ? _.clone(options) : {};
            var wait = options.wait;
            model = this._prepareModel(model, options);
            if (!model) return false;
            if (!wait) this.add(model, options);
            var collection = this;
            var success = options.success;
            options.success = function(m, resp, callbackOpts) {
                if (wait) {
                    m.off("error", collection._forwardPristineError, collection);
                    collection.add(m, callbackOpts);
                }
                if (success) success.call(callbackOpts.context, m, resp, callbackOpts);
            };
            // In case of wait:true, our collection is not listening to any
            // of the model's events yet, so it will not forward the error
            // event. In this special case, we need to listen for it
            // separately and handle the event just once.
            // (The reason we don't need to do this for the sync event is
            // in the success handler above: we add the model first, which
            // causes the collection to listen, and then invoke the callback
            // that triggers the event.)
            if (wait) model.once("error", this._forwardPristineError, this);
            model.save(null, options);
            return model;
        },
        // **parse** converts a response into a list of models to be added to the
        // collection. The default implementation is just to pass it through.
        parse: function(resp, options) {
            return resp;
        },
        // Create a new collection with an identical list of models as this one.
        clone: function() {
            return new this.constructor(this.models, {
                model: this.model,
                comparator: this.comparator
            });
        },
        // Define how to uniquely identify models in the collection.
        modelId: function(attrs, idAttribute) {
            return attrs[idAttribute || this.model.prototype.idAttribute || "id"];
        },
        // Get an iterator of all models in this collection.
        values: function() {
            return new CollectionIterator(this, ITERATOR_VALUES);
        },
        // Get an iterator of all model IDs in this collection.
        keys: function() {
            return new CollectionIterator(this, ITERATOR_KEYS);
        },
        // Get an iterator of all [ID, model] tuples in this collection.
        entries: function() {
            return new CollectionIterator(this, ITERATOR_KEYSVALUES);
        },
        // Private method to reset all internal state. Called when the collection
        // is first initialized or reset.
        _reset: function() {
            this.length = 0;
            this.models = [];
            this._byId = {};
        },
        // Prepare a hash of attributes (or other model) to be added to this
        // collection.
        _prepareModel: function(attrs, options) {
            if (this._isModel(attrs)) {
                if (!attrs.collection) attrs.collection = this;
                return attrs;
            }
            options = options ? _.clone(options) : {};
            options.collection = this;
            var model;
            if (this.model.prototype) model = new this.model(attrs, options);
            else // ES class methods didn't have prototype
            model = this.model(attrs, options);
            if (!model.validationError) return model;
            this.trigger("invalid", this, model.validationError, options);
            return false;
        },
        // Internal method called by both remove and set.
        _removeModels: function(models, options) {
            var removed = [];
            for(var i = 0; i < models.length; i++){
                var model = this.get(models[i]);
                if (!model) continue;
                var index = this.indexOf(model);
                this.models.splice(index, 1);
                this.length--;
                // Remove references before triggering 'remove' event to prevent an
                // infinite loop. #3693
                delete this._byId[model.cid];
                var id = this.modelId(model.attributes, model.idAttribute);
                if (id != null) delete this._byId[id];
                if (!options.silent) {
                    options.index = index;
                    model.trigger("remove", model, this, options);
                }
                removed.push(model);
                this._removeReference(model, options);
            }
            if (models.length > 0 && !options.silent) delete options.index;
            return removed;
        },
        // Method for checking whether an object should be considered a model for
        // the purposes of adding to the collection.
        _isModel: function(model) {
            return model instanceof Model;
        },
        // Internal method to create a model's ties to a collection.
        _addReference: function(model, options) {
            this._byId[model.cid] = model;
            var id = this.modelId(model.attributes, model.idAttribute);
            if (id != null) this._byId[id] = model;
            model.on("all", this._onModelEvent, this);
        },
        // Internal method to sever a model's ties to a collection.
        _removeReference: function(model, options) {
            delete this._byId[model.cid];
            var id = this.modelId(model.attributes, model.idAttribute);
            if (id != null) delete this._byId[id];
            if (this === model.collection) delete model.collection;
            model.off("all", this._onModelEvent, this);
        },
        // Internal method called every time a model in the set fires an event.
        // Sets need to update their indexes when models change ids. All other
        // events simply proxy through. "add" and "remove" events that originate
        // in other collections are ignored.
        _onModelEvent: function(event, model, collection, options) {
            if (model) {
                if ((event === "add" || event === "remove") && collection !== this) return;
                if (event === "destroy") this.remove(model, options);
                if (event === "changeId") {
                    var prevId = this.modelId(model.previousAttributes(), model.idAttribute);
                    var id = this.modelId(model.attributes, model.idAttribute);
                    if (prevId != null) delete this._byId[prevId];
                    if (id != null) this._byId[id] = model;
                }
            }
            this.trigger.apply(this, arguments);
        },
        // Internal callback method used in `create`. It serves as a
        // stand-in for the `_onModelEvent` method, which is not yet bound
        // during the `wait` period of the `create` call. We still want to
        // forward any `'error'` event at the end of the `wait` period,
        // hence a customized callback.
        _forwardPristineError: function(model, collection, options) {
            // Prevent double forward if the model was already in the
            // collection before the call to `create`.
            if (this.has(model)) return;
            this._onModelEvent("error", model, collection, options);
        }
    });
    // Defining an @@iterator method implements JavaScript's Iterable protocol.
    // In modern ES2015 browsers, this value is found at Symbol.iterator.
    /* global Symbol */ var $$iterator = typeof Symbol === "function" && Symbol.iterator;
    if ($$iterator) Collection.prototype[$$iterator] = Collection.prototype.values;
    // CollectionIterator
    // ------------------
    // A CollectionIterator implements JavaScript's Iterator protocol, allowing the
    // use of `for of` loops in modern browsers and interoperation between
    // Backbone.Collection and other JavaScript functions and third-party libraries
    // which can operate on Iterables.
    var CollectionIterator = function(collection, kind) {
        this._collection = collection;
        this._kind = kind;
        this._index = 0;
    };
    // This "enum" defines the three possible kinds of values which can be emitted
    // by a CollectionIterator that correspond to the values(), keys() and entries()
    // methods on Collection, respectively.
    var ITERATOR_VALUES = 1;
    var ITERATOR_KEYS = 2;
    var ITERATOR_KEYSVALUES = 3;
    // All Iterators should themselves be Iterable.
    if ($$iterator) CollectionIterator.prototype[$$iterator] = function() {
        return this;
    };
    CollectionIterator.prototype.next = function() {
        if (this._collection) {
            // Only continue iterating if the iterated collection is long enough.
            if (this._index < this._collection.length) {
                var model = this._collection.at(this._index);
                this._index++;
                // Construct a value depending on what kind of values should be iterated.
                var value;
                if (this._kind === ITERATOR_VALUES) value = model;
                else {
                    var id = this._collection.modelId(model.attributes, model.idAttribute);
                    if (this._kind === ITERATOR_KEYS) value = id;
                    else value = [
                        id,
                        model
                    ];
                }
                return {
                    value: value,
                    done: false
                };
            }
            // Once exhausted, remove the reference to the collection so future
            // calls to the next method always return done.
            this._collection = void 0;
        }
        return {
            value: void 0,
            done: true
        };
    };
    // Backbone.View
    // -------------
    // Backbone Views are almost more convention than they are actual code. A View
    // is simply a JavaScript object that represents a logical chunk of UI in the
    // DOM. This might be a single item, an entire list, a sidebar or panel, or
    // even the surrounding frame which wraps your whole app. Defining a chunk of
    // UI as a **View** allows you to define your DOM events declaratively, without
    // having to worry about render order ... and makes it easy for the view to
    // react to specific changes in the state of your models.
    // Creating a Backbone.View creates its initial element outside of the DOM,
    // if an existing element is not provided...
    var View = Backbone.View = function(options) {
        this.cid = _.uniqueId("view");
        this.preinitialize.apply(this, arguments);
        _.extend(this, _.pick(options, viewOptions));
        this._ensureElement();
        this.initialize.apply(this, arguments);
    };
    // Cached regex to split keys for `delegate`.
    var delegateEventSplitter = /^(\S+)\s*(.*)$/;
    // List of view options to be set as properties.
    var viewOptions = [
        "model",
        "collection",
        "el",
        "id",
        "attributes",
        "className",
        "tagName",
        "events"
    ];
    // Set up all inheritable **Backbone.View** properties and methods.
    _.extend(View.prototype, Events, {
        // The default `tagName` of a View's element is `"div"`.
        tagName: "div",
        // jQuery delegate for element lookup, scoped to DOM elements within the
        // current view. This should be preferred to global lookups where possible.
        $: function(selector) {
            return this.$el.find(selector);
        },
        // preinitialize is an empty function by default. You can override it with a function
        // or object.  preinitialize will run before any instantiation logic is run in the View
        preinitialize: function() {},
        // Initialize is an empty function by default. Override it with your own
        // initialization logic.
        initialize: function() {},
        // **render** is the core function that your view should override, in order
        // to populate its element (`this.el`), with the appropriate HTML. The
        // convention is for **render** to always return `this`.
        render: function() {
            return this;
        },
        // Remove this view by taking the element out of the DOM, and removing any
        // applicable Backbone.Events listeners.
        remove: function() {
            this._removeElement();
            this.stopListening();
            return this;
        },
        // Remove this view's element from the document and all event listeners
        // attached to it. Exposed for subclasses using an alternative DOM
        // manipulation API.
        _removeElement: function() {
            this.$el.remove();
        },
        // Change the view's element (`this.el` property) and re-delegate the
        // view's events on the new element.
        setElement: function(element) {
            this.undelegateEvents();
            this._setElement(element);
            this.delegateEvents();
            return this;
        },
        // Creates the `this.el` and `this.$el` references for this view using the
        // given `el`. `el` can be a CSS selector or an HTML string, a jQuery
        // context or an element. Subclasses can override this to utilize an
        // alternative DOM manipulation API and are only required to set the
        // `this.el` property.
        _setElement: function(el) {
            this.$el = el instanceof Backbone.$ ? el : Backbone.$(el);
            this.el = this.$el[0];
        },
        // Set callbacks, where `this.events` is a hash of
        //
        // *{"event selector": "callback"}*
        //
        //     {
        //       'mousedown .title':  'edit',
        //       'click .button':     'save',
        //       'click .open':       function(e) { ... }
        //     }
        //
        // pairs. Callbacks will be bound to the view, with `this` set properly.
        // Uses event delegation for efficiency.
        // Omitting the selector binds the event to `this.el`.
        delegateEvents: function(events) {
            events || (events = _.result(this, "events"));
            if (!events) return this;
            this.undelegateEvents();
            for(var key in events){
                var method = events[key];
                if (!_.isFunction(method)) method = this[method];
                if (!method) continue;
                var match = key.match(delegateEventSplitter);
                this.delegate(match[1], match[2], method.bind(this));
            }
            return this;
        },
        // Add a single event listener to the view's element (or a child element
        // using `selector`). This only works for delegate-able events: not `focus`,
        // `blur`, and not `change`, `submit`, and `reset` in Internet Explorer.
        delegate: function(eventName, selector, listener) {
            this.$el.on(eventName + ".delegateEvents" + this.cid, selector, listener);
            return this;
        },
        // Clears all callbacks previously bound to the view by `delegateEvents`.
        // You usually don't need to use this, but may wish to if you have multiple
        // Backbone views attached to the same DOM element.
        undelegateEvents: function() {
            if (this.$el) this.$el.off(".delegateEvents" + this.cid);
            return this;
        },
        // A finer-grained `undelegateEvents` for removing a single delegated event.
        // `selector` and `listener` are both optional.
        undelegate: function(eventName, selector, listener) {
            this.$el.off(eventName + ".delegateEvents" + this.cid, selector, listener);
            return this;
        },
        // Produces a DOM element to be assigned to your view. Exposed for
        // subclasses using an alternative DOM manipulation API.
        _createElement: function(tagName) {
            return document.createElement(tagName);
        },
        // Ensure that the View has a DOM element to render into.
        // If `this.el` is a string, pass it through `$()`, take the first
        // matching element, and re-assign it to `el`. Otherwise, create
        // an element from the `id`, `className` and `tagName` properties.
        _ensureElement: function() {
            if (!this.el) {
                var attrs = _.extend({}, _.result(this, "attributes"));
                if (this.id) attrs.id = _.result(this, "id");
                if (this.className) attrs["class"] = _.result(this, "className");
                this.setElement(this._createElement(_.result(this, "tagName")));
                this._setAttributes(attrs);
            } else this.setElement(_.result(this, "el"));
        },
        // Set attributes from a hash on this view's element.  Exposed for
        // subclasses using an alternative DOM manipulation API.
        _setAttributes: function(attributes) {
            this.$el.attr(attributes);
        }
    });
    // Proxy Backbone class methods to Underscore functions, wrapping the model's
    // `attributes` object or collection's `models` array behind the scenes.
    //
    // collection.filter(function(model) { return model.get('age') > 10 });
    // collection.each(this.addView);
    //
    // `Function#apply` can be slow so we use the method's arg count, if we know it.
    var addMethod = function(base, length, method, attribute) {
        switch(length){
            case 1:
                return function() {
                    return base[method](this[attribute]);
                };
            case 2:
                return function(value) {
                    return base[method](this[attribute], value);
                };
            case 3:
                return function(iteratee, context) {
                    return base[method](this[attribute], cb(iteratee, this), context);
                };
            case 4:
                return function(iteratee, defaultVal, context) {
                    return base[method](this[attribute], cb(iteratee, this), defaultVal, context);
                };
            default:
                return function() {
                    var args = slice.call(arguments);
                    args.unshift(this[attribute]);
                    return base[method].apply(base, args);
                };
        }
    };
    var addUnderscoreMethods = function(Class, base, methods, attribute) {
        _.each(methods, function(length, method) {
            if (base[method]) Class.prototype[method] = addMethod(base, length, method, attribute);
        });
    };
    // Support `collection.sortBy('attr')` and `collection.findWhere({id: 1})`.
    var cb = function(iteratee, instance) {
        if (_.isFunction(iteratee)) return iteratee;
        if (_.isObject(iteratee) && !instance._isModel(iteratee)) return modelMatcher(iteratee);
        if (_.isString(iteratee)) return function(model) {
            return model.get(iteratee);
        };
        return iteratee;
    };
    var modelMatcher = function(attrs) {
        var matcher = _.matches(attrs);
        return function(model) {
            return matcher(model.attributes);
        };
    };
    // Underscore methods that we want to implement on the Collection.
    // 90% of the core usefulness of Backbone Collections is actually implemented
    // right here:
    var collectionMethods = {
        forEach: 3,
        each: 3,
        map: 3,
        collect: 3,
        reduce: 0,
        foldl: 0,
        inject: 0,
        reduceRight: 0,
        foldr: 0,
        find: 3,
        detect: 3,
        filter: 3,
        select: 3,
        reject: 3,
        every: 3,
        all: 3,
        some: 3,
        any: 3,
        include: 3,
        includes: 3,
        contains: 3,
        invoke: 0,
        max: 3,
        min: 3,
        toArray: 1,
        size: 1,
        first: 3,
        head: 3,
        take: 3,
        initial: 3,
        rest: 3,
        tail: 3,
        drop: 3,
        last: 3,
        without: 0,
        difference: 0,
        indexOf: 3,
        shuffle: 1,
        lastIndexOf: 3,
        isEmpty: 1,
        chain: 1,
        sample: 3,
        partition: 3,
        groupBy: 3,
        countBy: 3,
        sortBy: 3,
        indexBy: 3,
        findIndex: 3,
        findLastIndex: 3
    };
    // Underscore methods that we want to implement on the Model, mapped to the
    // number of arguments they take.
    var modelMethods = {
        keys: 1,
        values: 1,
        pairs: 1,
        invert: 1,
        pick: 0,
        omit: 0,
        chain: 1,
        isEmpty: 1
    };
    // Mix in each Underscore method as a proxy to `Collection#models`.
    _.each([
        [
            Collection,
            collectionMethods,
            "models"
        ],
        [
            Model,
            modelMethods,
            "attributes"
        ]
    ], function(config) {
        var Base = config[0], methods = config[1], attribute = config[2];
        Base.mixin = function(obj) {
            var mappings = _.reduce(_.functions(obj), function(memo, name) {
                memo[name] = 0;
                return memo;
            }, {});
            addUnderscoreMethods(Base, obj, mappings, attribute);
        };
        addUnderscoreMethods(Base, _, methods, attribute);
    });
    // Backbone.sync
    // -------------
    // Override this function to change the manner in which Backbone persists
    // models to the server. You will be passed the type of request, and the
    // model in question. By default, makes a RESTful Ajax request
    // to the model's `url()`. Some possible customizations could be:
    //
    // * Use `setTimeout` to batch rapid-fire updates into a single request.
    // * Send up the models as XML instead of JSON.
    // * Persist models via WebSockets instead of Ajax.
    //
    // Turn on `Backbone.emulateHTTP` in order to send `PUT` and `DELETE` requests
    // as `POST`, with a `_method` parameter containing the true HTTP method,
    // as well as all requests with the body as `application/x-www-form-urlencoded`
    // instead of `application/json` with the model in a param named `model`.
    // Useful when interfacing with server-side languages like **PHP** that make
    // it difficult to read the body of `PUT` requests.
    Backbone.sync = function(method, model, options) {
        var type = methodMap[method];
        // Default options, unless specified.
        _.defaults(options || (options = {}), {
            emulateHTTP: Backbone.emulateHTTP,
            emulateJSON: Backbone.emulateJSON
        });
        // Default JSON-request options.
        var params = {
            type: type,
            dataType: "json"
        };
        // Ensure that we have a URL.
        if (!options.url) params.url = _.result(model, "url") || urlError();
        // Ensure that we have the appropriate request data.
        if (options.data == null && model && (method === "create" || method === "update" || method === "patch")) {
            params.contentType = "application/json";
            params.data = JSON.stringify(options.attrs || model.toJSON(options));
        }
        // For older servers, emulate JSON by encoding the request into an HTML-form.
        if (options.emulateJSON) {
            params.contentType = "application/x-www-form-urlencoded";
            params.data = params.data ? {
                model: params.data
            } : {};
        }
        // For older servers, emulate HTTP by mimicking the HTTP method with `_method`
        // And an `X-HTTP-Method-Override` header.
        if (options.emulateHTTP && (type === "PUT" || type === "DELETE" || type === "PATCH")) {
            params.type = "POST";
            if (options.emulateJSON) params.data._method = type;
            var beforeSend = options.beforeSend;
            options.beforeSend = function(xhr) {
                xhr.setRequestHeader("X-HTTP-Method-Override", type);
                if (beforeSend) return beforeSend.apply(this, arguments);
            };
        }
        // Don't process data on a non-GET request.
        if (params.type !== "GET" && !options.emulateJSON) params.processData = false;
        // Pass along `textStatus` and `errorThrown` from jQuery.
        var error = options.error;
        options.error = function(xhr, textStatus, errorThrown) {
            options.textStatus = textStatus;
            options.errorThrown = errorThrown;
            if (error) error.call(options.context, xhr, textStatus, errorThrown);
        };
        // Make the request, allowing the user to override any Ajax options.
        var xhr = options.xhr = Backbone.ajax(_.extend(params, options));
        model.trigger("request", model, xhr, options);
        return xhr;
    };
    // Map from CRUD to HTTP for our default `Backbone.sync` implementation.
    var methodMap = {
        "create": "POST",
        "update": "PUT",
        "patch": "PATCH",
        "delete": "DELETE",
        "read": "GET"
    };
    // Set the default implementation of `Backbone.ajax` to proxy through to `$`.
    // Override this if you'd like to use a different library.
    Backbone.ajax = function() {
        return Backbone.$.ajax.apply(Backbone.$, arguments);
    };
    // Backbone.Router
    // ---------------
    // Routers map faux-URLs to actions, and fire events when routes are
    // matched. Creating a new one sets its `routes` hash, if not set statically.
    var Router = Backbone.Router = function(options) {
        options || (options = {});
        this.preinitialize.apply(this, arguments);
        if (options.routes) this.routes = options.routes;
        this._bindRoutes();
        this.initialize.apply(this, arguments);
    };
    // Cached regular expressions for matching named param parts and splatted
    // parts of route strings.
    var optionalParam = /\((.*?)\)/g;
    var namedParam = /(\(\?)?:\w+/g;
    var splatParam = /\*\w+/g;
    var escapeRegExp = /[\-{}\[\]+?.,\\\^$|#\s]/g;
    // Set up all inheritable **Backbone.Router** properties and methods.
    _.extend(Router.prototype, Events, {
        // preinitialize is an empty function by default. You can override it with a function
        // or object.  preinitialize will run before any instantiation logic is run in the Router.
        preinitialize: function() {},
        // Initialize is an empty function by default. Override it with your own
        // initialization logic.
        initialize: function() {},
        // Manually bind a single named route to a callback. For example:
        //
        //     this.route('search/:query/p:num', 'search', function(query, num) {
        //       ...
        //     });
        //
        route: function(route, name, callback) {
            if (!_.isRegExp(route)) route = this._routeToRegExp(route);
            if (_.isFunction(name)) {
                callback = name;
                name = "";
            }
            if (!callback) callback = this[name];
            var router = this;
            Backbone.history.route(route, function(fragment) {
                var args = router._extractParameters(route, fragment);
                if (router.execute(callback, args, name) !== false) {
                    router.trigger.apply(router, [
                        "route:" + name
                    ].concat(args));
                    router.trigger("route", name, args);
                    Backbone.history.trigger("route", router, name, args);
                }
            });
            return this;
        },
        // Execute a route handler with the provided parameters.  This is an
        // excellent place to do pre-route setup or post-route cleanup.
        execute: function(callback, args, name) {
            if (callback) callback.apply(this, args);
        },
        // Simple proxy to `Backbone.history` to save a fragment into the history.
        navigate: function(fragment, options) {
            Backbone.history.navigate(fragment, options);
            return this;
        },
        // Bind all defined routes to `Backbone.history`. We have to reverse the
        // order of the routes here to support behavior where the most general
        // routes can be defined at the bottom of the route map.
        _bindRoutes: function() {
            if (!this.routes) return;
            this.routes = _.result(this, "routes");
            var route, routes = _.keys(this.routes);
            while((route = routes.pop()) != null)this.route(route, this.routes[route]);
        },
        // Convert a route string into a regular expression, suitable for matching
        // against the current location hash.
        _routeToRegExp: function(route) {
            route = route.replace(escapeRegExp, "\\$&").replace(optionalParam, "(?:$1)?").replace(namedParam, function(match, optional) {
                return optional ? match : "([^/?]+)";
            }).replace(splatParam, "([^?]*?)");
            return new RegExp("^" + route + "(?:\\?([\\s\\S]*))?$");
        },
        // Given a route, and a URL fragment that it matches, return the array of
        // extracted decoded parameters. Empty or unmatched parameters will be
        // treated as `null` to normalize cross-browser behavior.
        _extractParameters: function(route, fragment) {
            var params = route.exec(fragment).slice(1);
            return _.map(params, function(param, i) {
                // Don't decode the search params.
                if (i === params.length - 1) return param || null;
                return param ? decodeURIComponent(param) : null;
            });
        }
    });
    // Backbone.History
    // ----------------
    // Handles cross-browser history management, based on either
    // [pushState](http://diveintohtml5.info/history.html) and real URLs, or
    // [onhashchange](https://developer.mozilla.org/en-US/docs/DOM/window.onhashchange)
    // and URL fragments. If the browser supports neither (old IE, natch),
    // falls back to polling.
    var History = Backbone.History = function() {
        this.handlers = [];
        this.checkUrl = this.checkUrl.bind(this);
        // Ensure that `History` can be used outside of the browser.
        if (typeof window !== "undefined") {
            this.location = window.location;
            this.history = window.history;
        }
    };
    // Cached regex for stripping a leading hash/slash and trailing space.
    var routeStripper = /^[#\/]|\s+$/g;
    // Cached regex for stripping leading and trailing slashes.
    var rootStripper = /^\/+|\/+$/g;
    // Cached regex for stripping urls of hash.
    var pathStripper = /#.*$/;
    // Has the history handling already been started?
    History.started = false;
    // Set up all inheritable **Backbone.History** properties and methods.
    _.extend(History.prototype, Events, {
        // The default interval to poll for hash changes, if necessary, is
        // twenty times a second.
        interval: 50,
        // Are we at the app root?
        atRoot: function() {
            var path = this.location.pathname.replace(/[^\/]$/, "$&/");
            return path === this.root && !this.getSearch();
        },
        // Does the pathname match the root?
        matchRoot: function() {
            var path = this.decodeFragment(this.location.pathname);
            var rootPath = path.slice(0, this.root.length - 1) + "/";
            return rootPath === this.root;
        },
        // Unicode characters in `location.pathname` are percent encoded so they're
        // decoded for comparison. `%25` should not be decoded since it may be part
        // of an encoded parameter.
        decodeFragment: function(fragment) {
            return decodeURI(fragment.replace(/%25/g, "%2525"));
        },
        // In IE6, the hash fragment and search params are incorrect if the
        // fragment contains `?`.
        getSearch: function() {
            var match = this.location.href.replace(/#.*/, "").match(/\?.+/);
            return match ? match[0] : "";
        },
        // Gets the true hash value. Cannot use location.hash directly due to bug
        // in Firefox where location.hash will always be decoded.
        getHash: function(window1) {
            var match = (window1 || this).location.href.match(/#(.*)$/);
            return match ? match[1] : "";
        },
        // Get the pathname and search params, without the root.
        getPath: function() {
            var path = this.decodeFragment(this.location.pathname + this.getSearch()).slice(this.root.length - 1);
            return path.charAt(0) === "/" ? path.slice(1) : path;
        },
        // Get the cross-browser normalized URL fragment from the path or hash.
        getFragment: function(fragment) {
            if (fragment == null) {
                if (this._usePushState || !this._wantsHashChange) fragment = this.getPath();
                else fragment = this.getHash();
            }
            return fragment.replace(routeStripper, "");
        },
        // Start the hash change handling, returning `true` if the current URL matches
        // an existing route, and `false` otherwise.
        start: function(options) {
            if (History.started) throw new Error("Backbone.history has already been started");
            History.started = true;
            // Figure out the initial configuration. Do we need an iframe?
            // Is pushState desired ... is it available?
            this.options = _.extend({
                root: "/"
            }, this.options, options);
            this.root = this.options.root;
            this._trailingSlash = this.options.trailingSlash;
            this._wantsHashChange = this.options.hashChange !== false;
            this._hasHashChange = "onhashchange" in window && (document.documentMode === void 0 || document.documentMode > 7);
            this._useHashChange = this._wantsHashChange && this._hasHashChange;
            this._wantsPushState = !!this.options.pushState;
            this._hasPushState = !!(this.history && this.history.pushState);
            this._usePushState = this._wantsPushState && this._hasPushState;
            this.fragment = this.getFragment();
            // Normalize root to always include a leading and trailing slash.
            this.root = ("/" + this.root + "/").replace(rootStripper, "/");
            // Transition from hashChange to pushState or vice versa if both are
            // requested.
            if (this._wantsHashChange && this._wantsPushState) {
                // If we've started off with a route from a `pushState`-enabled
                // browser, but we're currently in a browser that doesn't support it...
                if (!this._hasPushState && !this.atRoot()) {
                    var rootPath = this.root.slice(0, -1) || "/";
                    this.location.replace(rootPath + "#" + this.getPath());
                    // Return immediately as browser will do redirect to new url
                    return true;
                // Or if we've started out with a hash-based route, but we're currently
                // in a browser where it could be `pushState`-based instead...
                } else if (this._hasPushState && this.atRoot()) this.navigate(this.getHash(), {
                    replace: true
                });
            }
            // Proxy an iframe to handle location events if the browser doesn't
            // support the `hashchange` event, HTML5 history, or the user wants
            // `hashChange` but not `pushState`.
            if (!this._hasHashChange && this._wantsHashChange && !this._usePushState) {
                this.iframe = document.createElement("iframe");
                this.iframe.src = "javascript:0";
                this.iframe.style.display = "none";
                this.iframe.tabIndex = -1;
                var body = document.body;
                // Using `appendChild` will throw on IE < 9 if the document is not ready.
                var iWindow = body.insertBefore(this.iframe, body.firstChild).contentWindow;
                iWindow.document.open();
                iWindow.document.close();
                iWindow.location.hash = "#" + this.fragment;
            }
            // Add a cross-platform `addEventListener` shim for older browsers.
            var addEventListener = window.addEventListener || function(eventName, listener) {
                return attachEvent("on" + eventName, listener);
            };
            // Depending on whether we're using pushState or hashes, and whether
            // 'onhashchange' is supported, determine how we check the URL state.
            if (this._usePushState) addEventListener("popstate", this.checkUrl, false);
            else if (this._useHashChange && !this.iframe) addEventListener("hashchange", this.checkUrl, false);
            else if (this._wantsHashChange) this._checkUrlInterval = setInterval(this.checkUrl, this.interval);
            if (!this.options.silent) return this.loadUrl();
        },
        // Disable Backbone.history, perhaps temporarily. Not useful in a real app,
        // but possibly useful for unit testing Routers.
        stop: function() {
            // Add a cross-platform `removeEventListener` shim for older browsers.
            var removeEventListener = window.removeEventListener || function(eventName, listener) {
                return detachEvent("on" + eventName, listener);
            };
            // Remove window listeners.
            if (this._usePushState) removeEventListener("popstate", this.checkUrl, false);
            else if (this._useHashChange && !this.iframe) removeEventListener("hashchange", this.checkUrl, false);
            // Clean up the iframe if necessary.
            if (this.iframe) {
                document.body.removeChild(this.iframe);
                this.iframe = null;
            }
            // Some environments will throw when clearing an undefined interval.
            if (this._checkUrlInterval) clearInterval(this._checkUrlInterval);
            History.started = false;
        },
        // Add a route to be tested when the fragment changes. Routes added later
        // may override previous routes.
        route: function(route, callback) {
            this.handlers.unshift({
                route: route,
                callback: callback
            });
        },
        // Checks the current URL to see if it has changed, and if it has,
        // calls `loadUrl`, normalizing across the hidden iframe.
        checkUrl: function(e) {
            var current = this.getFragment();
            // If the user pressed the back button, the iframe's hash will have
            // changed and we should use that for comparison.
            if (current === this.fragment && this.iframe) current = this.getHash(this.iframe.contentWindow);
            if (current === this.fragment) {
                if (!this.matchRoot()) return this.notfound();
                return false;
            }
            if (this.iframe) this.navigate(current);
            this.loadUrl();
        },
        // Attempt to load the current URL fragment. If a route succeeds with a
        // match, returns `true`. If no defined routes matches the fragment,
        // returns `false`.
        loadUrl: function(fragment) {
            // If the root doesn't match, no routes can match either.
            if (!this.matchRoot()) return this.notfound();
            fragment = this.fragment = this.getFragment(fragment);
            return _.some(this.handlers, function(handler) {
                if (handler.route.test(fragment)) {
                    handler.callback(fragment);
                    return true;
                }
            }) || this.notfound();
        },
        // When no route could be matched, this method is called internally to
        // trigger the `'notfound'` event. It returns `false` so that it can be used
        // in tail position.
        notfound: function() {
            this.trigger("notfound");
            return false;
        },
        // Save a fragment into the hash history, or replace the URL state if the
        // 'replace' option is passed. You are responsible for properly URL-encoding
        // the fragment in advance.
        //
        // The options object can contain `trigger: true` if you wish to have the
        // route callback be fired (not usually desirable), or `replace: true`, if
        // you wish to modify the current URL without adding an entry to the history.
        navigate: function(fragment, options) {
            if (!History.started) return false;
            if (!options || options === true) options = {
                trigger: !!options
            };
            // Normalize the fragment.
            fragment = this.getFragment(fragment || "");
            // Strip trailing slash on the root unless _trailingSlash is true
            var rootPath = this.root;
            if (!this._trailingSlash && (fragment === "" || fragment.charAt(0) === "?")) rootPath = rootPath.slice(0, -1) || "/";
            var url = rootPath + fragment;
            // Strip the fragment of the query and hash for matching.
            fragment = fragment.replace(pathStripper, "");
            // Decode for matching.
            var decodedFragment = this.decodeFragment(fragment);
            if (this.fragment === decodedFragment) return;
            this.fragment = decodedFragment;
            // If pushState is available, we use it to set the fragment as a real URL.
            if (this._usePushState) this.history[options.replace ? "replaceState" : "pushState"]({}, document.title, url);
            else if (this._wantsHashChange) {
                this._updateHash(this.location, fragment, options.replace);
                if (this.iframe && fragment !== this.getHash(this.iframe.contentWindow)) {
                    var iWindow = this.iframe.contentWindow;
                    // Opening and closing the iframe tricks IE7 and earlier to push a
                    // history entry on hash-tag change.  When replace is true, we don't
                    // want this.
                    if (!options.replace) {
                        iWindow.document.open();
                        iWindow.document.close();
                    }
                    this._updateHash(iWindow.location, fragment, options.replace);
                }
            // If you've told us that you explicitly don't want fallback hashchange-
            // based history, then `navigate` becomes a page refresh.
            } else return this.location.assign(url);
            if (options.trigger) return this.loadUrl(fragment);
        },
        // Update the hash location, either replacing the current entry, or adding
        // a new one to the browser history.
        _updateHash: function(location, fragment, replace) {
            if (replace) {
                var href = location.href.replace(/(javascript:|#).*$/, "");
                location.replace(href + "#" + fragment);
            } else // Some browsers require that `hash` contains a leading #.
            location.hash = "#" + fragment;
        }
    });
    // Create the default Backbone.history.
    Backbone.history = new History;
    // Helpers
    // -------
    // Helper function to correctly set up the prototype chain for subclasses.
    // Similar to `goog.inherits`, but uses a hash of prototype properties and
    // class properties to be extended.
    var extend = function(protoProps, staticProps) {
        var parent = this;
        var child;
        // The constructor function for the new subclass is either defined by you
        // (the "constructor" property in your `extend` definition), or defaulted
        // by us to simply call the parent constructor.
        if (protoProps && _.has(protoProps, "constructor")) child = protoProps.constructor;
        else child = function() {
            return parent.apply(this, arguments);
        };
        // Add static properties to the constructor function, if supplied.
        _.extend(child, parent, staticProps);
        // Set the prototype chain to inherit from `parent`, without calling
        // `parent`'s constructor function and add the prototype properties.
        child.prototype = _.create(parent.prototype, protoProps);
        child.prototype.constructor = child;
        // Set a convenience property in case the parent's prototype is needed
        // later.
        child.__super__ = parent.prototype;
        return child;
    };
    // Set up inheritance for the model, collection, router, view and history.
    Model.extend = Collection.extend = Router.extend = View.extend = History.extend = extend;
    // Throw an error when a URL is needed, and none is supplied.
    var urlError = function() {
        throw new Error('A "url" property or function must be specified');
    };
    // Wrap an optional error callback with a fallback error event.
    var wrapError = function(model, options) {
        var error = options.error;
        options.error = function(resp) {
            if (error) error.call(options.context, model, resp, options);
            model.trigger("error", model, resp, options);
        };
    };
    // Provide useful information when things go wrong. This method is not meant
    // to be used directly; it merely provides the necessary introspection for the
    // external `debugInfo` function.
    Backbone._debug = function() {
        return {
            root: root,
            _: _
        };
    };
    return Backbone;
});

});
parcelRegister("2q7Wm", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => (parcelRequire("g1NQe")).default);
// ESM Exports
// ===========
// This module is the package entry point for ES module users. In other words,
// it is the module they are interfacing with when they import from the whole
// package instead of from a submodule, like this:
//
// ```js
// import { map } from 'underscore';
// ```
//
// The difference with `./index-default`, which is the package entry point for
// CommonJS, AMD and UMD users, is purely technical. In ES modules, named and
// default exports are considered to be siblings, so when you have a default
// export, its properties are not automatically available as named exports. For
// this reason, we re-export the named exports in addition to providing the same
// default export as in `./index-default`.

var $g1NQe = parcelRequire("g1NQe");

var $f6yhk = parcelRequire("f6yhk");
$parcel$exportWildcard(module.exports, $f6yhk);

});
parcelRegister("g1NQe", function(module, exports) {

$parcel$export(module.exports, "default", () => $bab366cf4ee55a65$export$2e2bcd8739ae039);
// Default Export
// ==============
// In this module, we mix our bundled exports into the `_` object and export
// the result. This is analogous to setting `module.exports = _` in CommonJS.
// Hence, this module is also the entry point of our UMD bundle and the package
// entry point for CommonJS and AMD users. In other words, this is (the source
// of) the module you are interfacing with when you do any of the following:
//
// ```js
// // CommonJS
// var _ = require('underscore');
//
// // AMD
// define(['underscore'], function(_) {...});
//
// // UMD in the browser
// // _ is available as a global variable
// ```
parcelRequire("f6yhk");
var $eVoGU = parcelRequire("eVoGU");
var $f6yhk = parcelRequire("f6yhk");
// Add all of the Underscore functions to the wrapper object.
var $bab366cf4ee55a65$var$_ = (0, $eVoGU.default)($f6yhk);
// Legacy Node.js API.
$bab366cf4ee55a65$var$_._ = $bab366cf4ee55a65$var$_;
var // Export the Underscore API.
$bab366cf4ee55a65$export$2e2bcd8739ae039 = $bab366cf4ee55a65$var$_;

});
parcelRegister("f6yhk", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "VERSION", () => (parcelRequire("3TBJw")).VERSION);
$parcel$export(module.exports, "restArguments", () => (parcelRequire("0bHlN")).default);
$parcel$export(module.exports, "isObject", () => (parcelRequire("9sPg0")).default);
$parcel$export(module.exports, "isNull", () => (parcelRequire("dL3gl")).default);
$parcel$export(module.exports, "isUndefined", () => (parcelRequire("189H9")).default);
$parcel$export(module.exports, "isBoolean", () => (parcelRequire("7aTMn")).default);
$parcel$export(module.exports, "isElement", () => (parcelRequire("hQKxy")).default);
$parcel$export(module.exports, "isString", () => (parcelRequire("h0gl0")).default);
$parcel$export(module.exports, "isNumber", () => (parcelRequire("bYhQz")).default);
$parcel$export(module.exports, "isDate", () => (parcelRequire("3Z4XQ")).default);
$parcel$export(module.exports, "isRegExp", () => (parcelRequire("4NPjY")).default);
$parcel$export(module.exports, "isError", () => (parcelRequire("fcbuE")).default);
$parcel$export(module.exports, "isSymbol", () => (parcelRequire("5lYxy")).default);
$parcel$export(module.exports, "isArrayBuffer", () => (parcelRequire("1ydks")).default);
$parcel$export(module.exports, "isDataView", () => (parcelRequire("3rRtm")).default);
$parcel$export(module.exports, "isArray", () => (parcelRequire("lsdAl")).default);
$parcel$export(module.exports, "isFunction", () => (parcelRequire("kkIYY")).default);
$parcel$export(module.exports, "isArguments", () => (parcelRequire("eiwQq")).default);
$parcel$export(module.exports, "isFinite", () => (parcelRequire("j7D23")).default);
$parcel$export(module.exports, "isNaN", () => (parcelRequire("7Mch0")).default);
$parcel$export(module.exports, "isTypedArray", () => (parcelRequire("cp06X")).default);
$parcel$export(module.exports, "isEmpty", () => (parcelRequire("awgrO")).default);
$parcel$export(module.exports, "isMatch", () => (parcelRequire("4Kv25")).default);
$parcel$export(module.exports, "isEqual", () => (parcelRequire("iwEMT")).default);
$parcel$export(module.exports, "isMap", () => (parcelRequire("1tnu9")).default);
$parcel$export(module.exports, "isWeakMap", () => (parcelRequire("4scqY")).default);
$parcel$export(module.exports, "isSet", () => (parcelRequire("kiYQK")).default);
$parcel$export(module.exports, "isWeakSet", () => (parcelRequire("jZ2st")).default);
$parcel$export(module.exports, "keys", () => (parcelRequire("9BELh")).default);
$parcel$export(module.exports, "allKeys", () => (parcelRequire("ac7Ik")).default);
$parcel$export(module.exports, "values", () => (parcelRequire("keF5g")).default);
$parcel$export(module.exports, "pairs", () => (parcelRequire("8XqbY")).default);
$parcel$export(module.exports, "invert", () => (parcelRequire("g10pM")).default);
$parcel$export(module.exports, "functions", () => (parcelRequire("aROXJ")).default);
$parcel$export(module.exports, "methods", () => (parcelRequire("aROXJ")).default);
$parcel$export(module.exports, "extend", () => (parcelRequire("hDkYR")).default);
$parcel$export(module.exports, "extendOwn", () => (parcelRequire("kWUGD")).default);
$parcel$export(module.exports, "assign", () => (parcelRequire("kWUGD")).default);
$parcel$export(module.exports, "defaults", () => (parcelRequire("cxWnu")).default);
$parcel$export(module.exports, "create", () => (parcelRequire("gfsFT")).default);
$parcel$export(module.exports, "clone", () => (parcelRequire("eNx2q")).default);
$parcel$export(module.exports, "tap", () => (parcelRequire("5Nqvc")).default);
$parcel$export(module.exports, "get", () => (parcelRequire("b1RaH")).default);
$parcel$export(module.exports, "has", () => (parcelRequire("6QeN9")).default);
$parcel$export(module.exports, "mapObject", () => (parcelRequire("4DYUU")).default);
$parcel$export(module.exports, "identity", () => (parcelRequire("4wz3f")).default);
$parcel$export(module.exports, "constant", () => (parcelRequire("cB7r5")).default);
$parcel$export(module.exports, "noop", () => (parcelRequire("k7qMd")).default);
$parcel$export(module.exports, "toPath", () => (parcelRequire("1nsRK")).default);
$parcel$export(module.exports, "property", () => (parcelRequire("gdAxf")).default);
$parcel$export(module.exports, "propertyOf", () => (parcelRequire("6nuBV")).default);
$parcel$export(module.exports, "matcher", () => (parcelRequire("ifjsZ")).default);
$parcel$export(module.exports, "matches", () => (parcelRequire("ifjsZ")).default);
$parcel$export(module.exports, "times", () => (parcelRequire("cHHN7")).default);
$parcel$export(module.exports, "random", () => (parcelRequire("lrHzN")).default);
$parcel$export(module.exports, "now", () => (parcelRequire("lVpZ1")).default);
$parcel$export(module.exports, "escape", () => (parcelRequire("3AbbN")).default);
$parcel$export(module.exports, "unescape", () => (parcelRequire("d5KHs")).default);
$parcel$export(module.exports, "templateSettings", () => (parcelRequire("ar7Gu")).default);
$parcel$export(module.exports, "template", () => (parcelRequire("ajLBg")).default);
$parcel$export(module.exports, "result", () => (parcelRequire("jN6Ly")).default);
$parcel$export(module.exports, "uniqueId", () => (parcelRequire("5xNgK")).default);
$parcel$export(module.exports, "chain", () => (parcelRequire("FCdjz")).default);
$parcel$export(module.exports, "iteratee", () => (parcelRequire("4N9JI")).default);
$parcel$export(module.exports, "partial", () => (parcelRequire("2fm2D")).default);
$parcel$export(module.exports, "bind", () => (parcelRequire("dlMqS")).default);
$parcel$export(module.exports, "bindAll", () => (parcelRequire("htAB1")).default);
$parcel$export(module.exports, "memoize", () => (parcelRequire("5T8r4")).default);
$parcel$export(module.exports, "delay", () => (parcelRequire("5PD3T")).default);
$parcel$export(module.exports, "defer", () => (parcelRequire("WOaIJ")).default);
$parcel$export(module.exports, "throttle", () => (parcelRequire("gzKqI")).default);
$parcel$export(module.exports, "debounce", () => (parcelRequire("iNzni")).default);
$parcel$export(module.exports, "wrap", () => (parcelRequire("OfUFq")).default);
$parcel$export(module.exports, "negate", () => (parcelRequire("6DjdH")).default);
$parcel$export(module.exports, "compose", () => (parcelRequire("dEpOJ")).default);
$parcel$export(module.exports, "after", () => (parcelRequire("128uF")).default);
$parcel$export(module.exports, "before", () => (parcelRequire("4FCxR")).default);
$parcel$export(module.exports, "once", () => (parcelRequire("bdw8x")).default);
$parcel$export(module.exports, "findKey", () => (parcelRequire("arT8z")).default);
$parcel$export(module.exports, "findIndex", () => (parcelRequire("ciFS5")).default);
$parcel$export(module.exports, "findLastIndex", () => (parcelRequire("53vMY")).default);
$parcel$export(module.exports, "sortedIndex", () => (parcelRequire("wTUFC")).default);
$parcel$export(module.exports, "indexOf", () => (parcelRequire("aacCi")).default);
$parcel$export(module.exports, "lastIndexOf", () => (parcelRequire("64pcf")).default);
$parcel$export(module.exports, "find", () => (parcelRequire("e3veT")).default);
$parcel$export(module.exports, "detect", () => (parcelRequire("e3veT")).default);
$parcel$export(module.exports, "findWhere", () => (parcelRequire("kXziU")).default);
$parcel$export(module.exports, "each", () => (parcelRequire("fVQTG")).default);
$parcel$export(module.exports, "forEach", () => (parcelRequire("fVQTG")).default);
$parcel$export(module.exports, "map", () => (parcelRequire("h6JIr")).default);
$parcel$export(module.exports, "collect", () => (parcelRequire("h6JIr")).default);
$parcel$export(module.exports, "reduce", () => (parcelRequire("lDhwV")).default);
$parcel$export(module.exports, "foldl", () => (parcelRequire("lDhwV")).default);
$parcel$export(module.exports, "inject", () => (parcelRequire("lDhwV")).default);
$parcel$export(module.exports, "reduceRight", () => (parcelRequire("8Wigf")).default);
$parcel$export(module.exports, "foldr", () => (parcelRequire("8Wigf")).default);
$parcel$export(module.exports, "filter", () => (parcelRequire("5cVVz")).default);
$parcel$export(module.exports, "select", () => (parcelRequire("5cVVz")).default);
$parcel$export(module.exports, "reject", () => (parcelRequire("bKl8v")).default);
$parcel$export(module.exports, "every", () => (parcelRequire("2E2ms")).default);
$parcel$export(module.exports, "all", () => (parcelRequire("2E2ms")).default);
$parcel$export(module.exports, "some", () => (parcelRequire("2HilC")).default);
$parcel$export(module.exports, "any", () => (parcelRequire("2HilC")).default);
$parcel$export(module.exports, "contains", () => (parcelRequire("6aulQ")).default);
$parcel$export(module.exports, "includes", () => (parcelRequire("6aulQ")).default);
$parcel$export(module.exports, "include", () => (parcelRequire("6aulQ")).default);
$parcel$export(module.exports, "invoke", () => (parcelRequire("2kSPh")).default);
$parcel$export(module.exports, "pluck", () => (parcelRequire("8E7vk")).default);
$parcel$export(module.exports, "where", () => (parcelRequire("6mhjE")).default);
$parcel$export(module.exports, "max", () => (parcelRequire("kM5J8")).default);
$parcel$export(module.exports, "min", () => (parcelRequire("l0v28")).default);
$parcel$export(module.exports, "shuffle", () => (parcelRequire("1A2nV")).default);
$parcel$export(module.exports, "sample", () => (parcelRequire("02fY3")).default);
$parcel$export(module.exports, "sortBy", () => (parcelRequire("a9AIt")).default);
$parcel$export(module.exports, "groupBy", () => (parcelRequire("lBlZC")).default);
$parcel$export(module.exports, "indexBy", () => (parcelRequire("eNjka")).default);
$parcel$export(module.exports, "countBy", () => (parcelRequire("buft0")).default);
$parcel$export(module.exports, "partition", () => (parcelRequire("2q59Q")).default);
$parcel$export(module.exports, "toArray", () => (parcelRequire("f3hnQ")).default);
$parcel$export(module.exports, "size", () => (parcelRequire("gEqND")).default);
$parcel$export(module.exports, "pick", () => (parcelRequire("4FUqN")).default);
$parcel$export(module.exports, "omit", () => (parcelRequire("dmvIT")).default);
$parcel$export(module.exports, "first", () => (parcelRequire("5Y2Ih")).default);
$parcel$export(module.exports, "head", () => (parcelRequire("5Y2Ih")).default);
$parcel$export(module.exports, "take", () => (parcelRequire("5Y2Ih")).default);
$parcel$export(module.exports, "initial", () => (parcelRequire("hVNTQ")).default);
$parcel$export(module.exports, "last", () => (parcelRequire("87PtR")).default);
$parcel$export(module.exports, "rest", () => (parcelRequire("6rmcH")).default);
$parcel$export(module.exports, "tail", () => (parcelRequire("6rmcH")).default);
$parcel$export(module.exports, "drop", () => (parcelRequire("6rmcH")).default);
$parcel$export(module.exports, "compact", () => (parcelRequire("8dcbb")).default);
$parcel$export(module.exports, "flatten", () => (parcelRequire("32O62")).default);
$parcel$export(module.exports, "without", () => (parcelRequire("hZxEx")).default);
$parcel$export(module.exports, "uniq", () => (parcelRequire("kFtOh")).default);
$parcel$export(module.exports, "unique", () => (parcelRequire("kFtOh")).default);
$parcel$export(module.exports, "union", () => (parcelRequire("6AqJp")).default);
$parcel$export(module.exports, "intersection", () => (parcelRequire("8ABEg")).default);
$parcel$export(module.exports, "difference", () => (parcelRequire("kxlHx")).default);
$parcel$export(module.exports, "unzip", () => (parcelRequire("jSqR4")).default);
$parcel$export(module.exports, "transpose", () => (parcelRequire("jSqR4")).default);
$parcel$export(module.exports, "zip", () => (parcelRequire("lOcEr")).default);
$parcel$export(module.exports, "object", () => (parcelRequire("dgKNP")).default);
$parcel$export(module.exports, "range", () => (parcelRequire("9AMld")).default);
$parcel$export(module.exports, "chunk", () => (parcelRequire("9lix7")).default);
$parcel$export(module.exports, "mixin", () => (parcelRequire("eVoGU")).default);
$parcel$export(module.exports, "default", () => (parcelRequire("dNu6m")).default);
// Named Exports
// =============
//     Underscore.js 1.13.7
//     https://underscorejs.org
//     (c) 2009-2024 Jeremy Ashkenas, Julian Gonggrijp, and DocumentCloud and Investigative Reporters & Editors
//     Underscore may be freely distributed under the MIT license.
// Baseline setup.

var $3TBJw = parcelRequire("3TBJw");

var $0bHlN = parcelRequire("0bHlN");

var $9sPg0 = parcelRequire("9sPg0");

var $dL3gl = parcelRequire("dL3gl");

var $189H9 = parcelRequire("189H9");

var $7aTMn = parcelRequire("7aTMn");

var $hQKxy = parcelRequire("hQKxy");

var $h0gl0 = parcelRequire("h0gl0");

var $bYhQz = parcelRequire("bYhQz");

var $3Z4XQ = parcelRequire("3Z4XQ");

var $4NPjY = parcelRequire("4NPjY");

var $fcbuE = parcelRequire("fcbuE");

var $5lYxy = parcelRequire("5lYxy");

var $1ydks = parcelRequire("1ydks");

var $3rRtm = parcelRequire("3rRtm");

var $lsdAl = parcelRequire("lsdAl");

var $kkIYY = parcelRequire("kkIYY");

var $eiwQq = parcelRequire("eiwQq");

var $j7D23 = parcelRequire("j7D23");

var $7Mch0 = parcelRequire("7Mch0");

var $cp06X = parcelRequire("cp06X");

var $awgrO = parcelRequire("awgrO");

var $4Kv25 = parcelRequire("4Kv25");

var $iwEMT = parcelRequire("iwEMT");

var $1tnu9 = parcelRequire("1tnu9");

var $4scqY = parcelRequire("4scqY");

var $kiYQK = parcelRequire("kiYQK");

var $jZ2st = parcelRequire("jZ2st");

var $9BELh = parcelRequire("9BELh");

var $ac7Ik = parcelRequire("ac7Ik");

var $keF5g = parcelRequire("keF5g");

var $8XqbY = parcelRequire("8XqbY");

var $g10pM = parcelRequire("g10pM");

var $aROXJ = parcelRequire("aROXJ");

var $hDkYR = parcelRequire("hDkYR");

var $kWUGD = parcelRequire("kWUGD");

var $cxWnu = parcelRequire("cxWnu");

var $gfsFT = parcelRequire("gfsFT");

var $eNx2q = parcelRequire("eNx2q");

var $5Nqvc = parcelRequire("5Nqvc");

var $b1RaH = parcelRequire("b1RaH");

var $6QeN9 = parcelRequire("6QeN9");

var $4DYUU = parcelRequire("4DYUU");

var $4wz3f = parcelRequire("4wz3f");

var $cB7r5 = parcelRequire("cB7r5");

var $k7qMd = parcelRequire("k7qMd");

var $1nsRK = parcelRequire("1nsRK");

var $gdAxf = parcelRequire("gdAxf");

var $6nuBV = parcelRequire("6nuBV");

var $ifjsZ = parcelRequire("ifjsZ");

var $cHHN7 = parcelRequire("cHHN7");

var $lrHzN = parcelRequire("lrHzN");

var $lVpZ1 = parcelRequire("lVpZ1");

var $3AbbN = parcelRequire("3AbbN");

var $d5KHs = parcelRequire("d5KHs");

var $ar7Gu = parcelRequire("ar7Gu");

var $ajLBg = parcelRequire("ajLBg");

var $jN6Ly = parcelRequire("jN6Ly");

var $5xNgK = parcelRequire("5xNgK");

var $FCdjz = parcelRequire("FCdjz");

var $4N9JI = parcelRequire("4N9JI");

var $2fm2D = parcelRequire("2fm2D");

var $dlMqS = parcelRequire("dlMqS");

var $htAB1 = parcelRequire("htAB1");

var $5T8r4 = parcelRequire("5T8r4");

var $5PD3T = parcelRequire("5PD3T");

var $WOaIJ = parcelRequire("WOaIJ");

var $gzKqI = parcelRequire("gzKqI");

var $iNzni = parcelRequire("iNzni");

var $OfUFq = parcelRequire("OfUFq");

var $6DjdH = parcelRequire("6DjdH");

var $dEpOJ = parcelRequire("dEpOJ");

var $128uF = parcelRequire("128uF");

var $4FCxR = parcelRequire("4FCxR");

var $bdw8x = parcelRequire("bdw8x");

var $arT8z = parcelRequire("arT8z");

var $ciFS5 = parcelRequire("ciFS5");

var $53vMY = parcelRequire("53vMY");

var $wTUFC = parcelRequire("wTUFC");

var $aacCi = parcelRequire("aacCi");

var $64pcf = parcelRequire("64pcf");

var $e3veT = parcelRequire("e3veT");

var $kXziU = parcelRequire("kXziU");

var $fVQTG = parcelRequire("fVQTG");

var $h6JIr = parcelRequire("h6JIr");

var $lDhwV = parcelRequire("lDhwV");

var $8Wigf = parcelRequire("8Wigf");

var $5cVVz = parcelRequire("5cVVz");

var $bKl8v = parcelRequire("bKl8v");

var $2E2ms = parcelRequire("2E2ms");

var $2HilC = parcelRequire("2HilC");

var $6aulQ = parcelRequire("6aulQ");

var $2kSPh = parcelRequire("2kSPh");

var $8E7vk = parcelRequire("8E7vk");

var $6mhjE = parcelRequire("6mhjE");

var $kM5J8 = parcelRequire("kM5J8");

var $l0v28 = parcelRequire("l0v28");

var $1A2nV = parcelRequire("1A2nV");

var $02fY3 = parcelRequire("02fY3");

var $a9AIt = parcelRequire("a9AIt");

var $lBlZC = parcelRequire("lBlZC");

var $eNjka = parcelRequire("eNjka");

var $buft0 = parcelRequire("buft0");

var $2q59Q = parcelRequire("2q59Q");

var $f3hnQ = parcelRequire("f3hnQ");

var $gEqND = parcelRequire("gEqND");

var $4FUqN = parcelRequire("4FUqN");

var $dmvIT = parcelRequire("dmvIT");

var $5Y2Ih = parcelRequire("5Y2Ih");

var $hVNTQ = parcelRequire("hVNTQ");

var $87PtR = parcelRequire("87PtR");

var $6rmcH = parcelRequire("6rmcH");

var $8dcbb = parcelRequire("8dcbb");

var $32O62 = parcelRequire("32O62");

var $hZxEx = parcelRequire("hZxEx");

var $kFtOh = parcelRequire("kFtOh");

var $6AqJp = parcelRequire("6AqJp");

var $8ABEg = parcelRequire("8ABEg");

var $kxlHx = parcelRequire("kxlHx");

var $jSqR4 = parcelRequire("jSqR4");

var $lOcEr = parcelRequire("lOcEr");

var $dgKNP = parcelRequire("dgKNP");

var $9AMld = parcelRequire("9AMld");

var $9lix7 = parcelRequire("9lix7");

var $eVoGU = parcelRequire("eVoGU");

var $dNu6m = parcelRequire("dNu6m");

});
parcelRegister("3TBJw", function(module, exports) {

$parcel$export(module.exports, "VERSION", () => $2d63c72f11d36dd8$export$a4ad2735b021c132);
$parcel$export(module.exports, "root", () => $2d63c72f11d36dd8$export$e8e78c978b129247);
$parcel$export(module.exports, "ArrayProto", () => $2d63c72f11d36dd8$export$aabeece9448a227a);
$parcel$export(module.exports, "ObjProto", () => $2d63c72f11d36dd8$export$e77bb59b5e655b3d);
$parcel$export(module.exports, "SymbolProto", () => $2d63c72f11d36dd8$export$e229dcb397ceea81);
$parcel$export(module.exports, "push", () => $2d63c72f11d36dd8$export$4cbf152802aa238);
$parcel$export(module.exports, "slice", () => $2d63c72f11d36dd8$export$58adb3bec8346d0f);
$parcel$export(module.exports, "toString", () => $2d63c72f11d36dd8$export$f84e8e69fd4488a5);
$parcel$export(module.exports, "hasOwnProperty", () => $2d63c72f11d36dd8$export$5a15a386532a5ea4);
$parcel$export(module.exports, "supportsArrayBuffer", () => $2d63c72f11d36dd8$export$20eaf89d899ede58);
$parcel$export(module.exports, "supportsDataView", () => $2d63c72f11d36dd8$export$a2e478ad34dac33e);
$parcel$export(module.exports, "nativeIsArray", () => $2d63c72f11d36dd8$export$552cf9b635cef256);
$parcel$export(module.exports, "nativeKeys", () => $2d63c72f11d36dd8$export$e676cf06d7fd2114);
$parcel$export(module.exports, "nativeCreate", () => $2d63c72f11d36dd8$export$5b53dc95b548c58c);
$parcel$export(module.exports, "nativeIsView", () => $2d63c72f11d36dd8$export$35fc70fc5e80d5a7);
$parcel$export(module.exports, "_isNaN", () => $2d63c72f11d36dd8$export$a739ba33a90be0a1);
$parcel$export(module.exports, "_isFinite", () => $2d63c72f11d36dd8$export$8b48b92f6c9d5ad);
$parcel$export(module.exports, "hasEnumBug", () => $2d63c72f11d36dd8$export$7dcea4d27900b116);
$parcel$export(module.exports, "nonEnumerableProps", () => $2d63c72f11d36dd8$export$f8fa596d5e31cb19);
$parcel$export(module.exports, "MAX_ARRAY_INDEX", () => $2d63c72f11d36dd8$export$63b3abc5cd28bc48);
// Current version.
var $2d63c72f11d36dd8$export$a4ad2735b021c132 = "1.13.7";
var $2d63c72f11d36dd8$export$e8e78c978b129247 = typeof self == "object" && self.self === self && self || typeof $parcel$global == "object" && $parcel$global.global === $parcel$global && $parcel$global || Function("return this")() || {};
var $2d63c72f11d36dd8$export$aabeece9448a227a = Array.prototype, $2d63c72f11d36dd8$export$e77bb59b5e655b3d = Object.prototype;
var $2d63c72f11d36dd8$export$e229dcb397ceea81 = typeof Symbol !== "undefined" ? Symbol.prototype : null;
var $2d63c72f11d36dd8$export$4cbf152802aa238 = $2d63c72f11d36dd8$export$aabeece9448a227a.push, $2d63c72f11d36dd8$export$58adb3bec8346d0f = $2d63c72f11d36dd8$export$aabeece9448a227a.slice, $2d63c72f11d36dd8$export$f84e8e69fd4488a5 = $2d63c72f11d36dd8$export$e77bb59b5e655b3d.toString, $2d63c72f11d36dd8$export$5a15a386532a5ea4 = $2d63c72f11d36dd8$export$e77bb59b5e655b3d.hasOwnProperty;
var $2d63c72f11d36dd8$export$20eaf89d899ede58 = typeof ArrayBuffer !== "undefined", $2d63c72f11d36dd8$export$a2e478ad34dac33e = typeof DataView !== "undefined";
var $2d63c72f11d36dd8$export$552cf9b635cef256 = Array.isArray, $2d63c72f11d36dd8$export$e676cf06d7fd2114 = Object.keys, $2d63c72f11d36dd8$export$5b53dc95b548c58c = Object.create, $2d63c72f11d36dd8$export$35fc70fc5e80d5a7 = $2d63c72f11d36dd8$export$20eaf89d899ede58 && ArrayBuffer.isView;
var $2d63c72f11d36dd8$export$a739ba33a90be0a1 = isNaN, $2d63c72f11d36dd8$export$8b48b92f6c9d5ad = isFinite;
var $2d63c72f11d36dd8$export$7dcea4d27900b116 = !({
    toString: null
}).propertyIsEnumerable("toString");
var $2d63c72f11d36dd8$export$f8fa596d5e31cb19 = [
    "valueOf",
    "isPrototypeOf",
    "toString",
    "propertyIsEnumerable",
    "hasOwnProperty",
    "toLocaleString"
];
var $2d63c72f11d36dd8$export$63b3abc5cd28bc48 = Math.pow(2, 53) - 1;

});

parcelRegister("0bHlN", function(module, exports) {

$parcel$export(module.exports, "default", () => $00091338bb34561a$export$2e2bcd8739ae039);
// Some functions take a variable number of arguments, or a few expected
// arguments at the beginning and then a variable number of values to operate
// on. This helper accumulates all remaining arguments past the function’s
// argument length (or an explicit `startIndex`), into an array that becomes
// the last argument. Similar to ES6’s "rest parameter".
function $00091338bb34561a$export$2e2bcd8739ae039(func, startIndex) {
    startIndex = startIndex == null ? func.length - 1 : +startIndex;
    return function() {
        var length = Math.max(arguments.length - startIndex, 0), rest = Array(length), index = 0;
        for(; index < length; index++)rest[index] = arguments[index + startIndex];
        switch(startIndex){
            case 0:
                return func.call(this, rest);
            case 1:
                return func.call(this, arguments[0], rest);
            case 2:
                return func.call(this, arguments[0], arguments[1], rest);
        }
        var args = Array(startIndex + 1);
        for(index = 0; index < startIndex; index++)args[index] = arguments[index];
        args[startIndex] = rest;
        return func.apply(this, args);
    };
}

});

parcelRegister("9sPg0", function(module, exports) {

$parcel$export(module.exports, "default", () => $6e3e7d3004a0bd6f$export$2e2bcd8739ae039);
// Is a given variable an object?
function $6e3e7d3004a0bd6f$export$2e2bcd8739ae039(obj) {
    var type = typeof obj;
    return type === "function" || type === "object" && !!obj;
}

});

parcelRegister("dL3gl", function(module, exports) {

$parcel$export(module.exports, "default", () => $a042320c2c15e613$export$2e2bcd8739ae039);
// Is a given value equal to null?
function $a042320c2c15e613$export$2e2bcd8739ae039(obj) {
    return obj === null;
}

});

parcelRegister("189H9", function(module, exports) {

$parcel$export(module.exports, "default", () => $0d2e0eff9b6e26c2$export$2e2bcd8739ae039);
// Is a given variable undefined?
function $0d2e0eff9b6e26c2$export$2e2bcd8739ae039(obj) {
    return obj === void 0;
}

});

parcelRegister("7aTMn", function(module, exports) {

$parcel$export(module.exports, "default", () => $5394bc2f01152bbc$export$2e2bcd8739ae039);

var $3TBJw = parcelRequire("3TBJw");
function $5394bc2f01152bbc$export$2e2bcd8739ae039(obj) {
    return obj === true || obj === false || (0, $3TBJw.toString).call(obj) === "[object Boolean]";
}

});

parcelRegister("hQKxy", function(module, exports) {

$parcel$export(module.exports, "default", () => $cfeb64eb4197347f$export$2e2bcd8739ae039);
// Is a given value a DOM element?
function $cfeb64eb4197347f$export$2e2bcd8739ae039(obj) {
    return !!(obj && obj.nodeType === 1);
}

});

parcelRegister("h0gl0", function(module, exports) {

$parcel$export(module.exports, "default", () => $c60f1c14f06acd60$export$2e2bcd8739ae039);

var $l4EOE = parcelRequire("l4EOE");
var $c60f1c14f06acd60$export$2e2bcd8739ae039 = (0, $l4EOE.default)("String");

});
parcelRegister("l4EOE", function(module, exports) {

$parcel$export(module.exports, "default", () => $f579a1e3e166bc6c$export$2e2bcd8739ae039);

var $3TBJw = parcelRequire("3TBJw");
function $f579a1e3e166bc6c$export$2e2bcd8739ae039(name) {
    var tag = "[object " + name + "]";
    return function(obj) {
        return (0, $3TBJw.toString).call(obj) === tag;
    };
}

});


parcelRegister("bYhQz", function(module, exports) {

$parcel$export(module.exports, "default", () => $8b732457fbe276dc$export$2e2bcd8739ae039);

var $l4EOE = parcelRequire("l4EOE");
var $8b732457fbe276dc$export$2e2bcd8739ae039 = (0, $l4EOE.default)("Number");

});

parcelRegister("3Z4XQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $2e6aeb67ee40470b$export$2e2bcd8739ae039);

var $l4EOE = parcelRequire("l4EOE");
var $2e6aeb67ee40470b$export$2e2bcd8739ae039 = (0, $l4EOE.default)("Date");

});

parcelRegister("4NPjY", function(module, exports) {

$parcel$export(module.exports, "default", () => $37f38c538158829c$export$2e2bcd8739ae039);

var $l4EOE = parcelRequire("l4EOE");
var $37f38c538158829c$export$2e2bcd8739ae039 = (0, $l4EOE.default)("RegExp");

});

parcelRegister("fcbuE", function(module, exports) {

$parcel$export(module.exports, "default", () => $b100e45f427f9ef6$export$2e2bcd8739ae039);

var $l4EOE = parcelRequire("l4EOE");
var $b100e45f427f9ef6$export$2e2bcd8739ae039 = (0, $l4EOE.default)("Error");

});

parcelRegister("5lYxy", function(module, exports) {

$parcel$export(module.exports, "default", () => $3e5ddff5af045f50$export$2e2bcd8739ae039);

var $l4EOE = parcelRequire("l4EOE");
var $3e5ddff5af045f50$export$2e2bcd8739ae039 = (0, $l4EOE.default)("Symbol");

});

parcelRegister("1ydks", function(module, exports) {

$parcel$export(module.exports, "default", () => $12134e4967df2b87$export$2e2bcd8739ae039);

var $l4EOE = parcelRequire("l4EOE");
var $12134e4967df2b87$export$2e2bcd8739ae039 = (0, $l4EOE.default)("ArrayBuffer");

});

parcelRegister("3rRtm", function(module, exports) {

$parcel$export(module.exports, "default", () => $282d5f466b13837a$export$2e2bcd8739ae039);

var $l4EOE = parcelRequire("l4EOE");

var $kkIYY = parcelRequire("kkIYY");

var $1ydks = parcelRequire("1ydks");

var $ahTSr = parcelRequire("ahTSr");
var $282d5f466b13837a$var$isDataView = (0, $l4EOE.default)("DataView");
// In IE 10 - Edge 13, we need a different heuristic
// to determine whether an object is a `DataView`.
// Also, in cases where the native `DataView` is
// overridden we can't rely on the tag itself.
function $282d5f466b13837a$var$alternateIsDataView(obj) {
    return obj != null && (0, $kkIYY.default)(obj.getInt8) && (0, $1ydks.default)(obj.buffer);
}
var $282d5f466b13837a$export$2e2bcd8739ae039 = (0, $ahTSr.hasDataViewBug) ? $282d5f466b13837a$var$alternateIsDataView : $282d5f466b13837a$var$isDataView;

});
parcelRegister("kkIYY", function(module, exports) {

$parcel$export(module.exports, "default", () => $ecd89179b736cddb$export$2e2bcd8739ae039);

var $l4EOE = parcelRequire("l4EOE");

var $3TBJw = parcelRequire("3TBJw");
var $ecd89179b736cddb$var$isFunction = (0, $l4EOE.default)("Function");
// Optimize `isFunction` if appropriate. Work around some `typeof` bugs in old
// v8, IE 11 (#1621), Safari 8 (#1929), and PhantomJS (#2236).
var $ecd89179b736cddb$var$nodelist = (0, $3TBJw.root).document && (0, $3TBJw.root).document.childNodes;
if (typeof /./ != "function" && typeof Int8Array != "object" && typeof $ecd89179b736cddb$var$nodelist != "function") $ecd89179b736cddb$var$isFunction = function(obj) {
    return typeof obj == "function" || false;
};
var $ecd89179b736cddb$export$2e2bcd8739ae039 = $ecd89179b736cddb$var$isFunction;

});

parcelRegister("ahTSr", function(module, exports) {

$parcel$export(module.exports, "hasDataViewBug", () => $77d6d5ed2b916838$export$29b9ed4126fa90ab);
$parcel$export(module.exports, "isIE11", () => $77d6d5ed2b916838$export$f7bad96d83325a34);

var $3TBJw = parcelRequire("3TBJw");

var $esBwZ = parcelRequire("esBwZ");
var $77d6d5ed2b916838$export$29b9ed4126fa90ab = (0, $3TBJw.supportsDataView) && (!/\[native code\]/.test(String(DataView)) || (0, $esBwZ.default)(new DataView(new ArrayBuffer(8)))), $77d6d5ed2b916838$export$f7bad96d83325a34 = typeof Map !== "undefined" && (0, $esBwZ.default)(new Map);

});
parcelRegister("esBwZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $a870cb15b080e803$export$2e2bcd8739ae039);

var $l4EOE = parcelRequire("l4EOE");
var $a870cb15b080e803$export$2e2bcd8739ae039 = (0, $l4EOE.default)("Object");

});



parcelRegister("lsdAl", function(module, exports) {

$parcel$export(module.exports, "default", () => $f9e6c041730fdb31$export$2e2bcd8739ae039);

var $3TBJw = parcelRequire("3TBJw");

var $l4EOE = parcelRequire("l4EOE");
var // Is a given value an array?
// Delegates to ECMA5's native `Array.isArray`.
$f9e6c041730fdb31$export$2e2bcd8739ae039 = (0, $3TBJw.nativeIsArray) || (0, $l4EOE.default)("Array");

});

parcelRegister("eiwQq", function(module, exports) {

$parcel$export(module.exports, "default", () => $a68c3966b61ff959$export$2e2bcd8739ae039);

var $l4EOE = parcelRequire("l4EOE");

var $4YlR9 = parcelRequire("4YlR9");
var $a68c3966b61ff959$var$isArguments = (0, $l4EOE.default)("Arguments");
// Define a fallback version of the method in browsers (ahem, IE < 9), where
// there isn't any inspectable "Arguments" type.
(function() {
    if (!$a68c3966b61ff959$var$isArguments(arguments)) $a68c3966b61ff959$var$isArguments = function(obj) {
        return (0, $4YlR9.default)(obj, "callee");
    };
})();
var $a68c3966b61ff959$export$2e2bcd8739ae039 = $a68c3966b61ff959$var$isArguments;

});
parcelRegister("4YlR9", function(module, exports) {

$parcel$export(module.exports, "default", () => $39edb832e07faa22$export$2e2bcd8739ae039);

var $3TBJw = parcelRequire("3TBJw");
function $39edb832e07faa22$export$2e2bcd8739ae039(obj, key) {
    return obj != null && (0, $3TBJw.hasOwnProperty).call(obj, key);
}

});


parcelRegister("j7D23", function(module, exports) {

$parcel$export(module.exports, "default", () => $debcf2bd172293e4$export$2e2bcd8739ae039);

var $3TBJw = parcelRequire("3TBJw");

var $5lYxy = parcelRequire("5lYxy");
function $debcf2bd172293e4$export$2e2bcd8739ae039(obj) {
    return !(0, $5lYxy.default)(obj) && (0, $3TBJw._isFinite)(obj) && !isNaN(parseFloat(obj));
}

});

parcelRegister("7Mch0", function(module, exports) {

$parcel$export(module.exports, "default", () => $5a968955ec4f3425$export$2e2bcd8739ae039);

var $3TBJw = parcelRequire("3TBJw");

var $bYhQz = parcelRequire("bYhQz");
function $5a968955ec4f3425$export$2e2bcd8739ae039(obj) {
    return (0, $bYhQz.default)(obj) && (0, $3TBJw._isNaN)(obj);
}

});

parcelRegister("cp06X", function(module, exports) {

$parcel$export(module.exports, "default", () => $9077e7ed52c125e5$export$2e2bcd8739ae039);

var $3TBJw = parcelRequire("3TBJw");

var $3rRtm = parcelRequire("3rRtm");

var $cB7r5 = parcelRequire("cB7r5");

var $faI7t = parcelRequire("faI7t");
// Is a given value a typed array?
var $9077e7ed52c125e5$var$typedArrayPattern = /\[object ((I|Ui)nt(8|16|32)|Float(32|64)|Uint8Clamped|Big(I|Ui)nt64)Array\]/;
function $9077e7ed52c125e5$var$isTypedArray(obj) {
    // `ArrayBuffer.isView` is the most future-proof, so use it when available.
    // Otherwise, fall back on the above regular expression.
    return (0, $3TBJw.nativeIsView) ? (0, $3TBJw.nativeIsView)(obj) && !(0, $3rRtm.default)(obj) : (0, $faI7t.default)(obj) && $9077e7ed52c125e5$var$typedArrayPattern.test((0, $3TBJw.toString).call(obj));
}
var $9077e7ed52c125e5$export$2e2bcd8739ae039 = (0, $3TBJw.supportsArrayBuffer) ? $9077e7ed52c125e5$var$isTypedArray : (0, $cB7r5.default)(false);

});
parcelRegister("cB7r5", function(module, exports) {

$parcel$export(module.exports, "default", () => $92beb55e5504ffbe$export$2e2bcd8739ae039);
// Predicate-generating function. Often useful outside of Underscore.
function $92beb55e5504ffbe$export$2e2bcd8739ae039(value) {
    return function() {
        return value;
    };
}

});

parcelRegister("faI7t", function(module, exports) {

$parcel$export(module.exports, "default", () => $b0ba036a9e1182f7$export$2e2bcd8739ae039);

var $8ozKz = parcelRequire("8ozKz");

var $cEcCS = parcelRequire("cEcCS");
var // Internal helper to determine whether we should spend extensive checks against
// `ArrayBuffer` et al.
$b0ba036a9e1182f7$export$2e2bcd8739ae039 = (0, $8ozKz.default)((0, $cEcCS.default));

});
parcelRegister("8ozKz", function(module, exports) {

$parcel$export(module.exports, "default", () => $61cc4bd77dea34f8$export$2e2bcd8739ae039);

var $3TBJw = parcelRequire("3TBJw");
function $61cc4bd77dea34f8$export$2e2bcd8739ae039(getSizeProperty) {
    return function(collection) {
        var sizeProperty = getSizeProperty(collection);
        return typeof sizeProperty == "number" && sizeProperty >= 0 && sizeProperty <= (0, $3TBJw.MAX_ARRAY_INDEX);
    };
}

});

parcelRegister("cEcCS", function(module, exports) {

$parcel$export(module.exports, "default", () => $935303bff590dfe3$export$2e2bcd8739ae039);

var $354h3 = parcelRequire("354h3");
var // Internal helper to obtain the `byteLength` property of an object.
$935303bff590dfe3$export$2e2bcd8739ae039 = (0, $354h3.default)("byteLength");

});
parcelRegister("354h3", function(module, exports) {

$parcel$export(module.exports, "default", () => $23e52771e26c0d29$export$2e2bcd8739ae039);
// Internal helper to generate a function to obtain property `key` from `obj`.
function $23e52771e26c0d29$export$2e2bcd8739ae039(key) {
    return function(obj) {
        return obj == null ? void 0 : obj[key];
    };
}

});




parcelRegister("awgrO", function(module, exports) {

$parcel$export(module.exports, "default", () => $7a89a6b6e948e772$export$2e2bcd8739ae039);

var $iER8D = parcelRequire("iER8D");

var $lsdAl = parcelRequire("lsdAl");

var $h0gl0 = parcelRequire("h0gl0");

var $eiwQq = parcelRequire("eiwQq");

var $9BELh = parcelRequire("9BELh");
function $7a89a6b6e948e772$export$2e2bcd8739ae039(obj) {
    if (obj == null) return true;
    // Skip the more expensive `toString`-based type checks if `obj` has no
    // `.length`.
    var length = (0, $iER8D.default)(obj);
    if (typeof length == "number" && ((0, $lsdAl.default)(obj) || (0, $h0gl0.default)(obj) || (0, $eiwQq.default)(obj))) return length === 0;
    return (0, $iER8D.default)((0, $9BELh.default)(obj)) === 0;
}

});
parcelRegister("iER8D", function(module, exports) {

$parcel$export(module.exports, "default", () => $d9552e9372db9187$export$2e2bcd8739ae039);

var $354h3 = parcelRequire("354h3");
var // Internal helper to obtain the `length` property of an object.
$d9552e9372db9187$export$2e2bcd8739ae039 = (0, $354h3.default)("length");

});

parcelRegister("9BELh", function(module, exports) {

$parcel$export(module.exports, "default", () => $6fe7302bdcad38ac$export$2e2bcd8739ae039);

var $9sPg0 = parcelRequire("9sPg0");

var $3TBJw = parcelRequire("3TBJw");

var $4YlR9 = parcelRequire("4YlR9");

var $dlLwf = parcelRequire("dlLwf");
function $6fe7302bdcad38ac$export$2e2bcd8739ae039(obj) {
    if (!(0, $9sPg0.default)(obj)) return [];
    if (0, $3TBJw.nativeKeys) return (0, $3TBJw.nativeKeys)(obj);
    var keys = [];
    for(var key in obj)if ((0, $4YlR9.default)(obj, key)) keys.push(key);
    // Ahem, IE < 9.
    if (0, $3TBJw.hasEnumBug) (0, $dlLwf.default)(obj, keys);
    return keys;
}

});
parcelRegister("dlLwf", function(module, exports) {

$parcel$export(module.exports, "default", () => $9b8218d47529a1ac$export$2e2bcd8739ae039);

var $3TBJw = parcelRequire("3TBJw");

var $kkIYY = parcelRequire("kkIYY");

var $4YlR9 = parcelRequire("4YlR9");
// Internal helper to create a simple lookup structure.
// `collectNonEnumProps` used to depend on `_.contains`, but this led to
// circular imports. `emulatedSet` is a one-off solution that only works for
// arrays of strings.
function $9b8218d47529a1ac$var$emulatedSet(keys) {
    var hash = {};
    for(var l = keys.length, i = 0; i < l; ++i)hash[keys[i]] = true;
    return {
        contains: function(key) {
            return hash[key] === true;
        },
        push: function(key) {
            hash[key] = true;
            return keys.push(key);
        }
    };
}
function $9b8218d47529a1ac$export$2e2bcd8739ae039(obj, keys) {
    keys = $9b8218d47529a1ac$var$emulatedSet(keys);
    var nonEnumIdx = (0, $3TBJw.nonEnumerableProps).length;
    var constructor = obj.constructor;
    var proto = (0, $kkIYY.default)(constructor) && constructor.prototype || (0, $3TBJw.ObjProto);
    // Constructor is a special case.
    var prop = "constructor";
    if ((0, $4YlR9.default)(obj, prop) && !keys.contains(prop)) keys.push(prop);
    while(nonEnumIdx--){
        prop = (0, $3TBJw.nonEnumerableProps)[nonEnumIdx];
        if (prop in obj && obj[prop] !== proto[prop] && !keys.contains(prop)) keys.push(prop);
    }
}

});



parcelRegister("4Kv25", function(module, exports) {

$parcel$export(module.exports, "default", () => $375387b8b59ffb29$export$2e2bcd8739ae039);

var $9BELh = parcelRequire("9BELh");
function $375387b8b59ffb29$export$2e2bcd8739ae039(object, attrs) {
    var _keys = (0, $9BELh.default)(attrs), length = _keys.length;
    if (object == null) return !length;
    var obj = Object(object);
    for(var i = 0; i < length; i++){
        var key = _keys[i];
        if (attrs[key] !== obj[key] || !(key in obj)) return false;
    }
    return true;
}

});

parcelRegister("iwEMT", function(module, exports) {

$parcel$export(module.exports, "default", () => $d7cadaba8ed5bf16$export$2e2bcd8739ae039);

var $6ZSi9 = parcelRequire("6ZSi9");

var $3TBJw = parcelRequire("3TBJw");

var $cEcCS = parcelRequire("cEcCS");

var $cp06X = parcelRequire("cp06X");

var $kkIYY = parcelRequire("kkIYY");

var $ahTSr = parcelRequire("ahTSr");

var $3rRtm = parcelRequire("3rRtm");

var $9BELh = parcelRequire("9BELh");

var $4YlR9 = parcelRequire("4YlR9");

var $5gaNV = parcelRequire("5gaNV");
// We use this string twice, so give it a name for minification.
var $d7cadaba8ed5bf16$var$tagDataView = "[object DataView]";
// Internal recursive comparison function for `_.isEqual`.
function $d7cadaba8ed5bf16$var$eq(a, b, aStack, bStack) {
    // Identical objects are equal. `0 === -0`, but they aren't identical.
    // See the [Harmony `egal` proposal](https://wiki.ecmascript.org/doku.php?id=harmony:egal).
    if (a === b) return a !== 0 || 1 / a === 1 / b;
    // `null` or `undefined` only equal to itself (strict comparison).
    if (a == null || b == null) return false;
    // `NaN`s are equivalent, but non-reflexive.
    if (a !== a) return b !== b;
    // Exhaust primitive checks
    var type = typeof a;
    if (type !== "function" && type !== "object" && typeof b != "object") return false;
    return $d7cadaba8ed5bf16$var$deepEq(a, b, aStack, bStack);
}
// Internal recursive comparison function for `_.isEqual`.
function $d7cadaba8ed5bf16$var$deepEq(a, b, aStack, bStack) {
    // Unwrap any wrapped objects.
    if (a instanceof (0, $6ZSi9.default)) a = a._wrapped;
    if (b instanceof (0, $6ZSi9.default)) b = b._wrapped;
    // Compare `[[Class]]` names.
    var className = (0, $3TBJw.toString).call(a);
    if (className !== (0, $3TBJw.toString).call(b)) return false;
    // Work around a bug in IE 10 - Edge 13.
    if ((0, $ahTSr.hasDataViewBug) && className == "[object Object]" && (0, $3rRtm.default)(a)) {
        if (!(0, $3rRtm.default)(b)) return false;
        className = $d7cadaba8ed5bf16$var$tagDataView;
    }
    switch(className){
        // These types are compared by value.
        case "[object RegExp]":
        // RegExps are coerced to strings for comparison (Note: '' + /a/i === '/a/i')
        case "[object String]":
            // Primitives and their corresponding object wrappers are equivalent; thus, `"5"` is
            // equivalent to `new String("5")`.
            return "" + a === "" + b;
        case "[object Number]":
            // `NaN`s are equivalent, but non-reflexive.
            // Object(NaN) is equivalent to NaN.
            if (+a !== +a) return +b !== +b;
            // An `egal` comparison is performed for other numeric values.
            return +a === 0 ? 1 / +a === 1 / b : +a === +b;
        case "[object Date]":
        case "[object Boolean]":
            // Coerce dates and booleans to numeric primitive values. Dates are compared by their
            // millisecond representations. Note that invalid dates with millisecond representations
            // of `NaN` are not equivalent.
            return +a === +b;
        case "[object Symbol]":
            return (0, $3TBJw.SymbolProto).valueOf.call(a) === (0, $3TBJw.SymbolProto).valueOf.call(b);
        case "[object ArrayBuffer]":
        case $d7cadaba8ed5bf16$var$tagDataView:
            // Coerce to typed array so we can fall through.
            return $d7cadaba8ed5bf16$var$deepEq((0, $5gaNV.default)(a), (0, $5gaNV.default)(b), aStack, bStack);
    }
    var areArrays = className === "[object Array]";
    if (!areArrays && (0, $cp06X.default)(a)) {
        var byteLength = (0, $cEcCS.default)(a);
        if (byteLength !== (0, $cEcCS.default)(b)) return false;
        if (a.buffer === b.buffer && a.byteOffset === b.byteOffset) return true;
        areArrays = true;
    }
    if (!areArrays) {
        if (typeof a != "object" || typeof b != "object") return false;
        // Objects with different constructors are not equivalent, but `Object`s or `Array`s
        // from different frames are.
        var aCtor = a.constructor, bCtor = b.constructor;
        if (aCtor !== bCtor && !((0, $kkIYY.default)(aCtor) && aCtor instanceof aCtor && (0, $kkIYY.default)(bCtor) && bCtor instanceof bCtor) && "constructor" in a && "constructor" in b) return false;
    }
    // Assume equality for cyclic structures. The algorithm for detecting cyclic
    // structures is adapted from ES 5.1 section 15.12.3, abstract operation `JO`.
    // Initializing stack of traversed objects.
    // It's done here since we only need them for objects and arrays comparison.
    aStack = aStack || [];
    bStack = bStack || [];
    var length = aStack.length;
    while(length--){
        // Linear search. Performance is inversely proportional to the number of
        // unique nested structures.
        if (aStack[length] === a) return bStack[length] === b;
    }
    // Add the first object to the stack of traversed objects.
    aStack.push(a);
    bStack.push(b);
    // Recursively compare objects and arrays.
    if (areArrays) {
        // Compare array lengths to determine if a deep comparison is necessary.
        length = a.length;
        if (length !== b.length) return false;
        // Deep compare the contents, ignoring non-numeric properties.
        while(length--){
            if (!$d7cadaba8ed5bf16$var$eq(a[length], b[length], aStack, bStack)) return false;
        }
    } else {
        // Deep compare objects.
        var _keys = (0, $9BELh.default)(a), key;
        length = _keys.length;
        // Ensure that both objects contain the same number of properties before comparing deep equality.
        if ((0, $9BELh.default)(b).length !== length) return false;
        while(length--){
            // Deep compare each member
            key = _keys[length];
            if (!((0, $4YlR9.default)(b, key) && $d7cadaba8ed5bf16$var$eq(a[key], b[key], aStack, bStack))) return false;
        }
    }
    // Remove the first object from the stack of traversed objects.
    aStack.pop();
    bStack.pop();
    return true;
}
function $d7cadaba8ed5bf16$export$2e2bcd8739ae039(a, b) {
    return $d7cadaba8ed5bf16$var$eq(a, b);
}

});
parcelRegister("6ZSi9", function(module, exports) {

$parcel$export(module.exports, "default", () => $51828dc883981eb1$export$2e2bcd8739ae039);

var $3TBJw = parcelRequire("3TBJw");
function $51828dc883981eb1$export$2e2bcd8739ae039(obj) {
    if (obj instanceof $51828dc883981eb1$export$2e2bcd8739ae039) return obj;
    if (!(this instanceof $51828dc883981eb1$export$2e2bcd8739ae039)) return new $51828dc883981eb1$export$2e2bcd8739ae039(obj);
    this._wrapped = obj;
}
$51828dc883981eb1$export$2e2bcd8739ae039.VERSION = (0, $3TBJw.VERSION);
// Extracts the result from a wrapped and chained object.
$51828dc883981eb1$export$2e2bcd8739ae039.prototype.value = function() {
    return this._wrapped;
};
// Provide unwrapping proxies for some methods used in engine operations
// such as arithmetic and JSON stringification.
$51828dc883981eb1$export$2e2bcd8739ae039.prototype.valueOf = $51828dc883981eb1$export$2e2bcd8739ae039.prototype.toJSON = $51828dc883981eb1$export$2e2bcd8739ae039.prototype.value;
$51828dc883981eb1$export$2e2bcd8739ae039.prototype.toString = function() {
    return String(this._wrapped);
};

});

parcelRegister("5gaNV", function(module, exports) {

$parcel$export(module.exports, "default", () => $3d46d3e4e4eb9906$export$2e2bcd8739ae039);

var $cEcCS = parcelRequire("cEcCS");
function $3d46d3e4e4eb9906$export$2e2bcd8739ae039(bufferSource) {
    return new Uint8Array(bufferSource.buffer || bufferSource, bufferSource.byteOffset || 0, (0, $cEcCS.default)(bufferSource));
}

});


parcelRegister("1tnu9", function(module, exports) {

$parcel$export(module.exports, "default", () => $112ab78c61fa9f88$export$2e2bcd8739ae039);

var $l4EOE = parcelRequire("l4EOE");

var $ahTSr = parcelRequire("ahTSr");

var $81UkW = parcelRequire("81UkW");
var $112ab78c61fa9f88$export$2e2bcd8739ae039 = (0, $ahTSr.isIE11) ? (0, $81UkW.ie11fingerprint)((0, $81UkW.mapMethods)) : (0, $l4EOE.default)("Map");

});
parcelRegister("81UkW", function(module, exports) {

$parcel$export(module.exports, "ie11fingerprint", () => $5d8a1e0d10a29a99$export$15230eca1f400e40);
$parcel$export(module.exports, "weakMapMethods", () => $5d8a1e0d10a29a99$export$2f74b890a72cf48);
$parcel$export(module.exports, "mapMethods", () => $5d8a1e0d10a29a99$export$de9acb94190bb764);
$parcel$export(module.exports, "setMethods", () => $5d8a1e0d10a29a99$export$60e14a5e2a057f78);

var $iER8D = parcelRequire("iER8D");

var $kkIYY = parcelRequire("kkIYY");

var $ac7Ik = parcelRequire("ac7Ik");
function $5d8a1e0d10a29a99$export$15230eca1f400e40(methods) {
    var length = (0, $iER8D.default)(methods);
    return function(obj) {
        if (obj == null) return false;
        // `Map`, `WeakMap` and `Set` have no enumerable keys.
        var keys = (0, $ac7Ik.default)(obj);
        if ((0, $iER8D.default)(keys)) return false;
        for(var i = 0; i < length; i++){
            if (!(0, $kkIYY.default)(obj[methods[i]])) return false;
        }
        // If we are testing against `WeakMap`, we need to ensure that
        // `obj` doesn't have a `forEach` method in order to distinguish
        // it from a regular `Map`.
        return methods !== $5d8a1e0d10a29a99$export$2f74b890a72cf48 || !(0, $kkIYY.default)(obj[$5d8a1e0d10a29a99$var$forEachName]);
    };
}
// In the interest of compact minification, we write
// each string in the fingerprints only once.
var $5d8a1e0d10a29a99$var$forEachName = "forEach", $5d8a1e0d10a29a99$var$hasName = "has", $5d8a1e0d10a29a99$var$commonInit = [
    "clear",
    "delete"
], $5d8a1e0d10a29a99$var$mapTail = [
    "get",
    $5d8a1e0d10a29a99$var$hasName,
    "set"
];
var $5d8a1e0d10a29a99$export$de9acb94190bb764 = $5d8a1e0d10a29a99$var$commonInit.concat($5d8a1e0d10a29a99$var$forEachName, $5d8a1e0d10a29a99$var$mapTail), $5d8a1e0d10a29a99$export$2f74b890a72cf48 = $5d8a1e0d10a29a99$var$commonInit.concat($5d8a1e0d10a29a99$var$mapTail), $5d8a1e0d10a29a99$export$60e14a5e2a057f78 = [
    "add"
].concat($5d8a1e0d10a29a99$var$commonInit, $5d8a1e0d10a29a99$var$forEachName, $5d8a1e0d10a29a99$var$hasName);

});
parcelRegister("ac7Ik", function(module, exports) {

$parcel$export(module.exports, "default", () => $76c102325be5f353$export$2e2bcd8739ae039);

var $9sPg0 = parcelRequire("9sPg0");

var $3TBJw = parcelRequire("3TBJw");

var $dlLwf = parcelRequire("dlLwf");
function $76c102325be5f353$export$2e2bcd8739ae039(obj) {
    if (!(0, $9sPg0.default)(obj)) return [];
    var keys = [];
    for(var key in obj)keys.push(key);
    // Ahem, IE < 9.
    if (0, $3TBJw.hasEnumBug) (0, $dlLwf.default)(obj, keys);
    return keys;
}

});



parcelRegister("4scqY", function(module, exports) {

$parcel$export(module.exports, "default", () => $33e36c138b4bf873$export$2e2bcd8739ae039);

var $l4EOE = parcelRequire("l4EOE");

var $ahTSr = parcelRequire("ahTSr");

var $81UkW = parcelRequire("81UkW");
var $33e36c138b4bf873$export$2e2bcd8739ae039 = (0, $ahTSr.isIE11) ? (0, $81UkW.ie11fingerprint)((0, $81UkW.weakMapMethods)) : (0, $l4EOE.default)("WeakMap");

});

parcelRegister("kiYQK", function(module, exports) {

$parcel$export(module.exports, "default", () => $ec84b0948615a45b$export$2e2bcd8739ae039);

var $l4EOE = parcelRequire("l4EOE");

var $ahTSr = parcelRequire("ahTSr");

var $81UkW = parcelRequire("81UkW");
var $ec84b0948615a45b$export$2e2bcd8739ae039 = (0, $ahTSr.isIE11) ? (0, $81UkW.ie11fingerprint)((0, $81UkW.setMethods)) : (0, $l4EOE.default)("Set");

});

parcelRegister("jZ2st", function(module, exports) {

$parcel$export(module.exports, "default", () => $e8c59ef6a6f4fcee$export$2e2bcd8739ae039);

var $l4EOE = parcelRequire("l4EOE");
var $e8c59ef6a6f4fcee$export$2e2bcd8739ae039 = (0, $l4EOE.default)("WeakSet");

});

parcelRegister("keF5g", function(module, exports) {

$parcel$export(module.exports, "default", () => $ebb4fbd725ae82a0$export$2e2bcd8739ae039);

var $9BELh = parcelRequire("9BELh");
function $ebb4fbd725ae82a0$export$2e2bcd8739ae039(obj) {
    var _keys = (0, $9BELh.default)(obj);
    var length = _keys.length;
    var values = Array(length);
    for(var i = 0; i < length; i++)values[i] = obj[_keys[i]];
    return values;
}

});

parcelRegister("8XqbY", function(module, exports) {

$parcel$export(module.exports, "default", () => $6858269b58b81583$export$2e2bcd8739ae039);

var $9BELh = parcelRequire("9BELh");
function $6858269b58b81583$export$2e2bcd8739ae039(obj) {
    var _keys = (0, $9BELh.default)(obj);
    var length = _keys.length;
    var pairs = Array(length);
    for(var i = 0; i < length; i++)pairs[i] = [
        _keys[i],
        obj[_keys[i]]
    ];
    return pairs;
}

});

parcelRegister("g10pM", function(module, exports) {

$parcel$export(module.exports, "default", () => $ba8d0fba6632eaff$export$2e2bcd8739ae039);

var $9BELh = parcelRequire("9BELh");
function $ba8d0fba6632eaff$export$2e2bcd8739ae039(obj) {
    var result = {};
    var _keys = (0, $9BELh.default)(obj);
    for(var i = 0, length = _keys.length; i < length; i++)result[obj[_keys[i]]] = _keys[i];
    return result;
}

});

parcelRegister("aROXJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $7e9662b114b4a099$export$2e2bcd8739ae039);

var $kkIYY = parcelRequire("kkIYY");
function $7e9662b114b4a099$export$2e2bcd8739ae039(obj) {
    var names = [];
    for(var key in obj)if ((0, $kkIYY.default)(obj[key])) names.push(key);
    return names.sort();
}

});

parcelRegister("hDkYR", function(module, exports) {

$parcel$export(module.exports, "default", () => $cd665a7b16f49314$export$2e2bcd8739ae039);

var $glwxV = parcelRequire("glwxV");

var $ac7Ik = parcelRequire("ac7Ik");
var // Extend a given object with all the properties in passed-in object(s).
$cd665a7b16f49314$export$2e2bcd8739ae039 = (0, $glwxV.default)((0, $ac7Ik.default));

});
parcelRegister("glwxV", function(module, exports) {

$parcel$export(module.exports, "default", () => $be67da832d3a72cd$export$2e2bcd8739ae039);
// An internal function for creating assigner functions.
function $be67da832d3a72cd$export$2e2bcd8739ae039(keysFunc, defaults) {
    return function(obj) {
        var length = arguments.length;
        if (defaults) obj = Object(obj);
        if (length < 2 || obj == null) return obj;
        for(var index = 1; index < length; index++){
            var source = arguments[index], keys = keysFunc(source), l = keys.length;
            for(var i = 0; i < l; i++){
                var key = keys[i];
                if (!defaults || obj[key] === void 0) obj[key] = source[key];
            }
        }
        return obj;
    };
}

});


parcelRegister("kWUGD", function(module, exports) {

$parcel$export(module.exports, "default", () => $f40532393fd97aec$export$2e2bcd8739ae039);

var $glwxV = parcelRequire("glwxV");

var $9BELh = parcelRequire("9BELh");
var // Assigns a given object with all the own properties in the passed-in
// object(s).
// (https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Object/assign)
$f40532393fd97aec$export$2e2bcd8739ae039 = (0, $glwxV.default)((0, $9BELh.default));

});

parcelRegister("cxWnu", function(module, exports) {

$parcel$export(module.exports, "default", () => $9225d9bed8720bc5$export$2e2bcd8739ae039);

var $glwxV = parcelRequire("glwxV");

var $ac7Ik = parcelRequire("ac7Ik");
var // Fill in a given object with default properties.
$9225d9bed8720bc5$export$2e2bcd8739ae039 = (0, $glwxV.default)((0, $ac7Ik.default), true);

});

parcelRegister("gfsFT", function(module, exports) {

$parcel$export(module.exports, "default", () => $bd444a42534a739d$export$2e2bcd8739ae039);

var $fI7xF = parcelRequire("fI7xF");

var $kWUGD = parcelRequire("kWUGD");
function $bd444a42534a739d$export$2e2bcd8739ae039(prototype, props) {
    var result = (0, $fI7xF.default)(prototype);
    if (props) (0, $kWUGD.default)(result, props);
    return result;
}

});
parcelRegister("fI7xF", function(module, exports) {

$parcel$export(module.exports, "default", () => $b700d0be25024b3f$export$2e2bcd8739ae039);

var $9sPg0 = parcelRequire("9sPg0");

var $3TBJw = parcelRequire("3TBJw");
// Create a naked function reference for surrogate-prototype-swapping.
function $b700d0be25024b3f$var$ctor() {
    return function() {};
}
function $b700d0be25024b3f$export$2e2bcd8739ae039(prototype) {
    if (!(0, $9sPg0.default)(prototype)) return {};
    if (0, $3TBJw.nativeCreate) return (0, $3TBJw.nativeCreate)(prototype);
    var Ctor = $b700d0be25024b3f$var$ctor();
    Ctor.prototype = prototype;
    var result = new Ctor;
    Ctor.prototype = null;
    return result;
}

});


parcelRegister("eNx2q", function(module, exports) {

$parcel$export(module.exports, "default", () => $ac5f44fcda61a289$export$2e2bcd8739ae039);

var $9sPg0 = parcelRequire("9sPg0");

var $lsdAl = parcelRequire("lsdAl");

var $hDkYR = parcelRequire("hDkYR");
function $ac5f44fcda61a289$export$2e2bcd8739ae039(obj) {
    if (!(0, $9sPg0.default)(obj)) return obj;
    return (0, $lsdAl.default)(obj) ? obj.slice() : (0, $hDkYR.default)({}, obj);
}

});

parcelRegister("5Nqvc", function(module, exports) {

$parcel$export(module.exports, "default", () => $4386162a0709f5b5$export$2e2bcd8739ae039);
// Invokes `interceptor` with the `obj` and then returns `obj`.
// The primary purpose of this method is to "tap into" a method chain, in
// order to perform operations on intermediate results within the chain.
function $4386162a0709f5b5$export$2e2bcd8739ae039(obj, interceptor) {
    interceptor(obj);
    return obj;
}

});

parcelRegister("b1RaH", function(module, exports) {

$parcel$export(module.exports, "default", () => $80790876ee4b09c1$export$2e2bcd8739ae039);

var $cs56a = parcelRequire("cs56a");

var $9rcZo = parcelRequire("9rcZo");

var $189H9 = parcelRequire("189H9");
function $80790876ee4b09c1$export$2e2bcd8739ae039(object, path, defaultValue) {
    var value = (0, $9rcZo.default)(object, (0, $cs56a.default)(path));
    return (0, $189H9.default)(value) ? defaultValue : value;
}

});
parcelRegister("cs56a", function(module, exports) {

$parcel$export(module.exports, "default", () => $910c0dff4ed1facf$export$2e2bcd8739ae039);

var $6ZSi9 = parcelRequire("6ZSi9");
parcelRequire("1nsRK");
function $910c0dff4ed1facf$export$2e2bcd8739ae039(path) {
    return (0, $6ZSi9.default).toPath(path);
}

});
parcelRegister("1nsRK", function(module, exports) {

$parcel$export(module.exports, "default", () => $100e549c0eece915$export$2e2bcd8739ae039);

var $6ZSi9 = parcelRequire("6ZSi9");

var $lsdAl = parcelRequire("lsdAl");
function $100e549c0eece915$export$2e2bcd8739ae039(path) {
    return (0, $lsdAl.default)(path) ? path : [
        path
    ];
}
(0, $6ZSi9.default).toPath = $100e549c0eece915$export$2e2bcd8739ae039;

});


parcelRegister("9rcZo", function(module, exports) {

$parcel$export(module.exports, "default", () => $6df0b60a061e6090$export$2e2bcd8739ae039);
// Internal function to obtain a nested property in `obj` along `path`.
function $6df0b60a061e6090$export$2e2bcd8739ae039(obj, path) {
    var length = path.length;
    for(var i = 0; i < length; i++){
        if (obj == null) return void 0;
        obj = obj[path[i]];
    }
    return length ? obj : void 0;
}

});


parcelRegister("6QeN9", function(module, exports) {

$parcel$export(module.exports, "default", () => $4fb312c1270006dd$export$2e2bcd8739ae039);

var $4YlR9 = parcelRequire("4YlR9");

var $cs56a = parcelRequire("cs56a");
function $4fb312c1270006dd$export$2e2bcd8739ae039(obj, path) {
    path = (0, $cs56a.default)(path);
    var length = path.length;
    for(var i = 0; i < length; i++){
        var key = path[i];
        if (!(0, $4YlR9.default)(obj, key)) return false;
        obj = obj[key];
    }
    return !!length;
}

});

parcelRegister("4DYUU", function(module, exports) {

$parcel$export(module.exports, "default", () => $361a0ec142a97115$export$2e2bcd8739ae039);

var $fLkDf = parcelRequire("fLkDf");

var $9BELh = parcelRequire("9BELh");
function $361a0ec142a97115$export$2e2bcd8739ae039(obj, iteratee, context) {
    iteratee = (0, $fLkDf.default)(iteratee, context);
    var _keys = (0, $9BELh.default)(obj), length = _keys.length, results = {};
    for(var index = 0; index < length; index++){
        var currentKey = _keys[index];
        results[currentKey] = iteratee(obj[currentKey], currentKey, obj);
    }
    return results;
}

});
parcelRegister("fLkDf", function(module, exports) {

$parcel$export(module.exports, "default", () => $b79b3fe14fe37daf$export$2e2bcd8739ae039);

var $6ZSi9 = parcelRequire("6ZSi9");

var $9KyyY = parcelRequire("9KyyY");

var $4N9JI = parcelRequire("4N9JI");
function $b79b3fe14fe37daf$export$2e2bcd8739ae039(value, context, argCount) {
    if ((0, $6ZSi9.default).iteratee !== (0, $4N9JI.default)) return (0, $6ZSi9.default).iteratee(value, context);
    return (0, $9KyyY.default)(value, context, argCount);
}

});
parcelRegister("9KyyY", function(module, exports) {

$parcel$export(module.exports, "default", () => $7193386dd6feb6cd$export$2e2bcd8739ae039);

var $4wz3f = parcelRequire("4wz3f");

var $kkIYY = parcelRequire("kkIYY");

var $9sPg0 = parcelRequire("9sPg0");

var $lsdAl = parcelRequire("lsdAl");

var $ifjsZ = parcelRequire("ifjsZ");

var $gdAxf = parcelRequire("gdAxf");

var $kSmYv = parcelRequire("kSmYv");
function $7193386dd6feb6cd$export$2e2bcd8739ae039(value, context, argCount) {
    if (value == null) return 0, $4wz3f.default;
    if ((0, $kkIYY.default)(value)) return (0, $kSmYv.default)(value, context, argCount);
    if ((0, $9sPg0.default)(value) && !(0, $lsdAl.default)(value)) return (0, $ifjsZ.default)(value);
    return (0, $gdAxf.default)(value);
}

});
parcelRegister("4wz3f", function(module, exports) {

$parcel$export(module.exports, "default", () => $34b5571162c34d5a$export$2e2bcd8739ae039);
// Keep the identity function around for default iteratees.
function $34b5571162c34d5a$export$2e2bcd8739ae039(value) {
    return value;
}

});

parcelRegister("ifjsZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $d488ba5b1a5b1ffd$export$2e2bcd8739ae039);

var $kWUGD = parcelRequire("kWUGD");

var $4Kv25 = parcelRequire("4Kv25");
function $d488ba5b1a5b1ffd$export$2e2bcd8739ae039(attrs) {
    attrs = (0, $kWUGD.default)({}, attrs);
    return function(obj) {
        return (0, $4Kv25.default)(obj, attrs);
    };
}

});

parcelRegister("gdAxf", function(module, exports) {

$parcel$export(module.exports, "default", () => $bcea3364d1615dfa$export$2e2bcd8739ae039);

var $9rcZo = parcelRequire("9rcZo");

var $cs56a = parcelRequire("cs56a");
function $bcea3364d1615dfa$export$2e2bcd8739ae039(path) {
    path = (0, $cs56a.default)(path);
    return function(obj) {
        return (0, $9rcZo.default)(obj, path);
    };
}

});

parcelRegister("kSmYv", function(module, exports) {

$parcel$export(module.exports, "default", () => $f32aac1c6eda188b$export$2e2bcd8739ae039);
// Internal function that returns an efficient (for current engines) version
// of the passed-in callback, to be repeatedly applied in other Underscore
// functions.
function $f32aac1c6eda188b$export$2e2bcd8739ae039(func, context, argCount) {
    if (context === void 0) return func;
    switch(argCount == null ? 3 : argCount){
        case 1:
            return function(value) {
                return func.call(context, value);
            };
        // The 2-argument case is omitted because we’re not using it.
        case 3:
            return function(value, index, collection) {
                return func.call(context, value, index, collection);
            };
        case 4:
            return function(accumulator, value, index, collection) {
                return func.call(context, accumulator, value, index, collection);
            };
    }
    return function() {
        return func.apply(context, arguments);
    };
}

});


parcelRegister("4N9JI", function(module, exports) {

$parcel$export(module.exports, "default", () => $37d34a73637a8f26$export$2e2bcd8739ae039);

var $6ZSi9 = parcelRequire("6ZSi9");

var $9KyyY = parcelRequire("9KyyY");
function $37d34a73637a8f26$export$2e2bcd8739ae039(value, context) {
    return (0, $9KyyY.default)(value, context, Infinity);
}
(0, $6ZSi9.default).iteratee = $37d34a73637a8f26$export$2e2bcd8739ae039;

});



parcelRegister("k7qMd", function(module, exports) {

$parcel$export(module.exports, "default", () => $ea593b64ef4e2a8e$export$2e2bcd8739ae039);
// Predicate-generating function. Often useful outside of Underscore.
function $ea593b64ef4e2a8e$export$2e2bcd8739ae039() {}

});

parcelRegister("6nuBV", function(module, exports) {

$parcel$export(module.exports, "default", () => $4a4ca2b2793dbf28$export$2e2bcd8739ae039);

var $k7qMd = parcelRequire("k7qMd");

var $b1RaH = parcelRequire("b1RaH");
function $4a4ca2b2793dbf28$export$2e2bcd8739ae039(obj) {
    if (obj == null) return 0, $k7qMd.default;
    return function(path) {
        return (0, $b1RaH.default)(obj, path);
    };
}

});

parcelRegister("cHHN7", function(module, exports) {

$parcel$export(module.exports, "default", () => $93fb7833cb34acaa$export$2e2bcd8739ae039);

var $kSmYv = parcelRequire("kSmYv");
function $93fb7833cb34acaa$export$2e2bcd8739ae039(n, iteratee, context) {
    var accum = Array(Math.max(0, n));
    iteratee = (0, $kSmYv.default)(iteratee, context, 1);
    for(var i = 0; i < n; i++)accum[i] = iteratee(i);
    return accum;
}

});

parcelRegister("lrHzN", function(module, exports) {

$parcel$export(module.exports, "default", () => $f9cdebf5ce2af7ea$export$2e2bcd8739ae039);
// Return a random integer between `min` and `max` (inclusive).
function $f9cdebf5ce2af7ea$export$2e2bcd8739ae039(min, max) {
    if (max == null) {
        max = min;
        min = 0;
    }
    return min + Math.floor(Math.random() * (max - min + 1));
}

});

parcelRegister("lVpZ1", function(module, exports) {

$parcel$export(module.exports, "default", () => $ff631391d2cf96ac$export$2e2bcd8739ae039);
// A (possibly faster) way to get the current timestamp as an integer.
var $ff631391d2cf96ac$export$2e2bcd8739ae039 = Date.now || function() {
    return new Date().getTime();
};

});

parcelRegister("3AbbN", function(module, exports) {

$parcel$export(module.exports, "default", () => $29bd69dc36818855$export$2e2bcd8739ae039);

var $f2cu6 = parcelRequire("f2cu6");

var $bkzPc = parcelRequire("bkzPc");
var // Function for escaping strings to HTML interpolation.
$29bd69dc36818855$export$2e2bcd8739ae039 = (0, $f2cu6.default)((0, $bkzPc.default));

});
parcelRegister("f2cu6", function(module, exports) {

$parcel$export(module.exports, "default", () => $af20ba17f1dfce7b$export$2e2bcd8739ae039);

var $9BELh = parcelRequire("9BELh");
function $af20ba17f1dfce7b$export$2e2bcd8739ae039(map) {
    var escaper = function(match) {
        return map[match];
    };
    // Regexes for identifying a key that needs to be escaped.
    var source = "(?:" + (0, $9BELh.default)(map).join("|") + ")";
    var testRegexp = RegExp(source);
    var replaceRegexp = RegExp(source, "g");
    return function(string) {
        string = string == null ? "" : "" + string;
        return testRegexp.test(string) ? string.replace(replaceRegexp, escaper) : string;
    };
}

});

parcelRegister("bkzPc", function(module, exports) {

$parcel$export(module.exports, "default", () => $83fd5a079fe500fb$export$2e2bcd8739ae039);
// Internal list of HTML entities for escaping.
var $83fd5a079fe500fb$export$2e2bcd8739ae039 = {
    "&": "&amp;",
    "<": "&lt;",
    ">": "&gt;",
    '"': "&quot;",
    "'": "&#x27;",
    "`": "&#x60;"
};

});


parcelRegister("d5KHs", function(module, exports) {

$parcel$export(module.exports, "default", () => $987ff7a55bdcc95b$export$2e2bcd8739ae039);

var $f2cu6 = parcelRequire("f2cu6");

var $hZ2Yu = parcelRequire("hZ2Yu");
var // Function for unescaping strings from HTML interpolation.
$987ff7a55bdcc95b$export$2e2bcd8739ae039 = (0, $f2cu6.default)((0, $hZ2Yu.default));

});
parcelRegister("hZ2Yu", function(module, exports) {

$parcel$export(module.exports, "default", () => $d17a70e2463640c6$export$2e2bcd8739ae039);

var $g10pM = parcelRequire("g10pM");

var $bkzPc = parcelRequire("bkzPc");
var // Internal list of HTML entities for unescaping.
$d17a70e2463640c6$export$2e2bcd8739ae039 = (0, $g10pM.default)((0, $bkzPc.default));

});


parcelRegister("ar7Gu", function(module, exports) {

$parcel$export(module.exports, "default", () => $799262f659d00f51$export$2e2bcd8739ae039);

var $6ZSi9 = parcelRequire("6ZSi9");
var // By default, Underscore uses ERB-style template delimiters. Change the
// following template settings to use alternative delimiters.
$799262f659d00f51$export$2e2bcd8739ae039 = (0, $6ZSi9.default).templateSettings = {
    evaluate: /<%([\s\S]+?)%>/g,
    interpolate: /<%=([\s\S]+?)%>/g,
    escape: /<%-([\s\S]+?)%>/g
};

});

parcelRegister("ajLBg", function(module, exports) {

$parcel$export(module.exports, "default", () => $78309a1f9f459973$export$2e2bcd8739ae039);

var $cxWnu = parcelRequire("cxWnu");

var $6ZSi9 = parcelRequire("6ZSi9");
parcelRequire("ar7Gu");
// When customizing `_.templateSettings`, if you don't want to define an
// interpolation, evaluation or escaping regex, we need one that is
// guaranteed not to match.
var $78309a1f9f459973$var$noMatch = /(.)^/;
// Certain characters need to be escaped so that they can be put into a
// string literal.
var $78309a1f9f459973$var$escapes = {
    "'": "'",
    "\\": "\\",
    "\r": "r",
    "\n": "n",
    "\u2028": "u2028",
    "\u2029": "u2029"
};
var $78309a1f9f459973$var$escapeRegExp = /\\|'|\r|\n|\u2028|\u2029/g;
function $78309a1f9f459973$var$escapeChar(match) {
    return "\\" + $78309a1f9f459973$var$escapes[match];
}
// In order to prevent third-party code injection through
// `_.templateSettings.variable`, we test it against the following regular
// expression. It is intentionally a bit more liberal than just matching valid
// identifiers, but still prevents possible loopholes through defaults or
// destructuring assignment.
var $78309a1f9f459973$var$bareIdentifier = /^\s*(\w|\$)+\s*$/;
function $78309a1f9f459973$export$2e2bcd8739ae039(text, settings, oldSettings) {
    if (!settings && oldSettings) settings = oldSettings;
    settings = (0, $cxWnu.default)({}, settings, (0, $6ZSi9.default).templateSettings);
    // Combine delimiters into one regular expression via alternation.
    var matcher = RegExp([
        (settings.escape || $78309a1f9f459973$var$noMatch).source,
        (settings.interpolate || $78309a1f9f459973$var$noMatch).source,
        (settings.evaluate || $78309a1f9f459973$var$noMatch).source
    ].join("|") + "|$", "g");
    // Compile the template source, escaping string literals appropriately.
    var index = 0;
    var source = "__p+='";
    text.replace(matcher, function(match, escape, interpolate, evaluate, offset) {
        source += text.slice(index, offset).replace($78309a1f9f459973$var$escapeRegExp, $78309a1f9f459973$var$escapeChar);
        index = offset + match.length;
        if (escape) source += "'+\n((__t=(" + escape + "))==null?'':_.escape(__t))+\n'";
        else if (interpolate) source += "'+\n((__t=(" + interpolate + "))==null?'':__t)+\n'";
        else if (evaluate) source += "';\n" + evaluate + "\n__p+='";
        // Adobe VMs need the match returned to produce the correct offset.
        return match;
    });
    source += "';\n";
    var argument = settings.variable;
    if (argument) {
        // Insure against third-party code injection. (CVE-2021-23358)
        if (!$78309a1f9f459973$var$bareIdentifier.test(argument)) throw new Error("variable is not a bare identifier: " + argument);
    } else {
        // If a variable is not specified, place data values in local scope.
        source = "with(obj||{}){\n" + source + "}\n";
        argument = "obj";
    }
    source = "var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};\n" + source + "return __p;\n";
    var render;
    try {
        render = new Function(argument, "_", source);
    } catch (e) {
        e.source = source;
        throw e;
    }
    var template = function(data) {
        return render.call(this, data, (0, $6ZSi9.default));
    };
    // Provide the compiled source as a convenience for precompilation.
    template.source = "function(" + argument + "){\n" + source + "}";
    return template;
}

});

parcelRegister("jN6Ly", function(module, exports) {

$parcel$export(module.exports, "default", () => $e687d77f3e8f8cc0$export$2e2bcd8739ae039);

var $kkIYY = parcelRequire("kkIYY");

var $cs56a = parcelRequire("cs56a");
function $e687d77f3e8f8cc0$export$2e2bcd8739ae039(obj, path, fallback) {
    path = (0, $cs56a.default)(path);
    var length = path.length;
    if (!length) return (0, $kkIYY.default)(fallback) ? fallback.call(obj) : fallback;
    for(var i = 0; i < length; i++){
        var prop = obj == null ? void 0 : obj[path[i]];
        if (prop === void 0) {
            prop = fallback;
            i = length; // Ensure we don't continue iterating.
        }
        obj = (0, $kkIYY.default)(prop) ? prop.call(obj) : prop;
    }
    return obj;
}

});

parcelRegister("5xNgK", function(module, exports) {

$parcel$export(module.exports, "default", () => $409640a219323d5c$export$2e2bcd8739ae039);
// Generate a unique integer id (unique within the entire client session).
// Useful for temporary DOM ids.
var $409640a219323d5c$var$idCounter = 0;
function $409640a219323d5c$export$2e2bcd8739ae039(prefix) {
    var id = ++$409640a219323d5c$var$idCounter + "";
    return prefix ? prefix + id : id;
}

});

parcelRegister("FCdjz", function(module, exports) {

$parcel$export(module.exports, "default", () => $07d178e7c93d3e66$export$2e2bcd8739ae039);

var $6ZSi9 = parcelRequire("6ZSi9");
function $07d178e7c93d3e66$export$2e2bcd8739ae039(obj) {
    var instance = (0, $6ZSi9.default)(obj);
    instance._chain = true;
    return instance;
}

});

parcelRegister("2fm2D", function(module, exports) {

$parcel$export(module.exports, "default", () => $1a2e147da63105f5$export$2e2bcd8739ae039);

var $0bHlN = parcelRequire("0bHlN");

var $hWQgM = parcelRequire("hWQgM");

var $6ZSi9 = parcelRequire("6ZSi9");
// Partially apply a function by creating a version that has had some of its
// arguments pre-filled, without changing its dynamic `this` context. `_` acts
// as a placeholder by default, allowing any combination of arguments to be
// pre-filled. Set `_.partial.placeholder` for a custom placeholder argument.
var $1a2e147da63105f5$var$partial = (0, $0bHlN.default)(function(func, boundArgs) {
    var placeholder = $1a2e147da63105f5$var$partial.placeholder;
    var bound = function() {
        var position = 0, length = boundArgs.length;
        var args = Array(length);
        for(var i = 0; i < length; i++)args[i] = boundArgs[i] === placeholder ? arguments[position++] : boundArgs[i];
        while(position < arguments.length)args.push(arguments[position++]);
        return (0, $hWQgM.default)(func, bound, this, this, args);
    };
    return bound;
});
$1a2e147da63105f5$var$partial.placeholder = (0, $6ZSi9.default);
var $1a2e147da63105f5$export$2e2bcd8739ae039 = $1a2e147da63105f5$var$partial;

});
parcelRegister("hWQgM", function(module, exports) {

$parcel$export(module.exports, "default", () => $d1106616df14cda0$export$2e2bcd8739ae039);

var $fI7xF = parcelRequire("fI7xF");

var $9sPg0 = parcelRequire("9sPg0");
function $d1106616df14cda0$export$2e2bcd8739ae039(sourceFunc, boundFunc, context, callingContext, args) {
    if (!(callingContext instanceof boundFunc)) return sourceFunc.apply(context, args);
    var self = (0, $fI7xF.default)(sourceFunc.prototype);
    var result = sourceFunc.apply(self, args);
    if ((0, $9sPg0.default)(result)) return result;
    return self;
}

});


parcelRegister("dlMqS", function(module, exports) {

$parcel$export(module.exports, "default", () => $9b82ce32b9f64f95$export$2e2bcd8739ae039);

var $0bHlN = parcelRequire("0bHlN");

var $kkIYY = parcelRequire("kkIYY");

var $hWQgM = parcelRequire("hWQgM");
var // Create a function bound to a given object (assigning `this`, and arguments,
// optionally).
$9b82ce32b9f64f95$export$2e2bcd8739ae039 = (0, $0bHlN.default)(function(func, context, args) {
    if (!(0, $kkIYY.default)(func)) throw new TypeError("Bind must be called on a function");
    var bound = (0, $0bHlN.default)(function(callArgs) {
        return (0, $hWQgM.default)(func, bound, context, this, args.concat(callArgs));
    });
    return bound;
});

});

parcelRegister("htAB1", function(module, exports) {

$parcel$export(module.exports, "default", () => $cb918855b9157d53$export$2e2bcd8739ae039);

var $0bHlN = parcelRequire("0bHlN");

var $8J4RW = parcelRequire("8J4RW");

var $dlMqS = parcelRequire("dlMqS");
var // Bind a number of an object's methods to that object. Remaining arguments
// are the method names to be bound. Useful for ensuring that all callbacks
// defined on an object belong to it.
$cb918855b9157d53$export$2e2bcd8739ae039 = (0, $0bHlN.default)(function(obj, keys) {
    keys = (0, $8J4RW.default)(keys, false, false);
    var index = keys.length;
    if (index < 1) throw new Error("bindAll must be passed function names");
    while(index--){
        var key = keys[index];
        obj[key] = (0, $dlMqS.default)(obj[key], obj);
    }
    return obj;
});

});
parcelRegister("8J4RW", function(module, exports) {

$parcel$export(module.exports, "default", () => $65a64d9b8854b61f$export$2e2bcd8739ae039);

var $iER8D = parcelRequire("iER8D");

var $4C6Z5 = parcelRequire("4C6Z5");

var $lsdAl = parcelRequire("lsdAl");

var $eiwQq = parcelRequire("eiwQq");
function $65a64d9b8854b61f$export$2e2bcd8739ae039(input, depth, strict, output) {
    output = output || [];
    if (!depth && depth !== 0) depth = Infinity;
    else if (depth <= 0) return output.concat(input);
    var idx = output.length;
    for(var i = 0, length = (0, $iER8D.default)(input); i < length; i++){
        var value = input[i];
        if ((0, $4C6Z5.default)(value) && ((0, $lsdAl.default)(value) || (0, $eiwQq.default)(value))) {
            // Flatten current level of array or arguments object.
            if (depth > 1) {
                $65a64d9b8854b61f$export$2e2bcd8739ae039(value, depth - 1, strict, output);
                idx = output.length;
            } else {
                var j = 0, len = value.length;
                while(j < len)output[idx++] = value[j++];
            }
        } else if (!strict) output[idx++] = value;
    }
    return output;
}

});
parcelRegister("4C6Z5", function(module, exports) {

$parcel$export(module.exports, "default", () => $35c020f3a261c5a1$export$2e2bcd8739ae039);

var $8ozKz = parcelRequire("8ozKz");

var $iER8D = parcelRequire("iER8D");
var // Internal helper for collection methods to determine whether a collection
// should be iterated as an array or as an object.
// Related: https://people.mozilla.org/~jorendorff/es6-draft.html#sec-tolength
// Avoids a very nasty iOS 8 JIT bug on ARM-64. #2094
$35c020f3a261c5a1$export$2e2bcd8739ae039 = (0, $8ozKz.default)((0, $iER8D.default));

});



parcelRegister("5T8r4", function(module, exports) {

$parcel$export(module.exports, "default", () => $4498a1ed71e9fe6a$export$2e2bcd8739ae039);

var $4YlR9 = parcelRequire("4YlR9");
function $4498a1ed71e9fe6a$export$2e2bcd8739ae039(func, hasher) {
    var memoize = function(key) {
        var cache = memoize.cache;
        var address = "" + (hasher ? hasher.apply(this, arguments) : key);
        if (!(0, $4YlR9.default)(cache, address)) cache[address] = func.apply(this, arguments);
        return cache[address];
    };
    memoize.cache = {};
    return memoize;
}

});

parcelRegister("5PD3T", function(module, exports) {

$parcel$export(module.exports, "default", () => $43f004011196acc1$export$2e2bcd8739ae039);

var $0bHlN = parcelRequire("0bHlN");
var // Delays a function for the given number of milliseconds, and then calls
// it with the arguments supplied.
$43f004011196acc1$export$2e2bcd8739ae039 = (0, $0bHlN.default)(function(func, wait, args) {
    return setTimeout(function() {
        return func.apply(null, args);
    }, wait);
});

});

parcelRegister("WOaIJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $0b0c55fd99270793$export$2e2bcd8739ae039);

var $2fm2D = parcelRequire("2fm2D");

var $5PD3T = parcelRequire("5PD3T");

var $6ZSi9 = parcelRequire("6ZSi9");
var // Defers a function, scheduling it to run after the current call stack has
// cleared.
$0b0c55fd99270793$export$2e2bcd8739ae039 = (0, $2fm2D.default)((0, $5PD3T.default), (0, $6ZSi9.default), 1);

});

parcelRegister("gzKqI", function(module, exports) {

$parcel$export(module.exports, "default", () => $c113ee3e9b3b083d$export$2e2bcd8739ae039);

var $lVpZ1 = parcelRequire("lVpZ1");
function $c113ee3e9b3b083d$export$2e2bcd8739ae039(func, wait, options) {
    var timeout, context, args, result;
    var previous = 0;
    if (!options) options = {};
    var later = function() {
        previous = options.leading === false ? 0 : (0, $lVpZ1.default)();
        timeout = null;
        result = func.apply(context, args);
        if (!timeout) context = args = null;
    };
    var throttled = function() {
        var _now = (0, $lVpZ1.default)();
        if (!previous && options.leading === false) previous = _now;
        var remaining = wait - (_now - previous);
        context = this;
        args = arguments;
        if (remaining <= 0 || remaining > wait) {
            if (timeout) {
                clearTimeout(timeout);
                timeout = null;
            }
            previous = _now;
            result = func.apply(context, args);
            if (!timeout) context = args = null;
        } else if (!timeout && options.trailing !== false) timeout = setTimeout(later, remaining);
        return result;
    };
    throttled.cancel = function() {
        clearTimeout(timeout);
        previous = 0;
        timeout = context = args = null;
    };
    return throttled;
}

});

parcelRegister("iNzni", function(module, exports) {

$parcel$export(module.exports, "default", () => $daf83e4f50d19913$export$2e2bcd8739ae039);

var $0bHlN = parcelRequire("0bHlN");

var $lVpZ1 = parcelRequire("lVpZ1");
function $daf83e4f50d19913$export$2e2bcd8739ae039(func, wait, immediate) {
    var timeout, previous, args, result, context;
    var later = function() {
        var passed = (0, $lVpZ1.default)() - previous;
        if (wait > passed) timeout = setTimeout(later, wait - passed);
        else {
            timeout = null;
            if (!immediate) result = func.apply(context, args);
            // This check is needed because `func` can recursively invoke `debounced`.
            if (!timeout) args = context = null;
        }
    };
    var debounced = (0, $0bHlN.default)(function(_args) {
        context = this;
        args = _args;
        previous = (0, $lVpZ1.default)();
        if (!timeout) {
            timeout = setTimeout(later, wait);
            if (immediate) result = func.apply(context, args);
        }
        return result;
    });
    debounced.cancel = function() {
        clearTimeout(timeout);
        timeout = args = context = null;
    };
    return debounced;
}

});

parcelRegister("OfUFq", function(module, exports) {

$parcel$export(module.exports, "default", () => $0971039d46d98585$export$2e2bcd8739ae039);

var $2fm2D = parcelRequire("2fm2D");
function $0971039d46d98585$export$2e2bcd8739ae039(func, wrapper) {
    return (0, $2fm2D.default)(wrapper, func);
}

});

parcelRegister("6DjdH", function(module, exports) {

$parcel$export(module.exports, "default", () => $4d454b4b64719993$export$2e2bcd8739ae039);
// Returns a negated version of the passed-in predicate.
function $4d454b4b64719993$export$2e2bcd8739ae039(predicate) {
    return function() {
        return !predicate.apply(this, arguments);
    };
}

});

parcelRegister("dEpOJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $9f03098fdf5e98d2$export$2e2bcd8739ae039);
// Returns a function that is the composition of a list of functions, each
// consuming the return value of the function that follows.
function $9f03098fdf5e98d2$export$2e2bcd8739ae039() {
    var args = arguments;
    var start = args.length - 1;
    return function() {
        var i = start;
        var result = args[start].apply(this, arguments);
        while(i--)result = args[i].call(this, result);
        return result;
    };
}

});

parcelRegister("128uF", function(module, exports) {

$parcel$export(module.exports, "default", () => $0c0c90fff32f81b8$export$2e2bcd8739ae039);
// Returns a function that will only be executed on and after the Nth call.
function $0c0c90fff32f81b8$export$2e2bcd8739ae039(times, func) {
    return function() {
        if (--times < 1) return func.apply(this, arguments);
    };
}

});

parcelRegister("4FCxR", function(module, exports) {

$parcel$export(module.exports, "default", () => $3668e405225021ed$export$2e2bcd8739ae039);
// Returns a function that will only be executed up to (but not including) the
// Nth call.
function $3668e405225021ed$export$2e2bcd8739ae039(times, func) {
    var memo;
    return function() {
        if (--times > 0) memo = func.apply(this, arguments);
        if (times <= 1) func = null;
        return memo;
    };
}

});

parcelRegister("bdw8x", function(module, exports) {

$parcel$export(module.exports, "default", () => $82a9d64a1bd25e8f$export$2e2bcd8739ae039);

var $2fm2D = parcelRequire("2fm2D");

var $4FCxR = parcelRequire("4FCxR");
var // Returns a function that will be executed at most one time, no matter how
// often you call it. Useful for lazy initialization.
$82a9d64a1bd25e8f$export$2e2bcd8739ae039 = (0, $2fm2D.default)((0, $4FCxR.default), 2);

});

parcelRegister("arT8z", function(module, exports) {

$parcel$export(module.exports, "default", () => $79b73215b289181c$export$2e2bcd8739ae039);

var $fLkDf = parcelRequire("fLkDf");

var $9BELh = parcelRequire("9BELh");
function $79b73215b289181c$export$2e2bcd8739ae039(obj, predicate, context) {
    predicate = (0, $fLkDf.default)(predicate, context);
    var _keys = (0, $9BELh.default)(obj), key;
    for(var i = 0, length = _keys.length; i < length; i++){
        key = _keys[i];
        if (predicate(obj[key], key, obj)) return key;
    }
}

});

parcelRegister("ciFS5", function(module, exports) {

$parcel$export(module.exports, "default", () => $8f47a544aeb08a7e$export$2e2bcd8739ae039);

var $jfYCQ = parcelRequire("jfYCQ");
var // Returns the first index on an array-like that passes a truth test.
$8f47a544aeb08a7e$export$2e2bcd8739ae039 = (0, $jfYCQ.default)(1);

});
parcelRegister("jfYCQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $e04e7205f71f5f02$export$2e2bcd8739ae039);

var $fLkDf = parcelRequire("fLkDf");

var $iER8D = parcelRequire("iER8D");
function $e04e7205f71f5f02$export$2e2bcd8739ae039(dir) {
    return function(array, predicate, context) {
        predicate = (0, $fLkDf.default)(predicate, context);
        var length = (0, $iER8D.default)(array);
        var index = dir > 0 ? 0 : length - 1;
        for(; index >= 0 && index < length; index += dir){
            if (predicate(array[index], index, array)) return index;
        }
        return -1;
    };
}

});


parcelRegister("53vMY", function(module, exports) {

$parcel$export(module.exports, "default", () => $3ae5e429277e4694$export$2e2bcd8739ae039);

var $jfYCQ = parcelRequire("jfYCQ");
var // Returns the last index on an array-like that passes a truth test.
$3ae5e429277e4694$export$2e2bcd8739ae039 = (0, $jfYCQ.default)(-1);

});

parcelRegister("wTUFC", function(module, exports) {

$parcel$export(module.exports, "default", () => $062e5c7017ea1c58$export$2e2bcd8739ae039);

var $fLkDf = parcelRequire("fLkDf");

var $iER8D = parcelRequire("iER8D");
function $062e5c7017ea1c58$export$2e2bcd8739ae039(array, obj, iteratee, context) {
    iteratee = (0, $fLkDf.default)(iteratee, context, 1);
    var value = iteratee(obj);
    var low = 0, high = (0, $iER8D.default)(array);
    while(low < high){
        var mid = Math.floor((low + high) / 2);
        if (iteratee(array[mid]) < value) low = mid + 1;
        else high = mid;
    }
    return low;
}

});

parcelRegister("aacCi", function(module, exports) {

$parcel$export(module.exports, "default", () => $76649ff64c4c112d$export$2e2bcd8739ae039);

var $wTUFC = parcelRequire("wTUFC");

var $ciFS5 = parcelRequire("ciFS5");

var $i4r49 = parcelRequire("i4r49");
var // Return the position of the first occurrence of an item in an array,
// or -1 if the item is not included in the array.
// If the array is large and already in sort order, pass `true`
// for **isSorted** to use binary search.
$76649ff64c4c112d$export$2e2bcd8739ae039 = (0, $i4r49.default)(1, (0, $ciFS5.default), (0, $wTUFC.default));

});
parcelRegister("i4r49", function(module, exports) {

$parcel$export(module.exports, "default", () => $d27d9875f79d1e0d$export$2e2bcd8739ae039);

var $iER8D = parcelRequire("iER8D");

var $3TBJw = parcelRequire("3TBJw");

var $7Mch0 = parcelRequire("7Mch0");
function $d27d9875f79d1e0d$export$2e2bcd8739ae039(dir, predicateFind, sortedIndex) {
    return function(array, item, idx) {
        var i = 0, length = (0, $iER8D.default)(array);
        if (typeof idx == "number") {
            if (dir > 0) i = idx >= 0 ? idx : Math.max(idx + length, i);
            else length = idx >= 0 ? Math.min(idx + 1, length) : idx + length + 1;
        } else if (sortedIndex && idx && length) {
            idx = sortedIndex(array, item);
            return array[idx] === item ? idx : -1;
        }
        if (item !== item) {
            idx = predicateFind((0, $3TBJw.slice).call(array, i, length), (0, $7Mch0.default));
            return idx >= 0 ? idx + i : -1;
        }
        for(idx = dir > 0 ? i : length - 1; idx >= 0 && idx < length; idx += dir){
            if (array[idx] === item) return idx;
        }
        return -1;
    };
}

});


parcelRegister("64pcf", function(module, exports) {

$parcel$export(module.exports, "default", () => $46b6a951c1416c2e$export$2e2bcd8739ae039);

var $53vMY = parcelRequire("53vMY");

var $i4r49 = parcelRequire("i4r49");
var // Return the position of the last occurrence of an item in an array,
// or -1 if the item is not included in the array.
$46b6a951c1416c2e$export$2e2bcd8739ae039 = (0, $i4r49.default)(-1, (0, $53vMY.default));

});

parcelRegister("e3veT", function(module, exports) {

$parcel$export(module.exports, "default", () => $a3b993f50683293a$export$2e2bcd8739ae039);

var $4C6Z5 = parcelRequire("4C6Z5");

var $ciFS5 = parcelRequire("ciFS5");

var $arT8z = parcelRequire("arT8z");
function $a3b993f50683293a$export$2e2bcd8739ae039(obj, predicate, context) {
    var keyFinder = (0, $4C6Z5.default)(obj) ? (0, $ciFS5.default) : (0, $arT8z.default);
    var key = keyFinder(obj, predicate, context);
    if (key !== void 0 && key !== -1) return obj[key];
}

});

parcelRegister("kXziU", function(module, exports) {

$parcel$export(module.exports, "default", () => $f424b3ff2217dd6e$export$2e2bcd8739ae039);

var $e3veT = parcelRequire("e3veT");

var $ifjsZ = parcelRequire("ifjsZ");
function $f424b3ff2217dd6e$export$2e2bcd8739ae039(obj, attrs) {
    return (0, $e3veT.default)(obj, (0, $ifjsZ.default)(attrs));
}

});

parcelRegister("fVQTG", function(module, exports) {

$parcel$export(module.exports, "default", () => $b995362b61cbe134$export$2e2bcd8739ae039);

var $kSmYv = parcelRequire("kSmYv");

var $4C6Z5 = parcelRequire("4C6Z5");

var $9BELh = parcelRequire("9BELh");
function $b995362b61cbe134$export$2e2bcd8739ae039(obj, iteratee, context) {
    iteratee = (0, $kSmYv.default)(iteratee, context);
    var i, length;
    if ((0, $4C6Z5.default)(obj)) for(i = 0, length = obj.length; i < length; i++)iteratee(obj[i], i, obj);
    else {
        var _keys = (0, $9BELh.default)(obj);
        for(i = 0, length = _keys.length; i < length; i++)iteratee(obj[_keys[i]], _keys[i], obj);
    }
    return obj;
}

});

parcelRegister("h6JIr", function(module, exports) {

$parcel$export(module.exports, "default", () => $c746756a67aa053b$export$2e2bcd8739ae039);

var $fLkDf = parcelRequire("fLkDf");

var $4C6Z5 = parcelRequire("4C6Z5");

var $9BELh = parcelRequire("9BELh");
function $c746756a67aa053b$export$2e2bcd8739ae039(obj, iteratee, context) {
    iteratee = (0, $fLkDf.default)(iteratee, context);
    var _keys = !(0, $4C6Z5.default)(obj) && (0, $9BELh.default)(obj), length = (_keys || obj).length, results = Array(length);
    for(var index = 0; index < length; index++){
        var currentKey = _keys ? _keys[index] : index;
        results[index] = iteratee(obj[currentKey], currentKey, obj);
    }
    return results;
}

});

parcelRegister("lDhwV", function(module, exports) {

$parcel$export(module.exports, "default", () => $fbfad6943e87d98c$export$2e2bcd8739ae039);

var $AxlZD = parcelRequire("AxlZD");
var // **Reduce** builds up a single result from a list of values, aka `inject`,
// or `foldl`.
$fbfad6943e87d98c$export$2e2bcd8739ae039 = (0, $AxlZD.default)(1);

});
parcelRegister("AxlZD", function(module, exports) {

$parcel$export(module.exports, "default", () => $06dd3c43740688f9$export$2e2bcd8739ae039);

var $4C6Z5 = parcelRequire("4C6Z5");

var $9BELh = parcelRequire("9BELh");

var $kSmYv = parcelRequire("kSmYv");
function $06dd3c43740688f9$export$2e2bcd8739ae039(dir) {
    // Wrap code that reassigns argument variables in a separate function than
    // the one that accesses `arguments.length` to avoid a perf hit. (#1991)
    var reducer = function(obj, iteratee, memo, initial) {
        var _keys = !(0, $4C6Z5.default)(obj) && (0, $9BELh.default)(obj), length = (_keys || obj).length, index = dir > 0 ? 0 : length - 1;
        if (!initial) {
            memo = obj[_keys ? _keys[index] : index];
            index += dir;
        }
        for(; index >= 0 && index < length; index += dir){
            var currentKey = _keys ? _keys[index] : index;
            memo = iteratee(memo, obj[currentKey], currentKey, obj);
        }
        return memo;
    };
    return function(obj, iteratee, memo, context) {
        var initial = arguments.length >= 3;
        return reducer(obj, (0, $kSmYv.default)(iteratee, context, 4), memo, initial);
    };
}

});


parcelRegister("8Wigf", function(module, exports) {

$parcel$export(module.exports, "default", () => $6821e7cd1cda490c$export$2e2bcd8739ae039);

var $AxlZD = parcelRequire("AxlZD");
var // The right-associative version of reduce, also known as `foldr`.
$6821e7cd1cda490c$export$2e2bcd8739ae039 = (0, $AxlZD.default)(-1);

});

parcelRegister("5cVVz", function(module, exports) {

$parcel$export(module.exports, "default", () => $3cab01f560c3a138$export$2e2bcd8739ae039);

var $fLkDf = parcelRequire("fLkDf");

var $fVQTG = parcelRequire("fVQTG");
function $3cab01f560c3a138$export$2e2bcd8739ae039(obj, predicate, context) {
    var results = [];
    predicate = (0, $fLkDf.default)(predicate, context);
    (0, $fVQTG.default)(obj, function(value, index, list) {
        if (predicate(value, index, list)) results.push(value);
    });
    return results;
}

});

parcelRegister("bKl8v", function(module, exports) {

$parcel$export(module.exports, "default", () => $88d462cd31dad735$export$2e2bcd8739ae039);

var $5cVVz = parcelRequire("5cVVz");

var $6DjdH = parcelRequire("6DjdH");

var $fLkDf = parcelRequire("fLkDf");
function $88d462cd31dad735$export$2e2bcd8739ae039(obj, predicate, context) {
    return (0, $5cVVz.default)(obj, (0, $6DjdH.default)((0, $fLkDf.default)(predicate)), context);
}

});

parcelRegister("2E2ms", function(module, exports) {

$parcel$export(module.exports, "default", () => $1ed12610b787b54c$export$2e2bcd8739ae039);

var $fLkDf = parcelRequire("fLkDf");

var $4C6Z5 = parcelRequire("4C6Z5");

var $9BELh = parcelRequire("9BELh");
function $1ed12610b787b54c$export$2e2bcd8739ae039(obj, predicate, context) {
    predicate = (0, $fLkDf.default)(predicate, context);
    var _keys = !(0, $4C6Z5.default)(obj) && (0, $9BELh.default)(obj), length = (_keys || obj).length;
    for(var index = 0; index < length; index++){
        var currentKey = _keys ? _keys[index] : index;
        if (!predicate(obj[currentKey], currentKey, obj)) return false;
    }
    return true;
}

});

parcelRegister("2HilC", function(module, exports) {

$parcel$export(module.exports, "default", () => $1f6dd4637b6de52e$export$2e2bcd8739ae039);

var $fLkDf = parcelRequire("fLkDf");

var $4C6Z5 = parcelRequire("4C6Z5");

var $9BELh = parcelRequire("9BELh");
function $1f6dd4637b6de52e$export$2e2bcd8739ae039(obj, predicate, context) {
    predicate = (0, $fLkDf.default)(predicate, context);
    var _keys = !(0, $4C6Z5.default)(obj) && (0, $9BELh.default)(obj), length = (_keys || obj).length;
    for(var index = 0; index < length; index++){
        var currentKey = _keys ? _keys[index] : index;
        if (predicate(obj[currentKey], currentKey, obj)) return true;
    }
    return false;
}

});

parcelRegister("6aulQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $47db385fda09988c$export$2e2bcd8739ae039);

var $4C6Z5 = parcelRequire("4C6Z5");

var $keF5g = parcelRequire("keF5g");

var $aacCi = parcelRequire("aacCi");
function $47db385fda09988c$export$2e2bcd8739ae039(obj, item, fromIndex, guard) {
    if (!(0, $4C6Z5.default)(obj)) obj = (0, $keF5g.default)(obj);
    if (typeof fromIndex != "number" || guard) fromIndex = 0;
    return (0, $aacCi.default)(obj, item, fromIndex) >= 0;
}

});

parcelRegister("2kSPh", function(module, exports) {

$parcel$export(module.exports, "default", () => $1b37fa5b86fe2986$export$2e2bcd8739ae039);

var $0bHlN = parcelRequire("0bHlN");

var $kkIYY = parcelRequire("kkIYY");

var $h6JIr = parcelRequire("h6JIr");

var $9rcZo = parcelRequire("9rcZo");

var $cs56a = parcelRequire("cs56a");
var // Invoke a method (with arguments) on every item in a collection.
$1b37fa5b86fe2986$export$2e2bcd8739ae039 = (0, $0bHlN.default)(function(obj, path, args) {
    var contextPath, func;
    if ((0, $kkIYY.default)(path)) func = path;
    else {
        path = (0, $cs56a.default)(path);
        contextPath = path.slice(0, -1);
        path = path[path.length - 1];
    }
    return (0, $h6JIr.default)(obj, function(context) {
        var method = func;
        if (!method) {
            if (contextPath && contextPath.length) context = (0, $9rcZo.default)(context, contextPath);
            if (context == null) return void 0;
            method = context[path];
        }
        return method == null ? method : method.apply(context, args);
    });
});

});

parcelRegister("8E7vk", function(module, exports) {

$parcel$export(module.exports, "default", () => $64b7e156b18644d0$export$2e2bcd8739ae039);

var $h6JIr = parcelRequire("h6JIr");

var $gdAxf = parcelRequire("gdAxf");
function $64b7e156b18644d0$export$2e2bcd8739ae039(obj, key) {
    return (0, $h6JIr.default)(obj, (0, $gdAxf.default)(key));
}

});

parcelRegister("6mhjE", function(module, exports) {

$parcel$export(module.exports, "default", () => $4a123abd524cfc92$export$2e2bcd8739ae039);

var $5cVVz = parcelRequire("5cVVz");

var $ifjsZ = parcelRequire("ifjsZ");
function $4a123abd524cfc92$export$2e2bcd8739ae039(obj, attrs) {
    return (0, $5cVVz.default)(obj, (0, $ifjsZ.default)(attrs));
}

});

parcelRegister("kM5J8", function(module, exports) {

$parcel$export(module.exports, "default", () => $f1fcbb9a3e80ebe3$export$2e2bcd8739ae039);

var $4C6Z5 = parcelRequire("4C6Z5");

var $keF5g = parcelRequire("keF5g");

var $fLkDf = parcelRequire("fLkDf");

var $fVQTG = parcelRequire("fVQTG");
function $f1fcbb9a3e80ebe3$export$2e2bcd8739ae039(obj, iteratee, context) {
    var result = -Infinity, lastComputed = -Infinity, value, computed;
    if (iteratee == null || typeof iteratee == "number" && typeof obj[0] != "object" && obj != null) {
        obj = (0, $4C6Z5.default)(obj) ? obj : (0, $keF5g.default)(obj);
        for(var i = 0, length = obj.length; i < length; i++){
            value = obj[i];
            if (value != null && value > result) result = value;
        }
    } else {
        iteratee = (0, $fLkDf.default)(iteratee, context);
        (0, $fVQTG.default)(obj, function(v, index, list) {
            computed = iteratee(v, index, list);
            if (computed > lastComputed || computed === -Infinity && result === -Infinity) {
                result = v;
                lastComputed = computed;
            }
        });
    }
    return result;
}

});

parcelRegister("l0v28", function(module, exports) {

$parcel$export(module.exports, "default", () => $f4b1abaac39e8250$export$2e2bcd8739ae039);

var $4C6Z5 = parcelRequire("4C6Z5");

var $keF5g = parcelRequire("keF5g");

var $fLkDf = parcelRequire("fLkDf");

var $fVQTG = parcelRequire("fVQTG");
function $f4b1abaac39e8250$export$2e2bcd8739ae039(obj, iteratee, context) {
    var result = Infinity, lastComputed = Infinity, value, computed;
    if (iteratee == null || typeof iteratee == "number" && typeof obj[0] != "object" && obj != null) {
        obj = (0, $4C6Z5.default)(obj) ? obj : (0, $keF5g.default)(obj);
        for(var i = 0, length = obj.length; i < length; i++){
            value = obj[i];
            if (value != null && value < result) result = value;
        }
    } else {
        iteratee = (0, $fLkDf.default)(iteratee, context);
        (0, $fVQTG.default)(obj, function(v, index, list) {
            computed = iteratee(v, index, list);
            if (computed < lastComputed || computed === Infinity && result === Infinity) {
                result = v;
                lastComputed = computed;
            }
        });
    }
    return result;
}

});

parcelRegister("1A2nV", function(module, exports) {

$parcel$export(module.exports, "default", () => $126b00d4f3d6622f$export$2e2bcd8739ae039);

var $02fY3 = parcelRequire("02fY3");
function $126b00d4f3d6622f$export$2e2bcd8739ae039(obj) {
    return (0, $02fY3.default)(obj, Infinity);
}

});
parcelRegister("02fY3", function(module, exports) {

$parcel$export(module.exports, "default", () => $006c92d573cf9580$export$2e2bcd8739ae039);

var $4C6Z5 = parcelRequire("4C6Z5");

var $keF5g = parcelRequire("keF5g");

var $iER8D = parcelRequire("iER8D");

var $lrHzN = parcelRequire("lrHzN");

var $f3hnQ = parcelRequire("f3hnQ");
function $006c92d573cf9580$export$2e2bcd8739ae039(obj, n, guard) {
    if (n == null || guard) {
        if (!(0, $4C6Z5.default)(obj)) obj = (0, $keF5g.default)(obj);
        return obj[(0, $lrHzN.default)(obj.length - 1)];
    }
    var sample = (0, $f3hnQ.default)(obj);
    var length = (0, $iER8D.default)(sample);
    n = Math.max(Math.min(n, length), 0);
    var last = length - 1;
    for(var index = 0; index < n; index++){
        var rand = (0, $lrHzN.default)(index, last);
        var temp = sample[index];
        sample[index] = sample[rand];
        sample[rand] = temp;
    }
    return sample.slice(0, n);
}

});
parcelRegister("f3hnQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $af549ed737dbc31a$export$2e2bcd8739ae039);

var $lsdAl = parcelRequire("lsdAl");

var $3TBJw = parcelRequire("3TBJw");

var $h0gl0 = parcelRequire("h0gl0");

var $4C6Z5 = parcelRequire("4C6Z5");

var $h6JIr = parcelRequire("h6JIr");

var $4wz3f = parcelRequire("4wz3f");

var $keF5g = parcelRequire("keF5g");
// Safely create a real, live array from anything iterable.
var $af549ed737dbc31a$var$reStrSymbol = /[^\ud800-\udfff]|[\ud800-\udbff][\udc00-\udfff]|[\ud800-\udfff]/g;
function $af549ed737dbc31a$export$2e2bcd8739ae039(obj) {
    if (!obj) return [];
    if ((0, $lsdAl.default)(obj)) return (0, $3TBJw.slice).call(obj);
    if ((0, $h0gl0.default)(obj)) // Keep surrogate pair characters together.
    return obj.match($af549ed737dbc31a$var$reStrSymbol);
    if ((0, $4C6Z5.default)(obj)) return (0, $h6JIr.default)(obj, (0, $4wz3f.default));
    return (0, $keF5g.default)(obj);
}

});



parcelRegister("a9AIt", function(module, exports) {

$parcel$export(module.exports, "default", () => $764739bcb0503f2e$export$2e2bcd8739ae039);

var $fLkDf = parcelRequire("fLkDf");

var $8E7vk = parcelRequire("8E7vk");

var $h6JIr = parcelRequire("h6JIr");
function $764739bcb0503f2e$export$2e2bcd8739ae039(obj, iteratee, context) {
    var index = 0;
    iteratee = (0, $fLkDf.default)(iteratee, context);
    return (0, $8E7vk.default)((0, $h6JIr.default)(obj, function(value, key, list) {
        return {
            value: value,
            index: index++,
            criteria: iteratee(value, key, list)
        };
    }).sort(function(left, right) {
        var a = left.criteria;
        var b = right.criteria;
        if (a !== b) {
            if (a > b || a === void 0) return 1;
            if (a < b || b === void 0) return -1;
        }
        return left.index - right.index;
    }), "value");
}

});

parcelRegister("lBlZC", function(module, exports) {

$parcel$export(module.exports, "default", () => $fb9e1d043a6fe792$export$2e2bcd8739ae039);

var $bHxII = parcelRequire("bHxII");

var $4YlR9 = parcelRequire("4YlR9");
var // Groups the object's values by a criterion. Pass either a string attribute
// to group by, or a function that returns the criterion.
$fb9e1d043a6fe792$export$2e2bcd8739ae039 = (0, $bHxII.default)(function(result, value, key) {
    if ((0, $4YlR9.default)(result, key)) result[key].push(value);
    else result[key] = [
        value
    ];
});

});
parcelRegister("bHxII", function(module, exports) {

$parcel$export(module.exports, "default", () => $884dddfcebade919$export$2e2bcd8739ae039);

var $fLkDf = parcelRequire("fLkDf");

var $fVQTG = parcelRequire("fVQTG");
function $884dddfcebade919$export$2e2bcd8739ae039(behavior, partition) {
    return function(obj, iteratee, context) {
        var result = partition ? [
            [],
            []
        ] : {};
        iteratee = (0, $fLkDf.default)(iteratee, context);
        (0, $fVQTG.default)(obj, function(value, index) {
            var key = iteratee(value, index, obj);
            behavior(result, value, key);
        });
        return result;
    };
}

});


parcelRegister("eNjka", function(module, exports) {

$parcel$export(module.exports, "default", () => $ac54a1aed9ba8a72$export$2e2bcd8739ae039);

var $bHxII = parcelRequire("bHxII");
var // Indexes the object's values by a criterion, similar to `_.groupBy`, but for
// when you know that your index values will be unique.
$ac54a1aed9ba8a72$export$2e2bcd8739ae039 = (0, $bHxII.default)(function(result, value, key) {
    result[key] = value;
});

});

parcelRegister("buft0", function(module, exports) {

$parcel$export(module.exports, "default", () => $85ce7e736ff1427c$export$2e2bcd8739ae039);

var $bHxII = parcelRequire("bHxII");

var $4YlR9 = parcelRequire("4YlR9");
var // Counts instances of an object that group by a certain criterion. Pass
// either a string attribute to count by, or a function that returns the
// criterion.
$85ce7e736ff1427c$export$2e2bcd8739ae039 = (0, $bHxII.default)(function(result, value, key) {
    if ((0, $4YlR9.default)(result, key)) result[key]++;
    else result[key] = 1;
});

});

parcelRegister("2q59Q", function(module, exports) {

$parcel$export(module.exports, "default", () => $1c3202b1cbae054a$export$2e2bcd8739ae039);

var $bHxII = parcelRequire("bHxII");
var // Split a collection into two arrays: one whose elements all pass the given
// truth test, and one whose elements all do not pass the truth test.
$1c3202b1cbae054a$export$2e2bcd8739ae039 = (0, $bHxII.default)(function(result, value, pass) {
    result[pass ? 0 : 1].push(value);
}, true);

});

parcelRegister("gEqND", function(module, exports) {

$parcel$export(module.exports, "default", () => $c1f52b9a7c4ef91e$export$2e2bcd8739ae039);

var $4C6Z5 = parcelRequire("4C6Z5");

var $9BELh = parcelRequire("9BELh");
function $c1f52b9a7c4ef91e$export$2e2bcd8739ae039(obj) {
    if (obj == null) return 0;
    return (0, $4C6Z5.default)(obj) ? obj.length : (0, $9BELh.default)(obj).length;
}

});

parcelRegister("4FUqN", function(module, exports) {

$parcel$export(module.exports, "default", () => $3676c3d07a7362ef$export$2e2bcd8739ae039);

var $0bHlN = parcelRequire("0bHlN");

var $kkIYY = parcelRequire("kkIYY");

var $kSmYv = parcelRequire("kSmYv");

var $ac7Ik = parcelRequire("ac7Ik");

var $hYWWz = parcelRequire("hYWWz");

var $8J4RW = parcelRequire("8J4RW");
var // Return a copy of the object only containing the allowed properties.
$3676c3d07a7362ef$export$2e2bcd8739ae039 = (0, $0bHlN.default)(function(obj, keys) {
    var result = {}, iteratee = keys[0];
    if (obj == null) return result;
    if ((0, $kkIYY.default)(iteratee)) {
        if (keys.length > 1) iteratee = (0, $kSmYv.default)(iteratee, keys[1]);
        keys = (0, $ac7Ik.default)(obj);
    } else {
        iteratee = (0, $hYWWz.default);
        keys = (0, $8J4RW.default)(keys, false, false);
        obj = Object(obj);
    }
    for(var i = 0, length = keys.length; i < length; i++){
        var key = keys[i];
        var value = obj[key];
        if (iteratee(value, key, obj)) result[key] = value;
    }
    return result;
});

});
parcelRegister("hYWWz", function(module, exports) {

$parcel$export(module.exports, "default", () => $d175c33d901c7d33$export$2e2bcd8739ae039);
// Internal `_.pick` helper function to determine whether `key` is an enumerable
// property name of `obj`.
function $d175c33d901c7d33$export$2e2bcd8739ae039(value, key, obj) {
    return key in obj;
}

});


parcelRegister("dmvIT", function(module, exports) {

$parcel$export(module.exports, "default", () => $9ba5eff4e454bc2e$export$2e2bcd8739ae039);

var $0bHlN = parcelRequire("0bHlN");

var $kkIYY = parcelRequire("kkIYY");

var $6DjdH = parcelRequire("6DjdH");

var $h6JIr = parcelRequire("h6JIr");

var $8J4RW = parcelRequire("8J4RW");

var $6aulQ = parcelRequire("6aulQ");

var $4FUqN = parcelRequire("4FUqN");
var // Return a copy of the object without the disallowed properties.
$9ba5eff4e454bc2e$export$2e2bcd8739ae039 = (0, $0bHlN.default)(function(obj, keys) {
    var iteratee = keys[0], context;
    if ((0, $kkIYY.default)(iteratee)) {
        iteratee = (0, $6DjdH.default)(iteratee);
        if (keys.length > 1) context = keys[1];
    } else {
        keys = (0, $h6JIr.default)((0, $8J4RW.default)(keys, false, false), String);
        iteratee = function(value, key) {
            return !(0, $6aulQ.default)(keys, key);
        };
    }
    return (0, $4FUqN.default)(obj, iteratee, context);
});

});

parcelRegister("5Y2Ih", function(module, exports) {

$parcel$export(module.exports, "default", () => $4584a922b20bbe9b$export$2e2bcd8739ae039);

var $hVNTQ = parcelRequire("hVNTQ");
function $4584a922b20bbe9b$export$2e2bcd8739ae039(array, n, guard) {
    if (array == null || array.length < 1) return n == null || guard ? void 0 : [];
    if (n == null || guard) return array[0];
    return (0, $hVNTQ.default)(array, array.length - n);
}

});
parcelRegister("hVNTQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $d0de77978a68d9ea$export$2e2bcd8739ae039);

var $3TBJw = parcelRequire("3TBJw");
function $d0de77978a68d9ea$export$2e2bcd8739ae039(array, n, guard) {
    return (0, $3TBJw.slice).call(array, 0, Math.max(0, array.length - (n == null || guard ? 1 : n)));
}

});


parcelRegister("87PtR", function(module, exports) {

$parcel$export(module.exports, "default", () => $5ea6e92bed107ca3$export$2e2bcd8739ae039);

var $6rmcH = parcelRequire("6rmcH");
function $5ea6e92bed107ca3$export$2e2bcd8739ae039(array, n, guard) {
    if (array == null || array.length < 1) return n == null || guard ? void 0 : [];
    if (n == null || guard) return array[array.length - 1];
    return (0, $6rmcH.default)(array, Math.max(0, array.length - n));
}

});
parcelRegister("6rmcH", function(module, exports) {

$parcel$export(module.exports, "default", () => $4b067ce637fc54a6$export$2e2bcd8739ae039);

var $3TBJw = parcelRequire("3TBJw");
function $4b067ce637fc54a6$export$2e2bcd8739ae039(array, n, guard) {
    return (0, $3TBJw.slice).call(array, n == null || guard ? 1 : n);
}

});


parcelRegister("8dcbb", function(module, exports) {

$parcel$export(module.exports, "default", () => $5fa8fc2d5a95b6b3$export$2e2bcd8739ae039);

var $5cVVz = parcelRequire("5cVVz");
function $5fa8fc2d5a95b6b3$export$2e2bcd8739ae039(array) {
    return (0, $5cVVz.default)(array, Boolean);
}

});

parcelRegister("32O62", function(module, exports) {

$parcel$export(module.exports, "default", () => $23786b176608059b$export$2e2bcd8739ae039);

var $8J4RW = parcelRequire("8J4RW");
function $23786b176608059b$export$2e2bcd8739ae039(array, depth) {
    return (0, $8J4RW.default)(array, depth, false);
}

});

parcelRegister("hZxEx", function(module, exports) {

$parcel$export(module.exports, "default", () => $d1923ce94a67b9a2$export$2e2bcd8739ae039);

var $0bHlN = parcelRequire("0bHlN");

var $kxlHx = parcelRequire("kxlHx");
var // Return a version of the array that does not contain the specified value(s).
$d1923ce94a67b9a2$export$2e2bcd8739ae039 = (0, $0bHlN.default)(function(array, otherArrays) {
    return (0, $kxlHx.default)(array, otherArrays);
});

});
parcelRegister("kxlHx", function(module, exports) {

$parcel$export(module.exports, "default", () => $ef37b923cabd07c5$export$2e2bcd8739ae039);

var $0bHlN = parcelRequire("0bHlN");

var $8J4RW = parcelRequire("8J4RW");

var $5cVVz = parcelRequire("5cVVz");

var $6aulQ = parcelRequire("6aulQ");
var // Take the difference between one array and a number of other arrays.
// Only the elements present in just the first array will remain.
$ef37b923cabd07c5$export$2e2bcd8739ae039 = (0, $0bHlN.default)(function(array, rest) {
    rest = (0, $8J4RW.default)(rest, true, true);
    return (0, $5cVVz.default)(array, function(value) {
        return !(0, $6aulQ.default)(rest, value);
    });
});

});


parcelRegister("kFtOh", function(module, exports) {

$parcel$export(module.exports, "default", () => $f0bec29b96d47a33$export$2e2bcd8739ae039);

var $7aTMn = parcelRequire("7aTMn");

var $fLkDf = parcelRequire("fLkDf");

var $iER8D = parcelRequire("iER8D");

var $6aulQ = parcelRequire("6aulQ");
function $f0bec29b96d47a33$export$2e2bcd8739ae039(array, isSorted, iteratee, context) {
    if (!(0, $7aTMn.default)(isSorted)) {
        context = iteratee;
        iteratee = isSorted;
        isSorted = false;
    }
    if (iteratee != null) iteratee = (0, $fLkDf.default)(iteratee, context);
    var result = [];
    var seen = [];
    for(var i = 0, length = (0, $iER8D.default)(array); i < length; i++){
        var value = array[i], computed = iteratee ? iteratee(value, i, array) : value;
        if (isSorted && !iteratee) {
            if (!i || seen !== computed) result.push(value);
            seen = computed;
        } else if (iteratee) {
            if (!(0, $6aulQ.default)(seen, computed)) {
                seen.push(computed);
                result.push(value);
            }
        } else if (!(0, $6aulQ.default)(result, value)) result.push(value);
    }
    return result;
}

});

parcelRegister("6AqJp", function(module, exports) {

$parcel$export(module.exports, "default", () => $4cbad72dc0b3402b$export$2e2bcd8739ae039);

var $0bHlN = parcelRequire("0bHlN");

var $kFtOh = parcelRequire("kFtOh");

var $8J4RW = parcelRequire("8J4RW");
var // Produce an array that contains the union: each distinct element from all of
// the passed-in arrays.
$4cbad72dc0b3402b$export$2e2bcd8739ae039 = (0, $0bHlN.default)(function(arrays) {
    return (0, $kFtOh.default)((0, $8J4RW.default)(arrays, true, true));
});

});

parcelRegister("8ABEg", function(module, exports) {

$parcel$export(module.exports, "default", () => $640ee3b4c6854636$export$2e2bcd8739ae039);

var $iER8D = parcelRequire("iER8D");

var $6aulQ = parcelRequire("6aulQ");
function $640ee3b4c6854636$export$2e2bcd8739ae039(array) {
    var result = [];
    var argsLength = arguments.length;
    for(var i = 0, length = (0, $iER8D.default)(array); i < length; i++){
        var item = array[i];
        if ((0, $6aulQ.default)(result, item)) continue;
        var j;
        for(j = 1; j < argsLength; j++){
            if (!(0, $6aulQ.default)(arguments[j], item)) break;
        }
        if (j === argsLength) result.push(item);
    }
    return result;
}

});

parcelRegister("jSqR4", function(module, exports) {

$parcel$export(module.exports, "default", () => $e787e451ed8ddde4$export$2e2bcd8739ae039);

var $kM5J8 = parcelRequire("kM5J8");

var $iER8D = parcelRequire("iER8D");

var $8E7vk = parcelRequire("8E7vk");
function $e787e451ed8ddde4$export$2e2bcd8739ae039(array) {
    var length = array && (0, $kM5J8.default)(array, (0, $iER8D.default)).length || 0;
    var result = Array(length);
    for(var index = 0; index < length; index++)result[index] = (0, $8E7vk.default)(array, index);
    return result;
}

});

parcelRegister("lOcEr", function(module, exports) {

$parcel$export(module.exports, "default", () => $fe0814bdf6654e7d$export$2e2bcd8739ae039);

var $0bHlN = parcelRequire("0bHlN");

var $jSqR4 = parcelRequire("jSqR4");
var // Zip together multiple lists into a single array -- elements that share
// an index go together.
$fe0814bdf6654e7d$export$2e2bcd8739ae039 = (0, $0bHlN.default)((0, $jSqR4.default));

});

parcelRegister("dgKNP", function(module, exports) {

$parcel$export(module.exports, "default", () => $9a9112ffd6f5d502$export$2e2bcd8739ae039);

var $iER8D = parcelRequire("iER8D");
function $9a9112ffd6f5d502$export$2e2bcd8739ae039(list, values) {
    var result = {};
    for(var i = 0, length = (0, $iER8D.default)(list); i < length; i++)if (values) result[list[i]] = values[i];
    else result[list[i][0]] = list[i][1];
    return result;
}

});

parcelRegister("9AMld", function(module, exports) {

$parcel$export(module.exports, "default", () => $6fbcf963c33899f9$export$2e2bcd8739ae039);
// Generate an integer Array containing an arithmetic progression. A port of
// the native Python `range()` function. See
// [the Python documentation](https://docs.python.org/library/functions.html#range).
function $6fbcf963c33899f9$export$2e2bcd8739ae039(start, stop, step) {
    if (stop == null) {
        stop = start || 0;
        start = 0;
    }
    if (!step) step = stop < start ? -1 : 1;
    var length = Math.max(Math.ceil((stop - start) / step), 0);
    var range = Array(length);
    for(var idx = 0; idx < length; idx++, start += step)range[idx] = start;
    return range;
}

});

parcelRegister("9lix7", function(module, exports) {

$parcel$export(module.exports, "default", () => $6cd4738b38ff6a08$export$2e2bcd8739ae039);

var $3TBJw = parcelRequire("3TBJw");
function $6cd4738b38ff6a08$export$2e2bcd8739ae039(array, count) {
    if (count == null || count < 1) return [];
    var result = [];
    var i = 0, length = array.length;
    while(i < length)result.push((0, $3TBJw.slice).call(array, i, i += count));
    return result;
}

});

parcelRegister("eVoGU", function(module, exports) {

$parcel$export(module.exports, "default", () => $add98ab171b98313$export$2e2bcd8739ae039);

var $6ZSi9 = parcelRequire("6ZSi9");

var $fVQTG = parcelRequire("fVQTG");

var $aROXJ = parcelRequire("aROXJ");

var $3TBJw = parcelRequire("3TBJw");

var $glTTM = parcelRequire("glTTM");
function $add98ab171b98313$export$2e2bcd8739ae039(obj) {
    (0, $fVQTG.default)((0, $aROXJ.default)(obj), function(name) {
        var func = (0, $6ZSi9.default)[name] = obj[name];
        (0, $6ZSi9.default).prototype[name] = function() {
            var args = [
                this._wrapped
            ];
            (0, $3TBJw.push).apply(args, arguments);
            return (0, $glTTM.default)(this, func.apply((0, $6ZSi9.default), args));
        };
    });
    return 0, $6ZSi9.default;
}

});
parcelRegister("glTTM", function(module, exports) {

$parcel$export(module.exports, "default", () => $be79f7cccb5c97d6$export$2e2bcd8739ae039);

var $6ZSi9 = parcelRequire("6ZSi9");
function $be79f7cccb5c97d6$export$2e2bcd8739ae039(instance, obj) {
    return instance._chain ? (0, $6ZSi9.default)(obj).chain() : obj;
}

});


parcelRegister("dNu6m", function(module, exports) {

$parcel$export(module.exports, "default", () => $a0b73385c05e176b$export$2e2bcd8739ae039);

var $6ZSi9 = parcelRequire("6ZSi9");

var $fVQTG = parcelRequire("fVQTG");

var $3TBJw = parcelRequire("3TBJw");

var $glTTM = parcelRequire("glTTM");
// Add all mutator `Array` functions to the wrapper.
(0, $fVQTG.default)([
    "pop",
    "push",
    "reverse",
    "shift",
    "sort",
    "splice",
    "unshift"
], function(name) {
    var method = (0, $3TBJw.ArrayProto)[name];
    (0, $6ZSi9.default).prototype[name] = function() {
        var obj = this._wrapped;
        if (obj != null) {
            method.apply(obj, arguments);
            if ((name === "shift" || name === "splice") && obj.length === 0) delete obj[0];
        }
        return (0, $glTTM.default)(this, obj);
    };
});
// Add all accessor `Array` functions to the wrapper.
(0, $fVQTG.default)([
    "concat",
    "join",
    "slice"
], function(name) {
    var method = (0, $3TBJw.ArrayProto)[name];
    (0, $6ZSi9.default).prototype[name] = function() {
        var obj = this._wrapped;
        if (obj != null) obj = method.apply(obj, arguments);
        return (0, $glTTM.default)(this, obj);
    };
});
var $a0b73385c05e176b$export$2e2bcd8739ae039 = (0, $6ZSi9.default);

});




parcelRegister("6KOho", function(module, exports) {
/*!
 * jQuery JavaScript Library v3.7.1
 * https://jquery.com/
 *
 * Copyright OpenJS Foundation and other contributors
 * Released under the MIT license
 * https://jquery.org/license
 *
 * Date: 2023-08-28T13:37Z
 */ (function(global, factory) {
    "use strict";
    if (typeof module.exports === "object") // For CommonJS and CommonJS-like environments where a proper `window`
    // is present, execute the factory and get jQuery.
    // For environments that do not have a `window` with a `document`
    // (such as Node.js), expose a factory as module.exports.
    // This accentuates the need for the creation of a real `window`.
    // e.g. var jQuery = require("jquery")(window);
    // See ticket trac-14549 for more info.
    module.exports = global.document ? factory(global, true) : function(w) {
        if (!w.document) throw new Error("jQuery requires a window with a document");
        return factory(w);
    };
    else factory(global);
// Pass this if window is not defined yet
})(typeof window !== "undefined" ? window : module.exports, function(window1, noGlobal) {
    // Edge <= 12 - 13+, Firefox <=18 - 45+, IE 10 - 11, Safari 5.1 - 9+, iOS 6 - 9.1
    // throw exceptions when non-strict code (e.g., ASP.NET 4.5) accesses strict mode
    // arguments.callee.caller (trac-13335). But as of jQuery 3.0 (2016), strict mode should be common
    // enough that all such attempts are guarded in a try block.
    "use strict";
    var arr = [];
    var getProto = Object.getPrototypeOf;
    var slice = arr.slice;
    var flat = arr.flat ? function(array) {
        return arr.flat.call(array);
    } : function(array) {
        return arr.concat.apply([], array);
    };
    var push = arr.push;
    var indexOf = arr.indexOf;
    var class2type = {};
    var toString = class2type.toString;
    var hasOwn = class2type.hasOwnProperty;
    var fnToString = hasOwn.toString;
    var ObjectFunctionString = fnToString.call(Object);
    var support = {};
    var isFunction = function isFunction(obj) {
        // Support: Chrome <=57, Firefox <=52
        // In some browsers, typeof returns "function" for HTML <object> elements
        // (i.e., `typeof document.createElement( "object" ) === "function"`).
        // We don't want to classify *any* DOM node as a function.
        // Support: QtWeb <=3.8.5, WebKit <=534.34, wkhtmltopdf tool <=0.12.5
        // Plus for old WebKit, typeof returns "function" for HTML collections
        // (e.g., `typeof document.getElementsByTagName("div") === "function"`). (gh-4756)
        return typeof obj === "function" && typeof obj.nodeType !== "number" && typeof obj.item !== "function";
    };
    var isWindow = function isWindow(obj) {
        return obj != null && obj === obj.window;
    };
    var document = window1.document;
    var preservedScriptAttributes = {
        type: true,
        src: true,
        nonce: true,
        noModule: true
    };
    function DOMEval(code, node, doc) {
        doc = doc || document;
        var i, val, script = doc.createElement("script");
        script.text = code;
        if (node) for(i in preservedScriptAttributes){
            // Support: Firefox 64+, Edge 18+
            // Some browsers don't support the "nonce" property on scripts.
            // On the other hand, just using `getAttribute` is not enough as
            // the `nonce` attribute is reset to an empty string whenever it
            // becomes browsing-context connected.
            // See https://github.com/whatwg/html/issues/2369
            // See https://html.spec.whatwg.org/#nonce-attributes
            // The `node.getAttribute` check was added for the sake of
            // `jQuery.globalEval` so that it can fake a nonce-containing node
            // via an object.
            val = node[i] || node.getAttribute && node.getAttribute(i);
            if (val) script.setAttribute(i, val);
        }
        doc.head.appendChild(script).parentNode.removeChild(script);
    }
    function toType(obj) {
        if (obj == null) return obj + "";
        // Support: Android <=2.3 only (functionish RegExp)
        return typeof obj === "object" || typeof obj === "function" ? class2type[toString.call(obj)] || "object" : typeof obj;
    }
    /* global Symbol */ // Defining this global in .eslintrc.json would create a danger of using the global
    // unguarded in another place, it seems safer to define global only for this module
    var version = "3.7.1", rhtmlSuffix = /HTML$/i, // Define a local copy of jQuery
    jQuery = function(selector, context) {
        // The jQuery object is actually just the init constructor 'enhanced'
        // Need init if jQuery is called (just allow error to be thrown if not included)
        return new jQuery.fn.init(selector, context);
    };
    jQuery.fn = jQuery.prototype = {
        // The current version of jQuery being used
        jquery: version,
        constructor: jQuery,
        // The default length of a jQuery object is 0
        length: 0,
        toArray: function() {
            return slice.call(this);
        },
        // Get the Nth element in the matched element set OR
        // Get the whole matched element set as a clean array
        get: function(num) {
            // Return all the elements in a clean array
            if (num == null) return slice.call(this);
            // Return just the one element from the set
            return num < 0 ? this[num + this.length] : this[num];
        },
        // Take an array of elements and push it onto the stack
        // (returning the new matched element set)
        pushStack: function(elems) {
            // Build a new jQuery matched element set
            var ret = jQuery.merge(this.constructor(), elems);
            // Add the old object onto the stack (as a reference)
            ret.prevObject = this;
            // Return the newly-formed element set
            return ret;
        },
        // Execute a callback for every element in the matched set.
        each: function(callback) {
            return jQuery.each(this, callback);
        },
        map: function(callback) {
            return this.pushStack(jQuery.map(this, function(elem, i) {
                return callback.call(elem, i, elem);
            }));
        },
        slice: function() {
            return this.pushStack(slice.apply(this, arguments));
        },
        first: function() {
            return this.eq(0);
        },
        last: function() {
            return this.eq(-1);
        },
        even: function() {
            return this.pushStack(jQuery.grep(this, function(_elem, i) {
                return (i + 1) % 2;
            }));
        },
        odd: function() {
            return this.pushStack(jQuery.grep(this, function(_elem, i) {
                return i % 2;
            }));
        },
        eq: function(i) {
            var len = this.length, j = +i + (i < 0 ? len : 0);
            return this.pushStack(j >= 0 && j < len ? [
                this[j]
            ] : []);
        },
        end: function() {
            return this.prevObject || this.constructor();
        },
        // For internal use only.
        // Behaves like an Array's method, not like a jQuery method.
        push: push,
        sort: arr.sort,
        splice: arr.splice
    };
    jQuery.extend = jQuery.fn.extend = function() {
        var options, name, src, copy, copyIsArray, clone, target = arguments[0] || {}, i = 1, length = arguments.length, deep = false;
        // Handle a deep copy situation
        if (typeof target === "boolean") {
            deep = target;
            // Skip the boolean and the target
            target = arguments[i] || {};
            i++;
        }
        // Handle case when target is a string or something (possible in deep copy)
        if (typeof target !== "object" && !isFunction(target)) target = {};
        // Extend jQuery itself if only one argument is passed
        if (i === length) {
            target = this;
            i--;
        }
        for(; i < length; i++){
            // Only deal with non-null/undefined values
            if ((options = arguments[i]) != null) // Extend the base object
            for(name in options){
                copy = options[name];
                // Prevent Object.prototype pollution
                // Prevent never-ending loop
                if (name === "__proto__" || target === copy) continue;
                // Recurse if we're merging plain objects or arrays
                if (deep && copy && (jQuery.isPlainObject(copy) || (copyIsArray = Array.isArray(copy)))) {
                    src = target[name];
                    // Ensure proper type for the source value
                    if (copyIsArray && !Array.isArray(src)) clone = [];
                    else if (!copyIsArray && !jQuery.isPlainObject(src)) clone = {};
                    else clone = src;
                    copyIsArray = false;
                    // Never move original objects, clone them
                    target[name] = jQuery.extend(deep, clone, copy);
                // Don't bring in undefined values
                } else if (copy !== undefined) target[name] = copy;
            }
        }
        // Return the modified object
        return target;
    };
    jQuery.extend({
        // Unique for each copy of jQuery on the page
        expando: "jQuery" + (version + Math.random()).replace(/\D/g, ""),
        // Assume jQuery is ready without the ready module
        isReady: true,
        error: function(msg) {
            throw new Error(msg);
        },
        noop: function() {},
        isPlainObject: function(obj) {
            var proto, Ctor;
            // Detect obvious negatives
            // Use toString instead of jQuery.type to catch host objects
            if (!obj || toString.call(obj) !== "[object Object]") return false;
            proto = getProto(obj);
            // Objects with no prototype (e.g., `Object.create( null )`) are plain
            if (!proto) return true;
            // Objects with prototype are plain iff they were constructed by a global Object function
            Ctor = hasOwn.call(proto, "constructor") && proto.constructor;
            return typeof Ctor === "function" && fnToString.call(Ctor) === ObjectFunctionString;
        },
        isEmptyObject: function(obj) {
            var name;
            for(name in obj)return false;
            return true;
        },
        // Evaluates a script in a provided context; falls back to the global one
        // if not specified.
        globalEval: function(code, options, doc) {
            DOMEval(code, {
                nonce: options && options.nonce
            }, doc);
        },
        each: function(obj, callback) {
            var length, i = 0;
            if (isArrayLike(obj)) {
                length = obj.length;
                for(; i < length; i++){
                    if (callback.call(obj[i], i, obj[i]) === false) break;
                }
            } else for(i in obj){
                if (callback.call(obj[i], i, obj[i]) === false) break;
            }
            return obj;
        },
        // Retrieve the text value of an array of DOM nodes
        text: function(elem) {
            var node, ret = "", i = 0, nodeType = elem.nodeType;
            if (!nodeType) // If no nodeType, this is expected to be an array
            while(node = elem[i++])// Do not traverse comment nodes
            ret += jQuery.text(node);
            if (nodeType === 1 || nodeType === 11) return elem.textContent;
            if (nodeType === 9) return elem.documentElement.textContent;
            if (nodeType === 3 || nodeType === 4) return elem.nodeValue;
            // Do not include comment or processing instruction nodes
            return ret;
        },
        // results is for internal usage only
        makeArray: function(arr, results) {
            var ret = results || [];
            if (arr != null) {
                if (isArrayLike(Object(arr))) jQuery.merge(ret, typeof arr === "string" ? [
                    arr
                ] : arr);
                else push.call(ret, arr);
            }
            return ret;
        },
        inArray: function(elem, arr, i) {
            return arr == null ? -1 : indexOf.call(arr, elem, i);
        },
        isXMLDoc: function(elem) {
            var namespace = elem && elem.namespaceURI, docElem = elem && (elem.ownerDocument || elem).documentElement;
            // Assume HTML when documentElement doesn't yet exist, such as inside
            // document fragments.
            return !rhtmlSuffix.test(namespace || docElem && docElem.nodeName || "HTML");
        },
        // Support: Android <=4.0 only, PhantomJS 1 only
        // push.apply(_, arraylike) throws on ancient WebKit
        merge: function(first, second) {
            var len = +second.length, j = 0, i = first.length;
            for(; j < len; j++)first[i++] = second[j];
            first.length = i;
            return first;
        },
        grep: function(elems, callback, invert) {
            var callbackInverse, matches = [], i = 0, length = elems.length, callbackExpect = !invert;
            // Go through the array, only saving the items
            // that pass the validator function
            for(; i < length; i++){
                callbackInverse = !callback(elems[i], i);
                if (callbackInverse !== callbackExpect) matches.push(elems[i]);
            }
            return matches;
        },
        // arg is for internal usage only
        map: function(elems, callback, arg) {
            var length, value, i = 0, ret = [];
            // Go through the array, translating each of the items to their new values
            if (isArrayLike(elems)) {
                length = elems.length;
                for(; i < length; i++){
                    value = callback(elems[i], i, arg);
                    if (value != null) ret.push(value);
                }
            // Go through every key on the object,
            } else for(i in elems){
                value = callback(elems[i], i, arg);
                if (value != null) ret.push(value);
            }
            // Flatten any nested arrays
            return flat(ret);
        },
        // A global GUID counter for objects
        guid: 1,
        // jQuery.support is not used in Core but other projects attach their
        // properties to it so it needs to exist.
        support: support
    });
    if (typeof Symbol === "function") jQuery.fn[Symbol.iterator] = arr[Symbol.iterator];
    // Populate the class2type map
    jQuery.each("Boolean Number String Function Array Date RegExp Object Error Symbol".split(" "), function(_i, name) {
        class2type["[object " + name + "]"] = name.toLowerCase();
    });
    function isArrayLike(obj) {
        // Support: real iOS 8.2 only (not reproducible in simulator)
        // `in` check used to prevent JIT error (gh-2145)
        // hasOwn isn't used here due to false negatives
        // regarding Nodelist length in IE
        var length = !!obj && "length" in obj && obj.length, type = toType(obj);
        if (isFunction(obj) || isWindow(obj)) return false;
        return type === "array" || length === 0 || typeof length === "number" && length > 0 && length - 1 in obj;
    }
    function nodeName(elem, name) {
        return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();
    }
    var pop = arr.pop;
    var sort = arr.sort;
    var splice = arr.splice;
    var whitespace = "[\\x20\\t\\r\\n\\f]";
    var rtrimCSS = new RegExp("^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" + whitespace + "+$", "g");
    // Note: an element does not contain itself
    jQuery.contains = function(a, b) {
        var bup = b && b.parentNode;
        return a === bup || !!(bup && bup.nodeType === 1 && // Support: IE 9 - 11+
        // IE doesn't have `contains` on SVG.
        (a.contains ? a.contains(bup) : a.compareDocumentPosition && a.compareDocumentPosition(bup) & 16));
    };
    // CSS string/identifier serialization
    // https://drafts.csswg.org/cssom/#common-serializing-idioms
    var rcssescape = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\x80-\uFFFF\w-]/g;
    function fcssescape(ch, asCodePoint) {
        if (asCodePoint) {
            // U+0000 NULL becomes U+FFFD REPLACEMENT CHARACTER
            if (ch === "\0") return "\uFFFD";
            // Control characters and (dependent upon position) numbers get escaped as code points
            return ch.slice(0, -1) + "\\" + ch.charCodeAt(ch.length - 1).toString(16) + " ";
        }
        // Other potentially-special ASCII characters get backslash-escaped
        return "\\" + ch;
    }
    jQuery.escapeSelector = function(sel) {
        return (sel + "").replace(rcssescape, fcssescape);
    };
    var preferredDoc = document, pushNative = push;
    (function() {
        var i, Expr, outermostContext, sortInput, hasDuplicate, push = pushNative, // Local document vars
        document, documentElement, documentIsHTML, rbuggyQSA, matches, // Instance-specific data
        expando = jQuery.expando, dirruns = 0, done = 0, classCache = createCache(), tokenCache = createCache(), compilerCache = createCache(), nonnativeSelectorCache = createCache(), sortOrder = function(a, b) {
            if (a === b) hasDuplicate = true;
            return 0;
        }, booleans = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped", // Regular expressions
        // https://www.w3.org/TR/css-syntax-3/#ident-token-diagram
        identifier = "(?:\\\\[\\da-fA-F]{1,6}" + whitespace + "?|\\\\[^\\r\\n\\f]|[\\w-]|[^\0-\\x7f])+", // Attribute selectors: https://www.w3.org/TR/selectors/#attribute-selectors
        attributes = "\\[" + whitespace + "*(" + identifier + ")(?:" + whitespace + // Operator (capture 2)
        "*([*^$|!~]?=)" + whitespace + // "Attribute values must be CSS identifiers [capture 5] or strings [capture 3 or capture 4]"
        "*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + identifier + "))|)" + whitespace + "*\\]", pseudos = ":(" + identifier + ")(?:\\((" + // To reduce the number of selectors needing tokenize in the preFilter, prefer arguments:
        // 1. quoted (capture 3; capture 4 or capture 5)
        "('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" + // 2. simple (capture 6)
        "((?:\\\\.|[^\\\\()[\\]]|" + attributes + ")*)|" + // 3. anything else (capture 2)
        ".*" + ")\\)|)", // Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter
        rwhitespace = new RegExp(whitespace + "+", "g"), rcomma = new RegExp("^" + whitespace + "*," + whitespace + "*"), rleadingCombinator = new RegExp("^" + whitespace + "*([>+~]|" + whitespace + ")" + whitespace + "*"), rdescend = new RegExp(whitespace + "|>"), rpseudo = new RegExp(pseudos), ridentifier = new RegExp("^" + identifier + "$"), matchExpr = {
            ID: new RegExp("^#(" + identifier + ")"),
            CLASS: new RegExp("^\\.(" + identifier + ")"),
            TAG: new RegExp("^(" + identifier + "|[*])"),
            ATTR: new RegExp("^" + attributes),
            PSEUDO: new RegExp("^" + pseudos),
            CHILD: new RegExp("^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + whitespace + "*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" + whitespace + "*(\\d+)|))" + whitespace + "*\\)|)", "i"),
            bool: new RegExp("^(?:" + booleans + ")$", "i"),
            // For use in libraries implementing .is()
            // We use this for POS matching in `select`
            needsContext: new RegExp("^" + whitespace + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" + whitespace + "*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i")
        }, rinputs = /^(?:input|select|textarea|button)$/i, rheader = /^h\d$/i, // Easily-parseable/retrievable ID or TAG or CLASS selectors
        rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/, rsibling = /[+~]/, // CSS escapes
        // https://www.w3.org/TR/CSS21/syndata.html#escaped-characters
        runescape = new RegExp("\\\\[\\da-fA-F]{1,6}" + whitespace + "?|\\\\([^\\r\\n\\f])", "g"), funescape = function(escape, nonHex) {
            var high = "0x" + escape.slice(1) - 0x10000;
            if (nonHex) // Strip the backslash prefix from a non-hex escape sequence
            return nonHex;
            // Replace a hexadecimal escape sequence with the encoded Unicode code point
            // Support: IE <=11+
            // For values outside the Basic Multilingual Plane (BMP), manually construct a
            // surrogate pair
            return high < 0 ? String.fromCharCode(high + 0x10000) : String.fromCharCode(high >> 10 | 0xD800, high & 0x3FF | 0xDC00);
        }, // Used for iframes; see `setDocument`.
        // Support: IE 9 - 11+, Edge 12 - 18+
        // Removing the function wrapper causes a "Permission Denied"
        // error in IE/Edge.
        unloadHandler = function() {
            setDocument();
        }, inDisabledFieldset = addCombinator(function(elem) {
            return elem.disabled === true && nodeName(elem, "fieldset");
        }, {
            dir: "parentNode",
            next: "legend"
        });
        // Support: IE <=9 only
        // Accessing document.activeElement can throw unexpectedly
        // https://bugs.jquery.com/ticket/13393
        function safeActiveElement() {
            try {
                return document.activeElement;
            } catch (err) {}
        }
        // Optimize for push.apply( _, NodeList )
        try {
            push.apply(arr = slice.call(preferredDoc.childNodes), preferredDoc.childNodes);
            // Support: Android <=4.0
            // Detect silently failing push.apply
            // eslint-disable-next-line no-unused-expressions
            arr[preferredDoc.childNodes.length].nodeType;
        } catch (e) {
            push = {
                apply: function(target, els) {
                    pushNative.apply(target, slice.call(els));
                },
                call: function(target) {
                    pushNative.apply(target, slice.call(arguments, 1));
                }
            };
        }
        function find(selector, context, results, seed) {
            var m, i, elem, nid, match, groups, newSelector, newContext = context && context.ownerDocument, // nodeType defaults to 9, since context defaults to document
            nodeType = context ? context.nodeType : 9;
            results = results || [];
            // Return early from calls with invalid selector or context
            if (typeof selector !== "string" || !selector || nodeType !== 1 && nodeType !== 9 && nodeType !== 11) return results;
            // Try to shortcut find operations (as opposed to filters) in HTML documents
            if (!seed) {
                setDocument(context);
                context = context || document;
                if (documentIsHTML) {
                    // If the selector is sufficiently simple, try using a "get*By*" DOM method
                    // (excepting DocumentFragment context, where the methods don't exist)
                    if (nodeType !== 11 && (match = rquickExpr.exec(selector))) {
                        // ID selector
                        if (m = match[1]) {
                            // Document context
                            if (nodeType === 9) {
                                if (elem = context.getElementById(m)) // Support: IE 9 only
                                // getElementById can match elements by name instead of ID
                                {
                                    if (elem.id === m) {
                                        push.call(results, elem);
                                        return results;
                                    }
                                } else return results;
                            // Element context
                            } else // Support: IE 9 only
                            // getElementById can match elements by name instead of ID
                            if (newContext && (elem = newContext.getElementById(m)) && find.contains(context, elem) && elem.id === m) {
                                push.call(results, elem);
                                return results;
                            }
                        // Type selector
                        } else if (match[2]) {
                            push.apply(results, context.getElementsByTagName(selector));
                            return results;
                        // Class selector
                        } else if ((m = match[3]) && context.getElementsByClassName) {
                            push.apply(results, context.getElementsByClassName(m));
                            return results;
                        }
                    }
                    // Take advantage of querySelectorAll
                    if (!nonnativeSelectorCache[selector + " "] && (!rbuggyQSA || !rbuggyQSA.test(selector))) {
                        newSelector = selector;
                        newContext = context;
                        // qSA considers elements outside a scoping root when evaluating child or
                        // descendant combinators, which is not what we want.
                        // In such cases, we work around the behavior by prefixing every selector in the
                        // list with an ID selector referencing the scope context.
                        // The technique has to be used as well when a leading combinator is used
                        // as such selectors are not recognized by querySelectorAll.
                        // Thanks to Andrew Dupont for this technique.
                        if (nodeType === 1 && (rdescend.test(selector) || rleadingCombinator.test(selector))) {
                            // Expand context for sibling selectors
                            newContext = rsibling.test(selector) && testContext(context.parentNode) || context;
                            // We can use :scope instead of the ID hack if the browser
                            // supports it & if we're not changing the context.
                            // Support: IE 11+, Edge 17 - 18+
                            // IE/Edge sometimes throw a "Permission denied" error when
                            // strict-comparing two documents; shallow comparisons work.
                            // eslint-disable-next-line eqeqeq
                            if (newContext != context || !support.scope) {
                                // Capture the context ID, setting it first if necessary
                                if (nid = context.getAttribute("id")) nid = jQuery.escapeSelector(nid);
                                else context.setAttribute("id", nid = expando);
                            }
                            // Prefix every selector in the list
                            groups = tokenize(selector);
                            i = groups.length;
                            while(i--)groups[i] = (nid ? "#" + nid : ":scope") + " " + toSelector(groups[i]);
                            newSelector = groups.join(",");
                        }
                        try {
                            push.apply(results, newContext.querySelectorAll(newSelector));
                            return results;
                        } catch (qsaError) {
                            nonnativeSelectorCache(selector, true);
                        } finally{
                            if (nid === expando) context.removeAttribute("id");
                        }
                    }
                }
            }
            // All others
            return select(selector.replace(rtrimCSS, "$1"), context, results, seed);
        }
        /**
 * Create key-value caches of limited size
 * @returns {function(string, object)} Returns the Object data after storing it on itself with
 *	property name the (space-suffixed) string and (if the cache is larger than Expr.cacheLength)
 *	deleting the oldest entry
 */ function createCache() {
            var keys = [];
            function cache(key, value) {
                // Use (key + " ") to avoid collision with native prototype properties
                // (see https://github.com/jquery/sizzle/issues/157)
                if (keys.push(key + " ") > Expr.cacheLength) // Only keep the most recent entries
                delete cache[keys.shift()];
                return cache[key + " "] = value;
            }
            return cache;
        }
        /**
 * Mark a function for special use by jQuery selector module
 * @param {Function} fn The function to mark
 */ function markFunction(fn) {
            fn[expando] = true;
            return fn;
        }
        /**
 * Support testing using an element
 * @param {Function} fn Passed the created element and returns a boolean result
 */ function assert(fn) {
            var el = document.createElement("fieldset");
            try {
                return !!fn(el);
            } catch (e) {
                return false;
            } finally{
                // Remove from its parent by default
                if (el.parentNode) el.parentNode.removeChild(el);
                // release memory in IE
                el = null;
            }
        }
        /**
 * Returns a function to use in pseudos for input types
 * @param {String} type
 */ function createInputPseudo(type) {
            return function(elem) {
                return nodeName(elem, "input") && elem.type === type;
            };
        }
        /**
 * Returns a function to use in pseudos for buttons
 * @param {String} type
 */ function createButtonPseudo(type) {
            return function(elem) {
                return (nodeName(elem, "input") || nodeName(elem, "button")) && elem.type === type;
            };
        }
        /**
 * Returns a function to use in pseudos for :enabled/:disabled
 * @param {Boolean} disabled true for :disabled; false for :enabled
 */ function createDisabledPseudo(disabled) {
            // Known :disabled false positives: fieldset[disabled] > legend:nth-of-type(n+2) :can-disable
            return function(elem) {
                // Only certain elements can match :enabled or :disabled
                // https://html.spec.whatwg.org/multipage/scripting.html#selector-enabled
                // https://html.spec.whatwg.org/multipage/scripting.html#selector-disabled
                if ("form" in elem) {
                    // Check for inherited disabledness on relevant non-disabled elements:
                    // * listed form-associated elements in a disabled fieldset
                    //   https://html.spec.whatwg.org/multipage/forms.html#category-listed
                    //   https://html.spec.whatwg.org/multipage/forms.html#concept-fe-disabled
                    // * option elements in a disabled optgroup
                    //   https://html.spec.whatwg.org/multipage/forms.html#concept-option-disabled
                    // All such elements have a "form" property.
                    if (elem.parentNode && elem.disabled === false) {
                        // Option elements defer to a parent optgroup if present
                        if ("label" in elem) {
                            if ("label" in elem.parentNode) return elem.parentNode.disabled === disabled;
                            else return elem.disabled === disabled;
                        }
                        // Support: IE 6 - 11+
                        // Use the isDisabled shortcut property to check for disabled fieldset ancestors
                        return elem.isDisabled === disabled || // Where there is no isDisabled, check manually
                        elem.isDisabled !== !disabled && inDisabledFieldset(elem) === disabled;
                    }
                    return elem.disabled === disabled;
                // Try to winnow out elements that can't be disabled before trusting the disabled property.
                // Some victims get caught in our net (label, legend, menu, track), but it shouldn't
                // even exist on them, let alone have a boolean value.
                } else if ("label" in elem) return elem.disabled === disabled;
                // Remaining elements are neither :enabled nor :disabled
                return false;
            };
        }
        /**
 * Returns a function to use in pseudos for positionals
 * @param {Function} fn
 */ function createPositionalPseudo(fn) {
            return markFunction(function(argument) {
                argument = +argument;
                return markFunction(function(seed, matches) {
                    var j, matchIndexes = fn([], seed.length, argument), i = matchIndexes.length;
                    // Match elements found at the specified indexes
                    while(i--)if (seed[j = matchIndexes[i]]) seed[j] = !(matches[j] = seed[j]);
                });
            });
        }
        /**
 * Checks a node for validity as a jQuery selector context
 * @param {Element|Object=} context
 * @returns {Element|Object|Boolean} The input node if acceptable, otherwise a falsy value
 */ function testContext(context) {
            return context && typeof context.getElementsByTagName !== "undefined" && context;
        }
        /**
 * Sets document-related variables once based on the current document
 * @param {Element|Object} [node] An element or document object to use to set the document
 * @returns {Object} Returns the current document
 */ function setDocument(node) {
            var subWindow, doc = node ? node.ownerDocument || node : preferredDoc;
            // Return early if doc is invalid or already selected
            // Support: IE 11+, Edge 17 - 18+
            // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
            // two documents; shallow comparisons work.
            // eslint-disable-next-line eqeqeq
            if (doc == document || doc.nodeType !== 9 || !doc.documentElement) return document;
            // Update global variables
            document = doc;
            documentElement = document.documentElement;
            documentIsHTML = !jQuery.isXMLDoc(document);
            // Support: iOS 7 only, IE 9 - 11+
            // Older browsers didn't support unprefixed `matches`.
            matches = documentElement.matches || documentElement.webkitMatchesSelector || documentElement.msMatchesSelector;
            // Support: IE 9 - 11+, Edge 12 - 18+
            // Accessing iframe documents after unload throws "permission denied" errors
            // (see trac-13936).
            // Limit the fix to IE & Edge Legacy; despite Edge 15+ implementing `matches`,
            // all IE 9+ and Edge Legacy versions implement `msMatchesSelector` as well.
            if (documentElement.msMatchesSelector && // Support: IE 11+, Edge 17 - 18+
            // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
            // two documents; shallow comparisons work.
            // eslint-disable-next-line eqeqeq
            preferredDoc != document && (subWindow = document.defaultView) && subWindow.top !== subWindow) // Support: IE 9 - 11+, Edge 12 - 18+
            subWindow.addEventListener("unload", unloadHandler);
            // Support: IE <10
            // Check if getElementById returns elements by name
            // The broken getElementById methods don't pick up programmatically-set names,
            // so use a roundabout getElementsByName test
            support.getById = assert(function(el) {
                documentElement.appendChild(el).id = jQuery.expando;
                return !document.getElementsByName || !document.getElementsByName(jQuery.expando).length;
            });
            // Support: IE 9 only
            // Check to see if it's possible to do matchesSelector
            // on a disconnected node.
            support.disconnectedMatch = assert(function(el) {
                return matches.call(el, "*");
            });
            // Support: IE 9 - 11+, Edge 12 - 18+
            // IE/Edge don't support the :scope pseudo-class.
            support.scope = assert(function() {
                return document.querySelectorAll(":scope");
            });
            // Support: Chrome 105 - 111 only, Safari 15.4 - 16.3 only
            // Make sure the `:has()` argument is parsed unforgivingly.
            // We include `*` in the test to detect buggy implementations that are
            // _selectively_ forgiving (specifically when the list includes at least
            // one valid selector).
            // Note that we treat complete lack of support for `:has()` as if it were
            // spec-compliant support, which is fine because use of `:has()` in such
            // environments will fail in the qSA path and fall back to jQuery traversal
            // anyway.
            support.cssHas = assert(function() {
                try {
                    document.querySelector(":has(*,:jqfake)");
                    return false;
                } catch (e) {
                    return true;
                }
            });
            // ID filter and find
            if (support.getById) {
                Expr.filter.ID = function(id) {
                    var attrId = id.replace(runescape, funescape);
                    return function(elem) {
                        return elem.getAttribute("id") === attrId;
                    };
                };
                Expr.find.ID = function(id, context) {
                    if (typeof context.getElementById !== "undefined" && documentIsHTML) {
                        var elem = context.getElementById(id);
                        return elem ? [
                            elem
                        ] : [];
                    }
                };
            } else {
                Expr.filter.ID = function(id) {
                    var attrId = id.replace(runescape, funescape);
                    return function(elem) {
                        var node = typeof elem.getAttributeNode !== "undefined" && elem.getAttributeNode("id");
                        return node && node.value === attrId;
                    };
                };
                // Support: IE 6 - 7 only
                // getElementById is not reliable as a find shortcut
                Expr.find.ID = function(id, context) {
                    if (typeof context.getElementById !== "undefined" && documentIsHTML) {
                        var node, i, elems, elem = context.getElementById(id);
                        if (elem) {
                            // Verify the id attribute
                            node = elem.getAttributeNode("id");
                            if (node && node.value === id) return [
                                elem
                            ];
                            // Fall back on getElementsByName
                            elems = context.getElementsByName(id);
                            i = 0;
                            while(elem = elems[i++]){
                                node = elem.getAttributeNode("id");
                                if (node && node.value === id) return [
                                    elem
                                ];
                            }
                        }
                        return [];
                    }
                };
            }
            // Tag
            Expr.find.TAG = function(tag, context) {
                if (typeof context.getElementsByTagName !== "undefined") return context.getElementsByTagName(tag);
                else return context.querySelectorAll(tag);
            };
            // Class
            Expr.find.CLASS = function(className, context) {
                if (typeof context.getElementsByClassName !== "undefined" && documentIsHTML) return context.getElementsByClassName(className);
            };
            /* QSA/matchesSelector
	---------------------------------------------------------------------- */ // QSA and matchesSelector support
            rbuggyQSA = [];
            // Build QSA regex
            // Regex strategy adopted from Diego Perini
            assert(function(el) {
                var input;
                documentElement.appendChild(el).innerHTML = "<a id='" + expando + "' href='' disabled='disabled'></a>" + "<select id='" + expando + "-\r\\' disabled='disabled'>" + "<option selected=''></option></select>";
                // Support: iOS <=7 - 8 only
                // Boolean attributes and "value" are not treated correctly in some XML documents
                if (!el.querySelectorAll("[selected]").length) rbuggyQSA.push("\\[" + whitespace + "*(?:value|" + booleans + ")");
                // Support: iOS <=7 - 8 only
                if (!el.querySelectorAll("[id~=" + expando + "-]").length) rbuggyQSA.push("~=");
                // Support: iOS 8 only
                // https://bugs.webkit.org/show_bug.cgi?id=136851
                // In-page `selector#id sibling-combinator selector` fails
                if (!el.querySelectorAll("a#" + expando + "+*").length) rbuggyQSA.push(".#.+[+~]");
                // Support: Chrome <=105+, Firefox <=104+, Safari <=15.4+
                // In some of the document kinds, these selectors wouldn't work natively.
                // This is probably OK but for backwards compatibility we want to maintain
                // handling them through jQuery traversal in jQuery 3.x.
                if (!el.querySelectorAll(":checked").length) rbuggyQSA.push(":checked");
                // Support: Windows 8 Native Apps
                // The type and name attributes are restricted during .innerHTML assignment
                input = document.createElement("input");
                input.setAttribute("type", "hidden");
                el.appendChild(input).setAttribute("name", "D");
                // Support: IE 9 - 11+
                // IE's :disabled selector does not pick up the children of disabled fieldsets
                // Support: Chrome <=105+, Firefox <=104+, Safari <=15.4+
                // In some of the document kinds, these selectors wouldn't work natively.
                // This is probably OK but for backwards compatibility we want to maintain
                // handling them through jQuery traversal in jQuery 3.x.
                documentElement.appendChild(el).disabled = true;
                if (el.querySelectorAll(":disabled").length !== 2) rbuggyQSA.push(":enabled", ":disabled");
                // Support: IE 11+, Edge 15 - 18+
                // IE 11/Edge don't find elements on a `[name='']` query in some cases.
                // Adding a temporary attribute to the document before the selection works
                // around the issue.
                // Interestingly, IE 10 & older don't seem to have the issue.
                input = document.createElement("input");
                input.setAttribute("name", "");
                el.appendChild(input);
                if (!el.querySelectorAll("[name='']").length) rbuggyQSA.push("\\[" + whitespace + "*name" + whitespace + "*=" + whitespace + "*(?:''|\"\")");
            });
            if (!support.cssHas) // Support: Chrome 105 - 110+, Safari 15.4 - 16.3+
            // Our regular `try-catch` mechanism fails to detect natively-unsupported
            // pseudo-classes inside `:has()` (such as `:has(:contains("Foo"))`)
            // in browsers that parse the `:has()` argument as a forgiving selector list.
            // https://drafts.csswg.org/selectors/#relational now requires the argument
            // to be parsed unforgivingly, but browsers have not yet fully adjusted.
            rbuggyQSA.push(":has");
            rbuggyQSA = rbuggyQSA.length && new RegExp(rbuggyQSA.join("|"));
            /* Sorting
	---------------------------------------------------------------------- */ // Document order sorting
            sortOrder = function(a, b) {
                // Flag for duplicate removal
                if (a === b) {
                    hasDuplicate = true;
                    return 0;
                }
                // Sort on method existence if only one input has compareDocumentPosition
                var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
                if (compare) return compare;
                // Calculate position if both inputs belong to the same document
                // Support: IE 11+, Edge 17 - 18+
                // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                // two documents; shallow comparisons work.
                // eslint-disable-next-line eqeqeq
                compare = (a.ownerDocument || a) == (b.ownerDocument || b) ? a.compareDocumentPosition(b) : // Otherwise we know they are disconnected
                1;
                // Disconnected nodes
                if (compare & 1 || !support.sortDetached && b.compareDocumentPosition(a) === compare) {
                    // Choose the first element that is related to our preferred document
                    // Support: IE 11+, Edge 17 - 18+
                    // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                    // two documents; shallow comparisons work.
                    // eslint-disable-next-line eqeqeq
                    if (a === document || a.ownerDocument == preferredDoc && find.contains(preferredDoc, a)) return -1;
                    // Support: IE 11+, Edge 17 - 18+
                    // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                    // two documents; shallow comparisons work.
                    // eslint-disable-next-line eqeqeq
                    if (b === document || b.ownerDocument == preferredDoc && find.contains(preferredDoc, b)) return 1;
                    // Maintain original order
                    return sortInput ? indexOf.call(sortInput, a) - indexOf.call(sortInput, b) : 0;
                }
                return compare & 4 ? -1 : 1;
            };
            return document;
        }
        find.matches = function(expr, elements) {
            return find(expr, null, null, elements);
        };
        find.matchesSelector = function(elem, expr) {
            setDocument(elem);
            if (documentIsHTML && !nonnativeSelectorCache[expr + " "] && (!rbuggyQSA || !rbuggyQSA.test(expr))) try {
                var ret = matches.call(elem, expr);
                // IE 9's matchesSelector returns false on disconnected nodes
                if (ret || support.disconnectedMatch || // As well, disconnected nodes are said to be in a document
                // fragment in IE 9
                elem.document && elem.document.nodeType !== 11) return ret;
            } catch (e) {
                nonnativeSelectorCache(expr, true);
            }
            return find(expr, document, null, [
                elem
            ]).length > 0;
        };
        find.contains = function(context, elem) {
            // Set document vars if needed
            // Support: IE 11+, Edge 17 - 18+
            // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
            // two documents; shallow comparisons work.
            // eslint-disable-next-line eqeqeq
            if ((context.ownerDocument || context) != document) setDocument(context);
            return jQuery.contains(context, elem);
        };
        find.attr = function(elem, name) {
            // Set document vars if needed
            // Support: IE 11+, Edge 17 - 18+
            // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
            // two documents; shallow comparisons work.
            // eslint-disable-next-line eqeqeq
            if ((elem.ownerDocument || elem) != document) setDocument(elem);
            var fn = Expr.attrHandle[name.toLowerCase()], // Don't get fooled by Object.prototype properties (see trac-13807)
            val = fn && hasOwn.call(Expr.attrHandle, name.toLowerCase()) ? fn(elem, name, !documentIsHTML) : undefined;
            if (val !== undefined) return val;
            return elem.getAttribute(name);
        };
        find.error = function(msg) {
            throw new Error("Syntax error, unrecognized expression: " + msg);
        };
        /**
 * Document sorting and removing duplicates
 * @param {ArrayLike} results
 */ jQuery.uniqueSort = function(results) {
            var elem, duplicates = [], j = 0, i = 0;
            // Unless we *know* we can detect duplicates, assume their presence
            //
            // Support: Android <=4.0+
            // Testing for detecting duplicates is unpredictable so instead assume we can't
            // depend on duplicate detection in all browsers without a stable sort.
            hasDuplicate = !support.sortStable;
            sortInput = !support.sortStable && slice.call(results, 0);
            sort.call(results, sortOrder);
            if (hasDuplicate) {
                while(elem = results[i++])if (elem === results[i]) j = duplicates.push(i);
                while(j--)splice.call(results, duplicates[j], 1);
            }
            // Clear input after sorting to release objects
            // See https://github.com/jquery/sizzle/pull/225
            sortInput = null;
            return results;
        };
        jQuery.fn.uniqueSort = function() {
            return this.pushStack(jQuery.uniqueSort(slice.apply(this)));
        };
        Expr = jQuery.expr = {
            // Can be adjusted by the user
            cacheLength: 50,
            createPseudo: markFunction,
            match: matchExpr,
            attrHandle: {},
            find: {},
            relative: {
                ">": {
                    dir: "parentNode",
                    first: true
                },
                " ": {
                    dir: "parentNode"
                },
                "+": {
                    dir: "previousSibling",
                    first: true
                },
                "~": {
                    dir: "previousSibling"
                }
            },
            preFilter: {
                ATTR: function(match) {
                    match[1] = match[1].replace(runescape, funescape);
                    // Move the given value to match[3] whether quoted or unquoted
                    match[3] = (match[3] || match[4] || match[5] || "").replace(runescape, funescape);
                    if (match[2] === "~=") match[3] = " " + match[3] + " ";
                    return match.slice(0, 4);
                },
                CHILD: function(match) {
                    /* matches from matchExpr["CHILD"]
				1 type (only|nth|...)
				2 what (child|of-type)
				3 argument (even|odd|\d*|\d*n([+-]\d+)?|...)
				4 xn-component of xn+y argument ([+-]?\d*n|)
				5 sign of xn-component
				6 x of xn-component
				7 sign of y-component
				8 y of y-component
			*/ match[1] = match[1].toLowerCase();
                    if (match[1].slice(0, 3) === "nth") {
                        // nth-* requires argument
                        if (!match[3]) find.error(match[0]);
                        // numeric x and y parameters for Expr.filter.CHILD
                        // remember that false/true cast respectively to 0/1
                        match[4] = +(match[4] ? match[5] + (match[6] || 1) : 2 * (match[3] === "even" || match[3] === "odd"));
                        match[5] = +(match[7] + match[8] || match[3] === "odd");
                    // other types prohibit arguments
                    } else if (match[3]) find.error(match[0]);
                    return match;
                },
                PSEUDO: function(match) {
                    var excess, unquoted = !match[6] && match[2];
                    if (matchExpr.CHILD.test(match[0])) return null;
                    // Accept quoted arguments as-is
                    if (match[3]) match[2] = match[4] || match[5] || "";
                    else if (unquoted && rpseudo.test(unquoted) && // Get excess from tokenize (recursively)
                    (excess = tokenize(unquoted, true)) && // advance to the next closing parenthesis
                    (excess = unquoted.indexOf(")", unquoted.length - excess) - unquoted.length)) {
                        // excess is a negative index
                        match[0] = match[0].slice(0, excess);
                        match[2] = unquoted.slice(0, excess);
                    }
                    // Return only captures needed by the pseudo filter method (type and argument)
                    return match.slice(0, 3);
                }
            },
            filter: {
                TAG: function(nodeNameSelector) {
                    var expectedNodeName = nodeNameSelector.replace(runescape, funescape).toLowerCase();
                    return nodeNameSelector === "*" ? function() {
                        return true;
                    } : function(elem) {
                        return nodeName(elem, expectedNodeName);
                    };
                },
                CLASS: function(className) {
                    var pattern = classCache[className + " "];
                    return pattern || (pattern = new RegExp("(^|" + whitespace + ")" + className + "(" + whitespace + "|$)"), classCache(className, function(elem) {
                        return pattern.test(typeof elem.className === "string" && elem.className || typeof elem.getAttribute !== "undefined" && elem.getAttribute("class") || "");
                    }));
                },
                ATTR: function(name, operator, check) {
                    return function(elem) {
                        var result = find.attr(elem, name);
                        if (result == null) return operator === "!=";
                        if (!operator) return true;
                        result += "";
                        if (operator === "=") return result === check;
                        if (operator === "!=") return result !== check;
                        if (operator === "^=") return check && result.indexOf(check) === 0;
                        if (operator === "*=") return check && result.indexOf(check) > -1;
                        if (operator === "$=") return check && result.slice(-check.length) === check;
                        if (operator === "~=") return (" " + result.replace(rwhitespace, " ") + " ").indexOf(check) > -1;
                        if (operator === "|=") return result === check || result.slice(0, check.length + 1) === check + "-";
                        return false;
                    };
                },
                CHILD: function(type, what, _argument, first, last) {
                    var simple = type.slice(0, 3) !== "nth", forward = type.slice(-4) !== "last", ofType = what === "of-type";
                    return first === 1 && last === 0 ? // Shortcut for :nth-*(n)
                    function(elem) {
                        return !!elem.parentNode;
                    } : function(elem, _context, xml) {
                        var cache, outerCache, node, nodeIndex, start, dir = simple !== forward ? "nextSibling" : "previousSibling", parent = elem.parentNode, name = ofType && elem.nodeName.toLowerCase(), useCache = !xml && !ofType, diff = false;
                        if (parent) {
                            // :(first|last|only)-(child|of-type)
                            if (simple) {
                                while(dir){
                                    node = elem;
                                    while(node = node[dir]){
                                        if (ofType ? nodeName(node, name) : node.nodeType === 1) return false;
                                    }
                                    // Reverse direction for :only-* (if we haven't yet done so)
                                    start = dir = type === "only" && !start && "nextSibling";
                                }
                                return true;
                            }
                            start = [
                                forward ? parent.firstChild : parent.lastChild
                            ];
                            // non-xml :nth-child(...) stores cache data on `parent`
                            if (forward && useCache) {
                                // Seek `elem` from a previously-cached index
                                outerCache = parent[expando] || (parent[expando] = {});
                                cache = outerCache[type] || [];
                                nodeIndex = cache[0] === dirruns && cache[1];
                                diff = nodeIndex && cache[2];
                                node = nodeIndex && parent.childNodes[nodeIndex];
                                while(node = ++nodeIndex && node && node[dir] || // Fallback to seeking `elem` from the start
                                (diff = nodeIndex = 0) || start.pop())// When found, cache indexes on `parent` and break
                                if (node.nodeType === 1 && ++diff && node === elem) {
                                    outerCache[type] = [
                                        dirruns,
                                        nodeIndex,
                                        diff
                                    ];
                                    break;
                                }
                            } else {
                                // Use previously-cached element index if available
                                if (useCache) {
                                    outerCache = elem[expando] || (elem[expando] = {});
                                    cache = outerCache[type] || [];
                                    nodeIndex = cache[0] === dirruns && cache[1];
                                    diff = nodeIndex;
                                }
                                // xml :nth-child(...)
                                // or :nth-last-child(...) or :nth(-last)?-of-type(...)
                                if (diff === false) {
                                    // Use the same loop as above to seek `elem` from the start
                                    while(node = ++nodeIndex && node && node[dir] || (diff = nodeIndex = 0) || start.pop())if ((ofType ? nodeName(node, name) : node.nodeType === 1) && ++diff) {
                                        // Cache the index of each encountered element
                                        if (useCache) {
                                            outerCache = node[expando] || (node[expando] = {});
                                            outerCache[type] = [
                                                dirruns,
                                                diff
                                            ];
                                        }
                                        if (node === elem) break;
                                    }
                                }
                            }
                            // Incorporate the offset, then check against cycle size
                            diff -= last;
                            return diff === first || diff % first === 0 && diff / first >= 0;
                        }
                    };
                },
                PSEUDO: function(pseudo, argument) {
                    // pseudo-class names are case-insensitive
                    // https://www.w3.org/TR/selectors/#pseudo-classes
                    // Prioritize by case sensitivity in case custom pseudos are added with uppercase letters
                    // Remember that setFilters inherits from pseudos
                    var args, fn = Expr.pseudos[pseudo] || Expr.setFilters[pseudo.toLowerCase()] || find.error("unsupported pseudo: " + pseudo);
                    // The user may use createPseudo to indicate that
                    // arguments are needed to create the filter function
                    // just as jQuery does
                    if (fn[expando]) return fn(argument);
                    // But maintain support for old signatures
                    if (fn.length > 1) {
                        args = [
                            pseudo,
                            pseudo,
                            "",
                            argument
                        ];
                        return Expr.setFilters.hasOwnProperty(pseudo.toLowerCase()) ? markFunction(function(seed, matches) {
                            var idx, matched = fn(seed, argument), i = matched.length;
                            while(i--){
                                idx = indexOf.call(seed, matched[i]);
                                seed[idx] = !(matches[idx] = matched[i]);
                            }
                        }) : function(elem) {
                            return fn(elem, 0, args);
                        };
                    }
                    return fn;
                }
            },
            pseudos: {
                // Potentially complex pseudos
                not: markFunction(function(selector) {
                    // Trim the selector passed to compile
                    // to avoid treating leading and trailing
                    // spaces as combinators
                    var input = [], results = [], matcher = compile(selector.replace(rtrimCSS, "$1"));
                    return matcher[expando] ? markFunction(function(seed, matches, _context, xml) {
                        var elem, unmatched = matcher(seed, null, xml, []), i = seed.length;
                        // Match elements unmatched by `matcher`
                        while(i--)if (elem = unmatched[i]) seed[i] = !(matches[i] = elem);
                    }) : function(elem, _context, xml) {
                        input[0] = elem;
                        matcher(input, null, xml, results);
                        // Don't keep the element
                        // (see https://github.com/jquery/sizzle/issues/299)
                        input[0] = null;
                        return !results.pop();
                    };
                }),
                has: markFunction(function(selector) {
                    return function(elem) {
                        return find(selector, elem).length > 0;
                    };
                }),
                contains: markFunction(function(text) {
                    text = text.replace(runescape, funescape);
                    return function(elem) {
                        return (elem.textContent || jQuery.text(elem)).indexOf(text) > -1;
                    };
                }),
                // "Whether an element is represented by a :lang() selector
                // is based solely on the element's language value
                // being equal to the identifier C,
                // or beginning with the identifier C immediately followed by "-".
                // The matching of C against the element's language value is performed case-insensitively.
                // The identifier C does not have to be a valid language name."
                // https://www.w3.org/TR/selectors/#lang-pseudo
                lang: markFunction(function(lang) {
                    // lang value must be a valid identifier
                    if (!ridentifier.test(lang || "")) find.error("unsupported lang: " + lang);
                    lang = lang.replace(runescape, funescape).toLowerCase();
                    return function(elem) {
                        var elemLang;
                        do if (elemLang = documentIsHTML ? elem.lang : elem.getAttribute("xml:lang") || elem.getAttribute("lang")) {
                            elemLang = elemLang.toLowerCase();
                            return elemLang === lang || elemLang.indexOf(lang + "-") === 0;
                        }
                        while ((elem = elem.parentNode) && elem.nodeType === 1);
                        return false;
                    };
                }),
                // Miscellaneous
                target: function(elem) {
                    var hash = window1.location && window1.location.hash;
                    return hash && hash.slice(1) === elem.id;
                },
                root: function(elem) {
                    return elem === documentElement;
                },
                focus: function(elem) {
                    return elem === safeActiveElement() && document.hasFocus() && !!(elem.type || elem.href || ~elem.tabIndex);
                },
                // Boolean properties
                enabled: createDisabledPseudo(false),
                disabled: createDisabledPseudo(true),
                checked: function(elem) {
                    // In CSS3, :checked should return both checked and selected elements
                    // https://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
                    return nodeName(elem, "input") && !!elem.checked || nodeName(elem, "option") && !!elem.selected;
                },
                selected: function(elem) {
                    // Support: IE <=11+
                    // Accessing the selectedIndex property
                    // forces the browser to treat the default option as
                    // selected when in an optgroup.
                    if (elem.parentNode) // eslint-disable-next-line no-unused-expressions
                    elem.parentNode.selectedIndex;
                    return elem.selected === true;
                },
                // Contents
                empty: function(elem) {
                    // https://www.w3.org/TR/selectors/#empty-pseudo
                    // :empty is negated by element (1) or content nodes (text: 3; cdata: 4; entity ref: 5),
                    //   but not by others (comment: 8; processing instruction: 7; etc.)
                    // nodeType < 6 works because attributes (2) do not appear as children
                    for(elem = elem.firstChild; elem; elem = elem.nextSibling){
                        if (elem.nodeType < 6) return false;
                    }
                    return true;
                },
                parent: function(elem) {
                    return !Expr.pseudos.empty(elem);
                },
                // Element/input types
                header: function(elem) {
                    return rheader.test(elem.nodeName);
                },
                input: function(elem) {
                    return rinputs.test(elem.nodeName);
                },
                button: function(elem) {
                    return nodeName(elem, "input") && elem.type === "button" || nodeName(elem, "button");
                },
                text: function(elem) {
                    var attr;
                    return nodeName(elem, "input") && elem.type === "text" && // Support: IE <10 only
                    // New HTML5 attribute values (e.g., "search") appear
                    // with elem.type === "text"
                    ((attr = elem.getAttribute("type")) == null || attr.toLowerCase() === "text");
                },
                // Position-in-collection
                first: createPositionalPseudo(function() {
                    return [
                        0
                    ];
                }),
                last: createPositionalPseudo(function(_matchIndexes, length) {
                    return [
                        length - 1
                    ];
                }),
                eq: createPositionalPseudo(function(_matchIndexes, length, argument) {
                    return [
                        argument < 0 ? argument + length : argument
                    ];
                }),
                even: createPositionalPseudo(function(matchIndexes, length) {
                    var i = 0;
                    for(; i < length; i += 2)matchIndexes.push(i);
                    return matchIndexes;
                }),
                odd: createPositionalPseudo(function(matchIndexes, length) {
                    var i = 1;
                    for(; i < length; i += 2)matchIndexes.push(i);
                    return matchIndexes;
                }),
                lt: createPositionalPseudo(function(matchIndexes, length, argument) {
                    var i;
                    if (argument < 0) i = argument + length;
                    else if (argument > length) i = length;
                    else i = argument;
                    for(; --i >= 0;)matchIndexes.push(i);
                    return matchIndexes;
                }),
                gt: createPositionalPseudo(function(matchIndexes, length, argument) {
                    var i = argument < 0 ? argument + length : argument;
                    for(; ++i < length;)matchIndexes.push(i);
                    return matchIndexes;
                })
            }
        };
        Expr.pseudos.nth = Expr.pseudos.eq;
        // Add button/input type pseudos
        for(i in {
            radio: true,
            checkbox: true,
            file: true,
            password: true,
            image: true
        })Expr.pseudos[i] = createInputPseudo(i);
        for(i in {
            submit: true,
            reset: true
        })Expr.pseudos[i] = createButtonPseudo(i);
        // Easy API for creating new setFilters
        function setFilters() {}
        setFilters.prototype = Expr.filters = Expr.pseudos;
        Expr.setFilters = new setFilters();
        function tokenize(selector, parseOnly) {
            var matched, match, tokens, type, soFar, groups, preFilters, cached = tokenCache[selector + " "];
            if (cached) return parseOnly ? 0 : cached.slice(0);
            soFar = selector;
            groups = [];
            preFilters = Expr.preFilter;
            while(soFar){
                // Comma and first run
                if (!matched || (match = rcomma.exec(soFar))) {
                    if (match) // Don't consume trailing commas as valid
                    soFar = soFar.slice(match[0].length) || soFar;
                    groups.push(tokens = []);
                }
                matched = false;
                // Combinators
                if (match = rleadingCombinator.exec(soFar)) {
                    matched = match.shift();
                    tokens.push({
                        value: matched,
                        // Cast descendant combinators to space
                        type: match[0].replace(rtrimCSS, " ")
                    });
                    soFar = soFar.slice(matched.length);
                }
                // Filters
                for(type in Expr.filter)if ((match = matchExpr[type].exec(soFar)) && (!preFilters[type] || (match = preFilters[type](match)))) {
                    matched = match.shift();
                    tokens.push({
                        value: matched,
                        type: type,
                        matches: match
                    });
                    soFar = soFar.slice(matched.length);
                }
                if (!matched) break;
            }
            // Return the length of the invalid excess
            // if we're just parsing
            // Otherwise, throw an error or return tokens
            if (parseOnly) return soFar.length;
            return soFar ? find.error(selector) : // Cache the tokens
            tokenCache(selector, groups).slice(0);
        }
        function toSelector(tokens) {
            var i = 0, len = tokens.length, selector = "";
            for(; i < len; i++)selector += tokens[i].value;
            return selector;
        }
        function addCombinator(matcher, combinator, base) {
            var dir = combinator.dir, skip = combinator.next, key = skip || dir, checkNonElements = base && key === "parentNode", doneName = done++;
            return combinator.first ? // Check against closest ancestor/preceding element
            function(elem, context, xml) {
                while(elem = elem[dir]){
                    if (elem.nodeType === 1 || checkNonElements) return matcher(elem, context, xml);
                }
                return false;
            } : // Check against all ancestor/preceding elements
            function(elem, context, xml) {
                var oldCache, outerCache, newCache = [
                    dirruns,
                    doneName
                ];
                // We can't set arbitrary data on XML nodes, so they don't benefit from combinator caching
                if (xml) {
                    while(elem = elem[dir])if (elem.nodeType === 1 || checkNonElements) {
                        if (matcher(elem, context, xml)) return true;
                    }
                } else {
                    while(elem = elem[dir])if (elem.nodeType === 1 || checkNonElements) {
                        outerCache = elem[expando] || (elem[expando] = {});
                        if (skip && nodeName(elem, skip)) elem = elem[dir] || elem;
                        else if ((oldCache = outerCache[key]) && oldCache[0] === dirruns && oldCache[1] === doneName) // Assign to newCache so results back-propagate to previous elements
                        return newCache[2] = oldCache[2];
                        else {
                            // Reuse newcache so results back-propagate to previous elements
                            outerCache[key] = newCache;
                            // A match means we're done; a fail means we have to keep checking
                            if (newCache[2] = matcher(elem, context, xml)) return true;
                        }
                    }
                }
                return false;
            };
        }
        function elementMatcher(matchers) {
            return matchers.length > 1 ? function(elem, context, xml) {
                var i = matchers.length;
                while(i--){
                    if (!matchers[i](elem, context, xml)) return false;
                }
                return true;
            } : matchers[0];
        }
        function multipleContexts(selector, contexts, results) {
            var i = 0, len = contexts.length;
            for(; i < len; i++)find(selector, contexts[i], results);
            return results;
        }
        function condense(unmatched, map, filter, context, xml) {
            var elem, newUnmatched = [], i = 0, len = unmatched.length, mapped = map != null;
            for(; i < len; i++){
                if (elem = unmatched[i]) {
                    if (!filter || filter(elem, context, xml)) {
                        newUnmatched.push(elem);
                        if (mapped) map.push(i);
                    }
                }
            }
            return newUnmatched;
        }
        function setMatcher(preFilter, selector, matcher, postFilter, postFinder, postSelector) {
            if (postFilter && !postFilter[expando]) postFilter = setMatcher(postFilter);
            if (postFinder && !postFinder[expando]) postFinder = setMatcher(postFinder, postSelector);
            return markFunction(function(seed, results, context, xml) {
                var temp, i, elem, matcherOut, preMap = [], postMap = [], preexisting = results.length, // Get initial elements from seed or context
                elems = seed || multipleContexts(selector || "*", context.nodeType ? [
                    context
                ] : context, []), // Prefilter to get matcher input, preserving a map for seed-results synchronization
                matcherIn = preFilter && (seed || !selector) ? condense(elems, preMap, preFilter, context, xml) : elems;
                if (matcher) {
                    // If we have a postFinder, or filtered seed, or non-seed postFilter
                    // or preexisting results,
                    matcherOut = postFinder || (seed ? preFilter : preexisting || postFilter) ? // ...intermediate processing is necessary
                    [] : // ...otherwise use results directly
                    results;
                    // Find primary matches
                    matcher(matcherIn, matcherOut, context, xml);
                } else matcherOut = matcherIn;
                // Apply postFilter
                if (postFilter) {
                    temp = condense(matcherOut, postMap);
                    postFilter(temp, [], context, xml);
                    // Un-match failing elements by moving them back to matcherIn
                    i = temp.length;
                    while(i--)if (elem = temp[i]) matcherOut[postMap[i]] = !(matcherIn[postMap[i]] = elem);
                }
                if (seed) {
                    if (postFinder || preFilter) {
                        if (postFinder) {
                            // Get the final matcherOut by condensing this intermediate into postFinder contexts
                            temp = [];
                            i = matcherOut.length;
                            while(i--)if (elem = matcherOut[i]) // Restore matcherIn since elem is not yet a final match
                            temp.push(matcherIn[i] = elem);
                            postFinder(null, matcherOut = [], temp, xml);
                        }
                        // Move matched elements from seed to results to keep them synchronized
                        i = matcherOut.length;
                        while(i--)if ((elem = matcherOut[i]) && (temp = postFinder ? indexOf.call(seed, elem) : preMap[i]) > -1) seed[temp] = !(results[temp] = elem);
                    }
                } else {
                    matcherOut = condense(matcherOut === results ? matcherOut.splice(preexisting, matcherOut.length) : matcherOut);
                    if (postFinder) postFinder(null, results, matcherOut, xml);
                    else push.apply(results, matcherOut);
                }
            });
        }
        function matcherFromTokens(tokens) {
            var checkContext, matcher, j, len = tokens.length, leadingRelative = Expr.relative[tokens[0].type], implicitRelative = leadingRelative || Expr.relative[" "], i = leadingRelative ? 1 : 0, // The foundational matcher ensures that elements are reachable from top-level context(s)
            matchContext = addCombinator(function(elem) {
                return elem === checkContext;
            }, implicitRelative, true), matchAnyContext = addCombinator(function(elem) {
                return indexOf.call(checkContext, elem) > -1;
            }, implicitRelative, true), matchers = [
                function(elem, context, xml) {
                    // Support: IE 11+, Edge 17 - 18+
                    // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                    // two documents; shallow comparisons work.
                    // eslint-disable-next-line eqeqeq
                    var ret = !leadingRelative && (xml || context != outermostContext) || ((checkContext = context).nodeType ? matchContext(elem, context, xml) : matchAnyContext(elem, context, xml));
                    // Avoid hanging onto element
                    // (see https://github.com/jquery/sizzle/issues/299)
                    checkContext = null;
                    return ret;
                }
            ];
            for(; i < len; i++)if (matcher = Expr.relative[tokens[i].type]) matchers = [
                addCombinator(elementMatcher(matchers), matcher)
            ];
            else {
                matcher = Expr.filter[tokens[i].type].apply(null, tokens[i].matches);
                // Return special upon seeing a positional matcher
                if (matcher[expando]) {
                    // Find the next relative operator (if any) for proper handling
                    j = ++i;
                    for(; j < len; j++){
                        if (Expr.relative[tokens[j].type]) break;
                    }
                    return setMatcher(i > 1 && elementMatcher(matchers), i > 1 && toSelector(// If the preceding token was a descendant combinator, insert an implicit any-element `*`
                    tokens.slice(0, i - 1).concat({
                        value: tokens[i - 2].type === " " ? "*" : ""
                    })).replace(rtrimCSS, "$1"), matcher, i < j && matcherFromTokens(tokens.slice(i, j)), j < len && matcherFromTokens(tokens = tokens.slice(j)), j < len && toSelector(tokens));
                }
                matchers.push(matcher);
            }
            return elementMatcher(matchers);
        }
        function matcherFromGroupMatchers(elementMatchers, setMatchers) {
            var bySet = setMatchers.length > 0, byElement = elementMatchers.length > 0, superMatcher = function(seed, context, xml, results, outermost) {
                var elem, j, matcher, matchedCount = 0, i = "0", unmatched = seed && [], setMatched = [], contextBackup = outermostContext, // We must always have either seed elements or outermost context
                elems = seed || byElement && Expr.find.TAG("*", outermost), // Use integer dirruns iff this is the outermost matcher
                dirrunsUnique = dirruns += contextBackup == null ? 1 : Math.random() || 0.1, len = elems.length;
                if (outermost) // Support: IE 11+, Edge 17 - 18+
                // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                // two documents; shallow comparisons work.
                // eslint-disable-next-line eqeqeq
                outermostContext = context == document || context || outermost;
                // Add elements passing elementMatchers directly to results
                // Support: iOS <=7 - 9 only
                // Tolerate NodeList properties (IE: "length"; Safari: <number>) matching
                // elements by id. (see trac-14142)
                for(; i !== len && (elem = elems[i]) != null; i++){
                    if (byElement && elem) {
                        j = 0;
                        // Support: IE 11+, Edge 17 - 18+
                        // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                        // two documents; shallow comparisons work.
                        // eslint-disable-next-line eqeqeq
                        if (!context && elem.ownerDocument != document) {
                            setDocument(elem);
                            xml = !documentIsHTML;
                        }
                        while(matcher = elementMatchers[j++])if (matcher(elem, context || document, xml)) {
                            push.call(results, elem);
                            break;
                        }
                        if (outermost) dirruns = dirrunsUnique;
                    }
                    // Track unmatched elements for set filters
                    if (bySet) {
                        // They will have gone through all possible matchers
                        if (elem = !matcher && elem) matchedCount--;
                        // Lengthen the array for every element, matched or not
                        if (seed) unmatched.push(elem);
                    }
                }
                // `i` is now the count of elements visited above, and adding it to `matchedCount`
                // makes the latter nonnegative.
                matchedCount += i;
                // Apply set filters to unmatched elements
                // NOTE: This can be skipped if there are no unmatched elements (i.e., `matchedCount`
                // equals `i`), unless we didn't visit _any_ elements in the above loop because we have
                // no element matchers and no seed.
                // Incrementing an initially-string "0" `i` allows `i` to remain a string only in that
                // case, which will result in a "00" `matchedCount` that differs from `i` but is also
                // numerically zero.
                if (bySet && i !== matchedCount) {
                    j = 0;
                    while(matcher = setMatchers[j++])matcher(unmatched, setMatched, context, xml);
                    if (seed) {
                        // Reintegrate element matches to eliminate the need for sorting
                        if (matchedCount > 0) {
                            while(i--)if (!(unmatched[i] || setMatched[i])) setMatched[i] = pop.call(results);
                        }
                        // Discard index placeholder values to get only actual matches
                        setMatched = condense(setMatched);
                    }
                    // Add matches to results
                    push.apply(results, setMatched);
                    // Seedless set matches succeeding multiple successful matchers stipulate sorting
                    if (outermost && !seed && setMatched.length > 0 && matchedCount + setMatchers.length > 1) jQuery.uniqueSort(results);
                }
                // Override manipulation of globals by nested matchers
                if (outermost) {
                    dirruns = dirrunsUnique;
                    outermostContext = contextBackup;
                }
                return unmatched;
            };
            return bySet ? markFunction(superMatcher) : superMatcher;
        }
        function compile(selector, match /* Internal Use Only */ ) {
            var i, setMatchers = [], elementMatchers = [], cached = compilerCache[selector + " "];
            if (!cached) {
                // Generate a function of recursive functions that can be used to check each element
                if (!match) match = tokenize(selector);
                i = match.length;
                while(i--){
                    cached = matcherFromTokens(match[i]);
                    if (cached[expando]) setMatchers.push(cached);
                    else elementMatchers.push(cached);
                }
                // Cache the compiled function
                cached = compilerCache(selector, matcherFromGroupMatchers(elementMatchers, setMatchers));
                // Save selector and tokenization
                cached.selector = selector;
            }
            return cached;
        }
        /**
 * A low-level selection function that works with jQuery's compiled
 *  selector functions
 * @param {String|Function} selector A selector or a pre-compiled
 *  selector function built with jQuery selector compile
 * @param {Element} context
 * @param {Array} [results]
 * @param {Array} [seed] A set of elements to match against
 */ function select(selector, context, results, seed) {
            var i, tokens, token, type, find, compiled = typeof selector === "function" && selector, match = !seed && tokenize(selector = compiled.selector || selector);
            results = results || [];
            // Try to minimize operations if there is only one selector in the list and no seed
            // (the latter of which guarantees us context)
            if (match.length === 1) {
                // Reduce context if the leading compound selector is an ID
                tokens = match[0] = match[0].slice(0);
                if (tokens.length > 2 && (token = tokens[0]).type === "ID" && context.nodeType === 9 && documentIsHTML && Expr.relative[tokens[1].type]) {
                    context = (Expr.find.ID(token.matches[0].replace(runescape, funescape), context) || [])[0];
                    if (!context) return results;
                    else if (compiled) context = context.parentNode;
                    selector = selector.slice(tokens.shift().value.length);
                }
                // Fetch a seed set for right-to-left matching
                i = matchExpr.needsContext.test(selector) ? 0 : tokens.length;
                while(i--){
                    token = tokens[i];
                    // Abort if we hit a combinator
                    if (Expr.relative[type = token.type]) break;
                    if (find = Expr.find[type]) // Search, expanding context for leading sibling combinators
                    {
                        if (seed = find(token.matches[0].replace(runescape, funescape), rsibling.test(tokens[0].type) && testContext(context.parentNode) || context)) {
                            // If seed is empty or no tokens remain, we can return early
                            tokens.splice(i, 1);
                            selector = seed.length && toSelector(tokens);
                            if (!selector) {
                                push.apply(results, seed);
                                return results;
                            }
                            break;
                        }
                    }
                }
            }
            // Compile and execute a filtering function if one is not provided
            // Provide `match` to avoid retokenization if we modified the selector above
            (compiled || compile(selector, match))(seed, context, !documentIsHTML, results, !context || rsibling.test(selector) && testContext(context.parentNode) || context);
            return results;
        }
        // One-time assignments
        // Support: Android <=4.0 - 4.1+
        // Sort stability
        support.sortStable = expando.split("").sort(sortOrder).join("") === expando;
        // Initialize against the default document
        setDocument();
        // Support: Android <=4.0 - 4.1+
        // Detached nodes confoundingly follow *each other*
        support.sortDetached = assert(function(el) {
            // Should return 1, but returns 4 (following)
            return el.compareDocumentPosition(document.createElement("fieldset")) & 1;
        });
        jQuery.find = find;
        // Deprecated
        jQuery.expr[":"] = jQuery.expr.pseudos;
        jQuery.unique = jQuery.uniqueSort;
        // These have always been private, but they used to be documented as part of
        // Sizzle so let's maintain them for now for backwards compatibility purposes.
        find.compile = compile;
        find.select = select;
        find.setDocument = setDocument;
        find.tokenize = tokenize;
        find.escape = jQuery.escapeSelector;
        find.getText = jQuery.text;
        find.isXML = jQuery.isXMLDoc;
        find.selectors = jQuery.expr;
        find.support = jQuery.support;
        find.uniqueSort = jQuery.uniqueSort;
    /* eslint-enable */ })();
    var dir = function(elem, dir, until) {
        var matched = [], truncate = until !== undefined;
        while((elem = elem[dir]) && elem.nodeType !== 9)if (elem.nodeType === 1) {
            if (truncate && jQuery(elem).is(until)) break;
            matched.push(elem);
        }
        return matched;
    };
    var siblings = function(n, elem) {
        var matched = [];
        for(; n; n = n.nextSibling)if (n.nodeType === 1 && n !== elem) matched.push(n);
        return matched;
    };
    var rneedsContext = jQuery.expr.match.needsContext;
    var rsingleTag = /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i;
    // Implement the identical functionality for filter and not
    function winnow(elements, qualifier, not) {
        if (isFunction(qualifier)) return jQuery.grep(elements, function(elem, i) {
            return !!qualifier.call(elem, i, elem) !== not;
        });
        // Single element
        if (qualifier.nodeType) return jQuery.grep(elements, function(elem) {
            return elem === qualifier !== not;
        });
        // Arraylike of elements (jQuery, arguments, Array)
        if (typeof qualifier !== "string") return jQuery.grep(elements, function(elem) {
            return indexOf.call(qualifier, elem) > -1 !== not;
        });
        // Filtered directly for both simple and complex selectors
        return jQuery.filter(qualifier, elements, not);
    }
    jQuery.filter = function(expr, elems, not) {
        var elem = elems[0];
        if (not) expr = ":not(" + expr + ")";
        if (elems.length === 1 && elem.nodeType === 1) return jQuery.find.matchesSelector(elem, expr) ? [
            elem
        ] : [];
        return jQuery.find.matches(expr, jQuery.grep(elems, function(elem) {
            return elem.nodeType === 1;
        }));
    };
    jQuery.fn.extend({
        find: function(selector) {
            var i, ret, len = this.length, self = this;
            if (typeof selector !== "string") return this.pushStack(jQuery(selector).filter(function() {
                for(i = 0; i < len; i++){
                    if (jQuery.contains(self[i], this)) return true;
                }
            }));
            ret = this.pushStack([]);
            for(i = 0; i < len; i++)jQuery.find(selector, self[i], ret);
            return len > 1 ? jQuery.uniqueSort(ret) : ret;
        },
        filter: function(selector) {
            return this.pushStack(winnow(this, selector || [], false));
        },
        not: function(selector) {
            return this.pushStack(winnow(this, selector || [], true));
        },
        is: function(selector) {
            return !!winnow(this, // If this is a positional/relative selector, check membership in the returned set
            // so $("p:first").is("p:last") won't return true for a doc with two "p".
            typeof selector === "string" && rneedsContext.test(selector) ? jQuery(selector) : selector || [], false).length;
        }
    });
    // Initialize a jQuery object
    // A central reference to the root jQuery(document)
    var rootjQuery, // A simple way to check for HTML strings
    // Prioritize #id over <tag> to avoid XSS via location.hash (trac-9521)
    // Strict HTML recognition (trac-11290: must start with <)
    // Shortcut simple #id case for speed
    rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/, init = jQuery.fn.init = function(selector, context, root) {
        var match, elem;
        // HANDLE: $(""), $(null), $(undefined), $(false)
        if (!selector) return this;
        // Method init() accepts an alternate rootjQuery
        // so migrate can support jQuery.sub (gh-2101)
        root = root || rootjQuery;
        // Handle HTML strings
        if (typeof selector === "string") {
            if (selector[0] === "<" && selector[selector.length - 1] === ">" && selector.length >= 3) // Assume that strings that start and end with <> are HTML and skip the regex check
            match = [
                null,
                selector,
                null
            ];
            else match = rquickExpr.exec(selector);
            // Match html or make sure no context is specified for #id
            if (match && (match[1] || !context)) {
                // HANDLE: $(html) -> $(array)
                if (match[1]) {
                    context = context instanceof jQuery ? context[0] : context;
                    // Option to run scripts is true for back-compat
                    // Intentionally let the error be thrown if parseHTML is not present
                    jQuery.merge(this, jQuery.parseHTML(match[1], context && context.nodeType ? context.ownerDocument || context : document, true));
                    // HANDLE: $(html, props)
                    if (rsingleTag.test(match[1]) && jQuery.isPlainObject(context)) {
                        for(match in context)// Properties of context are called as methods if possible
                        if (isFunction(this[match])) this[match](context[match]);
                        else this.attr(match, context[match]);
                    }
                    return this;
                // HANDLE: $(#id)
                } else {
                    elem = document.getElementById(match[2]);
                    if (elem) {
                        // Inject the element directly into the jQuery object
                        this[0] = elem;
                        this.length = 1;
                    }
                    return this;
                }
            } else if (!context || context.jquery) return (context || root).find(selector);
            else return this.constructor(context).find(selector);
        // HANDLE: $(DOMElement)
        } else if (selector.nodeType) {
            this[0] = selector;
            this.length = 1;
            return this;
        // HANDLE: $(function)
        // Shortcut for document ready
        } else if (isFunction(selector)) return root.ready !== undefined ? root.ready(selector) : // Execute immediately if ready is not present
        selector(jQuery);
        return jQuery.makeArray(selector, this);
    };
    // Give the init function the jQuery prototype for later instantiation
    init.prototype = jQuery.fn;
    // Initialize central reference
    rootjQuery = jQuery(document);
    var rparentsprev = /^(?:parents|prev(?:Until|All))/, // Methods guaranteed to produce a unique set when starting from a unique set
    guaranteedUnique = {
        children: true,
        contents: true,
        next: true,
        prev: true
    };
    jQuery.fn.extend({
        has: function(target) {
            var targets = jQuery(target, this), l = targets.length;
            return this.filter(function() {
                var i = 0;
                for(; i < l; i++){
                    if (jQuery.contains(this, targets[i])) return true;
                }
            });
        },
        closest: function(selectors, context) {
            var cur, i = 0, l = this.length, matched = [], targets = typeof selectors !== "string" && jQuery(selectors);
            // Positional selectors never match, since there's no _selection_ context
            if (!rneedsContext.test(selectors)) for(; i < l; i++){
                for(cur = this[i]; cur && cur !== context; cur = cur.parentNode)// Always skip document fragments
                if (cur.nodeType < 11 && (targets ? targets.index(cur) > -1 : // Don't pass non-elements to jQuery#find
                cur.nodeType === 1 && jQuery.find.matchesSelector(cur, selectors))) {
                    matched.push(cur);
                    break;
                }
            }
            return this.pushStack(matched.length > 1 ? jQuery.uniqueSort(matched) : matched);
        },
        // Determine the position of an element within the set
        index: function(elem) {
            // No argument, return index in parent
            if (!elem) return this[0] && this[0].parentNode ? this.first().prevAll().length : -1;
            // Index in selector
            if (typeof elem === "string") return indexOf.call(jQuery(elem), this[0]);
            // Locate the position of the desired element
            return indexOf.call(this, // If it receives a jQuery object, the first element is used
            elem.jquery ? elem[0] : elem);
        },
        add: function(selector, context) {
            return this.pushStack(jQuery.uniqueSort(jQuery.merge(this.get(), jQuery(selector, context))));
        },
        addBack: function(selector) {
            return this.add(selector == null ? this.prevObject : this.prevObject.filter(selector));
        }
    });
    function sibling(cur, dir) {
        while((cur = cur[dir]) && cur.nodeType !== 1);
        return cur;
    }
    jQuery.each({
        parent: function(elem) {
            var parent = elem.parentNode;
            return parent && parent.nodeType !== 11 ? parent : null;
        },
        parents: function(elem) {
            return dir(elem, "parentNode");
        },
        parentsUntil: function(elem, _i, until) {
            return dir(elem, "parentNode", until);
        },
        next: function(elem) {
            return sibling(elem, "nextSibling");
        },
        prev: function(elem) {
            return sibling(elem, "previousSibling");
        },
        nextAll: function(elem) {
            return dir(elem, "nextSibling");
        },
        prevAll: function(elem) {
            return dir(elem, "previousSibling");
        },
        nextUntil: function(elem, _i, until) {
            return dir(elem, "nextSibling", until);
        },
        prevUntil: function(elem, _i, until) {
            return dir(elem, "previousSibling", until);
        },
        siblings: function(elem) {
            return siblings((elem.parentNode || {}).firstChild, elem);
        },
        children: function(elem) {
            return siblings(elem.firstChild);
        },
        contents: function(elem) {
            if (elem.contentDocument != null && // Support: IE 11+
            // <object> elements with no `data` attribute has an object
            // `contentDocument` with a `null` prototype.
            getProto(elem.contentDocument)) return elem.contentDocument;
            // Support: IE 9 - 11 only, iOS 7 only, Android Browser <=4.3 only
            // Treat the template element as a regular one in browsers that
            // don't support it.
            if (nodeName(elem, "template")) elem = elem.content || elem;
            return jQuery.merge([], elem.childNodes);
        }
    }, function(name, fn) {
        jQuery.fn[name] = function(until, selector) {
            var matched = jQuery.map(this, fn, until);
            if (name.slice(-5) !== "Until") selector = until;
            if (selector && typeof selector === "string") matched = jQuery.filter(selector, matched);
            if (this.length > 1) {
                // Remove duplicates
                if (!guaranteedUnique[name]) jQuery.uniqueSort(matched);
                // Reverse order for parents* and prev-derivatives
                if (rparentsprev.test(name)) matched.reverse();
            }
            return this.pushStack(matched);
        };
    });
    var rnothtmlwhite = /[^\x20\t\r\n\f]+/g;
    // Convert String-formatted options into Object-formatted ones
    function createOptions(options) {
        var object = {};
        jQuery.each(options.match(rnothtmlwhite) || [], function(_, flag) {
            object[flag] = true;
        });
        return object;
    }
    /*
 * Create a callback list using the following parameters:
 *
 *	options: an optional list of space-separated options that will change how
 *			the callback list behaves or a more traditional option object
 *
 * By default a callback list will act like an event callback list and can be
 * "fired" multiple times.
 *
 * Possible options:
 *
 *	once:			will ensure the callback list can only be fired once (like a Deferred)
 *
 *	memory:			will keep track of previous values and will call any callback added
 *					after the list has been fired right away with the latest "memorized"
 *					values (like a Deferred)
 *
 *	unique:			will ensure a callback can only be added once (no duplicate in the list)
 *
 *	stopOnFalse:	interrupt callings when a callback returns false
 *
 */ jQuery.Callbacks = function(options) {
        // Convert options from String-formatted to Object-formatted if needed
        // (we check in cache first)
        options = typeof options === "string" ? createOptions(options) : jQuery.extend({}, options);
        var firing, // Last fire value for non-forgettable lists
        memory, // Flag to know if list was already fired
        fired, // Flag to prevent firing
        locked, // Actual callback list
        list = [], // Queue of execution data for repeatable lists
        queue = [], // Index of currently firing callback (modified by add/remove as needed)
        firingIndex = -1, // Fire callbacks
        fire = function() {
            // Enforce single-firing
            locked = locked || options.once;
            // Execute callbacks for all pending executions,
            // respecting firingIndex overrides and runtime changes
            fired = firing = true;
            for(; queue.length; firingIndex = -1){
                memory = queue.shift();
                while(++firingIndex < list.length)// Run callback and check for early termination
                if (list[firingIndex].apply(memory[0], memory[1]) === false && options.stopOnFalse) {
                    // Jump to end and forget the data so .add doesn't re-fire
                    firingIndex = list.length;
                    memory = false;
                }
            }
            // Forget the data if we're done with it
            if (!options.memory) memory = false;
            firing = false;
            // Clean up if we're done firing for good
            if (locked) {
                // Keep an empty list if we have data for future add calls
                if (memory) list = [];
                else list = "";
            }
        }, // Actual Callbacks object
        self = {
            // Add a callback or a collection of callbacks to the list
            add: function() {
                if (list) {
                    // If we have memory from a past run, we should fire after adding
                    if (memory && !firing) {
                        firingIndex = list.length - 1;
                        queue.push(memory);
                    }
                    (function add(args) {
                        jQuery.each(args, function(_, arg) {
                            if (isFunction(arg)) {
                                if (!options.unique || !self.has(arg)) list.push(arg);
                            } else if (arg && arg.length && toType(arg) !== "string") // Inspect recursively
                            add(arg);
                        });
                    })(arguments);
                    if (memory && !firing) fire();
                }
                return this;
            },
            // Remove a callback from the list
            remove: function() {
                jQuery.each(arguments, function(_, arg) {
                    var index;
                    while((index = jQuery.inArray(arg, list, index)) > -1){
                        list.splice(index, 1);
                        // Handle firing indexes
                        if (index <= firingIndex) firingIndex--;
                    }
                });
                return this;
            },
            // Check if a given callback is in the list.
            // If no argument is given, return whether or not list has callbacks attached.
            has: function(fn) {
                return fn ? jQuery.inArray(fn, list) > -1 : list.length > 0;
            },
            // Remove all callbacks from the list
            empty: function() {
                if (list) list = [];
                return this;
            },
            // Disable .fire and .add
            // Abort any current/pending executions
            // Clear all callbacks and values
            disable: function() {
                locked = queue = [];
                list = memory = "";
                return this;
            },
            disabled: function() {
                return !list;
            },
            // Disable .fire
            // Also disable .add unless we have memory (since it would have no effect)
            // Abort any pending executions
            lock: function() {
                locked = queue = [];
                if (!memory && !firing) list = memory = "";
                return this;
            },
            locked: function() {
                return !!locked;
            },
            // Call all callbacks with the given context and arguments
            fireWith: function(context, args) {
                if (!locked) {
                    args = args || [];
                    args = [
                        context,
                        args.slice ? args.slice() : args
                    ];
                    queue.push(args);
                    if (!firing) fire();
                }
                return this;
            },
            // Call all the callbacks with the given arguments
            fire: function() {
                self.fireWith(this, arguments);
                return this;
            },
            // To know if the callbacks have already been called at least once
            fired: function() {
                return !!fired;
            }
        };
        return self;
    };
    function Identity(v) {
        return v;
    }
    function Thrower(ex) {
        throw ex;
    }
    function adoptValue(value, resolve, reject, noValue) {
        var method;
        try {
            // Check for promise aspect first to privilege synchronous behavior
            if (value && isFunction(method = value.promise)) method.call(value).done(resolve).fail(reject);
            else if (value && isFunction(method = value.then)) method.call(value, resolve, reject);
            else // Control `resolve` arguments by letting Array#slice cast boolean `noValue` to integer:
            // * false: [ value ].slice( 0 ) => resolve( value )
            // * true: [ value ].slice( 1 ) => resolve()
            resolve.apply(undefined, [
                value
            ].slice(noValue));
        // For Promises/A+, convert exceptions into rejections
        // Since jQuery.when doesn't unwrap thenables, we can skip the extra checks appearing in
        // Deferred#then to conditionally suppress rejection.
        } catch (value) {
            // Support: Android 4.0 only
            // Strict mode functions invoked without .call/.apply get global-object context
            reject.apply(undefined, [
                value
            ]);
        }
    }
    jQuery.extend({
        Deferred: function(func) {
            var tuples = [
                // action, add listener, callbacks,
                // ... .then handlers, argument index, [final state]
                [
                    "notify",
                    "progress",
                    jQuery.Callbacks("memory"),
                    jQuery.Callbacks("memory"),
                    2
                ],
                [
                    "resolve",
                    "done",
                    jQuery.Callbacks("once memory"),
                    jQuery.Callbacks("once memory"),
                    0,
                    "resolved"
                ],
                [
                    "reject",
                    "fail",
                    jQuery.Callbacks("once memory"),
                    jQuery.Callbacks("once memory"),
                    1,
                    "rejected"
                ]
            ], state = "pending", promise = {
                state: function() {
                    return state;
                },
                always: function() {
                    deferred.done(arguments).fail(arguments);
                    return this;
                },
                "catch": function(fn) {
                    return promise.then(null, fn);
                },
                // Keep pipe for back-compat
                pipe: function() {
                    var fns = arguments;
                    return jQuery.Deferred(function(newDefer) {
                        jQuery.each(tuples, function(_i, tuple) {
                            // Map tuples (progress, done, fail) to arguments (done, fail, progress)
                            var fn = isFunction(fns[tuple[4]]) && fns[tuple[4]];
                            // deferred.progress(function() { bind to newDefer or newDefer.notify })
                            // deferred.done(function() { bind to newDefer or newDefer.resolve })
                            // deferred.fail(function() { bind to newDefer or newDefer.reject })
                            deferred[tuple[1]](function() {
                                var returned = fn && fn.apply(this, arguments);
                                if (returned && isFunction(returned.promise)) returned.promise().progress(newDefer.notify).done(newDefer.resolve).fail(newDefer.reject);
                                else newDefer[tuple[0] + "With"](this, fn ? [
                                    returned
                                ] : arguments);
                            });
                        });
                        fns = null;
                    }).promise();
                },
                then: function(onFulfilled, onRejected, onProgress) {
                    var maxDepth = 0;
                    function resolve(depth, deferred, handler, special) {
                        return function() {
                            var that = this, args = arguments, mightThrow = function() {
                                var returned, then;
                                // Support: Promises/A+ section 2.3.3.3.3
                                // https://promisesaplus.com/#point-59
                                // Ignore double-resolution attempts
                                if (depth < maxDepth) return;
                                returned = handler.apply(that, args);
                                // Support: Promises/A+ section 2.3.1
                                // https://promisesaplus.com/#point-48
                                if (returned === deferred.promise()) throw new TypeError("Thenable self-resolution");
                                // Support: Promises/A+ sections 2.3.3.1, 3.5
                                // https://promisesaplus.com/#point-54
                                // https://promisesaplus.com/#point-75
                                // Retrieve `then` only once
                                then = returned && // Support: Promises/A+ section 2.3.4
                                // https://promisesaplus.com/#point-64
                                // Only check objects and functions for thenability
                                (typeof returned === "object" || typeof returned === "function") && returned.then;
                                // Handle a returned thenable
                                if (isFunction(then)) {
                                    // Special processors (notify) just wait for resolution
                                    if (special) then.call(returned, resolve(maxDepth, deferred, Identity, special), resolve(maxDepth, deferred, Thrower, special));
                                    else {
                                        // ...and disregard older resolution values
                                        maxDepth++;
                                        then.call(returned, resolve(maxDepth, deferred, Identity, special), resolve(maxDepth, deferred, Thrower, special), resolve(maxDepth, deferred, Identity, deferred.notifyWith));
                                    }
                                } else {
                                    // Only substitute handlers pass on context
                                    // and multiple values (non-spec behavior)
                                    if (handler !== Identity) {
                                        that = undefined;
                                        args = [
                                            returned
                                        ];
                                    }
                                    // Process the value(s)
                                    // Default process is resolve
                                    (special || deferred.resolveWith)(that, args);
                                }
                            }, // Only normal processors (resolve) catch and reject exceptions
                            process = special ? mightThrow : function() {
                                try {
                                    mightThrow();
                                } catch (e) {
                                    if (jQuery.Deferred.exceptionHook) jQuery.Deferred.exceptionHook(e, process.error);
                                    // Support: Promises/A+ section 2.3.3.3.4.1
                                    // https://promisesaplus.com/#point-61
                                    // Ignore post-resolution exceptions
                                    if (depth + 1 >= maxDepth) {
                                        // Only substitute handlers pass on context
                                        // and multiple values (non-spec behavior)
                                        if (handler !== Thrower) {
                                            that = undefined;
                                            args = [
                                                e
                                            ];
                                        }
                                        deferred.rejectWith(that, args);
                                    }
                                }
                            };
                            // Support: Promises/A+ section 2.3.3.3.1
                            // https://promisesaplus.com/#point-57
                            // Re-resolve promises immediately to dodge false rejection from
                            // subsequent errors
                            if (depth) process();
                            else {
                                // Call an optional hook to record the error, in case of exception
                                // since it's otherwise lost when execution goes async
                                if (jQuery.Deferred.getErrorHook) process.error = jQuery.Deferred.getErrorHook();
                                else if (jQuery.Deferred.getStackHook) process.error = jQuery.Deferred.getStackHook();
                                window1.setTimeout(process);
                            }
                        };
                    }
                    return jQuery.Deferred(function(newDefer) {
                        // progress_handlers.add( ... )
                        tuples[0][3].add(resolve(0, newDefer, isFunction(onProgress) ? onProgress : Identity, newDefer.notifyWith));
                        // fulfilled_handlers.add( ... )
                        tuples[1][3].add(resolve(0, newDefer, isFunction(onFulfilled) ? onFulfilled : Identity));
                        // rejected_handlers.add( ... )
                        tuples[2][3].add(resolve(0, newDefer, isFunction(onRejected) ? onRejected : Thrower));
                    }).promise();
                },
                // Get a promise for this deferred
                // If obj is provided, the promise aspect is added to the object
                promise: function(obj) {
                    return obj != null ? jQuery.extend(obj, promise) : promise;
                }
            }, deferred = {};
            // Add list-specific methods
            jQuery.each(tuples, function(i, tuple) {
                var list = tuple[2], stateString = tuple[5];
                // promise.progress = list.add
                // promise.done = list.add
                // promise.fail = list.add
                promise[tuple[1]] = list.add;
                // Handle state
                if (stateString) list.add(function() {
                    // state = "resolved" (i.e., fulfilled)
                    // state = "rejected"
                    state = stateString;
                }, // rejected_callbacks.disable
                // fulfilled_callbacks.disable
                tuples[3 - i][2].disable, // rejected_handlers.disable
                // fulfilled_handlers.disable
                tuples[3 - i][3].disable, // progress_callbacks.lock
                tuples[0][2].lock, // progress_handlers.lock
                tuples[0][3].lock);
                // progress_handlers.fire
                // fulfilled_handlers.fire
                // rejected_handlers.fire
                list.add(tuple[3].fire);
                // deferred.notify = function() { deferred.notifyWith(...) }
                // deferred.resolve = function() { deferred.resolveWith(...) }
                // deferred.reject = function() { deferred.rejectWith(...) }
                deferred[tuple[0]] = function() {
                    deferred[tuple[0] + "With"](this === deferred ? undefined : this, arguments);
                    return this;
                };
                // deferred.notifyWith = list.fireWith
                // deferred.resolveWith = list.fireWith
                // deferred.rejectWith = list.fireWith
                deferred[tuple[0] + "With"] = list.fireWith;
            });
            // Make the deferred a promise
            promise.promise(deferred);
            // Call given func if any
            if (func) func.call(deferred, deferred);
            // All done!
            return deferred;
        },
        // Deferred helper
        when: function(singleValue) {
            var // count of uncompleted subordinates
            remaining = arguments.length, // count of unprocessed arguments
            i = remaining, // subordinate fulfillment data
            resolveContexts = Array(i), resolveValues = slice.call(arguments), // the primary Deferred
            primary = jQuery.Deferred(), // subordinate callback factory
            updateFunc = function(i) {
                return function(value) {
                    resolveContexts[i] = this;
                    resolveValues[i] = arguments.length > 1 ? slice.call(arguments) : value;
                    if (!--remaining) primary.resolveWith(resolveContexts, resolveValues);
                };
            };
            // Single- and empty arguments are adopted like Promise.resolve
            if (remaining <= 1) {
                adoptValue(singleValue, primary.done(updateFunc(i)).resolve, primary.reject, !remaining);
                // Use .then() to unwrap secondary thenables (cf. gh-3000)
                if (primary.state() === "pending" || isFunction(resolveValues[i] && resolveValues[i].then)) return primary.then();
            }
            // Multiple arguments are aggregated like Promise.all array elements
            while(i--)adoptValue(resolveValues[i], updateFunc(i), primary.reject);
            return primary.promise();
        }
    });
    // These usually indicate a programmer mistake during development,
    // warn about them ASAP rather than swallowing them by default.
    var rerrorNames = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;
    // If `jQuery.Deferred.getErrorHook` is defined, `asyncError` is an error
    // captured before the async barrier to get the original error cause
    // which may otherwise be hidden.
    jQuery.Deferred.exceptionHook = function(error, asyncError) {
        // Support: IE 8 - 9 only
        // Console exists when dev tools are open, which can happen at any time
        if (window1.console && window1.console.warn && error && rerrorNames.test(error.name)) window1.console.warn("jQuery.Deferred exception: " + error.message, error.stack, asyncError);
    };
    jQuery.readyException = function(error) {
        window1.setTimeout(function() {
            throw error;
        });
    };
    // The deferred used on DOM ready
    var readyList = jQuery.Deferred();
    jQuery.fn.ready = function(fn) {
        readyList.then(fn)// Wrap jQuery.readyException in a function so that the lookup
        // happens at the time of error handling instead of callback
        // registration.
        .catch(function(error) {
            jQuery.readyException(error);
        });
        return this;
    };
    jQuery.extend({
        // Is the DOM ready to be used? Set to true once it occurs.
        isReady: false,
        // A counter to track how many items to wait for before
        // the ready event fires. See trac-6781
        readyWait: 1,
        // Handle when the DOM is ready
        ready: function(wait) {
            // Abort if there are pending holds or we're already ready
            if (wait === true ? --jQuery.readyWait : jQuery.isReady) return;
            // Remember that the DOM is ready
            jQuery.isReady = true;
            // If a normal DOM Ready event fired, decrement, and wait if need be
            if (wait !== true && --jQuery.readyWait > 0) return;
            // If there are functions bound, to execute
            readyList.resolveWith(document, [
                jQuery
            ]);
        }
    });
    jQuery.ready.then = readyList.then;
    // The ready event handler and self cleanup method
    function completed() {
        document.removeEventListener("DOMContentLoaded", completed);
        window1.removeEventListener("load", completed);
        jQuery.ready();
    }
    // Catch cases where $(document).ready() is called
    // after the browser event has already occurred.
    // Support: IE <=9 - 10 only
    // Older IE sometimes signals "interactive" too soon
    if (document.readyState === "complete" || document.readyState !== "loading" && !document.documentElement.doScroll) // Handle it asynchronously to allow scripts the opportunity to delay ready
    window1.setTimeout(jQuery.ready);
    else {
        // Use the handy event callback
        document.addEventListener("DOMContentLoaded", completed);
        // A fallback to window.onload, that will always work
        window1.addEventListener("load", completed);
    }
    // Multifunctional method to get and set values of a collection
    // The value/s can optionally be executed if it's a function
    var access = function(elems, fn, key, value, chainable, emptyGet, raw) {
        var i = 0, len = elems.length, bulk = key == null;
        // Sets many values
        if (toType(key) === "object") {
            chainable = true;
            for(i in key)access(elems, fn, i, key[i], true, emptyGet, raw);
        // Sets one value
        } else if (value !== undefined) {
            chainable = true;
            if (!isFunction(value)) raw = true;
            if (bulk) {
                // Bulk operations run against the entire set
                if (raw) {
                    fn.call(elems, value);
                    fn = null;
                // ...except when executing function values
                } else {
                    bulk = fn;
                    fn = function(elem, _key, value) {
                        return bulk.call(jQuery(elem), value);
                    };
                }
            }
            if (fn) for(; i < len; i++)fn(elems[i], key, raw ? value : value.call(elems[i], i, fn(elems[i], key)));
        }
        if (chainable) return elems;
        // Gets
        if (bulk) return fn.call(elems);
        return len ? fn(elems[0], key) : emptyGet;
    };
    // Matches dashed string for camelizing
    var rmsPrefix = /^-ms-/, rdashAlpha = /-([a-z])/g;
    // Used by camelCase as callback to replace()
    function fcamelCase(_all, letter) {
        return letter.toUpperCase();
    }
    // Convert dashed to camelCase; used by the css and data modules
    // Support: IE <=9 - 11, Edge 12 - 15
    // Microsoft forgot to hump their vendor prefix (trac-9572)
    function camelCase(string) {
        return string.replace(rmsPrefix, "ms-").replace(rdashAlpha, fcamelCase);
    }
    var acceptData = function(owner) {
        // Accepts only:
        //  - Node
        //    - Node.ELEMENT_NODE
        //    - Node.DOCUMENT_NODE
        //  - Object
        //    - Any
        return owner.nodeType === 1 || owner.nodeType === 9 || !+owner.nodeType;
    };
    function Data() {
        this.expando = jQuery.expando + Data.uid++;
    }
    Data.uid = 1;
    Data.prototype = {
        cache: function(owner) {
            // Check if the owner object already has a cache
            var value = owner[this.expando];
            // If not, create one
            if (!value) {
                value = {};
                // We can accept data for non-element nodes in modern browsers,
                // but we should not, see trac-8335.
                // Always return an empty object.
                if (acceptData(owner)) {
                    // If it is a node unlikely to be stringify-ed or looped over
                    // use plain assignment
                    if (owner.nodeType) owner[this.expando] = value;
                    else Object.defineProperty(owner, this.expando, {
                        value: value,
                        configurable: true
                    });
                }
            }
            return value;
        },
        set: function(owner, data, value) {
            var prop, cache = this.cache(owner);
            // Handle: [ owner, key, value ] args
            // Always use camelCase key (gh-2257)
            if (typeof data === "string") cache[camelCase(data)] = value;
            else // Copy the properties one-by-one to the cache object
            for(prop in data)cache[camelCase(prop)] = data[prop];
            return cache;
        },
        get: function(owner, key) {
            return key === undefined ? this.cache(owner) : // Always use camelCase key (gh-2257)
            owner[this.expando] && owner[this.expando][camelCase(key)];
        },
        access: function(owner, key, value) {
            // In cases where either:
            //
            //   1. No key was specified
            //   2. A string key was specified, but no value provided
            //
            // Take the "read" path and allow the get method to determine
            // which value to return, respectively either:
            //
            //   1. The entire cache object
            //   2. The data stored at the key
            //
            if (key === undefined || key && typeof key === "string" && value === undefined) return this.get(owner, key);
            // When the key is not a string, or both a key and value
            // are specified, set or extend (existing objects) with either:
            //
            //   1. An object of properties
            //   2. A key and value
            //
            this.set(owner, key, value);
            // Since the "set" path can have two possible entry points
            // return the expected data based on which path was taken[*]
            return value !== undefined ? value : key;
        },
        remove: function(owner, key) {
            var i, cache = owner[this.expando];
            if (cache === undefined) return;
            if (key !== undefined) {
                // Support array or space separated string of keys
                if (Array.isArray(key)) // If key is an array of keys...
                // We always set camelCase keys, so remove that.
                key = key.map(camelCase);
                else {
                    key = camelCase(key);
                    // If a key with the spaces exists, use it.
                    // Otherwise, create an array by matching non-whitespace
                    key = key in cache ? [
                        key
                    ] : key.match(rnothtmlwhite) || [];
                }
                i = key.length;
                while(i--)delete cache[key[i]];
            }
            // Remove the expando if there's no more data
            if (key === undefined || jQuery.isEmptyObject(cache)) {
                // Support: Chrome <=35 - 45
                // Webkit & Blink performance suffers when deleting properties
                // from DOM nodes, so set to undefined instead
                // https://bugs.chromium.org/p/chromium/issues/detail?id=378607 (bug restricted)
                if (owner.nodeType) owner[this.expando] = undefined;
                else delete owner[this.expando];
            }
        },
        hasData: function(owner) {
            var cache = owner[this.expando];
            return cache !== undefined && !jQuery.isEmptyObject(cache);
        }
    };
    var dataPriv = new Data();
    var dataUser = new Data();
    //	Implementation Summary
    //
    //	1. Enforce API surface and semantic compatibility with 1.9.x branch
    //	2. Improve the module's maintainability by reducing the storage
    //		paths to a single mechanism.
    //	3. Use the same single mechanism to support "private" and "user" data.
    //	4. _Never_ expose "private" data to user code (TODO: Drop _data, _removeData)
    //	5. Avoid exposing implementation details on user objects (eg. expando properties)
    //	6. Provide a clear path for implementation upgrade to WeakMap in 2014
    var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/, rmultiDash = /[A-Z]/g;
    function getData(data) {
        if (data === "true") return true;
        if (data === "false") return false;
        if (data === "null") return null;
        // Only convert to a number if it doesn't change the string
        if (data === +data + "") return +data;
        if (rbrace.test(data)) return JSON.parse(data);
        return data;
    }
    function dataAttr(elem, key, data) {
        var name;
        // If nothing was found internally, try to fetch any
        // data from the HTML5 data-* attribute
        if (data === undefined && elem.nodeType === 1) {
            name = "data-" + key.replace(rmultiDash, "-$&").toLowerCase();
            data = elem.getAttribute(name);
            if (typeof data === "string") {
                try {
                    data = getData(data);
                } catch (e) {}
                // Make sure we set the data so it isn't changed later
                dataUser.set(elem, key, data);
            } else data = undefined;
        }
        return data;
    }
    jQuery.extend({
        hasData: function(elem) {
            return dataUser.hasData(elem) || dataPriv.hasData(elem);
        },
        data: function(elem, name, data) {
            return dataUser.access(elem, name, data);
        },
        removeData: function(elem, name) {
            dataUser.remove(elem, name);
        },
        // TODO: Now that all calls to _data and _removeData have been replaced
        // with direct calls to dataPriv methods, these can be deprecated.
        _data: function(elem, name, data) {
            return dataPriv.access(elem, name, data);
        },
        _removeData: function(elem, name) {
            dataPriv.remove(elem, name);
        }
    });
    jQuery.fn.extend({
        data: function(key, value) {
            var i, name, data, elem = this[0], attrs = elem && elem.attributes;
            // Gets all values
            if (key === undefined) {
                if (this.length) {
                    data = dataUser.get(elem);
                    if (elem.nodeType === 1 && !dataPriv.get(elem, "hasDataAttrs")) {
                        i = attrs.length;
                        while(i--)// Support: IE 11 only
                        // The attrs elements can be null (trac-14894)
                        if (attrs[i]) {
                            name = attrs[i].name;
                            if (name.indexOf("data-") === 0) {
                                name = camelCase(name.slice(5));
                                dataAttr(elem, name, data[name]);
                            }
                        }
                        dataPriv.set(elem, "hasDataAttrs", true);
                    }
                }
                return data;
            }
            // Sets multiple values
            if (typeof key === "object") return this.each(function() {
                dataUser.set(this, key);
            });
            return access(this, function(value) {
                var data;
                // The calling jQuery object (element matches) is not empty
                // (and therefore has an element appears at this[ 0 ]) and the
                // `value` parameter was not undefined. An empty jQuery object
                // will result in `undefined` for elem = this[ 0 ] which will
                // throw an exception if an attempt to read a data cache is made.
                if (elem && value === undefined) {
                    // Attempt to get data from the cache
                    // The key will always be camelCased in Data
                    data = dataUser.get(elem, key);
                    if (data !== undefined) return data;
                    // Attempt to "discover" the data in
                    // HTML5 custom data-* attrs
                    data = dataAttr(elem, key);
                    if (data !== undefined) return data;
                    // We tried really hard, but the data doesn't exist.
                    return;
                }
                // Set the data...
                this.each(function() {
                    // We always store the camelCased key
                    dataUser.set(this, key, value);
                });
            }, null, value, arguments.length > 1, null, true);
        },
        removeData: function(key) {
            return this.each(function() {
                dataUser.remove(this, key);
            });
        }
    });
    jQuery.extend({
        queue: function(elem, type, data) {
            var queue;
            if (elem) {
                type = (type || "fx") + "queue";
                queue = dataPriv.get(elem, type);
                // Speed up dequeue by getting out quickly if this is just a lookup
                if (data) {
                    if (!queue || Array.isArray(data)) queue = dataPriv.access(elem, type, jQuery.makeArray(data));
                    else queue.push(data);
                }
                return queue || [];
            }
        },
        dequeue: function(elem, type) {
            type = type || "fx";
            var queue = jQuery.queue(elem, type), startLength = queue.length, fn = queue.shift(), hooks = jQuery._queueHooks(elem, type), next = function() {
                jQuery.dequeue(elem, type);
            };
            // If the fx queue is dequeued, always remove the progress sentinel
            if (fn === "inprogress") {
                fn = queue.shift();
                startLength--;
            }
            if (fn) {
                // Add a progress sentinel to prevent the fx queue from being
                // automatically dequeued
                if (type === "fx") queue.unshift("inprogress");
                // Clear up the last queue stop function
                delete hooks.stop;
                fn.call(elem, next, hooks);
            }
            if (!startLength && hooks) hooks.empty.fire();
        },
        // Not public - generate a queueHooks object, or return the current one
        _queueHooks: function(elem, type) {
            var key = type + "queueHooks";
            return dataPriv.get(elem, key) || dataPriv.access(elem, key, {
                empty: jQuery.Callbacks("once memory").add(function() {
                    dataPriv.remove(elem, [
                        type + "queue",
                        key
                    ]);
                })
            });
        }
    });
    jQuery.fn.extend({
        queue: function(type, data) {
            var setter = 2;
            if (typeof type !== "string") {
                data = type;
                type = "fx";
                setter--;
            }
            if (arguments.length < setter) return jQuery.queue(this[0], type);
            return data === undefined ? this : this.each(function() {
                var queue = jQuery.queue(this, type, data);
                // Ensure a hooks for this queue
                jQuery._queueHooks(this, type);
                if (type === "fx" && queue[0] !== "inprogress") jQuery.dequeue(this, type);
            });
        },
        dequeue: function(type) {
            return this.each(function() {
                jQuery.dequeue(this, type);
            });
        },
        clearQueue: function(type) {
            return this.queue(type || "fx", []);
        },
        // Get a promise resolved when queues of a certain type
        // are emptied (fx is the type by default)
        promise: function(type, obj) {
            var tmp, count = 1, defer = jQuery.Deferred(), elements = this, i = this.length, resolve = function() {
                if (!--count) defer.resolveWith(elements, [
                    elements
                ]);
            };
            if (typeof type !== "string") {
                obj = type;
                type = undefined;
            }
            type = type || "fx";
            while(i--){
                tmp = dataPriv.get(elements[i], type + "queueHooks");
                if (tmp && tmp.empty) {
                    count++;
                    tmp.empty.add(resolve);
                }
            }
            resolve();
            return defer.promise(obj);
        }
    });
    var pnum = /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source;
    var rcssNum = new RegExp("^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i");
    var cssExpand = [
        "Top",
        "Right",
        "Bottom",
        "Left"
    ];
    var documentElement = document.documentElement;
    var isAttached = function(elem) {
        return jQuery.contains(elem.ownerDocument, elem);
    }, composed = {
        composed: true
    };
    // Support: IE 9 - 11+, Edge 12 - 18+, iOS 10.0 - 10.2 only
    // Check attachment across shadow DOM boundaries when possible (gh-3504)
    // Support: iOS 10.0-10.2 only
    // Early iOS 10 versions support `attachShadow` but not `getRootNode`,
    // leading to errors. We need to check for `getRootNode`.
    if (documentElement.getRootNode) isAttached = function(elem) {
        return jQuery.contains(elem.ownerDocument, elem) || elem.getRootNode(composed) === elem.ownerDocument;
    };
    var isHiddenWithinTree = function(elem, el) {
        // isHiddenWithinTree might be called from jQuery#filter function;
        // in that case, element will be second argument
        elem = el || elem;
        // Inline style trumps all
        return elem.style.display === "none" || elem.style.display === "" && // Otherwise, check computed style
        // Support: Firefox <=43 - 45
        // Disconnected elements can have computed display: none, so first confirm that elem is
        // in the document.
        isAttached(elem) && jQuery.css(elem, "display") === "none";
    };
    function adjustCSS(elem, prop, valueParts, tween) {
        var adjusted, scale, maxIterations = 20, currentValue = tween ? function() {
            return tween.cur();
        } : function() {
            return jQuery.css(elem, prop, "");
        }, initial = currentValue(), unit = valueParts && valueParts[3] || (jQuery.cssNumber[prop] ? "" : "px"), // Starting value computation is required for potential unit mismatches
        initialInUnit = elem.nodeType && (jQuery.cssNumber[prop] || unit !== "px" && +initial) && rcssNum.exec(jQuery.css(elem, prop));
        if (initialInUnit && initialInUnit[3] !== unit) {
            // Support: Firefox <=54
            // Halve the iteration target value to prevent interference from CSS upper bounds (gh-2144)
            initial = initial / 2;
            // Trust units reported by jQuery.css
            unit = unit || initialInUnit[3];
            // Iteratively approximate from a nonzero starting point
            initialInUnit = +initial || 1;
            while(maxIterations--){
                // Evaluate and update our best guess (doubling guesses that zero out).
                // Finish if the scale equals or crosses 1 (making the old*new product non-positive).
                jQuery.style(elem, prop, initialInUnit + unit);
                if ((1 - scale) * (1 - (scale = currentValue() / initial || 0.5)) <= 0) maxIterations = 0;
                initialInUnit = initialInUnit / scale;
            }
            initialInUnit = initialInUnit * 2;
            jQuery.style(elem, prop, initialInUnit + unit);
            // Make sure we update the tween properties later on
            valueParts = valueParts || [];
        }
        if (valueParts) {
            initialInUnit = +initialInUnit || +initial || 0;
            // Apply relative offset (+=/-=) if specified
            adjusted = valueParts[1] ? initialInUnit + (valueParts[1] + 1) * valueParts[2] : +valueParts[2];
            if (tween) {
                tween.unit = unit;
                tween.start = initialInUnit;
                tween.end = adjusted;
            }
        }
        return adjusted;
    }
    var defaultDisplayMap = {};
    function getDefaultDisplay(elem) {
        var temp, doc = elem.ownerDocument, nodeName = elem.nodeName, display = defaultDisplayMap[nodeName];
        if (display) return display;
        temp = doc.body.appendChild(doc.createElement(nodeName));
        display = jQuery.css(temp, "display");
        temp.parentNode.removeChild(temp);
        if (display === "none") display = "block";
        defaultDisplayMap[nodeName] = display;
        return display;
    }
    function showHide(elements, show) {
        var display, elem, values = [], index = 0, length = elements.length;
        // Determine new display value for elements that need to change
        for(; index < length; index++){
            elem = elements[index];
            if (!elem.style) continue;
            display = elem.style.display;
            if (show) {
                // Since we force visibility upon cascade-hidden elements, an immediate (and slow)
                // check is required in this first loop unless we have a nonempty display value (either
                // inline or about-to-be-restored)
                if (display === "none") {
                    values[index] = dataPriv.get(elem, "display") || null;
                    if (!values[index]) elem.style.display = "";
                }
                if (elem.style.display === "" && isHiddenWithinTree(elem)) values[index] = getDefaultDisplay(elem);
            } else if (display !== "none") {
                values[index] = "none";
                // Remember what we're overwriting
                dataPriv.set(elem, "display", display);
            }
        }
        // Set the display of the elements in a second loop to avoid constant reflow
        for(index = 0; index < length; index++)if (values[index] != null) elements[index].style.display = values[index];
        return elements;
    }
    jQuery.fn.extend({
        show: function() {
            return showHide(this, true);
        },
        hide: function() {
            return showHide(this);
        },
        toggle: function(state) {
            if (typeof state === "boolean") return state ? this.show() : this.hide();
            return this.each(function() {
                if (isHiddenWithinTree(this)) jQuery(this).show();
                else jQuery(this).hide();
            });
        }
    });
    var rcheckableType = /^(?:checkbox|radio)$/i;
    var rtagName = /<([a-z][^\/\0>\x20\t\r\n\f]*)/i;
    var rscriptType = /^$|^module$|\/(?:java|ecma)script/i;
    (function() {
        var fragment = document.createDocumentFragment(), div = fragment.appendChild(document.createElement("div")), input = document.createElement("input");
        // Support: Android 4.0 - 4.3 only
        // Check state lost if the name is set (trac-11217)
        // Support: Windows Web Apps (WWA)
        // `name` and `type` must use .setAttribute for WWA (trac-14901)
        input.setAttribute("type", "radio");
        input.setAttribute("checked", "checked");
        input.setAttribute("name", "t");
        div.appendChild(input);
        // Support: Android <=4.1 only
        // Older WebKit doesn't clone checked state correctly in fragments
        support.checkClone = div.cloneNode(true).cloneNode(true).lastChild.checked;
        // Support: IE <=11 only
        // Make sure textarea (and checkbox) defaultValue is properly cloned
        div.innerHTML = "<textarea>x</textarea>";
        support.noCloneChecked = !!div.cloneNode(true).lastChild.defaultValue;
        // Support: IE <=9 only
        // IE <=9 replaces <option> tags with their contents when inserted outside of
        // the select element.
        div.innerHTML = "<option></option>";
        support.option = !!div.lastChild;
    })();
    // We have to close these tags to support XHTML (trac-13200)
    var wrapMap = {
        // XHTML parsers do not magically insert elements in the
        // same way that tag soup parsers do. So we cannot shorten
        // this by omitting <tbody> or other required elements.
        thead: [
            1,
            "<table>",
            "</table>"
        ],
        col: [
            2,
            "<table><colgroup>",
            "</colgroup></table>"
        ],
        tr: [
            2,
            "<table><tbody>",
            "</tbody></table>"
        ],
        td: [
            3,
            "<table><tbody><tr>",
            "</tr></tbody></table>"
        ],
        _default: [
            0,
            "",
            ""
        ]
    };
    wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
    wrapMap.th = wrapMap.td;
    // Support: IE <=9 only
    if (!support.option) wrapMap.optgroup = wrapMap.option = [
        1,
        "<select multiple='multiple'>",
        "</select>"
    ];
    function getAll(context, tag) {
        // Support: IE <=9 - 11 only
        // Use typeof to avoid zero-argument method invocation on host objects (trac-15151)
        var ret;
        if (typeof context.getElementsByTagName !== "undefined") ret = context.getElementsByTagName(tag || "*");
        else if (typeof context.querySelectorAll !== "undefined") ret = context.querySelectorAll(tag || "*");
        else ret = [];
        if (tag === undefined || tag && nodeName(context, tag)) return jQuery.merge([
            context
        ], ret);
        return ret;
    }
    // Mark scripts as having already been evaluated
    function setGlobalEval(elems, refElements) {
        var i = 0, l = elems.length;
        for(; i < l; i++)dataPriv.set(elems[i], "globalEval", !refElements || dataPriv.get(refElements[i], "globalEval"));
    }
    var rhtml = /<|&#?\w+;/;
    function buildFragment(elems, context, scripts, selection, ignored) {
        var elem, tmp, tag, wrap, attached, j, fragment = context.createDocumentFragment(), nodes = [], i = 0, l = elems.length;
        for(; i < l; i++){
            elem = elems[i];
            if (elem || elem === 0) {
                // Add nodes directly
                if (toType(elem) === "object") // Support: Android <=4.0 only, PhantomJS 1 only
                // push.apply(_, arraylike) throws on ancient WebKit
                jQuery.merge(nodes, elem.nodeType ? [
                    elem
                ] : elem);
                else if (!rhtml.test(elem)) nodes.push(context.createTextNode(elem));
                else {
                    tmp = tmp || fragment.appendChild(context.createElement("div"));
                    // Deserialize a standard representation
                    tag = (rtagName.exec(elem) || [
                        "",
                        ""
                    ])[1].toLowerCase();
                    wrap = wrapMap[tag] || wrapMap._default;
                    tmp.innerHTML = wrap[1] + jQuery.htmlPrefilter(elem) + wrap[2];
                    // Descend through wrappers to the right content
                    j = wrap[0];
                    while(j--)tmp = tmp.lastChild;
                    // Support: Android <=4.0 only, PhantomJS 1 only
                    // push.apply(_, arraylike) throws on ancient WebKit
                    jQuery.merge(nodes, tmp.childNodes);
                    // Remember the top-level container
                    tmp = fragment.firstChild;
                    // Ensure the created nodes are orphaned (trac-12392)
                    tmp.textContent = "";
                }
            }
        }
        // Remove wrapper from fragment
        fragment.textContent = "";
        i = 0;
        while(elem = nodes[i++]){
            // Skip elements already in the context collection (trac-4087)
            if (selection && jQuery.inArray(elem, selection) > -1) {
                if (ignored) ignored.push(elem);
                continue;
            }
            attached = isAttached(elem);
            // Append to fragment
            tmp = getAll(fragment.appendChild(elem), "script");
            // Preserve script evaluation history
            if (attached) setGlobalEval(tmp);
            // Capture executables
            if (scripts) {
                j = 0;
                while(elem = tmp[j++])if (rscriptType.test(elem.type || "")) scripts.push(elem);
            }
        }
        return fragment;
    }
    var rtypenamespace = /^([^.]*)(?:\.(.+)|)/;
    function returnTrue() {
        return true;
    }
    function returnFalse() {
        return false;
    }
    function on(elem, types, selector, data, fn, one) {
        var origFn, type;
        // Types can be a map of types/handlers
        if (typeof types === "object") {
            // ( types-Object, selector, data )
            if (typeof selector !== "string") {
                // ( types-Object, data )
                data = data || selector;
                selector = undefined;
            }
            for(type in types)on(elem, type, selector, data, types[type], one);
            return elem;
        }
        if (data == null && fn == null) {
            // ( types, fn )
            fn = selector;
            data = selector = undefined;
        } else if (fn == null) {
            if (typeof selector === "string") {
                // ( types, selector, fn )
                fn = data;
                data = undefined;
            } else {
                // ( types, data, fn )
                fn = data;
                data = selector;
                selector = undefined;
            }
        }
        if (fn === false) fn = returnFalse;
        else if (!fn) return elem;
        if (one === 1) {
            origFn = fn;
            fn = function(event) {
                // Can use an empty set, since event contains the info
                jQuery().off(event);
                return origFn.apply(this, arguments);
            };
            // Use same guid so caller can remove using origFn
            fn.guid = origFn.guid || (origFn.guid = jQuery.guid++);
        }
        return elem.each(function() {
            jQuery.event.add(this, types, fn, data, selector);
        });
    }
    /*
 * Helper functions for managing events -- not part of the public interface.
 * Props to Dean Edwards' addEvent library for many of the ideas.
 */ jQuery.event = {
        global: {},
        add: function(elem, types, handler, data, selector) {
            var handleObjIn, eventHandle, tmp, events, t, handleObj, special, handlers, type, namespaces, origType, elemData = dataPriv.get(elem);
            // Only attach events to objects that accept data
            if (!acceptData(elem)) return;
            // Caller can pass in an object of custom data in lieu of the handler
            if (handler.handler) {
                handleObjIn = handler;
                handler = handleObjIn.handler;
                selector = handleObjIn.selector;
            }
            // Ensure that invalid selectors throw exceptions at attach time
            // Evaluate against documentElement in case elem is a non-element node (e.g., document)
            if (selector) jQuery.find.matchesSelector(documentElement, selector);
            // Make sure that the handler has a unique ID, used to find/remove it later
            if (!handler.guid) handler.guid = jQuery.guid++;
            // Init the element's event structure and main handler, if this is the first
            if (!(events = elemData.events)) events = elemData.events = Object.create(null);
            if (!(eventHandle = elemData.handle)) eventHandle = elemData.handle = function(e) {
                // Discard the second event of a jQuery.event.trigger() and
                // when an event is called after a page has unloaded
                return typeof jQuery !== "undefined" && jQuery.event.triggered !== e.type ? jQuery.event.dispatch.apply(elem, arguments) : undefined;
            };
            // Handle multiple events separated by a space
            types = (types || "").match(rnothtmlwhite) || [
                ""
            ];
            t = types.length;
            while(t--){
                tmp = rtypenamespace.exec(types[t]) || [];
                type = origType = tmp[1];
                namespaces = (tmp[2] || "").split(".").sort();
                // There *must* be a type, no attaching namespace-only handlers
                if (!type) continue;
                // If event changes its type, use the special event handlers for the changed type
                special = jQuery.event.special[type] || {};
                // If selector defined, determine special event api type, otherwise given type
                type = (selector ? special.delegateType : special.bindType) || type;
                // Update special based on newly reset type
                special = jQuery.event.special[type] || {};
                // handleObj is passed to all event handlers
                handleObj = jQuery.extend({
                    type: type,
                    origType: origType,
                    data: data,
                    handler: handler,
                    guid: handler.guid,
                    selector: selector,
                    needsContext: selector && jQuery.expr.match.needsContext.test(selector),
                    namespace: namespaces.join(".")
                }, handleObjIn);
                // Init the event handler queue if we're the first
                if (!(handlers = events[type])) {
                    handlers = events[type] = [];
                    handlers.delegateCount = 0;
                    // Only use addEventListener if the special events handler returns false
                    if (!special.setup || special.setup.call(elem, data, namespaces, eventHandle) === false) {
                        if (elem.addEventListener) elem.addEventListener(type, eventHandle);
                    }
                }
                if (special.add) {
                    special.add.call(elem, handleObj);
                    if (!handleObj.handler.guid) handleObj.handler.guid = handler.guid;
                }
                // Add to the element's handler list, delegates in front
                if (selector) handlers.splice(handlers.delegateCount++, 0, handleObj);
                else handlers.push(handleObj);
                // Keep track of which events have ever been used, for event optimization
                jQuery.event.global[type] = true;
            }
        },
        // Detach an event or set of events from an element
        remove: function(elem, types, handler, selector, mappedTypes) {
            var j, origCount, tmp, events, t, handleObj, special, handlers, type, namespaces, origType, elemData = dataPriv.hasData(elem) && dataPriv.get(elem);
            if (!elemData || !(events = elemData.events)) return;
            // Once for each type.namespace in types; type may be omitted
            types = (types || "").match(rnothtmlwhite) || [
                ""
            ];
            t = types.length;
            while(t--){
                tmp = rtypenamespace.exec(types[t]) || [];
                type = origType = tmp[1];
                namespaces = (tmp[2] || "").split(".").sort();
                // Unbind all events (on this namespace, if provided) for the element
                if (!type) {
                    for(type in events)jQuery.event.remove(elem, type + types[t], handler, selector, true);
                    continue;
                }
                special = jQuery.event.special[type] || {};
                type = (selector ? special.delegateType : special.bindType) || type;
                handlers = events[type] || [];
                tmp = tmp[2] && new RegExp("(^|\\.)" + namespaces.join("\\.(?:.*\\.|)") + "(\\.|$)");
                // Remove matching events
                origCount = j = handlers.length;
                while(j--){
                    handleObj = handlers[j];
                    if ((mappedTypes || origType === handleObj.origType) && (!handler || handler.guid === handleObj.guid) && (!tmp || tmp.test(handleObj.namespace)) && (!selector || selector === handleObj.selector || selector === "**" && handleObj.selector)) {
                        handlers.splice(j, 1);
                        if (handleObj.selector) handlers.delegateCount--;
                        if (special.remove) special.remove.call(elem, handleObj);
                    }
                }
                // Remove generic event handler if we removed something and no more handlers exist
                // (avoids potential for endless recursion during removal of special event handlers)
                if (origCount && !handlers.length) {
                    if (!special.teardown || special.teardown.call(elem, namespaces, elemData.handle) === false) jQuery.removeEvent(elem, type, elemData.handle);
                    delete events[type];
                }
            }
            // Remove data and the expando if it's no longer used
            if (jQuery.isEmptyObject(events)) dataPriv.remove(elem, "handle events");
        },
        dispatch: function(nativeEvent) {
            var i, j, ret, matched, handleObj, handlerQueue, args = new Array(arguments.length), // Make a writable jQuery.Event from the native event object
            event = jQuery.event.fix(nativeEvent), handlers = (dataPriv.get(this, "events") || Object.create(null))[event.type] || [], special = jQuery.event.special[event.type] || {};
            // Use the fix-ed jQuery.Event rather than the (read-only) native event
            args[0] = event;
            for(i = 1; i < arguments.length; i++)args[i] = arguments[i];
            event.delegateTarget = this;
            // Call the preDispatch hook for the mapped type, and let it bail if desired
            if (special.preDispatch && special.preDispatch.call(this, event) === false) return;
            // Determine handlers
            handlerQueue = jQuery.event.handlers.call(this, event, handlers);
            // Run delegates first; they may want to stop propagation beneath us
            i = 0;
            while((matched = handlerQueue[i++]) && !event.isPropagationStopped()){
                event.currentTarget = matched.elem;
                j = 0;
                while((handleObj = matched.handlers[j++]) && !event.isImmediatePropagationStopped())// If the event is namespaced, then each handler is only invoked if it is
                // specially universal or its namespaces are a superset of the event's.
                if (!event.rnamespace || handleObj.namespace === false || event.rnamespace.test(handleObj.namespace)) {
                    event.handleObj = handleObj;
                    event.data = handleObj.data;
                    ret = ((jQuery.event.special[handleObj.origType] || {}).handle || handleObj.handler).apply(matched.elem, args);
                    if (ret !== undefined) {
                        if ((event.result = ret) === false) {
                            event.preventDefault();
                            event.stopPropagation();
                        }
                    }
                }
            }
            // Call the postDispatch hook for the mapped type
            if (special.postDispatch) special.postDispatch.call(this, event);
            return event.result;
        },
        handlers: function(event, handlers) {
            var i, handleObj, sel, matchedHandlers, matchedSelectors, handlerQueue = [], delegateCount = handlers.delegateCount, cur = event.target;
            // Find delegate handlers
            if (delegateCount && // Support: IE <=9
            // Black-hole SVG <use> instance trees (trac-13180)
            cur.nodeType && // Support: Firefox <=42
            // Suppress spec-violating clicks indicating a non-primary pointer button (trac-3861)
            // https://www.w3.org/TR/DOM-Level-3-Events/#event-type-click
            // Support: IE 11 only
            // ...but not arrow key "clicks" of radio inputs, which can have `button` -1 (gh-2343)
            !(event.type === "click" && event.button >= 1)) {
                for(; cur !== this; cur = cur.parentNode || this)// Don't check non-elements (trac-13208)
                // Don't process clicks on disabled elements (trac-6911, trac-8165, trac-11382, trac-11764)
                if (cur.nodeType === 1 && !(event.type === "click" && cur.disabled === true)) {
                    matchedHandlers = [];
                    matchedSelectors = {};
                    for(i = 0; i < delegateCount; i++){
                        handleObj = handlers[i];
                        // Don't conflict with Object.prototype properties (trac-13203)
                        sel = handleObj.selector + " ";
                        if (matchedSelectors[sel] === undefined) matchedSelectors[sel] = handleObj.needsContext ? jQuery(sel, this).index(cur) > -1 : jQuery.find(sel, this, null, [
                            cur
                        ]).length;
                        if (matchedSelectors[sel]) matchedHandlers.push(handleObj);
                    }
                    if (matchedHandlers.length) handlerQueue.push({
                        elem: cur,
                        handlers: matchedHandlers
                    });
                }
            }
            // Add the remaining (directly-bound) handlers
            cur = this;
            if (delegateCount < handlers.length) handlerQueue.push({
                elem: cur,
                handlers: handlers.slice(delegateCount)
            });
            return handlerQueue;
        },
        addProp: function(name, hook) {
            Object.defineProperty(jQuery.Event.prototype, name, {
                enumerable: true,
                configurable: true,
                get: isFunction(hook) ? function() {
                    if (this.originalEvent) return hook(this.originalEvent);
                } : function() {
                    if (this.originalEvent) return this.originalEvent[name];
                },
                set: function(value) {
                    Object.defineProperty(this, name, {
                        enumerable: true,
                        configurable: true,
                        writable: true,
                        value: value
                    });
                }
            });
        },
        fix: function(originalEvent) {
            return originalEvent[jQuery.expando] ? originalEvent : new jQuery.Event(originalEvent);
        },
        special: {
            load: {
                // Prevent triggered image.load events from bubbling to window.load
                noBubble: true
            },
            click: {
                // Utilize native event to ensure correct state for checkable inputs
                setup: function(data) {
                    // For mutual compressibility with _default, replace `this` access with a local var.
                    // `|| data` is dead code meant only to preserve the variable through minification.
                    var el = this || data;
                    // Claim the first handler
                    if (rcheckableType.test(el.type) && el.click && nodeName(el, "input")) // dataPriv.set( el, "click", ... )
                    leverageNative(el, "click", true);
                    // Return false to allow normal processing in the caller
                    return false;
                },
                trigger: function(data) {
                    // For mutual compressibility with _default, replace `this` access with a local var.
                    // `|| data` is dead code meant only to preserve the variable through minification.
                    var el = this || data;
                    // Force setup before triggering a click
                    if (rcheckableType.test(el.type) && el.click && nodeName(el, "input")) leverageNative(el, "click");
                    // Return non-false to allow normal event-path propagation
                    return true;
                },
                // For cross-browser consistency, suppress native .click() on links
                // Also prevent it if we're currently inside a leveraged native-event stack
                _default: function(event) {
                    var target = event.target;
                    return rcheckableType.test(target.type) && target.click && nodeName(target, "input") && dataPriv.get(target, "click") || nodeName(target, "a");
                }
            },
            beforeunload: {
                postDispatch: function(event) {
                    // Support: Firefox 20+
                    // Firefox doesn't alert if the returnValue field is not set.
                    if (event.result !== undefined && event.originalEvent) event.originalEvent.returnValue = event.result;
                }
            }
        }
    };
    // Ensure the presence of an event listener that handles manually-triggered
    // synthetic events by interrupting progress until reinvoked in response to
    // *native* events that it fires directly, ensuring that state changes have
    // already occurred before other listeners are invoked.
    function leverageNative(el, type, isSetup) {
        // Missing `isSetup` indicates a trigger call, which must force setup through jQuery.event.add
        if (!isSetup) {
            if (dataPriv.get(el, type) === undefined) jQuery.event.add(el, type, returnTrue);
            return;
        }
        // Register the controller as a special universal handler for all event namespaces
        dataPriv.set(el, type, false);
        jQuery.event.add(el, type, {
            namespace: false,
            handler: function(event) {
                var result, saved = dataPriv.get(this, type);
                if (event.isTrigger & 1 && this[type]) {
                    // Interrupt processing of the outer synthetic .trigger()ed event
                    if (!saved) {
                        // Store arguments for use when handling the inner native event
                        // There will always be at least one argument (an event object), so this array
                        // will not be confused with a leftover capture object.
                        saved = slice.call(arguments);
                        dataPriv.set(this, type, saved);
                        // Trigger the native event and capture its result
                        this[type]();
                        result = dataPriv.get(this, type);
                        dataPriv.set(this, type, false);
                        if (saved !== result) {
                            // Cancel the outer synthetic event
                            event.stopImmediatePropagation();
                            event.preventDefault();
                            return result;
                        }
                    // If this is an inner synthetic event for an event with a bubbling surrogate
                    // (focus or blur), assume that the surrogate already propagated from triggering
                    // the native event and prevent that from happening again here.
                    // This technically gets the ordering wrong w.r.t. to `.trigger()` (in which the
                    // bubbling surrogate propagates *after* the non-bubbling base), but that seems
                    // less bad than duplication.
                    } else if ((jQuery.event.special[type] || {}).delegateType) event.stopPropagation();
                // If this is a native event triggered above, everything is now in order
                // Fire an inner synthetic event with the original arguments
                } else if (saved) {
                    // ...and capture the result
                    dataPriv.set(this, type, jQuery.event.trigger(saved[0], saved.slice(1), this));
                    // Abort handling of the native event by all jQuery handlers while allowing
                    // native handlers on the same element to run. On target, this is achieved
                    // by stopping immediate propagation just on the jQuery event. However,
                    // the native event is re-wrapped by a jQuery one on each level of the
                    // propagation so the only way to stop it for jQuery is to stop it for
                    // everyone via native `stopPropagation()`. This is not a problem for
                    // focus/blur which don't bubble, but it does also stop click on checkboxes
                    // and radios. We accept this limitation.
                    event.stopPropagation();
                    event.isImmediatePropagationStopped = returnTrue;
                }
            }
        });
    }
    jQuery.removeEvent = function(elem, type, handle) {
        // This "if" is needed for plain objects
        if (elem.removeEventListener) elem.removeEventListener(type, handle);
    };
    jQuery.Event = function(src, props) {
        // Allow instantiation without the 'new' keyword
        if (!(this instanceof jQuery.Event)) return new jQuery.Event(src, props);
        // Event object
        if (src && src.type) {
            this.originalEvent = src;
            this.type = src.type;
            // Events bubbling up the document may have been marked as prevented
            // by a handler lower down the tree; reflect the correct value.
            this.isDefaultPrevented = src.defaultPrevented || src.defaultPrevented === undefined && // Support: Android <=2.3 only
            src.returnValue === false ? returnTrue : returnFalse;
            // Create target properties
            // Support: Safari <=6 - 7 only
            // Target should not be a text node (trac-504, trac-13143)
            this.target = src.target && src.target.nodeType === 3 ? src.target.parentNode : src.target;
            this.currentTarget = src.currentTarget;
            this.relatedTarget = src.relatedTarget;
        // Event type
        } else this.type = src;
        // Put explicitly provided properties onto the event object
        if (props) jQuery.extend(this, props);
        // Create a timestamp if incoming event doesn't have one
        this.timeStamp = src && src.timeStamp || Date.now();
        // Mark it as fixed
        this[jQuery.expando] = true;
    };
    // jQuery.Event is based on DOM3 Events as specified by the ECMAScript Language Binding
    // https://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html
    jQuery.Event.prototype = {
        constructor: jQuery.Event,
        isDefaultPrevented: returnFalse,
        isPropagationStopped: returnFalse,
        isImmediatePropagationStopped: returnFalse,
        isSimulated: false,
        preventDefault: function() {
            var e = this.originalEvent;
            this.isDefaultPrevented = returnTrue;
            if (e && !this.isSimulated) e.preventDefault();
        },
        stopPropagation: function() {
            var e = this.originalEvent;
            this.isPropagationStopped = returnTrue;
            if (e && !this.isSimulated) e.stopPropagation();
        },
        stopImmediatePropagation: function() {
            var e = this.originalEvent;
            this.isImmediatePropagationStopped = returnTrue;
            if (e && !this.isSimulated) e.stopImmediatePropagation();
            this.stopPropagation();
        }
    };
    // Includes all common event props including KeyEvent and MouseEvent specific props
    jQuery.each({
        altKey: true,
        bubbles: true,
        cancelable: true,
        changedTouches: true,
        ctrlKey: true,
        detail: true,
        eventPhase: true,
        metaKey: true,
        pageX: true,
        pageY: true,
        shiftKey: true,
        view: true,
        "char": true,
        code: true,
        charCode: true,
        key: true,
        keyCode: true,
        button: true,
        buttons: true,
        clientX: true,
        clientY: true,
        offsetX: true,
        offsetY: true,
        pointerId: true,
        pointerType: true,
        screenX: true,
        screenY: true,
        targetTouches: true,
        toElement: true,
        touches: true,
        which: true
    }, jQuery.event.addProp);
    jQuery.each({
        focus: "focusin",
        blur: "focusout"
    }, function(type, delegateType) {
        function focusMappedHandler(nativeEvent) {
            if (document.documentMode) {
                // Support: IE 11+
                // Attach a single focusin/focusout handler on the document while someone wants
                // focus/blur. This is because the former are synchronous in IE while the latter
                // are async. In other browsers, all those handlers are invoked synchronously.
                // `handle` from private data would already wrap the event, but we need
                // to change the `type` here.
                var handle = dataPriv.get(this, "handle"), event = jQuery.event.fix(nativeEvent);
                event.type = nativeEvent.type === "focusin" ? "focus" : "blur";
                event.isSimulated = true;
                // First, handle focusin/focusout
                handle(nativeEvent);
                // ...then, handle focus/blur
                //
                // focus/blur don't bubble while focusin/focusout do; simulate the former by only
                // invoking the handler at the lower level.
                if (event.target === event.currentTarget) // The setup part calls `leverageNative`, which, in turn, calls
                // `jQuery.event.add`, so event handle will already have been set
                // by this point.
                handle(event);
            } else // For non-IE browsers, attach a single capturing handler on the document
            // while someone wants focusin/focusout.
            jQuery.event.simulate(delegateType, nativeEvent.target, jQuery.event.fix(nativeEvent));
        }
        jQuery.event.special[type] = {
            // Utilize native event if possible so blur/focus sequence is correct
            setup: function() {
                var attaches;
                // Claim the first handler
                // dataPriv.set( this, "focus", ... )
                // dataPriv.set( this, "blur", ... )
                leverageNative(this, type, true);
                if (document.documentMode) {
                    // Support: IE 9 - 11+
                    // We use the same native handler for focusin & focus (and focusout & blur)
                    // so we need to coordinate setup & teardown parts between those events.
                    // Use `delegateType` as the key as `type` is already used by `leverageNative`.
                    attaches = dataPriv.get(this, delegateType);
                    if (!attaches) this.addEventListener(delegateType, focusMappedHandler);
                    dataPriv.set(this, delegateType, (attaches || 0) + 1);
                } else // Return false to allow normal processing in the caller
                return false;
            },
            trigger: function() {
                // Force setup before trigger
                leverageNative(this, type);
                // Return non-false to allow normal event-path propagation
                return true;
            },
            teardown: function() {
                var attaches;
                if (document.documentMode) {
                    attaches = dataPriv.get(this, delegateType) - 1;
                    if (!attaches) {
                        this.removeEventListener(delegateType, focusMappedHandler);
                        dataPriv.remove(this, delegateType);
                    } else dataPriv.set(this, delegateType, attaches);
                } else // Return false to indicate standard teardown should be applied
                return false;
            },
            // Suppress native focus or blur if we're currently inside
            // a leveraged native-event stack
            _default: function(event) {
                return dataPriv.get(event.target, type);
            },
            delegateType: delegateType
        };
        // Support: Firefox <=44
        // Firefox doesn't have focus(in | out) events
        // Related ticket - https://bugzilla.mozilla.org/show_bug.cgi?id=687787
        //
        // Support: Chrome <=48 - 49, Safari <=9.0 - 9.1
        // focus(in | out) events fire after focus & blur events,
        // which is spec violation - http://www.w3.org/TR/DOM-Level-3-Events/#events-focusevent-event-order
        // Related ticket - https://bugs.chromium.org/p/chromium/issues/detail?id=449857
        //
        // Support: IE 9 - 11+
        // To preserve relative focusin/focus & focusout/blur event order guaranteed on the 3.x branch,
        // attach a single handler for both events in IE.
        jQuery.event.special[delegateType] = {
            setup: function() {
                // Handle: regular nodes (via `this.ownerDocument`), window
                // (via `this.document`) & document (via `this`).
                var doc = this.ownerDocument || this.document || this, dataHolder = document.documentMode ? this : doc, attaches = dataPriv.get(dataHolder, delegateType);
                // Support: IE 9 - 11+
                // We use the same native handler for focusin & focus (and focusout & blur)
                // so we need to coordinate setup & teardown parts between those events.
                // Use `delegateType` as the key as `type` is already used by `leverageNative`.
                if (!attaches) {
                    if (document.documentMode) this.addEventListener(delegateType, focusMappedHandler);
                    else doc.addEventListener(type, focusMappedHandler, true);
                }
                dataPriv.set(dataHolder, delegateType, (attaches || 0) + 1);
            },
            teardown: function() {
                var doc = this.ownerDocument || this.document || this, dataHolder = document.documentMode ? this : doc, attaches = dataPriv.get(dataHolder, delegateType) - 1;
                if (!attaches) {
                    if (document.documentMode) this.removeEventListener(delegateType, focusMappedHandler);
                    else doc.removeEventListener(type, focusMappedHandler, true);
                    dataPriv.remove(dataHolder, delegateType);
                } else dataPriv.set(dataHolder, delegateType, attaches);
            }
        };
    });
    // Create mouseenter/leave events using mouseover/out and event-time checks
    // so that event delegation works in jQuery.
    // Do the same for pointerenter/pointerleave and pointerover/pointerout
    //
    // Support: Safari 7 only
    // Safari sends mouseenter too often; see:
    // https://bugs.chromium.org/p/chromium/issues/detail?id=470258
    // for the description of the bug (it existed in older Chrome versions as well).
    jQuery.each({
        mouseenter: "mouseover",
        mouseleave: "mouseout",
        pointerenter: "pointerover",
        pointerleave: "pointerout"
    }, function(orig, fix) {
        jQuery.event.special[orig] = {
            delegateType: fix,
            bindType: fix,
            handle: function(event) {
                var ret, target = this, related = event.relatedTarget, handleObj = event.handleObj;
                // For mouseenter/leave call the handler if related is outside the target.
                // NB: No relatedTarget if the mouse left/entered the browser window
                if (!related || related !== target && !jQuery.contains(target, related)) {
                    event.type = handleObj.origType;
                    ret = handleObj.handler.apply(this, arguments);
                    event.type = fix;
                }
                return ret;
            }
        };
    });
    jQuery.fn.extend({
        on: function(types, selector, data, fn) {
            return on(this, types, selector, data, fn);
        },
        one: function(types, selector, data, fn) {
            return on(this, types, selector, data, fn, 1);
        },
        off: function(types, selector, fn) {
            var handleObj, type;
            if (types && types.preventDefault && types.handleObj) {
                // ( event )  dispatched jQuery.Event
                handleObj = types.handleObj;
                jQuery(types.delegateTarget).off(handleObj.namespace ? handleObj.origType + "." + handleObj.namespace : handleObj.origType, handleObj.selector, handleObj.handler);
                return this;
            }
            if (typeof types === "object") {
                // ( types-object [, selector] )
                for(type in types)this.off(type, selector, types[type]);
                return this;
            }
            if (selector === false || typeof selector === "function") {
                // ( types [, fn] )
                fn = selector;
                selector = undefined;
            }
            if (fn === false) fn = returnFalse;
            return this.each(function() {
                jQuery.event.remove(this, types, fn, selector);
            });
        }
    });
    var // Support: IE <=10 - 11, Edge 12 - 13 only
    // In IE/Edge using regex groups here causes severe slowdowns.
    // See https://connect.microsoft.com/IE/feedback/details/1736512/
    rnoInnerhtml = /<script|<style|<link/i, // checked="checked" or checked
    rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i, rcleanScript = /^\s*<!\[CDATA\[|\]\]>\s*$/g;
    // Prefer a tbody over its parent table for containing new rows
    function manipulationTarget(elem, content) {
        if (nodeName(elem, "table") && nodeName(content.nodeType !== 11 ? content : content.firstChild, "tr")) return jQuery(elem).children("tbody")[0] || elem;
        return elem;
    }
    // Replace/restore the type attribute of script elements for safe DOM manipulation
    function disableScript(elem) {
        elem.type = (elem.getAttribute("type") !== null) + "/" + elem.type;
        return elem;
    }
    function restoreScript(elem) {
        if ((elem.type || "").slice(0, 5) === "true/") elem.type = elem.type.slice(5);
        else elem.removeAttribute("type");
        return elem;
    }
    function cloneCopyEvent(src, dest) {
        var i, l, type, pdataOld, udataOld, udataCur, events;
        if (dest.nodeType !== 1) return;
        // 1. Copy private data: events, handlers, etc.
        if (dataPriv.hasData(src)) {
            pdataOld = dataPriv.get(src);
            events = pdataOld.events;
            if (events) {
                dataPriv.remove(dest, "handle events");
                for(type in events)for(i = 0, l = events[type].length; i < l; i++)jQuery.event.add(dest, type, events[type][i]);
            }
        }
        // 2. Copy user data
        if (dataUser.hasData(src)) {
            udataOld = dataUser.access(src);
            udataCur = jQuery.extend({}, udataOld);
            dataUser.set(dest, udataCur);
        }
    }
    // Fix IE bugs, see support tests
    function fixInput(src, dest) {
        var nodeName = dest.nodeName.toLowerCase();
        // Fails to persist the checked state of a cloned checkbox or radio button.
        if (nodeName === "input" && rcheckableType.test(src.type)) dest.checked = src.checked;
        else if (nodeName === "input" || nodeName === "textarea") dest.defaultValue = src.defaultValue;
    }
    function domManip(collection, args, callback, ignored) {
        // Flatten any nested arrays
        args = flat(args);
        var fragment, first, scripts, hasScripts, node, doc, i = 0, l = collection.length, iNoClone = l - 1, value = args[0], valueIsFunction = isFunction(value);
        // We can't cloneNode fragments that contain checked, in WebKit
        if (valueIsFunction || l > 1 && typeof value === "string" && !support.checkClone && rchecked.test(value)) return collection.each(function(index) {
            var self = collection.eq(index);
            if (valueIsFunction) args[0] = value.call(this, index, self.html());
            domManip(self, args, callback, ignored);
        });
        if (l) {
            fragment = buildFragment(args, collection[0].ownerDocument, false, collection, ignored);
            first = fragment.firstChild;
            if (fragment.childNodes.length === 1) fragment = first;
            // Require either new content or an interest in ignored elements to invoke the callback
            if (first || ignored) {
                scripts = jQuery.map(getAll(fragment, "script"), disableScript);
                hasScripts = scripts.length;
                // Use the original fragment for the last item
                // instead of the first because it can end up
                // being emptied incorrectly in certain situations (trac-8070).
                for(; i < l; i++){
                    node = fragment;
                    if (i !== iNoClone) {
                        node = jQuery.clone(node, true, true);
                        // Keep references to cloned scripts for later restoration
                        if (hasScripts) // Support: Android <=4.0 only, PhantomJS 1 only
                        // push.apply(_, arraylike) throws on ancient WebKit
                        jQuery.merge(scripts, getAll(node, "script"));
                    }
                    callback.call(collection[i], node, i);
                }
                if (hasScripts) {
                    doc = scripts[scripts.length - 1].ownerDocument;
                    // Re-enable scripts
                    jQuery.map(scripts, restoreScript);
                    // Evaluate executable scripts on first document insertion
                    for(i = 0; i < hasScripts; i++){
                        node = scripts[i];
                        if (rscriptType.test(node.type || "") && !dataPriv.access(node, "globalEval") && jQuery.contains(doc, node)) {
                            if (node.src && (node.type || "").toLowerCase() !== "module") // Optional AJAX dependency, but won't run scripts if not present
                            {
                                if (jQuery._evalUrl && !node.noModule) jQuery._evalUrl(node.src, {
                                    nonce: node.nonce || node.getAttribute("nonce")
                                }, doc);
                            } else // Unwrap a CDATA section containing script contents. This shouldn't be
                            // needed as in XML documents they're already not visible when
                            // inspecting element contents and in HTML documents they have no
                            // meaning but we're preserving that logic for backwards compatibility.
                            // This will be removed completely in 4.0. See gh-4904.
                            DOMEval(node.textContent.replace(rcleanScript, ""), node, doc);
                        }
                    }
                }
            }
        }
        return collection;
    }
    function remove(elem, selector, keepData) {
        var node, nodes = selector ? jQuery.filter(selector, elem) : elem, i = 0;
        for(; (node = nodes[i]) != null; i++){
            if (!keepData && node.nodeType === 1) jQuery.cleanData(getAll(node));
            if (node.parentNode) {
                if (keepData && isAttached(node)) setGlobalEval(getAll(node, "script"));
                node.parentNode.removeChild(node);
            }
        }
        return elem;
    }
    jQuery.extend({
        htmlPrefilter: function(html) {
            return html;
        },
        clone: function(elem, dataAndEvents, deepDataAndEvents) {
            var i, l, srcElements, destElements, clone = elem.cloneNode(true), inPage = isAttached(elem);
            // Fix IE cloning issues
            if (!support.noCloneChecked && (elem.nodeType === 1 || elem.nodeType === 11) && !jQuery.isXMLDoc(elem)) {
                // We eschew jQuery#find here for performance reasons:
                // https://jsperf.com/getall-vs-sizzle/2
                destElements = getAll(clone);
                srcElements = getAll(elem);
                for(i = 0, l = srcElements.length; i < l; i++)fixInput(srcElements[i], destElements[i]);
            }
            // Copy the events from the original to the clone
            if (dataAndEvents) {
                if (deepDataAndEvents) {
                    srcElements = srcElements || getAll(elem);
                    destElements = destElements || getAll(clone);
                    for(i = 0, l = srcElements.length; i < l; i++)cloneCopyEvent(srcElements[i], destElements[i]);
                } else cloneCopyEvent(elem, clone);
            }
            // Preserve script evaluation history
            destElements = getAll(clone, "script");
            if (destElements.length > 0) setGlobalEval(destElements, !inPage && getAll(elem, "script"));
            // Return the cloned set
            return clone;
        },
        cleanData: function(elems) {
            var data, elem, type, special = jQuery.event.special, i = 0;
            for(; (elem = elems[i]) !== undefined; i++)if (acceptData(elem)) {
                if (data = elem[dataPriv.expando]) {
                    if (data.events) {
                        for(type in data.events)if (special[type]) jQuery.event.remove(elem, type);
                        else jQuery.removeEvent(elem, type, data.handle);
                    }
                    // Support: Chrome <=35 - 45+
                    // Assign undefined instead of using delete, see Data#remove
                    elem[dataPriv.expando] = undefined;
                }
                if (elem[dataUser.expando]) // Support: Chrome <=35 - 45+
                // Assign undefined instead of using delete, see Data#remove
                elem[dataUser.expando] = undefined;
            }
        }
    });
    jQuery.fn.extend({
        detach: function(selector) {
            return remove(this, selector, true);
        },
        remove: function(selector) {
            return remove(this, selector);
        },
        text: function(value) {
            return access(this, function(value) {
                return value === undefined ? jQuery.text(this) : this.empty().each(function() {
                    if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) this.textContent = value;
                });
            }, null, value, arguments.length);
        },
        append: function() {
            return domManip(this, arguments, function(elem) {
                if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) {
                    var target = manipulationTarget(this, elem);
                    target.appendChild(elem);
                }
            });
        },
        prepend: function() {
            return domManip(this, arguments, function(elem) {
                if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) {
                    var target = manipulationTarget(this, elem);
                    target.insertBefore(elem, target.firstChild);
                }
            });
        },
        before: function() {
            return domManip(this, arguments, function(elem) {
                if (this.parentNode) this.parentNode.insertBefore(elem, this);
            });
        },
        after: function() {
            return domManip(this, arguments, function(elem) {
                if (this.parentNode) this.parentNode.insertBefore(elem, this.nextSibling);
            });
        },
        empty: function() {
            var elem, i = 0;
            for(; (elem = this[i]) != null; i++)if (elem.nodeType === 1) {
                // Prevent memory leaks
                jQuery.cleanData(getAll(elem, false));
                // Remove any remaining nodes
                elem.textContent = "";
            }
            return this;
        },
        clone: function(dataAndEvents, deepDataAndEvents) {
            dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
            deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;
            return this.map(function() {
                return jQuery.clone(this, dataAndEvents, deepDataAndEvents);
            });
        },
        html: function(value) {
            return access(this, function(value) {
                var elem = this[0] || {}, i = 0, l = this.length;
                if (value === undefined && elem.nodeType === 1) return elem.innerHTML;
                // See if we can take a shortcut and just use innerHTML
                if (typeof value === "string" && !rnoInnerhtml.test(value) && !wrapMap[(rtagName.exec(value) || [
                    "",
                    ""
                ])[1].toLowerCase()]) {
                    value = jQuery.htmlPrefilter(value);
                    try {
                        for(; i < l; i++){
                            elem = this[i] || {};
                            // Remove element nodes and prevent memory leaks
                            if (elem.nodeType === 1) {
                                jQuery.cleanData(getAll(elem, false));
                                elem.innerHTML = value;
                            }
                        }
                        elem = 0;
                    // If using innerHTML throws an exception, use the fallback method
                    } catch (e) {}
                }
                if (elem) this.empty().append(value);
            }, null, value, arguments.length);
        },
        replaceWith: function() {
            var ignored = [];
            // Make the changes, replacing each non-ignored context element with the new content
            return domManip(this, arguments, function(elem) {
                var parent = this.parentNode;
                if (jQuery.inArray(this, ignored) < 0) {
                    jQuery.cleanData(getAll(this));
                    if (parent) parent.replaceChild(elem, this);
                }
            // Force callback invocation
            }, ignored);
        }
    });
    jQuery.each({
        appendTo: "append",
        prependTo: "prepend",
        insertBefore: "before",
        insertAfter: "after",
        replaceAll: "replaceWith"
    }, function(name, original) {
        jQuery.fn[name] = function(selector) {
            var elems, ret = [], insert = jQuery(selector), last = insert.length - 1, i = 0;
            for(; i <= last; i++){
                elems = i === last ? this : this.clone(true);
                jQuery(insert[i])[original](elems);
                // Support: Android <=4.0 only, PhantomJS 1 only
                // .get() because push.apply(_, arraylike) throws on ancient WebKit
                push.apply(ret, elems.get());
            }
            return this.pushStack(ret);
        };
    });
    var rnumnonpx = new RegExp("^(" + pnum + ")(?!px)[a-z%]+$", "i");
    var rcustomProp = /^--/;
    var getStyles = function(elem) {
        // Support: IE <=11 only, Firefox <=30 (trac-15098, trac-14150)
        // IE throws on elements created in popups
        // FF meanwhile throws on frame elements through "defaultView.getComputedStyle"
        var view = elem.ownerDocument.defaultView;
        if (!view || !view.opener) view = window1;
        return view.getComputedStyle(elem);
    };
    var swap = function(elem, options, callback) {
        var ret, name, old = {};
        // Remember the old values, and insert the new ones
        for(name in options){
            old[name] = elem.style[name];
            elem.style[name] = options[name];
        }
        ret = callback.call(elem);
        // Revert the old values
        for(name in options)elem.style[name] = old[name];
        return ret;
    };
    var rboxStyle = new RegExp(cssExpand.join("|"), "i");
    (function() {
        // Executing both pixelPosition & boxSizingReliable tests require only one layout
        // so they're executed at the same time to save the second computation.
        function computeStyleTests() {
            // This is a singleton, we need to execute it only once
            if (!div) return;
            container.style.cssText = "position:absolute;left:-11111px;width:60px;margin-top:1px;padding:0;border:0";
            div.style.cssText = "position:relative;display:block;box-sizing:border-box;overflow:scroll;margin:auto;border:1px;padding:1px;width:60%;top:1%";
            documentElement.appendChild(container).appendChild(div);
            var divStyle = window1.getComputedStyle(div);
            pixelPositionVal = divStyle.top !== "1%";
            // Support: Android 4.0 - 4.3 only, Firefox <=3 - 44
            reliableMarginLeftVal = roundPixelMeasures(divStyle.marginLeft) === 12;
            // Support: Android 4.0 - 4.3 only, Safari <=9.1 - 10.1, iOS <=7.0 - 9.3
            // Some styles come back with percentage values, even though they shouldn't
            div.style.right = "60%";
            pixelBoxStylesVal = roundPixelMeasures(divStyle.right) === 36;
            // Support: IE 9 - 11 only
            // Detect misreporting of content dimensions for box-sizing:border-box elements
            boxSizingReliableVal = roundPixelMeasures(divStyle.width) === 36;
            // Support: IE 9 only
            // Detect overflow:scroll screwiness (gh-3699)
            // Support: Chrome <=64
            // Don't get tricked when zoom affects offsetWidth (gh-4029)
            div.style.position = "absolute";
            scrollboxSizeVal = roundPixelMeasures(div.offsetWidth / 3) === 12;
            documentElement.removeChild(container);
            // Nullify the div so it wouldn't be stored in the memory and
            // it will also be a sign that checks already performed
            div = null;
        }
        function roundPixelMeasures(measure) {
            return Math.round(parseFloat(measure));
        }
        var pixelPositionVal, boxSizingReliableVal, scrollboxSizeVal, pixelBoxStylesVal, reliableTrDimensionsVal, reliableMarginLeftVal, container = document.createElement("div"), div = document.createElement("div");
        // Finish early in limited (non-browser) environments
        if (!div.style) return;
        // Support: IE <=9 - 11 only
        // Style of cloned element affects source element cloned (trac-8908)
        div.style.backgroundClip = "content-box";
        div.cloneNode(true).style.backgroundClip = "";
        support.clearCloneStyle = div.style.backgroundClip === "content-box";
        jQuery.extend(support, {
            boxSizingReliable: function() {
                computeStyleTests();
                return boxSizingReliableVal;
            },
            pixelBoxStyles: function() {
                computeStyleTests();
                return pixelBoxStylesVal;
            },
            pixelPosition: function() {
                computeStyleTests();
                return pixelPositionVal;
            },
            reliableMarginLeft: function() {
                computeStyleTests();
                return reliableMarginLeftVal;
            },
            scrollboxSize: function() {
                computeStyleTests();
                return scrollboxSizeVal;
            },
            // Support: IE 9 - 11+, Edge 15 - 18+
            // IE/Edge misreport `getComputedStyle` of table rows with width/height
            // set in CSS while `offset*` properties report correct values.
            // Behavior in IE 9 is more subtle than in newer versions & it passes
            // some versions of this test; make sure not to make it pass there!
            //
            // Support: Firefox 70+
            // Only Firefox includes border widths
            // in computed dimensions. (gh-4529)
            reliableTrDimensions: function() {
                var table, tr, trChild, trStyle;
                if (reliableTrDimensionsVal == null) {
                    table = document.createElement("table");
                    tr = document.createElement("tr");
                    trChild = document.createElement("div");
                    table.style.cssText = "position:absolute;left:-11111px;border-collapse:separate";
                    tr.style.cssText = "box-sizing:content-box;border:1px solid";
                    // Support: Chrome 86+
                    // Height set through cssText does not get applied.
                    // Computed height then comes back as 0.
                    tr.style.height = "1px";
                    trChild.style.height = "9px";
                    // Support: Android 8 Chrome 86+
                    // In our bodyBackground.html iframe,
                    // display for all div elements is set to "inline",
                    // which causes a problem only in Android 8 Chrome 86.
                    // Ensuring the div is `display: block`
                    // gets around this issue.
                    trChild.style.display = "block";
                    documentElement.appendChild(table).appendChild(tr).appendChild(trChild);
                    trStyle = window1.getComputedStyle(tr);
                    reliableTrDimensionsVal = parseInt(trStyle.height, 10) + parseInt(trStyle.borderTopWidth, 10) + parseInt(trStyle.borderBottomWidth, 10) === tr.offsetHeight;
                    documentElement.removeChild(table);
                }
                return reliableTrDimensionsVal;
            }
        });
    })();
    function curCSS(elem, name, computed) {
        var width, minWidth, maxWidth, ret, isCustomProp = rcustomProp.test(name), // Support: Firefox 51+
        // Retrieving style before computed somehow
        // fixes an issue with getting wrong values
        // on detached elements
        style = elem.style;
        computed = computed || getStyles(elem);
        // getPropertyValue is needed for:
        //   .css('filter') (IE 9 only, trac-12537)
        //   .css('--customProperty) (gh-3144)
        if (computed) {
            // Support: IE <=9 - 11+
            // IE only supports `"float"` in `getPropertyValue`; in computed styles
            // it's only available as `"cssFloat"`. We no longer modify properties
            // sent to `.css()` apart from camelCasing, so we need to check both.
            // Normally, this would create difference in behavior: if
            // `getPropertyValue` returns an empty string, the value returned
            // by `.css()` would be `undefined`. This is usually the case for
            // disconnected elements. However, in IE even disconnected elements
            // with no styles return `"none"` for `getPropertyValue( "float" )`
            ret = computed.getPropertyValue(name) || computed[name];
            if (isCustomProp && ret) // Support: Firefox 105+, Chrome <=105+
            // Spec requires trimming whitespace for custom properties (gh-4926).
            // Firefox only trims leading whitespace. Chrome just collapses
            // both leading & trailing whitespace to a single space.
            //
            // Fall back to `undefined` if empty string returned.
            // This collapses a missing definition with property defined
            // and set to an empty string but there's no standard API
            // allowing us to differentiate them without a performance penalty
            // and returning `undefined` aligns with older jQuery.
            //
            // rtrimCSS treats U+000D CARRIAGE RETURN and U+000C FORM FEED
            // as whitespace while CSS does not, but this is not a problem
            // because CSS preprocessing replaces them with U+000A LINE FEED
            // (which *is* CSS whitespace)
            // https://www.w3.org/TR/css-syntax-3/#input-preprocessing
            ret = ret.replace(rtrimCSS, "$1") || undefined;
            if (ret === "" && !isAttached(elem)) ret = jQuery.style(elem, name);
            // A tribute to the "awesome hack by Dean Edwards"
            // Android Browser returns percentage for some values,
            // but width seems to be reliably pixels.
            // This is against the CSSOM draft spec:
            // https://drafts.csswg.org/cssom/#resolved-values
            if (!support.pixelBoxStyles() && rnumnonpx.test(ret) && rboxStyle.test(name)) {
                // Remember the original values
                width = style.width;
                minWidth = style.minWidth;
                maxWidth = style.maxWidth;
                // Put in the new values to get a computed value out
                style.minWidth = style.maxWidth = style.width = ret;
                ret = computed.width;
                // Revert the changed values
                style.width = width;
                style.minWidth = minWidth;
                style.maxWidth = maxWidth;
            }
        }
        return ret !== undefined ? // Support: IE <=9 - 11 only
        // IE returns zIndex value as an integer.
        ret + "" : ret;
    }
    function addGetHookIf(conditionFn, hookFn) {
        // Define the hook, we'll check on the first run if it's really needed.
        return {
            get: function() {
                if (conditionFn()) {
                    // Hook not needed (or it's not possible to use it due
                    // to missing dependency), remove it.
                    delete this.get;
                    return;
                }
                // Hook needed; redefine it so that the support test is not executed again.
                return (this.get = hookFn).apply(this, arguments);
            }
        };
    }
    var cssPrefixes = [
        "Webkit",
        "Moz",
        "ms"
    ], emptyStyle = document.createElement("div").style, vendorProps = {};
    // Return a vendor-prefixed property or undefined
    function vendorPropName(name) {
        // Check for vendor prefixed names
        var capName = name[0].toUpperCase() + name.slice(1), i = cssPrefixes.length;
        while(i--){
            name = cssPrefixes[i] + capName;
            if (name in emptyStyle) return name;
        }
    }
    // Return a potentially-mapped jQuery.cssProps or vendor prefixed property
    function finalPropName(name) {
        var final = jQuery.cssProps[name] || vendorProps[name];
        if (final) return final;
        if (name in emptyStyle) return name;
        return vendorProps[name] = vendorPropName(name) || name;
    }
    var // Swappable if display is none or starts with table
    // except "table", "table-cell", or "table-caption"
    // See here for display values: https://developer.mozilla.org/en-US/docs/CSS/display
    rdisplayswap = /^(none|table(?!-c[ea]).+)/, cssShow = {
        position: "absolute",
        visibility: "hidden",
        display: "block"
    }, cssNormalTransform = {
        letterSpacing: "0",
        fontWeight: "400"
    };
    function setPositiveNumber(_elem, value, subtract) {
        // Any relative (+/-) values have already been
        // normalized at this point
        var matches = rcssNum.exec(value);
        return matches ? // Guard against undefined "subtract", e.g., when used as in cssHooks
        Math.max(0, matches[2] - (subtract || 0)) + (matches[3] || "px") : value;
    }
    function boxModelAdjustment(elem, dimension, box, isBorderBox, styles, computedVal) {
        var i = dimension === "width" ? 1 : 0, extra = 0, delta = 0, marginDelta = 0;
        // Adjustment may not be necessary
        if (box === (isBorderBox ? "border" : "content")) return 0;
        for(; i < 4; i += 2){
            // Both box models exclude margin
            // Count margin delta separately to only add it after scroll gutter adjustment.
            // This is needed to make negative margins work with `outerHeight( true )` (gh-3982).
            if (box === "margin") marginDelta += jQuery.css(elem, box + cssExpand[i], true, styles);
            // If we get here with a content-box, we're seeking "padding" or "border" or "margin"
            if (!isBorderBox) {
                // Add padding
                delta += jQuery.css(elem, "padding" + cssExpand[i], true, styles);
                // For "border" or "margin", add border
                if (box !== "padding") delta += jQuery.css(elem, "border" + cssExpand[i] + "Width", true, styles);
                else extra += jQuery.css(elem, "border" + cssExpand[i] + "Width", true, styles);
            // If we get here with a border-box (content + padding + border), we're seeking "content" or
            // "padding" or "margin"
            } else {
                // For "content", subtract padding
                if (box === "content") delta -= jQuery.css(elem, "padding" + cssExpand[i], true, styles);
                // For "content" or "padding", subtract border
                if (box !== "margin") delta -= jQuery.css(elem, "border" + cssExpand[i] + "Width", true, styles);
            }
        }
        // Account for positive content-box scroll gutter when requested by providing computedVal
        if (!isBorderBox && computedVal >= 0) // offsetWidth/offsetHeight is a rounded sum of content, padding, scroll gutter, and border
        // Assuming integer scroll gutter, subtract the rest and round down
        delta += Math.max(0, Math.ceil(elem["offset" + dimension[0].toUpperCase() + dimension.slice(1)] - computedVal - delta - extra - 0.5)) || 0;
        return delta + marginDelta;
    }
    function getWidthOrHeight(elem, dimension, extra) {
        // Start with computed style
        var styles = getStyles(elem), // To avoid forcing a reflow, only fetch boxSizing if we need it (gh-4322).
        // Fake content-box until we know it's needed to know the true value.
        boxSizingNeeded = !support.boxSizingReliable() || extra, isBorderBox = boxSizingNeeded && jQuery.css(elem, "boxSizing", false, styles) === "border-box", valueIsBorderBox = isBorderBox, val = curCSS(elem, dimension, styles), offsetProp = "offset" + dimension[0].toUpperCase() + dimension.slice(1);
        // Support: Firefox <=54
        // Return a confounding non-pixel value or feign ignorance, as appropriate.
        if (rnumnonpx.test(val)) {
            if (!extra) return val;
            val = "auto";
        }
        // Support: IE 9 - 11 only
        // Use offsetWidth/offsetHeight for when box sizing is unreliable.
        // In those cases, the computed value can be trusted to be border-box.
        if ((!support.boxSizingReliable() && isBorderBox || // Support: IE 10 - 11+, Edge 15 - 18+
        // IE/Edge misreport `getComputedStyle` of table rows with width/height
        // set in CSS while `offset*` properties report correct values.
        // Interestingly, in some cases IE 9 doesn't suffer from this issue.
        !support.reliableTrDimensions() && nodeName(elem, "tr") || // Fall back to offsetWidth/offsetHeight when value is "auto"
        // This happens for inline elements with no explicit setting (gh-3571)
        val === "auto" || // Support: Android <=4.1 - 4.3 only
        // Also use offsetWidth/offsetHeight for misreported inline dimensions (gh-3602)
        !parseFloat(val) && jQuery.css(elem, "display", false, styles) === "inline") && // Make sure the element is visible & connected
        elem.getClientRects().length) {
            isBorderBox = jQuery.css(elem, "boxSizing", false, styles) === "border-box";
            // Where available, offsetWidth/offsetHeight approximate border box dimensions.
            // Where not available (e.g., SVG), assume unreliable box-sizing and interpret the
            // retrieved value as a content box dimension.
            valueIsBorderBox = offsetProp in elem;
            if (valueIsBorderBox) val = elem[offsetProp];
        }
        // Normalize "" and auto
        val = parseFloat(val) || 0;
        // Adjust for the element's box model
        return val + boxModelAdjustment(elem, dimension, extra || (isBorderBox ? "border" : "content"), valueIsBorderBox, styles, // Provide the current computed size to request scroll gutter calculation (gh-3589)
        val) + "px";
    }
    jQuery.extend({
        // Add in style property hooks for overriding the default
        // behavior of getting and setting a style property
        cssHooks: {
            opacity: {
                get: function(elem, computed) {
                    if (computed) {
                        // We should always get a number back from opacity
                        var ret = curCSS(elem, "opacity");
                        return ret === "" ? "1" : ret;
                    }
                }
            }
        },
        // Don't automatically add "px" to these possibly-unitless properties
        cssNumber: {
            animationIterationCount: true,
            aspectRatio: true,
            borderImageSlice: true,
            columnCount: true,
            flexGrow: true,
            flexShrink: true,
            fontWeight: true,
            gridArea: true,
            gridColumn: true,
            gridColumnEnd: true,
            gridColumnStart: true,
            gridRow: true,
            gridRowEnd: true,
            gridRowStart: true,
            lineHeight: true,
            opacity: true,
            order: true,
            orphans: true,
            scale: true,
            widows: true,
            zIndex: true,
            zoom: true,
            // SVG-related
            fillOpacity: true,
            floodOpacity: true,
            stopOpacity: true,
            strokeMiterlimit: true,
            strokeOpacity: true
        },
        // Add in properties whose names you wish to fix before
        // setting or getting the value
        cssProps: {},
        // Get and set the style property on a DOM Node
        style: function(elem, name, value, extra) {
            // Don't set styles on text and comment nodes
            if (!elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style) return;
            // Make sure that we're working with the right name
            var ret, type, hooks, origName = camelCase(name), isCustomProp = rcustomProp.test(name), style = elem.style;
            // Make sure that we're working with the right name. We don't
            // want to query the value if it is a CSS custom property
            // since they are user-defined.
            if (!isCustomProp) name = finalPropName(origName);
            // Gets hook for the prefixed version, then unprefixed version
            hooks = jQuery.cssHooks[name] || jQuery.cssHooks[origName];
            // Check if we're setting a value
            if (value !== undefined) {
                type = typeof value;
                // Convert "+=" or "-=" to relative numbers (trac-7345)
                if (type === "string" && (ret = rcssNum.exec(value)) && ret[1]) {
                    value = adjustCSS(elem, name, ret);
                    // Fixes bug trac-9237
                    type = "number";
                }
                // Make sure that null and NaN values aren't set (trac-7116)
                if (value == null || value !== value) return;
                // If a number was passed in, add the unit (except for certain CSS properties)
                // The isCustomProp check can be removed in jQuery 4.0 when we only auto-append
                // "px" to a few hardcoded values.
                if (type === "number" && !isCustomProp) value += ret && ret[3] || (jQuery.cssNumber[origName] ? "" : "px");
                // background-* props affect original clone's values
                if (!support.clearCloneStyle && value === "" && name.indexOf("background") === 0) style[name] = "inherit";
                // If a hook was provided, use that value, otherwise just set the specified value
                if (!hooks || !("set" in hooks) || (value = hooks.set(elem, value, extra)) !== undefined) {
                    if (isCustomProp) style.setProperty(name, value);
                    else style[name] = value;
                }
            } else {
                // If a hook was provided get the non-computed value from there
                if (hooks && "get" in hooks && (ret = hooks.get(elem, false, extra)) !== undefined) return ret;
                // Otherwise just get the value from the style object
                return style[name];
            }
        },
        css: function(elem, name, extra, styles) {
            var val, num, hooks, origName = camelCase(name), isCustomProp = rcustomProp.test(name);
            // Make sure that we're working with the right name. We don't
            // want to modify the value if it is a CSS custom property
            // since they are user-defined.
            if (!isCustomProp) name = finalPropName(origName);
            // Try prefixed name followed by the unprefixed name
            hooks = jQuery.cssHooks[name] || jQuery.cssHooks[origName];
            // If a hook was provided get the computed value from there
            if (hooks && "get" in hooks) val = hooks.get(elem, true, extra);
            // Otherwise, if a way to get the computed value exists, use that
            if (val === undefined) val = curCSS(elem, name, styles);
            // Convert "normal" to computed value
            if (val === "normal" && name in cssNormalTransform) val = cssNormalTransform[name];
            // Make numeric if forced or a qualifier was provided and val looks numeric
            if (extra === "" || extra) {
                num = parseFloat(val);
                return extra === true || isFinite(num) ? num || 0 : val;
            }
            return val;
        }
    });
    jQuery.each([
        "height",
        "width"
    ], function(_i, dimension) {
        jQuery.cssHooks[dimension] = {
            get: function(elem, computed, extra) {
                if (computed) // Certain elements can have dimension info if we invisibly show them
                // but it must have a current display style that would benefit
                return rdisplayswap.test(jQuery.css(elem, "display")) && // Support: Safari 8+
                // Table columns in Safari have non-zero offsetWidth & zero
                // getBoundingClientRect().width unless display is changed.
                // Support: IE <=11 only
                // Running getBoundingClientRect on a disconnected node
                // in IE throws an error.
                (!elem.getClientRects().length || !elem.getBoundingClientRect().width) ? swap(elem, cssShow, function() {
                    return getWidthOrHeight(elem, dimension, extra);
                }) : getWidthOrHeight(elem, dimension, extra);
            },
            set: function(elem, value, extra) {
                var matches, styles = getStyles(elem), // Only read styles.position if the test has a chance to fail
                // to avoid forcing a reflow.
                scrollboxSizeBuggy = !support.scrollboxSize() && styles.position === "absolute", // To avoid forcing a reflow, only fetch boxSizing if we need it (gh-3991)
                boxSizingNeeded = scrollboxSizeBuggy || extra, isBorderBox = boxSizingNeeded && jQuery.css(elem, "boxSizing", false, styles) === "border-box", subtract = extra ? boxModelAdjustment(elem, dimension, extra, isBorderBox, styles) : 0;
                // Account for unreliable border-box dimensions by comparing offset* to computed and
                // faking a content-box to get border and padding (gh-3699)
                if (isBorderBox && scrollboxSizeBuggy) subtract -= Math.ceil(elem["offset" + dimension[0].toUpperCase() + dimension.slice(1)] - parseFloat(styles[dimension]) - boxModelAdjustment(elem, dimension, "border", false, styles) - 0.5);
                // Convert to pixels if value adjustment is needed
                if (subtract && (matches = rcssNum.exec(value)) && (matches[3] || "px") !== "px") {
                    elem.style[dimension] = value;
                    value = jQuery.css(elem, dimension);
                }
                return setPositiveNumber(elem, value, subtract);
            }
        };
    });
    jQuery.cssHooks.marginLeft = addGetHookIf(support.reliableMarginLeft, function(elem, computed) {
        if (computed) return (parseFloat(curCSS(elem, "marginLeft")) || elem.getBoundingClientRect().left - swap(elem, {
            marginLeft: 0
        }, function() {
            return elem.getBoundingClientRect().left;
        })) + "px";
    });
    // These hooks are used by animate to expand properties
    jQuery.each({
        margin: "",
        padding: "",
        border: "Width"
    }, function(prefix, suffix) {
        jQuery.cssHooks[prefix + suffix] = {
            expand: function(value) {
                var i = 0, expanded = {}, // Assumes a single number if not a string
                parts = typeof value === "string" ? value.split(" ") : [
                    value
                ];
                for(; i < 4; i++)expanded[prefix + cssExpand[i] + suffix] = parts[i] || parts[i - 2] || parts[0];
                return expanded;
            }
        };
        if (prefix !== "margin") jQuery.cssHooks[prefix + suffix].set = setPositiveNumber;
    });
    jQuery.fn.extend({
        css: function(name, value) {
            return access(this, function(elem, name, value) {
                var styles, len, map = {}, i = 0;
                if (Array.isArray(name)) {
                    styles = getStyles(elem);
                    len = name.length;
                    for(; i < len; i++)map[name[i]] = jQuery.css(elem, name[i], false, styles);
                    return map;
                }
                return value !== undefined ? jQuery.style(elem, name, value) : jQuery.css(elem, name);
            }, name, value, arguments.length > 1);
        }
    });
    function Tween(elem, options, prop, end, easing) {
        return new Tween.prototype.init(elem, options, prop, end, easing);
    }
    jQuery.Tween = Tween;
    Tween.prototype = {
        constructor: Tween,
        init: function(elem, options, prop, end, easing, unit) {
            this.elem = elem;
            this.prop = prop;
            this.easing = easing || jQuery.easing._default;
            this.options = options;
            this.start = this.now = this.cur();
            this.end = end;
            this.unit = unit || (jQuery.cssNumber[prop] ? "" : "px");
        },
        cur: function() {
            var hooks = Tween.propHooks[this.prop];
            return hooks && hooks.get ? hooks.get(this) : Tween.propHooks._default.get(this);
        },
        run: function(percent) {
            var eased, hooks = Tween.propHooks[this.prop];
            if (this.options.duration) this.pos = eased = jQuery.easing[this.easing](percent, this.options.duration * percent, 0, 1, this.options.duration);
            else this.pos = eased = percent;
            this.now = (this.end - this.start) * eased + this.start;
            if (this.options.step) this.options.step.call(this.elem, this.now, this);
            if (hooks && hooks.set) hooks.set(this);
            else Tween.propHooks._default.set(this);
            return this;
        }
    };
    Tween.prototype.init.prototype = Tween.prototype;
    Tween.propHooks = {
        _default: {
            get: function(tween) {
                var result;
                // Use a property on the element directly when it is not a DOM element,
                // or when there is no matching style property that exists.
                if (tween.elem.nodeType !== 1 || tween.elem[tween.prop] != null && tween.elem.style[tween.prop] == null) return tween.elem[tween.prop];
                // Passing an empty string as a 3rd parameter to .css will automatically
                // attempt a parseFloat and fallback to a string if the parse fails.
                // Simple values such as "10px" are parsed to Float;
                // complex values such as "rotate(1rad)" are returned as-is.
                result = jQuery.css(tween.elem, tween.prop, "");
                // Empty strings, null, undefined and "auto" are converted to 0.
                return !result || result === "auto" ? 0 : result;
            },
            set: function(tween) {
                // Use step hook for back compat.
                // Use cssHook if its there.
                // Use .style if available and use plain properties where available.
                if (jQuery.fx.step[tween.prop]) jQuery.fx.step[tween.prop](tween);
                else if (tween.elem.nodeType === 1 && (jQuery.cssHooks[tween.prop] || tween.elem.style[finalPropName(tween.prop)] != null)) jQuery.style(tween.elem, tween.prop, tween.now + tween.unit);
                else tween.elem[tween.prop] = tween.now;
            }
        }
    };
    // Support: IE <=9 only
    // Panic based approach to setting things on disconnected nodes
    Tween.propHooks.scrollTop = Tween.propHooks.scrollLeft = {
        set: function(tween) {
            if (tween.elem.nodeType && tween.elem.parentNode) tween.elem[tween.prop] = tween.now;
        }
    };
    jQuery.easing = {
        linear: function(p) {
            return p;
        },
        swing: function(p) {
            return 0.5 - Math.cos(p * Math.PI) / 2;
        },
        _default: "swing"
    };
    jQuery.fx = Tween.prototype.init;
    // Back compat <1.8 extension point
    jQuery.fx.step = {};
    var fxNow, inProgress, rfxtypes = /^(?:toggle|show|hide)$/, rrun = /queueHooks$/;
    function schedule() {
        if (inProgress) {
            if (document.hidden === false && window1.requestAnimationFrame) window1.requestAnimationFrame(schedule);
            else window1.setTimeout(schedule, jQuery.fx.interval);
            jQuery.fx.tick();
        }
    }
    // Animations created synchronously will run synchronously
    function createFxNow() {
        window1.setTimeout(function() {
            fxNow = undefined;
        });
        return fxNow = Date.now();
    }
    // Generate parameters to create a standard animation
    function genFx(type, includeWidth) {
        var which, i = 0, attrs = {
            height: type
        };
        // If we include width, step value is 1 to do all cssExpand values,
        // otherwise step value is 2 to skip over Left and Right
        includeWidth = includeWidth ? 1 : 0;
        for(; i < 4; i += 2 - includeWidth){
            which = cssExpand[i];
            attrs["margin" + which] = attrs["padding" + which] = type;
        }
        if (includeWidth) attrs.opacity = attrs.width = type;
        return attrs;
    }
    function createTween(value, prop, animation) {
        var tween, collection = (Animation.tweeners[prop] || []).concat(Animation.tweeners["*"]), index = 0, length = collection.length;
        for(; index < length; index++){
            if (tween = collection[index].call(animation, prop, value)) // We're done with this property
            return tween;
        }
    }
    function defaultPrefilter(elem, props, opts) {
        var prop, value, toggle, hooks, oldfire, propTween, restoreDisplay, display, isBox = "width" in props || "height" in props, anim = this, orig = {}, style = elem.style, hidden = elem.nodeType && isHiddenWithinTree(elem), dataShow = dataPriv.get(elem, "fxshow");
        // Queue-skipping animations hijack the fx hooks
        if (!opts.queue) {
            hooks = jQuery._queueHooks(elem, "fx");
            if (hooks.unqueued == null) {
                hooks.unqueued = 0;
                oldfire = hooks.empty.fire;
                hooks.empty.fire = function() {
                    if (!hooks.unqueued) oldfire();
                };
            }
            hooks.unqueued++;
            anim.always(function() {
                // Ensure the complete handler is called before this completes
                anim.always(function() {
                    hooks.unqueued--;
                    if (!jQuery.queue(elem, "fx").length) hooks.empty.fire();
                });
            });
        }
        // Detect show/hide animations
        for(prop in props){
            value = props[prop];
            if (rfxtypes.test(value)) {
                delete props[prop];
                toggle = toggle || value === "toggle";
                if (value === (hidden ? "hide" : "show")) {
                    // Pretend to be hidden if this is a "show" and
                    // there is still data from a stopped show/hide
                    if (value === "show" && dataShow && dataShow[prop] !== undefined) hidden = true;
                    else continue;
                }
                orig[prop] = dataShow && dataShow[prop] || jQuery.style(elem, prop);
            }
        }
        // Bail out if this is a no-op like .hide().hide()
        propTween = !jQuery.isEmptyObject(props);
        if (!propTween && jQuery.isEmptyObject(orig)) return;
        // Restrict "overflow" and "display" styles during box animations
        if (isBox && elem.nodeType === 1) {
            // Support: IE <=9 - 11, Edge 12 - 15
            // Record all 3 overflow attributes because IE does not infer the shorthand
            // from identically-valued overflowX and overflowY and Edge just mirrors
            // the overflowX value there.
            opts.overflow = [
                style.overflow,
                style.overflowX,
                style.overflowY
            ];
            // Identify a display type, preferring old show/hide data over the CSS cascade
            restoreDisplay = dataShow && dataShow.display;
            if (restoreDisplay == null) restoreDisplay = dataPriv.get(elem, "display");
            display = jQuery.css(elem, "display");
            if (display === "none") {
                if (restoreDisplay) display = restoreDisplay;
                else {
                    // Get nonempty value(s) by temporarily forcing visibility
                    showHide([
                        elem
                    ], true);
                    restoreDisplay = elem.style.display || restoreDisplay;
                    display = jQuery.css(elem, "display");
                    showHide([
                        elem
                    ]);
                }
            }
            // Animate inline elements as inline-block
            if (display === "inline" || display === "inline-block" && restoreDisplay != null) {
                if (jQuery.css(elem, "float") === "none") {
                    // Restore the original display value at the end of pure show/hide animations
                    if (!propTween) {
                        anim.done(function() {
                            style.display = restoreDisplay;
                        });
                        if (restoreDisplay == null) {
                            display = style.display;
                            restoreDisplay = display === "none" ? "" : display;
                        }
                    }
                    style.display = "inline-block";
                }
            }
        }
        if (opts.overflow) {
            style.overflow = "hidden";
            anim.always(function() {
                style.overflow = opts.overflow[0];
                style.overflowX = opts.overflow[1];
                style.overflowY = opts.overflow[2];
            });
        }
        // Implement show/hide animations
        propTween = false;
        for(prop in orig){
            // General show/hide setup for this element animation
            if (!propTween) {
                if (dataShow) {
                    if ("hidden" in dataShow) hidden = dataShow.hidden;
                } else dataShow = dataPriv.access(elem, "fxshow", {
                    display: restoreDisplay
                });
                // Store hidden/visible for toggle so `.stop().toggle()` "reverses"
                if (toggle) dataShow.hidden = !hidden;
                // Show elements before animating them
                if (hidden) showHide([
                    elem
                ], true);
                /* eslint-disable no-loop-func */ anim.done(function() {
                    /* eslint-enable no-loop-func */ // The final step of a "hide" animation is actually hiding the element
                    if (!hidden) showHide([
                        elem
                    ]);
                    dataPriv.remove(elem, "fxshow");
                    for(prop in orig)jQuery.style(elem, prop, orig[prop]);
                });
            }
            // Per-property setup
            propTween = createTween(hidden ? dataShow[prop] : 0, prop, anim);
            if (!(prop in dataShow)) {
                dataShow[prop] = propTween.start;
                if (hidden) {
                    propTween.end = propTween.start;
                    propTween.start = 0;
                }
            }
        }
    }
    function propFilter(props, specialEasing) {
        var index, name, easing, value, hooks;
        // camelCase, specialEasing and expand cssHook pass
        for(index in props){
            name = camelCase(index);
            easing = specialEasing[name];
            value = props[index];
            if (Array.isArray(value)) {
                easing = value[1];
                value = props[index] = value[0];
            }
            if (index !== name) {
                props[name] = value;
                delete props[index];
            }
            hooks = jQuery.cssHooks[name];
            if (hooks && "expand" in hooks) {
                value = hooks.expand(value);
                delete props[name];
                // Not quite $.extend, this won't overwrite existing keys.
                // Reusing 'index' because we have the correct "name"
                for(index in value)if (!(index in props)) {
                    props[index] = value[index];
                    specialEasing[index] = easing;
                }
            } else specialEasing[name] = easing;
        }
    }
    function Animation(elem, properties, options) {
        var result, stopped, index = 0, length = Animation.prefilters.length, deferred = jQuery.Deferred().always(function() {
            // Don't match elem in the :animated selector
            delete tick.elem;
        }), tick = function() {
            if (stopped) return false;
            var currentTime = fxNow || createFxNow(), remaining = Math.max(0, animation.startTime + animation.duration - currentTime), // Support: Android 2.3 only
            // Archaic crash bug won't allow us to use `1 - ( 0.5 || 0 )` (trac-12497)
            temp = remaining / animation.duration || 0, percent = 1 - temp, index = 0, length = animation.tweens.length;
            for(; index < length; index++)animation.tweens[index].run(percent);
            deferred.notifyWith(elem, [
                animation,
                percent,
                remaining
            ]);
            // If there's more to do, yield
            if (percent < 1 && length) return remaining;
            // If this was an empty animation, synthesize a final progress notification
            if (!length) deferred.notifyWith(elem, [
                animation,
                1,
                0
            ]);
            // Resolve the animation and report its conclusion
            deferred.resolveWith(elem, [
                animation
            ]);
            return false;
        }, animation = deferred.promise({
            elem: elem,
            props: jQuery.extend({}, properties),
            opts: jQuery.extend(true, {
                specialEasing: {},
                easing: jQuery.easing._default
            }, options),
            originalProperties: properties,
            originalOptions: options,
            startTime: fxNow || createFxNow(),
            duration: options.duration,
            tweens: [],
            createTween: function(prop, end) {
                var tween = jQuery.Tween(elem, animation.opts, prop, end, animation.opts.specialEasing[prop] || animation.opts.easing);
                animation.tweens.push(tween);
                return tween;
            },
            stop: function(gotoEnd) {
                var index = 0, // If we are going to the end, we want to run all the tweens
                // otherwise we skip this part
                length = gotoEnd ? animation.tweens.length : 0;
                if (stopped) return this;
                stopped = true;
                for(; index < length; index++)animation.tweens[index].run(1);
                // Resolve when we played the last frame; otherwise, reject
                if (gotoEnd) {
                    deferred.notifyWith(elem, [
                        animation,
                        1,
                        0
                    ]);
                    deferred.resolveWith(elem, [
                        animation,
                        gotoEnd
                    ]);
                } else deferred.rejectWith(elem, [
                    animation,
                    gotoEnd
                ]);
                return this;
            }
        }), props = animation.props;
        propFilter(props, animation.opts.specialEasing);
        for(; index < length; index++){
            result = Animation.prefilters[index].call(animation, elem, props, animation.opts);
            if (result) {
                if (isFunction(result.stop)) jQuery._queueHooks(animation.elem, animation.opts.queue).stop = result.stop.bind(result);
                return result;
            }
        }
        jQuery.map(props, createTween, animation);
        if (isFunction(animation.opts.start)) animation.opts.start.call(elem, animation);
        // Attach callbacks from options
        animation.progress(animation.opts.progress).done(animation.opts.done, animation.opts.complete).fail(animation.opts.fail).always(animation.opts.always);
        jQuery.fx.timer(jQuery.extend(tick, {
            elem: elem,
            anim: animation,
            queue: animation.opts.queue
        }));
        return animation;
    }
    jQuery.Animation = jQuery.extend(Animation, {
        tweeners: {
            "*": [
                function(prop, value) {
                    var tween = this.createTween(prop, value);
                    adjustCSS(tween.elem, prop, rcssNum.exec(value), tween);
                    return tween;
                }
            ]
        },
        tweener: function(props, callback) {
            if (isFunction(props)) {
                callback = props;
                props = [
                    "*"
                ];
            } else props = props.match(rnothtmlwhite);
            var prop, index = 0, length = props.length;
            for(; index < length; index++){
                prop = props[index];
                Animation.tweeners[prop] = Animation.tweeners[prop] || [];
                Animation.tweeners[prop].unshift(callback);
            }
        },
        prefilters: [
            defaultPrefilter
        ],
        prefilter: function(callback, prepend) {
            if (prepend) Animation.prefilters.unshift(callback);
            else Animation.prefilters.push(callback);
        }
    });
    jQuery.speed = function(speed, easing, fn) {
        var opt = speed && typeof speed === "object" ? jQuery.extend({}, speed) : {
            complete: fn || !fn && easing || isFunction(speed) && speed,
            duration: speed,
            easing: fn && easing || easing && !isFunction(easing) && easing
        };
        // Go to the end state if fx are off
        if (jQuery.fx.off) opt.duration = 0;
        else if (typeof opt.duration !== "number") {
            if (opt.duration in jQuery.fx.speeds) opt.duration = jQuery.fx.speeds[opt.duration];
            else opt.duration = jQuery.fx.speeds._default;
        }
        // Normalize opt.queue - true/undefined/null -> "fx"
        if (opt.queue == null || opt.queue === true) opt.queue = "fx";
        // Queueing
        opt.old = opt.complete;
        opt.complete = function() {
            if (isFunction(opt.old)) opt.old.call(this);
            if (opt.queue) jQuery.dequeue(this, opt.queue);
        };
        return opt;
    };
    jQuery.fn.extend({
        fadeTo: function(speed, to, easing, callback) {
            // Show any hidden elements after setting opacity to 0
            return this.filter(isHiddenWithinTree).css("opacity", 0).show()// Animate to the value specified
            .end().animate({
                opacity: to
            }, speed, easing, callback);
        },
        animate: function(prop, speed, easing, callback) {
            var empty = jQuery.isEmptyObject(prop), optall = jQuery.speed(speed, easing, callback), doAnimation = function() {
                // Operate on a copy of prop so per-property easing won't be lost
                var anim = Animation(this, jQuery.extend({}, prop), optall);
                // Empty animations, or finishing resolves immediately
                if (empty || dataPriv.get(this, "finish")) anim.stop(true);
            };
            doAnimation.finish = doAnimation;
            return empty || optall.queue === false ? this.each(doAnimation) : this.queue(optall.queue, doAnimation);
        },
        stop: function(type, clearQueue, gotoEnd) {
            var stopQueue = function(hooks) {
                var stop = hooks.stop;
                delete hooks.stop;
                stop(gotoEnd);
            };
            if (typeof type !== "string") {
                gotoEnd = clearQueue;
                clearQueue = type;
                type = undefined;
            }
            if (clearQueue) this.queue(type || "fx", []);
            return this.each(function() {
                var dequeue = true, index = type != null && type + "queueHooks", timers = jQuery.timers, data = dataPriv.get(this);
                if (index) {
                    if (data[index] && data[index].stop) stopQueue(data[index]);
                } else {
                    for(index in data)if (data[index] && data[index].stop && rrun.test(index)) stopQueue(data[index]);
                }
                for(index = timers.length; index--;)if (timers[index].elem === this && (type == null || timers[index].queue === type)) {
                    timers[index].anim.stop(gotoEnd);
                    dequeue = false;
                    timers.splice(index, 1);
                }
                // Start the next in the queue if the last step wasn't forced.
                // Timers currently will call their complete callbacks, which
                // will dequeue but only if they were gotoEnd.
                if (dequeue || !gotoEnd) jQuery.dequeue(this, type);
            });
        },
        finish: function(type) {
            if (type !== false) type = type || "fx";
            return this.each(function() {
                var index, data = dataPriv.get(this), queue = data[type + "queue"], hooks = data[type + "queueHooks"], timers = jQuery.timers, length = queue ? queue.length : 0;
                // Enable finishing flag on private data
                data.finish = true;
                // Empty the queue first
                jQuery.queue(this, type, []);
                if (hooks && hooks.stop) hooks.stop.call(this, true);
                // Look for any active animations, and finish them
                for(index = timers.length; index--;)if (timers[index].elem === this && timers[index].queue === type) {
                    timers[index].anim.stop(true);
                    timers.splice(index, 1);
                }
                // Look for any animations in the old queue and finish them
                for(index = 0; index < length; index++)if (queue[index] && queue[index].finish) queue[index].finish.call(this);
                // Turn off finishing flag
                delete data.finish;
            });
        }
    });
    jQuery.each([
        "toggle",
        "show",
        "hide"
    ], function(_i, name) {
        var cssFn = jQuery.fn[name];
        jQuery.fn[name] = function(speed, easing, callback) {
            return speed == null || typeof speed === "boolean" ? cssFn.apply(this, arguments) : this.animate(genFx(name, true), speed, easing, callback);
        };
    });
    // Generate shortcuts for custom animations
    jQuery.each({
        slideDown: genFx("show"),
        slideUp: genFx("hide"),
        slideToggle: genFx("toggle"),
        fadeIn: {
            opacity: "show"
        },
        fadeOut: {
            opacity: "hide"
        },
        fadeToggle: {
            opacity: "toggle"
        }
    }, function(name, props) {
        jQuery.fn[name] = function(speed, easing, callback) {
            return this.animate(props, speed, easing, callback);
        };
    });
    jQuery.timers = [];
    jQuery.fx.tick = function() {
        var timer, i = 0, timers = jQuery.timers;
        fxNow = Date.now();
        for(; i < timers.length; i++){
            timer = timers[i];
            // Run the timer and safely remove it when done (allowing for external removal)
            if (!timer() && timers[i] === timer) timers.splice(i--, 1);
        }
        if (!timers.length) jQuery.fx.stop();
        fxNow = undefined;
    };
    jQuery.fx.timer = function(timer) {
        jQuery.timers.push(timer);
        jQuery.fx.start();
    };
    jQuery.fx.interval = 13;
    jQuery.fx.start = function() {
        if (inProgress) return;
        inProgress = true;
        schedule();
    };
    jQuery.fx.stop = function() {
        inProgress = null;
    };
    jQuery.fx.speeds = {
        slow: 600,
        fast: 200,
        // Default speed
        _default: 400
    };
    // Based off of the plugin by Clint Helfers, with permission.
    jQuery.fn.delay = function(time, type) {
        time = jQuery.fx ? jQuery.fx.speeds[time] || time : time;
        type = type || "fx";
        return this.queue(type, function(next, hooks) {
            var timeout = window1.setTimeout(next, time);
            hooks.stop = function() {
                window1.clearTimeout(timeout);
            };
        });
    };
    (function() {
        var input = document.createElement("input"), select = document.createElement("select"), opt = select.appendChild(document.createElement("option"));
        input.type = "checkbox";
        // Support: Android <=4.3 only
        // Default value for a checkbox should be "on"
        support.checkOn = input.value !== "";
        // Support: IE <=11 only
        // Must access selectedIndex to make default options select
        support.optSelected = opt.selected;
        // Support: IE <=11 only
        // An input loses its value after becoming a radio
        input = document.createElement("input");
        input.value = "t";
        input.type = "radio";
        support.radioValue = input.value === "t";
    })();
    var boolHook, attrHandle = jQuery.expr.attrHandle;
    jQuery.fn.extend({
        attr: function(name, value) {
            return access(this, jQuery.attr, name, value, arguments.length > 1);
        },
        removeAttr: function(name) {
            return this.each(function() {
                jQuery.removeAttr(this, name);
            });
        }
    });
    jQuery.extend({
        attr: function(elem, name, value) {
            var ret, hooks, nType = elem.nodeType;
            // Don't get/set attributes on text, comment and attribute nodes
            if (nType === 3 || nType === 8 || nType === 2) return;
            // Fallback to prop when attributes are not supported
            if (typeof elem.getAttribute === "undefined") return jQuery.prop(elem, name, value);
            // Attribute hooks are determined by the lowercase version
            // Grab necessary hook if one is defined
            if (nType !== 1 || !jQuery.isXMLDoc(elem)) hooks = jQuery.attrHooks[name.toLowerCase()] || (jQuery.expr.match.bool.test(name) ? boolHook : undefined);
            if (value !== undefined) {
                if (value === null) {
                    jQuery.removeAttr(elem, name);
                    return;
                }
                if (hooks && "set" in hooks && (ret = hooks.set(elem, value, name)) !== undefined) return ret;
                elem.setAttribute(name, value + "");
                return value;
            }
            if (hooks && "get" in hooks && (ret = hooks.get(elem, name)) !== null) return ret;
            ret = jQuery.find.attr(elem, name);
            // Non-existent attributes return null, we normalize to undefined
            return ret == null ? undefined : ret;
        },
        attrHooks: {
            type: {
                set: function(elem, value) {
                    if (!support.radioValue && value === "radio" && nodeName(elem, "input")) {
                        var val = elem.value;
                        elem.setAttribute("type", value);
                        if (val) elem.value = val;
                        return value;
                    }
                }
            }
        },
        removeAttr: function(elem, value) {
            var name, i = 0, // Attribute names can contain non-HTML whitespace characters
            // https://html.spec.whatwg.org/multipage/syntax.html#attributes-2
            attrNames = value && value.match(rnothtmlwhite);
            if (attrNames && elem.nodeType === 1) while(name = attrNames[i++])elem.removeAttribute(name);
        }
    });
    // Hooks for boolean attributes
    boolHook = {
        set: function(elem, value, name) {
            if (value === false) // Remove boolean attributes when set to false
            jQuery.removeAttr(elem, name);
            else elem.setAttribute(name, name);
            return name;
        }
    };
    jQuery.each(jQuery.expr.match.bool.source.match(/\w+/g), function(_i, name) {
        var getter = attrHandle[name] || jQuery.find.attr;
        attrHandle[name] = function(elem, name, isXML) {
            var ret, handle, lowercaseName = name.toLowerCase();
            if (!isXML) {
                // Avoid an infinite loop by temporarily removing this function from the getter
                handle = attrHandle[lowercaseName];
                attrHandle[lowercaseName] = ret;
                ret = getter(elem, name, isXML) != null ? lowercaseName : null;
                attrHandle[lowercaseName] = handle;
            }
            return ret;
        };
    });
    var rfocusable = /^(?:input|select|textarea|button)$/i, rclickable = /^(?:a|area)$/i;
    jQuery.fn.extend({
        prop: function(name, value) {
            return access(this, jQuery.prop, name, value, arguments.length > 1);
        },
        removeProp: function(name) {
            return this.each(function() {
                delete this[jQuery.propFix[name] || name];
            });
        }
    });
    jQuery.extend({
        prop: function(elem, name, value) {
            var ret, hooks, nType = elem.nodeType;
            // Don't get/set properties on text, comment and attribute nodes
            if (nType === 3 || nType === 8 || nType === 2) return;
            if (nType !== 1 || !jQuery.isXMLDoc(elem)) {
                // Fix name and attach hooks
                name = jQuery.propFix[name] || name;
                hooks = jQuery.propHooks[name];
            }
            if (value !== undefined) {
                if (hooks && "set" in hooks && (ret = hooks.set(elem, value, name)) !== undefined) return ret;
                return elem[name] = value;
            }
            if (hooks && "get" in hooks && (ret = hooks.get(elem, name)) !== null) return ret;
            return elem[name];
        },
        propHooks: {
            tabIndex: {
                get: function(elem) {
                    // Support: IE <=9 - 11 only
                    // elem.tabIndex doesn't always return the
                    // correct value when it hasn't been explicitly set
                    // Use proper attribute retrieval (trac-12072)
                    var tabindex = jQuery.find.attr(elem, "tabindex");
                    if (tabindex) return parseInt(tabindex, 10);
                    if (rfocusable.test(elem.nodeName) || rclickable.test(elem.nodeName) && elem.href) return 0;
                    return -1;
                }
            }
        },
        propFix: {
            "for": "htmlFor",
            "class": "className"
        }
    });
    // Support: IE <=11 only
    // Accessing the selectedIndex property
    // forces the browser to respect setting selected
    // on the option
    // The getter ensures a default option is selected
    // when in an optgroup
    // eslint rule "no-unused-expressions" is disabled for this code
    // since it considers such accessions noop
    if (!support.optSelected) jQuery.propHooks.selected = {
        get: function(elem) {
            /* eslint no-unused-expressions: "off" */ var parent = elem.parentNode;
            if (parent && parent.parentNode) parent.parentNode.selectedIndex;
            return null;
        },
        set: function(elem) {
            /* eslint no-unused-expressions: "off" */ var parent = elem.parentNode;
            if (parent) {
                parent.selectedIndex;
                if (parent.parentNode) parent.parentNode.selectedIndex;
            }
        }
    };
    jQuery.each([
        "tabIndex",
        "readOnly",
        "maxLength",
        "cellSpacing",
        "cellPadding",
        "rowSpan",
        "colSpan",
        "useMap",
        "frameBorder",
        "contentEditable"
    ], function() {
        jQuery.propFix[this.toLowerCase()] = this;
    });
    // Strip and collapse whitespace according to HTML spec
    // https://infra.spec.whatwg.org/#strip-and-collapse-ascii-whitespace
    function stripAndCollapse(value) {
        var tokens = value.match(rnothtmlwhite) || [];
        return tokens.join(" ");
    }
    function getClass(elem) {
        return elem.getAttribute && elem.getAttribute("class") || "";
    }
    function classesToArray(value) {
        if (Array.isArray(value)) return value;
        if (typeof value === "string") return value.match(rnothtmlwhite) || [];
        return [];
    }
    jQuery.fn.extend({
        addClass: function(value) {
            var classNames, cur, curValue, className, i, finalValue;
            if (isFunction(value)) return this.each(function(j) {
                jQuery(this).addClass(value.call(this, j, getClass(this)));
            });
            classNames = classesToArray(value);
            if (classNames.length) return this.each(function() {
                curValue = getClass(this);
                cur = this.nodeType === 1 && " " + stripAndCollapse(curValue) + " ";
                if (cur) {
                    for(i = 0; i < classNames.length; i++){
                        className = classNames[i];
                        if (cur.indexOf(" " + className + " ") < 0) cur += className + " ";
                    }
                    // Only assign if different to avoid unneeded rendering.
                    finalValue = stripAndCollapse(cur);
                    if (curValue !== finalValue) this.setAttribute("class", finalValue);
                }
            });
            return this;
        },
        removeClass: function(value) {
            var classNames, cur, curValue, className, i, finalValue;
            if (isFunction(value)) return this.each(function(j) {
                jQuery(this).removeClass(value.call(this, j, getClass(this)));
            });
            if (!arguments.length) return this.attr("class", "");
            classNames = classesToArray(value);
            if (classNames.length) return this.each(function() {
                curValue = getClass(this);
                // This expression is here for better compressibility (see addClass)
                cur = this.nodeType === 1 && " " + stripAndCollapse(curValue) + " ";
                if (cur) {
                    for(i = 0; i < classNames.length; i++){
                        className = classNames[i];
                        // Remove *all* instances
                        while(cur.indexOf(" " + className + " ") > -1)cur = cur.replace(" " + className + " ", " ");
                    }
                    // Only assign if different to avoid unneeded rendering.
                    finalValue = stripAndCollapse(cur);
                    if (curValue !== finalValue) this.setAttribute("class", finalValue);
                }
            });
            return this;
        },
        toggleClass: function(value, stateVal) {
            var classNames, className, i, self, type = typeof value, isValidValue = type === "string" || Array.isArray(value);
            if (isFunction(value)) return this.each(function(i) {
                jQuery(this).toggleClass(value.call(this, i, getClass(this), stateVal), stateVal);
            });
            if (typeof stateVal === "boolean" && isValidValue) return stateVal ? this.addClass(value) : this.removeClass(value);
            classNames = classesToArray(value);
            return this.each(function() {
                if (isValidValue) {
                    // Toggle individual class names
                    self = jQuery(this);
                    for(i = 0; i < classNames.length; i++){
                        className = classNames[i];
                        // Check each className given, space separated list
                        if (self.hasClass(className)) self.removeClass(className);
                        else self.addClass(className);
                    }
                // Toggle whole class name
                } else if (value === undefined || type === "boolean") {
                    className = getClass(this);
                    if (className) // Store className if set
                    dataPriv.set(this, "__className__", className);
                    // If the element has a class name or if we're passed `false`,
                    // then remove the whole classname (if there was one, the above saved it).
                    // Otherwise bring back whatever was previously saved (if anything),
                    // falling back to the empty string if nothing was stored.
                    if (this.setAttribute) this.setAttribute("class", className || value === false ? "" : dataPriv.get(this, "__className__") || "");
                }
            });
        },
        hasClass: function(selector) {
            var className, elem, i = 0;
            className = " " + selector + " ";
            while(elem = this[i++]){
                if (elem.nodeType === 1 && (" " + stripAndCollapse(getClass(elem)) + " ").indexOf(className) > -1) return true;
            }
            return false;
        }
    });
    var rreturn = /\r/g;
    jQuery.fn.extend({
        val: function(value) {
            var hooks, ret, valueIsFunction, elem = this[0];
            if (!arguments.length) {
                if (elem) {
                    hooks = jQuery.valHooks[elem.type] || jQuery.valHooks[elem.nodeName.toLowerCase()];
                    if (hooks && "get" in hooks && (ret = hooks.get(elem, "value")) !== undefined) return ret;
                    ret = elem.value;
                    // Handle most common string cases
                    if (typeof ret === "string") return ret.replace(rreturn, "");
                    // Handle cases where value is null/undef or number
                    return ret == null ? "" : ret;
                }
                return;
            }
            valueIsFunction = isFunction(value);
            return this.each(function(i) {
                var val;
                if (this.nodeType !== 1) return;
                if (valueIsFunction) val = value.call(this, i, jQuery(this).val());
                else val = value;
                // Treat null/undefined as ""; convert numbers to string
                if (val == null) val = "";
                else if (typeof val === "number") val += "";
                else if (Array.isArray(val)) val = jQuery.map(val, function(value) {
                    return value == null ? "" : value + "";
                });
                hooks = jQuery.valHooks[this.type] || jQuery.valHooks[this.nodeName.toLowerCase()];
                // If set returns undefined, fall back to normal setting
                if (!hooks || !("set" in hooks) || hooks.set(this, val, "value") === undefined) this.value = val;
            });
        }
    });
    jQuery.extend({
        valHooks: {
            option: {
                get: function(elem) {
                    var val = jQuery.find.attr(elem, "value");
                    return val != null ? val : // Support: IE <=10 - 11 only
                    // option.text throws exceptions (trac-14686, trac-14858)
                    // Strip and collapse whitespace
                    // https://html.spec.whatwg.org/#strip-and-collapse-whitespace
                    stripAndCollapse(jQuery.text(elem));
                }
            },
            select: {
                get: function(elem) {
                    var value, option, i, options = elem.options, index = elem.selectedIndex, one = elem.type === "select-one", values = one ? null : [], max = one ? index + 1 : options.length;
                    if (index < 0) i = max;
                    else i = one ? index : 0;
                    // Loop through all the selected options
                    for(; i < max; i++){
                        option = options[i];
                        // Support: IE <=9 only
                        // IE8-9 doesn't update selected after form reset (trac-2551)
                        if ((option.selected || i === index) && // Don't return options that are disabled or in a disabled optgroup
                        !option.disabled && (!option.parentNode.disabled || !nodeName(option.parentNode, "optgroup"))) {
                            // Get the specific value for the option
                            value = jQuery(option).val();
                            // We don't need an array for one selects
                            if (one) return value;
                            // Multi-Selects return an array
                            values.push(value);
                        }
                    }
                    return values;
                },
                set: function(elem, value) {
                    var optionSet, option, options = elem.options, values = jQuery.makeArray(value), i = options.length;
                    while(i--){
                        option = options[i];
                        /* eslint-disable no-cond-assign */ if (option.selected = jQuery.inArray(jQuery.valHooks.option.get(option), values) > -1) optionSet = true;
                    /* eslint-enable no-cond-assign */ }
                    // Force browsers to behave consistently when non-matching value is set
                    if (!optionSet) elem.selectedIndex = -1;
                    return values;
                }
            }
        }
    });
    // Radios and checkboxes getter/setter
    jQuery.each([
        "radio",
        "checkbox"
    ], function() {
        jQuery.valHooks[this] = {
            set: function(elem, value) {
                if (Array.isArray(value)) return elem.checked = jQuery.inArray(jQuery(elem).val(), value) > -1;
            }
        };
        if (!support.checkOn) jQuery.valHooks[this].get = function(elem) {
            return elem.getAttribute("value") === null ? "on" : elem.value;
        };
    });
    // Return jQuery for attributes-only inclusion
    var location = window1.location;
    var nonce = {
        guid: Date.now()
    };
    var rquery = /\?/;
    // Cross-browser xml parsing
    jQuery.parseXML = function(data) {
        var xml, parserErrorElem;
        if (!data || typeof data !== "string") return null;
        // Support: IE 9 - 11 only
        // IE throws on parseFromString with invalid input.
        try {
            xml = new window1.DOMParser().parseFromString(data, "text/xml");
        } catch (e) {}
        parserErrorElem = xml && xml.getElementsByTagName("parsererror")[0];
        if (!xml || parserErrorElem) jQuery.error("Invalid XML: " + (parserErrorElem ? jQuery.map(parserErrorElem.childNodes, function(el) {
            return el.textContent;
        }).join("\n") : data));
        return xml;
    };
    var rfocusMorph = /^(?:focusinfocus|focusoutblur)$/, stopPropagationCallback = function(e) {
        e.stopPropagation();
    };
    jQuery.extend(jQuery.event, {
        trigger: function(event, data, elem, onlyHandlers) {
            var i, cur, tmp, bubbleType, ontype, handle, special, lastElement, eventPath = [
                elem || document
            ], type = hasOwn.call(event, "type") ? event.type : event, namespaces = hasOwn.call(event, "namespace") ? event.namespace.split(".") : [];
            cur = lastElement = tmp = elem = elem || document;
            // Don't do events on text and comment nodes
            if (elem.nodeType === 3 || elem.nodeType === 8) return;
            // focus/blur morphs to focusin/out; ensure we're not firing them right now
            if (rfocusMorph.test(type + jQuery.event.triggered)) return;
            if (type.indexOf(".") > -1) {
                // Namespaced trigger; create a regexp to match event type in handle()
                namespaces = type.split(".");
                type = namespaces.shift();
                namespaces.sort();
            }
            ontype = type.indexOf(":") < 0 && "on" + type;
            // Caller can pass in a jQuery.Event object, Object, or just an event type string
            event = event[jQuery.expando] ? event : new jQuery.Event(type, typeof event === "object" && event);
            // Trigger bitmask: & 1 for native handlers; & 2 for jQuery (always true)
            event.isTrigger = onlyHandlers ? 2 : 3;
            event.namespace = namespaces.join(".");
            event.rnamespace = event.namespace ? new RegExp("(^|\\.)" + namespaces.join("\\.(?:.*\\.|)") + "(\\.|$)") : null;
            // Clean up the event in case it is being reused
            event.result = undefined;
            if (!event.target) event.target = elem;
            // Clone any incoming data and prepend the event, creating the handler arg list
            data = data == null ? [
                event
            ] : jQuery.makeArray(data, [
                event
            ]);
            // Allow special events to draw outside the lines
            special = jQuery.event.special[type] || {};
            if (!onlyHandlers && special.trigger && special.trigger.apply(elem, data) === false) return;
            // Determine event propagation path in advance, per W3C events spec (trac-9951)
            // Bubble up to document, then to window; watch for a global ownerDocument var (trac-9724)
            if (!onlyHandlers && !special.noBubble && !isWindow(elem)) {
                bubbleType = special.delegateType || type;
                if (!rfocusMorph.test(bubbleType + type)) cur = cur.parentNode;
                for(; cur; cur = cur.parentNode){
                    eventPath.push(cur);
                    tmp = cur;
                }
                // Only add window if we got to document (e.g., not plain obj or detached DOM)
                if (tmp === (elem.ownerDocument || document)) eventPath.push(tmp.defaultView || tmp.parentWindow || window1);
            }
            // Fire handlers on the event path
            i = 0;
            while((cur = eventPath[i++]) && !event.isPropagationStopped()){
                lastElement = cur;
                event.type = i > 1 ? bubbleType : special.bindType || type;
                // jQuery handler
                handle = (dataPriv.get(cur, "events") || Object.create(null))[event.type] && dataPriv.get(cur, "handle");
                if (handle) handle.apply(cur, data);
                // Native handler
                handle = ontype && cur[ontype];
                if (handle && handle.apply && acceptData(cur)) {
                    event.result = handle.apply(cur, data);
                    if (event.result === false) event.preventDefault();
                }
            }
            event.type = type;
            // If nobody prevented the default action, do it now
            if (!onlyHandlers && !event.isDefaultPrevented()) {
                if ((!special._default || special._default.apply(eventPath.pop(), data) === false) && acceptData(elem)) // Call a native DOM method on the target with the same name as the event.
                // Don't do default actions on window, that's where global variables be (trac-6170)
                {
                    if (ontype && isFunction(elem[type]) && !isWindow(elem)) {
                        // Don't re-trigger an onFOO event when we call its FOO() method
                        tmp = elem[ontype];
                        if (tmp) elem[ontype] = null;
                        // Prevent re-triggering of the same event, since we already bubbled it above
                        jQuery.event.triggered = type;
                        if (event.isPropagationStopped()) lastElement.addEventListener(type, stopPropagationCallback);
                        elem[type]();
                        if (event.isPropagationStopped()) lastElement.removeEventListener(type, stopPropagationCallback);
                        jQuery.event.triggered = undefined;
                        if (tmp) elem[ontype] = tmp;
                    }
                }
            }
            return event.result;
        },
        // Piggyback on a donor event to simulate a different one
        // Used only for `focus(in | out)` events
        simulate: function(type, elem, event) {
            var e = jQuery.extend(new jQuery.Event(), event, {
                type: type,
                isSimulated: true
            });
            jQuery.event.trigger(e, null, elem);
        }
    });
    jQuery.fn.extend({
        trigger: function(type, data) {
            return this.each(function() {
                jQuery.event.trigger(type, data, this);
            });
        },
        triggerHandler: function(type, data) {
            var elem = this[0];
            if (elem) return jQuery.event.trigger(type, data, elem, true);
        }
    });
    var rbracket = /\[\]$/, rCRLF = /\r?\n/g, rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i, rsubmittable = /^(?:input|select|textarea|keygen)/i;
    function buildParams(prefix, obj, traditional, add) {
        var name;
        if (Array.isArray(obj)) // Serialize array item.
        jQuery.each(obj, function(i, v) {
            if (traditional || rbracket.test(prefix)) // Treat each array item as a scalar.
            add(prefix, v);
            else // Item is non-scalar (array or object), encode its numeric index.
            buildParams(prefix + "[" + (typeof v === "object" && v != null ? i : "") + "]", v, traditional, add);
        });
        else if (!traditional && toType(obj) === "object") // Serialize object item.
        for(name in obj)buildParams(prefix + "[" + name + "]", obj[name], traditional, add);
        else // Serialize scalar item.
        add(prefix, obj);
    }
    // Serialize an array of form elements or a set of
    // key/values into a query string
    jQuery.param = function(a, traditional) {
        var prefix, s = [], add = function(key, valueOrFunction) {
            // If value is a function, invoke it and use its return value
            var value = isFunction(valueOrFunction) ? valueOrFunction() : valueOrFunction;
            s[s.length] = encodeURIComponent(key) + "=" + encodeURIComponent(value == null ? "" : value);
        };
        if (a == null) return "";
        // If an array was passed in, assume that it is an array of form elements.
        if (Array.isArray(a) || a.jquery && !jQuery.isPlainObject(a)) // Serialize the form elements
        jQuery.each(a, function() {
            add(this.name, this.value);
        });
        else // If traditional, encode the "old" way (the way 1.3.2 or older
        // did it), otherwise encode params recursively.
        for(prefix in a)buildParams(prefix, a[prefix], traditional, add);
        // Return the resulting serialization
        return s.join("&");
    };
    jQuery.fn.extend({
        serialize: function() {
            return jQuery.param(this.serializeArray());
        },
        serializeArray: function() {
            return this.map(function() {
                // Can add propHook for "elements" to filter or add form elements
                var elements = jQuery.prop(this, "elements");
                return elements ? jQuery.makeArray(elements) : this;
            }).filter(function() {
                var type = this.type;
                // Use .is( ":disabled" ) so that fieldset[disabled] works
                return this.name && !jQuery(this).is(":disabled") && rsubmittable.test(this.nodeName) && !rsubmitterTypes.test(type) && (this.checked || !rcheckableType.test(type));
            }).map(function(_i, elem) {
                var val = jQuery(this).val();
                if (val == null) return null;
                if (Array.isArray(val)) return jQuery.map(val, function(val) {
                    return {
                        name: elem.name,
                        value: val.replace(rCRLF, "\r\n")
                    };
                });
                return {
                    name: elem.name,
                    value: val.replace(rCRLF, "\r\n")
                };
            }).get();
        }
    });
    var r20 = /%20/g, rhash = /#.*$/, rantiCache = /([?&])_=[^&]*/, rheaders = /^(.*?):[ \t]*([^\r\n]*)$/mg, // trac-7653, trac-8125, trac-8152: local protocol detection
    rlocalProtocol = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/, rnoContent = /^(?:GET|HEAD)$/, rprotocol = /^\/\//, /* Prefilters
	 * 1) They are useful to introduce custom dataTypes (see ajax/jsonp.js for an example)
	 * 2) These are called:
	 *    - BEFORE asking for a transport
	 *    - AFTER param serialization (s.data is a string if s.processData is true)
	 * 3) key is the dataType
	 * 4) the catchall symbol "*" can be used
	 * 5) execution will start with transport dataType and THEN continue down to "*" if needed
	 */ prefilters = {}, /* Transports bindings
	 * 1) key is the dataType
	 * 2) the catchall symbol "*" can be used
	 * 3) selection will start with transport dataType and THEN go to "*" if needed
	 */ transports = {}, // Avoid comment-prolog char sequence (trac-10098); must appease lint and evade compression
    allTypes = "*/".concat("*"), // Anchor tag for parsing the document origin
    originAnchor = document.createElement("a");
    originAnchor.href = location.href;
    // Base "constructor" for jQuery.ajaxPrefilter and jQuery.ajaxTransport
    function addToPrefiltersOrTransports(structure) {
        // dataTypeExpression is optional and defaults to "*"
        return function(dataTypeExpression, func) {
            if (typeof dataTypeExpression !== "string") {
                func = dataTypeExpression;
                dataTypeExpression = "*";
            }
            var dataType, i = 0, dataTypes = dataTypeExpression.toLowerCase().match(rnothtmlwhite) || [];
            if (isFunction(func)) {
                // For each dataType in the dataTypeExpression
                while(dataType = dataTypes[i++])// Prepend if requested
                if (dataType[0] === "+") {
                    dataType = dataType.slice(1) || "*";
                    (structure[dataType] = structure[dataType] || []).unshift(func);
                // Otherwise append
                } else (structure[dataType] = structure[dataType] || []).push(func);
            }
        };
    }
    // Base inspection function for prefilters and transports
    function inspectPrefiltersOrTransports(structure, options, originalOptions, jqXHR) {
        var inspected = {}, seekingTransport = structure === transports;
        function inspect(dataType) {
            var selected;
            inspected[dataType] = true;
            jQuery.each(structure[dataType] || [], function(_, prefilterOrFactory) {
                var dataTypeOrTransport = prefilterOrFactory(options, originalOptions, jqXHR);
                if (typeof dataTypeOrTransport === "string" && !seekingTransport && !inspected[dataTypeOrTransport]) {
                    options.dataTypes.unshift(dataTypeOrTransport);
                    inspect(dataTypeOrTransport);
                    return false;
                } else if (seekingTransport) return !(selected = dataTypeOrTransport);
            });
            return selected;
        }
        return inspect(options.dataTypes[0]) || !inspected["*"] && inspect("*");
    }
    // A special extend for ajax options
    // that takes "flat" options (not to be deep extended)
    // Fixes trac-9887
    function ajaxExtend(target, src) {
        var key, deep, flatOptions = jQuery.ajaxSettings.flatOptions || {};
        for(key in src)if (src[key] !== undefined) (flatOptions[key] ? target : deep || (deep = {}))[key] = src[key];
        if (deep) jQuery.extend(true, target, deep);
        return target;
    }
    /* Handles responses to an ajax request:
 * - finds the right dataType (mediates between content-type and expected dataType)
 * - returns the corresponding response
 */ function ajaxHandleResponses(s, jqXHR, responses) {
        var ct, type, finalDataType, firstDataType, contents = s.contents, dataTypes = s.dataTypes;
        // Remove auto dataType and get content-type in the process
        while(dataTypes[0] === "*"){
            dataTypes.shift();
            if (ct === undefined) ct = s.mimeType || jqXHR.getResponseHeader("Content-Type");
        }
        // Check if we're dealing with a known content-type
        if (ct) {
            for(type in contents)if (contents[type] && contents[type].test(ct)) {
                dataTypes.unshift(type);
                break;
            }
        }
        // Check to see if we have a response for the expected dataType
        if (dataTypes[0] in responses) finalDataType = dataTypes[0];
        else {
            // Try convertible dataTypes
            for(type in responses){
                if (!dataTypes[0] || s.converters[type + " " + dataTypes[0]]) {
                    finalDataType = type;
                    break;
                }
                if (!firstDataType) firstDataType = type;
            }
            // Or just use first one
            finalDataType = finalDataType || firstDataType;
        }
        // If we found a dataType
        // We add the dataType to the list if needed
        // and return the corresponding response
        if (finalDataType) {
            if (finalDataType !== dataTypes[0]) dataTypes.unshift(finalDataType);
            return responses[finalDataType];
        }
    }
    /* Chain conversions given the request and the original response
 * Also sets the responseXXX fields on the jqXHR instance
 */ function ajaxConvert(s, response, jqXHR, isSuccess) {
        var conv2, current, conv, tmp, prev, converters = {}, // Work with a copy of dataTypes in case we need to modify it for conversion
        dataTypes = s.dataTypes.slice();
        // Create converters map with lowercased keys
        if (dataTypes[1]) for(conv in s.converters)converters[conv.toLowerCase()] = s.converters[conv];
        current = dataTypes.shift();
        // Convert to each sequential dataType
        while(current){
            if (s.responseFields[current]) jqXHR[s.responseFields[current]] = response;
            // Apply the dataFilter if provided
            if (!prev && isSuccess && s.dataFilter) response = s.dataFilter(response, s.dataType);
            prev = current;
            current = dataTypes.shift();
            if (current) {
                // There's only work to do if current dataType is non-auto
                if (current === "*") current = prev;
                else if (prev !== "*" && prev !== current) {
                    // Seek a direct converter
                    conv = converters[prev + " " + current] || converters["* " + current];
                    // If none found, seek a pair
                    if (!conv) for(conv2 in converters){
                        // If conv2 outputs current
                        tmp = conv2.split(" ");
                        if (tmp[1] === current) {
                            // If prev can be converted to accepted input
                            conv = converters[prev + " " + tmp[0]] || converters["* " + tmp[0]];
                            if (conv) {
                                // Condense equivalence converters
                                if (conv === true) conv = converters[conv2];
                                else if (converters[conv2] !== true) {
                                    current = tmp[0];
                                    dataTypes.unshift(tmp[1]);
                                }
                                break;
                            }
                        }
                    }
                    // Apply converter (if not an equivalence)
                    if (conv !== true) {
                        // Unless errors are allowed to bubble, catch and return them
                        if (conv && s.throws) response = conv(response);
                        else try {
                            response = conv(response);
                        } catch (e) {
                            return {
                                state: "parsererror",
                                error: conv ? e : "No conversion from " + prev + " to " + current
                            };
                        }
                    }
                }
            }
        }
        return {
            state: "success",
            data: response
        };
    }
    jQuery.extend({
        // Counter for holding the number of active queries
        active: 0,
        // Last-Modified header cache for next request
        lastModified: {},
        etag: {},
        ajaxSettings: {
            url: location.href,
            type: "GET",
            isLocal: rlocalProtocol.test(location.protocol),
            global: true,
            processData: true,
            async: true,
            contentType: "application/x-www-form-urlencoded; charset=UTF-8",
            /*
		timeout: 0,
		data: null,
		dataType: null,
		username: null,
		password: null,
		cache: null,
		throws: false,
		traditional: false,
		headers: {},
		*/ accepts: {
                "*": allTypes,
                text: "text/plain",
                html: "text/html",
                xml: "application/xml, text/xml",
                json: "application/json, text/javascript"
            },
            contents: {
                xml: /\bxml\b/,
                html: /\bhtml/,
                json: /\bjson\b/
            },
            responseFields: {
                xml: "responseXML",
                text: "responseText",
                json: "responseJSON"
            },
            // Data converters
            // Keys separate source (or catchall "*") and destination types with a single space
            converters: {
                // Convert anything to text
                "* text": String,
                // Text to html (true = no transformation)
                "text html": true,
                // Evaluate text as a json expression
                "text json": JSON.parse,
                // Parse text as xml
                "text xml": jQuery.parseXML
            },
            // For options that shouldn't be deep extended:
            // you can add your own custom options here if
            // and when you create one that shouldn't be
            // deep extended (see ajaxExtend)
            flatOptions: {
                url: true,
                context: true
            }
        },
        // Creates a full fledged settings object into target
        // with both ajaxSettings and settings fields.
        // If target is omitted, writes into ajaxSettings.
        ajaxSetup: function(target, settings) {
            return settings ? // Building a settings object
            ajaxExtend(ajaxExtend(target, jQuery.ajaxSettings), settings) : // Extending ajaxSettings
            ajaxExtend(jQuery.ajaxSettings, target);
        },
        ajaxPrefilter: addToPrefiltersOrTransports(prefilters),
        ajaxTransport: addToPrefiltersOrTransports(transports),
        // Main method
        ajax: function(url, options) {
            // If url is an object, simulate pre-1.5 signature
            if (typeof url === "object") {
                options = url;
                url = undefined;
            }
            // Force options to be an object
            options = options || {};
            var transport, // URL without anti-cache param
            cacheURL, // Response headers
            responseHeadersString, responseHeaders, // timeout handle
            timeoutTimer, // Url cleanup var
            urlAnchor, // Request state (becomes false upon send and true upon completion)
            completed, // To know if global events are to be dispatched
            fireGlobals, // Loop variable
            i, // uncached part of the url
            uncached, // Create the final options object
            s = jQuery.ajaxSetup({}, options), // Callbacks context
            callbackContext = s.context || s, // Context for global events is callbackContext if it is a DOM node or jQuery collection
            globalEventContext = s.context && (callbackContext.nodeType || callbackContext.jquery) ? jQuery(callbackContext) : jQuery.event, // Deferreds
            deferred = jQuery.Deferred(), completeDeferred = jQuery.Callbacks("once memory"), // Status-dependent callbacks
            statusCode = s.statusCode || {}, // Headers (they are sent all at once)
            requestHeaders = {}, requestHeadersNames = {}, // Default abort message
            strAbort = "canceled", // Fake xhr
            jqXHR = {
                readyState: 0,
                // Builds headers hashtable if needed
                getResponseHeader: function(key) {
                    var match;
                    if (completed) {
                        if (!responseHeaders) {
                            responseHeaders = {};
                            while(match = rheaders.exec(responseHeadersString))responseHeaders[match[1].toLowerCase() + " "] = (responseHeaders[match[1].toLowerCase() + " "] || []).concat(match[2]);
                        }
                        match = responseHeaders[key.toLowerCase() + " "];
                    }
                    return match == null ? null : match.join(", ");
                },
                // Raw string
                getAllResponseHeaders: function() {
                    return completed ? responseHeadersString : null;
                },
                // Caches the header
                setRequestHeader: function(name, value) {
                    if (completed == null) {
                        name = requestHeadersNames[name.toLowerCase()] = requestHeadersNames[name.toLowerCase()] || name;
                        requestHeaders[name] = value;
                    }
                    return this;
                },
                // Overrides response content-type header
                overrideMimeType: function(type) {
                    if (completed == null) s.mimeType = type;
                    return this;
                },
                // Status-dependent callbacks
                statusCode: function(map) {
                    var code;
                    if (map) {
                        if (completed) // Execute the appropriate callbacks
                        jqXHR.always(map[jqXHR.status]);
                        else // Lazy-add the new callbacks in a way that preserves old ones
                        for(code in map)statusCode[code] = [
                            statusCode[code],
                            map[code]
                        ];
                    }
                    return this;
                },
                // Cancel the request
                abort: function(statusText) {
                    var finalText = statusText || strAbort;
                    if (transport) transport.abort(finalText);
                    done(0, finalText);
                    return this;
                }
            };
            // Attach deferreds
            deferred.promise(jqXHR);
            // Add protocol if not provided (prefilters might expect it)
            // Handle falsy url in the settings object (trac-10093: consistency with old signature)
            // We also use the url parameter if available
            s.url = ((url || s.url || location.href) + "").replace(rprotocol, location.protocol + "//");
            // Alias method option to type as per ticket trac-12004
            s.type = options.method || options.type || s.method || s.type;
            // Extract dataTypes list
            s.dataTypes = (s.dataType || "*").toLowerCase().match(rnothtmlwhite) || [
                ""
            ];
            // A cross-domain request is in order when the origin doesn't match the current origin.
            if (s.crossDomain == null) {
                urlAnchor = document.createElement("a");
                // Support: IE <=8 - 11, Edge 12 - 15
                // IE throws exception on accessing the href property if url is malformed,
                // e.g. http://example.com:80x/
                try {
                    urlAnchor.href = s.url;
                    // Support: IE <=8 - 11 only
                    // Anchor's host property isn't correctly set when s.url is relative
                    urlAnchor.href = urlAnchor.href;
                    s.crossDomain = originAnchor.protocol + "//" + originAnchor.host !== urlAnchor.protocol + "//" + urlAnchor.host;
                } catch (e) {
                    // If there is an error parsing the URL, assume it is crossDomain,
                    // it can be rejected by the transport if it is invalid
                    s.crossDomain = true;
                }
            }
            // Convert data if not already a string
            if (s.data && s.processData && typeof s.data !== "string") s.data = jQuery.param(s.data, s.traditional);
            // Apply prefilters
            inspectPrefiltersOrTransports(prefilters, s, options, jqXHR);
            // If request was aborted inside a prefilter, stop there
            if (completed) return jqXHR;
            // We can fire global events as of now if asked to
            // Don't fire events if jQuery.event is undefined in an AMD-usage scenario (trac-15118)
            fireGlobals = jQuery.event && s.global;
            // Watch for a new set of requests
            if (fireGlobals && jQuery.active++ === 0) jQuery.event.trigger("ajaxStart");
            // Uppercase the type
            s.type = s.type.toUpperCase();
            // Determine if request has content
            s.hasContent = !rnoContent.test(s.type);
            // Save the URL in case we're toying with the If-Modified-Since
            // and/or If-None-Match header later on
            // Remove hash to simplify url manipulation
            cacheURL = s.url.replace(rhash, "");
            // More options handling for requests with no content
            if (!s.hasContent) {
                // Remember the hash so we can put it back
                uncached = s.url.slice(cacheURL.length);
                // If data is available and should be processed, append data to url
                if (s.data && (s.processData || typeof s.data === "string")) {
                    cacheURL += (rquery.test(cacheURL) ? "&" : "?") + s.data;
                    // trac-9682: remove data so that it's not used in an eventual retry
                    delete s.data;
                }
                // Add or update anti-cache param if needed
                if (s.cache === false) {
                    cacheURL = cacheURL.replace(rantiCache, "$1");
                    uncached = (rquery.test(cacheURL) ? "&" : "?") + "_=" + nonce.guid++ + uncached;
                }
                // Put hash and anti-cache on the URL that will be requested (gh-1732)
                s.url = cacheURL + uncached;
            // Change '%20' to '+' if this is encoded form body content (gh-2658)
            } else if (s.data && s.processData && (s.contentType || "").indexOf("application/x-www-form-urlencoded") === 0) s.data = s.data.replace(r20, "+");
            // Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
            if (s.ifModified) {
                if (jQuery.lastModified[cacheURL]) jqXHR.setRequestHeader("If-Modified-Since", jQuery.lastModified[cacheURL]);
                if (jQuery.etag[cacheURL]) jqXHR.setRequestHeader("If-None-Match", jQuery.etag[cacheURL]);
            }
            // Set the correct header, if data is being sent
            if (s.data && s.hasContent && s.contentType !== false || options.contentType) jqXHR.setRequestHeader("Content-Type", s.contentType);
            // Set the Accepts header for the server, depending on the dataType
            jqXHR.setRequestHeader("Accept", s.dataTypes[0] && s.accepts[s.dataTypes[0]] ? s.accepts[s.dataTypes[0]] + (s.dataTypes[0] !== "*" ? ", " + allTypes + "; q=0.01" : "") : s.accepts["*"]);
            // Check for headers option
            for(i in s.headers)jqXHR.setRequestHeader(i, s.headers[i]);
            // Allow custom headers/mimetypes and early abort
            if (s.beforeSend && (s.beforeSend.call(callbackContext, jqXHR, s) === false || completed)) // Abort if not done already and return
            return jqXHR.abort();
            // Aborting is no longer a cancellation
            strAbort = "abort";
            // Install callbacks on deferreds
            completeDeferred.add(s.complete);
            jqXHR.done(s.success);
            jqXHR.fail(s.error);
            // Get transport
            transport = inspectPrefiltersOrTransports(transports, s, options, jqXHR);
            // If no transport, we auto-abort
            if (!transport) done(-1, "No Transport");
            else {
                jqXHR.readyState = 1;
                // Send global event
                if (fireGlobals) globalEventContext.trigger("ajaxSend", [
                    jqXHR,
                    s
                ]);
                // If request was aborted inside ajaxSend, stop there
                if (completed) return jqXHR;
                // Timeout
                if (s.async && s.timeout > 0) timeoutTimer = window1.setTimeout(function() {
                    jqXHR.abort("timeout");
                }, s.timeout);
                try {
                    completed = false;
                    transport.send(requestHeaders, done);
                } catch (e) {
                    // Rethrow post-completion exceptions
                    if (completed) throw e;
                    // Propagate others as results
                    done(-1, e);
                }
            }
            // Callback for when everything is done
            function done(status, nativeStatusText, responses, headers) {
                var isSuccess, success, error, response, modified, statusText = nativeStatusText;
                // Ignore repeat invocations
                if (completed) return;
                completed = true;
                // Clear timeout if it exists
                if (timeoutTimer) window1.clearTimeout(timeoutTimer);
                // Dereference transport for early garbage collection
                // (no matter how long the jqXHR object will be used)
                transport = undefined;
                // Cache response headers
                responseHeadersString = headers || "";
                // Set readyState
                jqXHR.readyState = status > 0 ? 4 : 0;
                // Determine if successful
                isSuccess = status >= 200 && status < 300 || status === 304;
                // Get response data
                if (responses) response = ajaxHandleResponses(s, jqXHR, responses);
                // Use a noop converter for missing script but not if jsonp
                if (!isSuccess && jQuery.inArray("script", s.dataTypes) > -1 && jQuery.inArray("json", s.dataTypes) < 0) s.converters["text script"] = function() {};
                // Convert no matter what (that way responseXXX fields are always set)
                response = ajaxConvert(s, response, jqXHR, isSuccess);
                // If successful, handle type chaining
                if (isSuccess) {
                    // Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
                    if (s.ifModified) {
                        modified = jqXHR.getResponseHeader("Last-Modified");
                        if (modified) jQuery.lastModified[cacheURL] = modified;
                        modified = jqXHR.getResponseHeader("etag");
                        if (modified) jQuery.etag[cacheURL] = modified;
                    }
                    // if no content
                    if (status === 204 || s.type === "HEAD") statusText = "nocontent";
                    else if (status === 304) statusText = "notmodified";
                    else {
                        statusText = response.state;
                        success = response.data;
                        error = response.error;
                        isSuccess = !error;
                    }
                } else {
                    // Extract error from statusText and normalize for non-aborts
                    error = statusText;
                    if (status || !statusText) {
                        statusText = "error";
                        if (status < 0) status = 0;
                    }
                }
                // Set data for the fake xhr object
                jqXHR.status = status;
                jqXHR.statusText = (nativeStatusText || statusText) + "";
                // Success/Error
                if (isSuccess) deferred.resolveWith(callbackContext, [
                    success,
                    statusText,
                    jqXHR
                ]);
                else deferred.rejectWith(callbackContext, [
                    jqXHR,
                    statusText,
                    error
                ]);
                // Status-dependent callbacks
                jqXHR.statusCode(statusCode);
                statusCode = undefined;
                if (fireGlobals) globalEventContext.trigger(isSuccess ? "ajaxSuccess" : "ajaxError", [
                    jqXHR,
                    s,
                    isSuccess ? success : error
                ]);
                // Complete
                completeDeferred.fireWith(callbackContext, [
                    jqXHR,
                    statusText
                ]);
                if (fireGlobals) {
                    globalEventContext.trigger("ajaxComplete", [
                        jqXHR,
                        s
                    ]);
                    // Handle the global AJAX counter
                    if (!--jQuery.active) jQuery.event.trigger("ajaxStop");
                }
            }
            return jqXHR;
        },
        getJSON: function(url, data, callback) {
            return jQuery.get(url, data, callback, "json");
        },
        getScript: function(url, callback) {
            return jQuery.get(url, undefined, callback, "script");
        }
    });
    jQuery.each([
        "get",
        "post"
    ], function(_i, method) {
        jQuery[method] = function(url, data, callback, type) {
            // Shift arguments if data argument was omitted
            if (isFunction(data)) {
                type = type || callback;
                callback = data;
                data = undefined;
            }
            // The url can be an options object (which then must have .url)
            return jQuery.ajax(jQuery.extend({
                url: url,
                type: method,
                dataType: type,
                data: data,
                success: callback
            }, jQuery.isPlainObject(url) && url));
        };
    });
    jQuery.ajaxPrefilter(function(s) {
        var i;
        for(i in s.headers)if (i.toLowerCase() === "content-type") s.contentType = s.headers[i] || "";
    });
    jQuery._evalUrl = function(url, options, doc) {
        return jQuery.ajax({
            url: url,
            // Make this explicit, since user can override this through ajaxSetup (trac-11264)
            type: "GET",
            dataType: "script",
            cache: true,
            async: false,
            global: false,
            // Only evaluate the response if it is successful (gh-4126)
            // dataFilter is not invoked for failure responses, so using it instead
            // of the default converter is kludgy but it works.
            converters: {
                "text script": function() {}
            },
            dataFilter: function(response) {
                jQuery.globalEval(response, options, doc);
            }
        });
    };
    jQuery.fn.extend({
        wrapAll: function(html) {
            var wrap;
            if (this[0]) {
                if (isFunction(html)) html = html.call(this[0]);
                // The elements to wrap the target around
                wrap = jQuery(html, this[0].ownerDocument).eq(0).clone(true);
                if (this[0].parentNode) wrap.insertBefore(this[0]);
                wrap.map(function() {
                    var elem = this;
                    while(elem.firstElementChild)elem = elem.firstElementChild;
                    return elem;
                }).append(this);
            }
            return this;
        },
        wrapInner: function(html) {
            if (isFunction(html)) return this.each(function(i) {
                jQuery(this).wrapInner(html.call(this, i));
            });
            return this.each(function() {
                var self = jQuery(this), contents = self.contents();
                if (contents.length) contents.wrapAll(html);
                else self.append(html);
            });
        },
        wrap: function(html) {
            var htmlIsFunction = isFunction(html);
            return this.each(function(i) {
                jQuery(this).wrapAll(htmlIsFunction ? html.call(this, i) : html);
            });
        },
        unwrap: function(selector) {
            this.parent(selector).not("body").each(function() {
                jQuery(this).replaceWith(this.childNodes);
            });
            return this;
        }
    });
    jQuery.expr.pseudos.hidden = function(elem) {
        return !jQuery.expr.pseudos.visible(elem);
    };
    jQuery.expr.pseudos.visible = function(elem) {
        return !!(elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length);
    };
    jQuery.ajaxSettings.xhr = function() {
        try {
            return new window1.XMLHttpRequest();
        } catch (e) {}
    };
    var xhrSuccessStatus = {
        // File protocol always yields status code 0, assume 200
        0: 200,
        // Support: IE <=9 only
        // trac-1450: sometimes IE returns 1223 when it should be 204
        1223: 204
    }, xhrSupported = jQuery.ajaxSettings.xhr();
    support.cors = !!xhrSupported && "withCredentials" in xhrSupported;
    support.ajax = xhrSupported = !!xhrSupported;
    jQuery.ajaxTransport(function(options) {
        var callback, errorCallback;
        // Cross domain only allowed if supported through XMLHttpRequest
        if (support.cors || xhrSupported && !options.crossDomain) return {
            send: function(headers, complete) {
                var i, xhr = options.xhr();
                xhr.open(options.type, options.url, options.async, options.username, options.password);
                // Apply custom fields if provided
                if (options.xhrFields) for(i in options.xhrFields)xhr[i] = options.xhrFields[i];
                // Override mime type if needed
                if (options.mimeType && xhr.overrideMimeType) xhr.overrideMimeType(options.mimeType);
                // X-Requested-With header
                // For cross-domain requests, seeing as conditions for a preflight are
                // akin to a jigsaw puzzle, we simply never set it to be sure.
                // (it can always be set on a per-request basis or even using ajaxSetup)
                // For same-domain requests, won't change header if already provided.
                if (!options.crossDomain && !headers["X-Requested-With"]) headers["X-Requested-With"] = "XMLHttpRequest";
                // Set headers
                for(i in headers)xhr.setRequestHeader(i, headers[i]);
                // Callback
                callback = function(type) {
                    return function() {
                        if (callback) {
                            callback = errorCallback = xhr.onload = xhr.onerror = xhr.onabort = xhr.ontimeout = xhr.onreadystatechange = null;
                            if (type === "abort") xhr.abort();
                            else if (type === "error") {
                                // Support: IE <=9 only
                                // On a manual native abort, IE9 throws
                                // errors on any property access that is not readyState
                                if (typeof xhr.status !== "number") complete(0, "error");
                                else complete(// File: protocol always yields status 0; see trac-8605, trac-14207
                                xhr.status, xhr.statusText);
                            } else complete(xhrSuccessStatus[xhr.status] || xhr.status, xhr.statusText, // Support: IE <=9 only
                            // IE9 has no XHR2 but throws on binary (trac-11426)
                            // For XHR2 non-text, let the caller handle it (gh-2498)
                            (xhr.responseType || "text") !== "text" || typeof xhr.responseText !== "string" ? {
                                binary: xhr.response
                            } : {
                                text: xhr.responseText
                            }, xhr.getAllResponseHeaders());
                        }
                    };
                };
                // Listen to events
                xhr.onload = callback();
                errorCallback = xhr.onerror = xhr.ontimeout = callback("error");
                // Support: IE 9 only
                // Use onreadystatechange to replace onabort
                // to handle uncaught aborts
                if (xhr.onabort !== undefined) xhr.onabort = errorCallback;
                else xhr.onreadystatechange = function() {
                    // Check readyState before timeout as it changes
                    if (xhr.readyState === 4) // Allow onerror to be called first,
                    // but that will not handle a native abort
                    // Also, save errorCallback to a variable
                    // as xhr.onerror cannot be accessed
                    window1.setTimeout(function() {
                        if (callback) errorCallback();
                    });
                };
                // Create the abort callback
                callback = callback("abort");
                try {
                    // Do send the request (this may raise an exception)
                    xhr.send(options.hasContent && options.data || null);
                } catch (e) {
                    // trac-14683: Only rethrow if this hasn't been notified as an error yet
                    if (callback) throw e;
                }
            },
            abort: function() {
                if (callback) callback();
            }
        };
    });
    // Prevent auto-execution of scripts when no explicit dataType was provided (See gh-2432)
    jQuery.ajaxPrefilter(function(s) {
        if (s.crossDomain) s.contents.script = false;
    });
    // Install script dataType
    jQuery.ajaxSetup({
        accepts: {
            script: "text/javascript, application/javascript, application/ecmascript, application/x-ecmascript"
        },
        contents: {
            script: /\b(?:java|ecma)script\b/
        },
        converters: {
            "text script": function(text) {
                jQuery.globalEval(text);
                return text;
            }
        }
    });
    // Handle cache's special case and crossDomain
    jQuery.ajaxPrefilter("script", function(s) {
        if (s.cache === undefined) s.cache = false;
        if (s.crossDomain) s.type = "GET";
    });
    // Bind script tag hack transport
    jQuery.ajaxTransport("script", function(s) {
        // This transport only deals with cross domain or forced-by-attrs requests
        if (s.crossDomain || s.scriptAttrs) {
            var script, callback;
            return {
                send: function(_, complete) {
                    script = jQuery("<script>").attr(s.scriptAttrs || {}).prop({
                        charset: s.scriptCharset,
                        src: s.url
                    }).on("load error", callback = function(evt) {
                        script.remove();
                        callback = null;
                        if (evt) complete(evt.type === "error" ? 404 : 200, evt.type);
                    });
                    // Use native DOM manipulation to avoid our domManip AJAX trickery
                    document.head.appendChild(script[0]);
                },
                abort: function() {
                    if (callback) callback();
                }
            };
        }
    });
    var oldCallbacks = [], rjsonp = /(=)\?(?=&|$)|\?\?/;
    // Default jsonp settings
    jQuery.ajaxSetup({
        jsonp: "callback",
        jsonpCallback: function() {
            var callback = oldCallbacks.pop() || jQuery.expando + "_" + nonce.guid++;
            this[callback] = true;
            return callback;
        }
    });
    // Detect, normalize options and install callbacks for jsonp requests
    jQuery.ajaxPrefilter("json jsonp", function(s, originalSettings, jqXHR) {
        var callbackName, overwritten, responseContainer, jsonProp = s.jsonp !== false && (rjsonp.test(s.url) ? "url" : typeof s.data === "string" && (s.contentType || "").indexOf("application/x-www-form-urlencoded") === 0 && rjsonp.test(s.data) && "data");
        // Handle iff the expected data type is "jsonp" or we have a parameter to set
        if (jsonProp || s.dataTypes[0] === "jsonp") {
            // Get callback name, remembering preexisting value associated with it
            callbackName = s.jsonpCallback = isFunction(s.jsonpCallback) ? s.jsonpCallback() : s.jsonpCallback;
            // Insert callback into url or form data
            if (jsonProp) s[jsonProp] = s[jsonProp].replace(rjsonp, "$1" + callbackName);
            else if (s.jsonp !== false) s.url += (rquery.test(s.url) ? "&" : "?") + s.jsonp + "=" + callbackName;
            // Use data converter to retrieve json after script execution
            s.converters["script json"] = function() {
                if (!responseContainer) jQuery.error(callbackName + " was not called");
                return responseContainer[0];
            };
            // Force json dataType
            s.dataTypes[0] = "json";
            // Install callback
            overwritten = window1[callbackName];
            window1[callbackName] = function() {
                responseContainer = arguments;
            };
            // Clean-up function (fires after converters)
            jqXHR.always(function() {
                // If previous value didn't exist - remove it
                if (overwritten === undefined) jQuery(window1).removeProp(callbackName);
                else window1[callbackName] = overwritten;
                // Save back as free
                if (s[callbackName]) {
                    // Make sure that re-using the options doesn't screw things around
                    s.jsonpCallback = originalSettings.jsonpCallback;
                    // Save the callback name for future use
                    oldCallbacks.push(callbackName);
                }
                // Call if it was a function and we have a response
                if (responseContainer && isFunction(overwritten)) overwritten(responseContainer[0]);
                responseContainer = overwritten = undefined;
            });
            // Delegate to script
            return "script";
        }
    });
    // Support: Safari 8 only
    // In Safari 8 documents created via document.implementation.createHTMLDocument
    // collapse sibling forms: the second one becomes a child of the first one.
    // Because of that, this security measure has to be disabled in Safari 8.
    // https://bugs.webkit.org/show_bug.cgi?id=137337
    support.createHTMLDocument = function() {
        var body = document.implementation.createHTMLDocument("").body;
        body.innerHTML = "<form></form><form></form>";
        return body.childNodes.length === 2;
    }();
    // Argument "data" should be string of html
    // context (optional): If specified, the fragment will be created in this context,
    // defaults to document
    // keepScripts (optional): If true, will include scripts passed in the html string
    jQuery.parseHTML = function(data, context, keepScripts) {
        if (typeof data !== "string") return [];
        if (typeof context === "boolean") {
            keepScripts = context;
            context = false;
        }
        var base, parsed, scripts;
        if (!context) {
            // Stop scripts or inline event handlers from being executed immediately
            // by using document.implementation
            if (support.createHTMLDocument) {
                context = document.implementation.createHTMLDocument("");
                // Set the base href for the created document
                // so any parsed elements with URLs
                // are based on the document's URL (gh-2965)
                base = context.createElement("base");
                base.href = document.location.href;
                context.head.appendChild(base);
            } else context = document;
        }
        parsed = rsingleTag.exec(data);
        scripts = !keepScripts && [];
        // Single tag
        if (parsed) return [
            context.createElement(parsed[1])
        ];
        parsed = buildFragment([
            data
        ], context, scripts);
        if (scripts && scripts.length) jQuery(scripts).remove();
        return jQuery.merge([], parsed.childNodes);
    };
    /**
 * Load a url into a page
 */ jQuery.fn.load = function(url, params, callback) {
        var selector, type, response, self = this, off = url.indexOf(" ");
        if (off > -1) {
            selector = stripAndCollapse(url.slice(off));
            url = url.slice(0, off);
        }
        // If it's a function
        if (isFunction(params)) {
            // We assume that it's the callback
            callback = params;
            params = undefined;
        // Otherwise, build a param string
        } else if (params && typeof params === "object") type = "POST";
        // If we have elements to modify, make the request
        if (self.length > 0) jQuery.ajax({
            url: url,
            // If "type" variable is undefined, then "GET" method will be used.
            // Make value of this field explicit since
            // user can override it through ajaxSetup method
            type: type || "GET",
            dataType: "html",
            data: params
        }).done(function(responseText) {
            // Save response for use in complete callback
            response = arguments;
            self.html(selector ? // If a selector was specified, locate the right elements in a dummy div
            // Exclude scripts to avoid IE 'Permission Denied' errors
            jQuery("<div>").append(jQuery.parseHTML(responseText)).find(selector) : // Otherwise use the full result
            responseText);
        // If the request succeeds, this function gets "data", "status", "jqXHR"
        // but they are ignored because response was set above.
        // If it fails, this function gets "jqXHR", "status", "error"
        }).always(callback && function(jqXHR, status) {
            self.each(function() {
                callback.apply(this, response || [
                    jqXHR.responseText,
                    status,
                    jqXHR
                ]);
            });
        });
        return this;
    };
    jQuery.expr.pseudos.animated = function(elem) {
        return jQuery.grep(jQuery.timers, function(fn) {
            return elem === fn.elem;
        }).length;
    };
    jQuery.offset = {
        setOffset: function(elem, options, i) {
            var curPosition, curLeft, curCSSTop, curTop, curOffset, curCSSLeft, calculatePosition, position = jQuery.css(elem, "position"), curElem = jQuery(elem), props = {};
            // Set position first, in-case top/left are set even on static elem
            if (position === "static") elem.style.position = "relative";
            curOffset = curElem.offset();
            curCSSTop = jQuery.css(elem, "top");
            curCSSLeft = jQuery.css(elem, "left");
            calculatePosition = (position === "absolute" || position === "fixed") && (curCSSTop + curCSSLeft).indexOf("auto") > -1;
            // Need to be able to calculate position if either
            // top or left is auto and position is either absolute or fixed
            if (calculatePosition) {
                curPosition = curElem.position();
                curTop = curPosition.top;
                curLeft = curPosition.left;
            } else {
                curTop = parseFloat(curCSSTop) || 0;
                curLeft = parseFloat(curCSSLeft) || 0;
            }
            if (isFunction(options)) // Use jQuery.extend here to allow modification of coordinates argument (gh-1848)
            options = options.call(elem, i, jQuery.extend({}, curOffset));
            if (options.top != null) props.top = options.top - curOffset.top + curTop;
            if (options.left != null) props.left = options.left - curOffset.left + curLeft;
            if ("using" in options) options.using.call(elem, props);
            else curElem.css(props);
        }
    };
    jQuery.fn.extend({
        // offset() relates an element's border box to the document origin
        offset: function(options) {
            // Preserve chaining for setter
            if (arguments.length) return options === undefined ? this : this.each(function(i) {
                jQuery.offset.setOffset(this, options, i);
            });
            var rect, win, elem = this[0];
            if (!elem) return;
            // Return zeros for disconnected and hidden (display: none) elements (gh-2310)
            // Support: IE <=11 only
            // Running getBoundingClientRect on a
            // disconnected node in IE throws an error
            if (!elem.getClientRects().length) return {
                top: 0,
                left: 0
            };
            // Get document-relative position by adding viewport scroll to viewport-relative gBCR
            rect = elem.getBoundingClientRect();
            win = elem.ownerDocument.defaultView;
            return {
                top: rect.top + win.pageYOffset,
                left: rect.left + win.pageXOffset
            };
        },
        // position() relates an element's margin box to its offset parent's padding box
        // This corresponds to the behavior of CSS absolute positioning
        position: function() {
            if (!this[0]) return;
            var offsetParent, offset, doc, elem = this[0], parentOffset = {
                top: 0,
                left: 0
            };
            // position:fixed elements are offset from the viewport, which itself always has zero offset
            if (jQuery.css(elem, "position") === "fixed") // Assume position:fixed implies availability of getBoundingClientRect
            offset = elem.getBoundingClientRect();
            else {
                offset = this.offset();
                // Account for the *real* offset parent, which can be the document or its root element
                // when a statically positioned element is identified
                doc = elem.ownerDocument;
                offsetParent = elem.offsetParent || doc.documentElement;
                while(offsetParent && (offsetParent === doc.body || offsetParent === doc.documentElement) && jQuery.css(offsetParent, "position") === "static")offsetParent = offsetParent.parentNode;
                if (offsetParent && offsetParent !== elem && offsetParent.nodeType === 1) {
                    // Incorporate borders into its offset, since they are outside its content origin
                    parentOffset = jQuery(offsetParent).offset();
                    parentOffset.top += jQuery.css(offsetParent, "borderTopWidth", true);
                    parentOffset.left += jQuery.css(offsetParent, "borderLeftWidth", true);
                }
            }
            // Subtract parent offsets and element margins
            return {
                top: offset.top - parentOffset.top - jQuery.css(elem, "marginTop", true),
                left: offset.left - parentOffset.left - jQuery.css(elem, "marginLeft", true)
            };
        },
        // This method will return documentElement in the following cases:
        // 1) For the element inside the iframe without offsetParent, this method will return
        //    documentElement of the parent window
        // 2) For the hidden or detached element
        // 3) For body or html element, i.e. in case of the html node - it will return itself
        //
        // but those exceptions were never presented as a real life use-cases
        // and might be considered as more preferable results.
        //
        // This logic, however, is not guaranteed and can change at any point in the future
        offsetParent: function() {
            return this.map(function() {
                var offsetParent = this.offsetParent;
                while(offsetParent && jQuery.css(offsetParent, "position") === "static")offsetParent = offsetParent.offsetParent;
                return offsetParent || documentElement;
            });
        }
    });
    // Create scrollLeft and scrollTop methods
    jQuery.each({
        scrollLeft: "pageXOffset",
        scrollTop: "pageYOffset"
    }, function(method, prop) {
        var top = "pageYOffset" === prop;
        jQuery.fn[method] = function(val) {
            return access(this, function(elem, method, val) {
                // Coalesce documents and windows
                var win;
                if (isWindow(elem)) win = elem;
                else if (elem.nodeType === 9) win = elem.defaultView;
                if (val === undefined) return win ? win[prop] : elem[method];
                if (win) win.scrollTo(!top ? val : win.pageXOffset, top ? val : win.pageYOffset);
                else elem[method] = val;
            }, method, val, arguments.length);
        };
    });
    // Support: Safari <=7 - 9.1, Chrome <=37 - 49
    // Add the top/left cssHooks using jQuery.fn.position
    // Webkit bug: https://bugs.webkit.org/show_bug.cgi?id=29084
    // Blink bug: https://bugs.chromium.org/p/chromium/issues/detail?id=589347
    // getComputedStyle returns percent when specified for top/left/bottom/right;
    // rather than make the css module depend on the offset module, just check for it here
    jQuery.each([
        "top",
        "left"
    ], function(_i, prop) {
        jQuery.cssHooks[prop] = addGetHookIf(support.pixelPosition, function(elem, computed) {
            if (computed) {
                computed = curCSS(elem, prop);
                // If curCSS returns percentage, fallback to offset
                return rnumnonpx.test(computed) ? jQuery(elem).position()[prop] + "px" : computed;
            }
        });
    });
    // Create innerHeight, innerWidth, height, width, outerHeight and outerWidth methods
    jQuery.each({
        Height: "height",
        Width: "width"
    }, function(name, type) {
        jQuery.each({
            padding: "inner" + name,
            content: type,
            "": "outer" + name
        }, function(defaultExtra, funcName) {
            // Margin is only for outerHeight, outerWidth
            jQuery.fn[funcName] = function(margin, value) {
                var chainable = arguments.length && (defaultExtra || typeof margin !== "boolean"), extra = defaultExtra || (margin === true || value === true ? "margin" : "border");
                return access(this, function(elem, type, value) {
                    var doc;
                    if (isWindow(elem)) // $( window ).outerWidth/Height return w/h including scrollbars (gh-1729)
                    return funcName.indexOf("outer") === 0 ? elem["inner" + name] : elem.document.documentElement["client" + name];
                    // Get document width or height
                    if (elem.nodeType === 9) {
                        doc = elem.documentElement;
                        // Either scroll[Width/Height] or offset[Width/Height] or client[Width/Height],
                        // whichever is greatest
                        return Math.max(elem.body["scroll" + name], doc["scroll" + name], elem.body["offset" + name], doc["offset" + name], doc["client" + name]);
                    }
                    return value === undefined ? // Get width or height on the element, requesting but not forcing parseFloat
                    jQuery.css(elem, type, extra) : // Set width or height on the element
                    jQuery.style(elem, type, value, extra);
                }, type, chainable ? margin : undefined, chainable);
            };
        });
    });
    jQuery.each([
        "ajaxStart",
        "ajaxStop",
        "ajaxComplete",
        "ajaxError",
        "ajaxSuccess",
        "ajaxSend"
    ], function(_i, type) {
        jQuery.fn[type] = function(fn) {
            return this.on(type, fn);
        };
    });
    jQuery.fn.extend({
        bind: function(types, data, fn) {
            return this.on(types, null, data, fn);
        },
        unbind: function(types, fn) {
            return this.off(types, null, fn);
        },
        delegate: function(selector, types, data, fn) {
            return this.on(types, selector, data, fn);
        },
        undelegate: function(selector, types, fn) {
            // ( namespace ) or ( selector, types [, fn] )
            return arguments.length === 1 ? this.off(selector, "**") : this.off(types, selector || "**", fn);
        },
        hover: function(fnOver, fnOut) {
            return this.on("mouseenter", fnOver).on("mouseleave", fnOut || fnOver);
        }
    });
    jQuery.each("blur focus focusin focusout resize scroll click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup contextmenu".split(" "), function(_i, name) {
        // Handle event binding
        jQuery.fn[name] = function(data, fn) {
            return arguments.length > 0 ? this.on(name, null, data, fn) : this.trigger(name);
        };
    });
    // Support: Android <=4.0 only
    // Make sure we trim BOM and NBSP
    // Require that the "whitespace run" starts from a non-whitespace
    // to avoid O(N^2) behavior when the engine would try matching "\s+$" at each space position.
    var rtrim = /^[\s\uFEFF\xA0]+|([^\s\uFEFF\xA0])[\s\uFEFF\xA0]+$/g;
    // Bind a function to a context, optionally partially applying any
    // arguments.
    // jQuery.proxy is deprecated to promote standards (specifically Function#bind)
    // However, it is not slated for removal any time soon
    jQuery.proxy = function(fn, context) {
        var tmp, args, proxy;
        if (typeof context === "string") {
            tmp = fn[context];
            context = fn;
            fn = tmp;
        }
        // Quick check to determine if target is callable, in the spec
        // this throws a TypeError, but we will just return undefined.
        if (!isFunction(fn)) return undefined;
        // Simulated bind
        args = slice.call(arguments, 2);
        proxy = function() {
            return fn.apply(context || this, args.concat(slice.call(arguments)));
        };
        // Set the guid of unique handler to the same of original handler, so it can be removed
        proxy.guid = fn.guid = fn.guid || jQuery.guid++;
        return proxy;
    };
    jQuery.holdReady = function(hold) {
        if (hold) jQuery.readyWait++;
        else jQuery.ready(true);
    };
    jQuery.isArray = Array.isArray;
    jQuery.parseJSON = JSON.parse;
    jQuery.nodeName = nodeName;
    jQuery.isFunction = isFunction;
    jQuery.isWindow = isWindow;
    jQuery.camelCase = camelCase;
    jQuery.type = toType;
    jQuery.now = Date.now;
    jQuery.isNumeric = function(obj) {
        // As of jQuery 3.0, isNumeric is limited to
        // strings and numbers (primitives or objects)
        // that can be coerced to finite numbers (gh-2662)
        var type = jQuery.type(obj);
        return (type === "number" || type === "string") && // parseFloat NaNs numeric-cast false positives ("")
        // ...but misinterprets leading-number strings, particularly hex literals ("0x...")
        // subtraction forces infinities to NaN
        !isNaN(obj - parseFloat(obj));
    };
    jQuery.trim = function(text) {
        return text == null ? "" : (text + "").replace(rtrim, "$1");
    };
    // Register as a named AMD module, since jQuery can be concatenated with other
    // files that may use define, but not via a proper concatenation script that
    // understands anonymous AMD modules. A named AMD is safest and most robust
    // way to register. Lowercase jquery is used because AMD module names are
    // derived from file names, and jQuery is normally delivered in a lowercase
    // file name. Do this after creating the global so that if an AMD module wants
    // to call noConflict to hide this version of jQuery, it will work.
    // Note that for maximum portability, libraries that are not jQuery should
    // declare themselves as anonymous modules, and avoid setting a global if an
    // AMD loader is present. jQuery is a special case. For more information, see
    // https://github.com/jrburke/requirejs/wiki/Updating-existing-libraries#wiki-anon
    if (typeof define === "function" && define.amd) define("jquery", [], function() {
        return jQuery;
    });
    var // Map over jQuery in case of overwrite
    _jQuery = window1.jQuery, // Map over the $ in case of overwrite
    _$ = window1.$;
    jQuery.noConflict = function(deep) {
        if (window1.$ === jQuery) window1.$ = _$;
        if (deep && window1.jQuery === jQuery) window1.jQuery = _jQuery;
        return jQuery;
    };
    // Expose jQuery and $ identifiers, even in AMD
    // (trac-7102#comment:10, https://github.com/jquery/jquery/pull/557)
    // and CommonJS for browser emulators (trac-13566)
    if (typeof noGlobal === "undefined") window1.jQuery = window1.$ = jQuery;
    return jQuery;
});

});


parcelRegister("jtLqq", function(module, exports) {


// Backbone.Radio v2.0.0
(function(global, factory) {
    module.exports = factory((parcelRequire("2q7Wm")), (parcelRequire("kL2Ep")));
})(module.exports, function(_, Backbone) {
    "use strict";
    _ = "default" in _ ? _["default"] : _;
    Backbone = "default" in Backbone ? Backbone["default"] : Backbone;
    var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj;
    };
    var previousRadio = Backbone.Radio;
    var Radio = Backbone.Radio = {};
    Radio.VERSION = "2.0.0";
    // This allows you to run multiple instances of Radio on the same
    // webapp. After loading the new version, call `noConflict()` to
    // get a reference to it. At the same time the old version will be
    // returned to Backbone.Radio.
    Radio.noConflict = function() {
        Backbone.Radio = previousRadio;
        return this;
    };
    // Whether or not we're in DEBUG mode or not. DEBUG mode helps you
    // get around the issues of lack of warnings when events are mis-typed.
    Radio.DEBUG = false;
    // Format debug text.
    Radio._debugText = function(warning, eventName, channelName) {
        return warning + (channelName ? " on the " + channelName + " channel" : "") + ': "' + eventName + '"';
    };
    // This is the method that's called when an unregistered event was called.
    // By default, it logs warning to the console. By overriding this you could
    // make it throw an Error, for instance. This would make firing a nonexistent event
    // have the same consequence as firing a nonexistent method on an Object.
    Radio.debugLog = function(warning, eventName, channelName) {
        if (Radio.DEBUG && console && console.warn) console.warn(Radio._debugText(warning, eventName, channelName));
    };
    var eventSplitter = /\s+/;
    // An internal method used to handle Radio's method overloading for Requests.
    // It's borrowed from Backbone.Events. It differs from Backbone's overload
    // API (which is used in Backbone.Events) in that it doesn't support space-separated
    // event names.
    Radio._eventsApi = function(obj, action, name, rest) {
        if (!name) return false;
        var results = {};
        // Handle event maps.
        if ((typeof name === "undefined" ? "undefined" : _typeof(name)) === "object") {
            for(var key in name){
                var result = obj[action].apply(obj, [
                    key,
                    name[key]
                ].concat(rest));
                eventSplitter.test(key) ? _.extend(results, result) : results[key] = result;
            }
            return results;
        }
        // Handle space separated event names.
        if (eventSplitter.test(name)) {
            var names = name.split(eventSplitter);
            for(var i = 0, l = names.length; i < l; i++)results[names[i]] = obj[action].apply(obj, [
                names[i]
            ].concat(rest));
            return results;
        }
        return false;
    };
    // An optimized way to execute callbacks.
    Radio._callHandler = function(callback, context, args) {
        var a1 = args[0], a2 = args[1], a3 = args[2];
        switch(args.length){
            case 0:
                return callback.call(context);
            case 1:
                return callback.call(context, a1);
            case 2:
                return callback.call(context, a1, a2);
            case 3:
                return callback.call(context, a1, a2, a3);
            default:
                return callback.apply(context, args);
        }
    };
    // A helper used by `off` methods to the handler from the store
    function removeHandler(store, name, callback, context) {
        var event = store[name];
        if ((!callback || callback === event.callback || callback === event.callback._callback) && (!context || context === event.context)) {
            delete store[name];
            return true;
        }
    }
    function removeHandlers(store, name, callback, context) {
        store || (store = {});
        var names = name ? [
            name
        ] : _.keys(store);
        var matched = false;
        for(var i = 0, length = names.length; i < length; i++){
            name = names[i];
            // If there's no event by this name, log it and continue
            // with the loop
            if (!store[name]) continue;
            if (removeHandler(store, name, callback, context)) matched = true;
        }
        return matched;
    }
    /*
   * tune-in
   * -------
   * Get console logs of a channel's activity
   *
   */ var _logs = {};
    // This is to produce an identical function in both tuneIn and tuneOut,
    // so that Backbone.Events unregisters it.
    function _partial(channelName) {
        return _logs[channelName] || (_logs[channelName] = _.bind(Radio.log, Radio, channelName));
    }
    _.extend(Radio, {
        // Log information about the channel and event
        log: function log(channelName, eventName) {
            if (typeof console === "undefined") return;
            var args = _.toArray(arguments).slice(2);
            console.log("[" + channelName + '] "' + eventName + '"', args);
        },
        // Logs all events on this channel to the console. It sets an
        // internal value on the channel telling it we're listening,
        // then sets a listener on the Backbone.Events
        tuneIn: function tuneIn(channelName) {
            var channel = Radio.channel(channelName);
            channel._tunedIn = true;
            channel.on("all", _partial(channelName));
            return this;
        },
        // Stop logging all of the activities on this channel to the console
        tuneOut: function tuneOut(channelName) {
            var channel = Radio.channel(channelName);
            channel._tunedIn = false;
            channel.off("all", _partial(channelName));
            delete _logs[channelName];
            return this;
        }
    });
    /*
   * Backbone.Radio.Requests
   * -----------------------
   * A messaging system for requesting data.
   *
   */ function makeCallback(callback) {
        return _.isFunction(callback) ? callback : function() {
            return callback;
        };
    }
    Radio.Requests = {
        // Make a request
        request: function request(name) {
            var args = _.toArray(arguments).slice(1);
            var results = Radio._eventsApi(this, "request", name, args);
            if (results) return results;
            var channelName = this.channelName;
            var requests = this._requests;
            // Check if we should log the request, and if so, do it
            if (channelName && this._tunedIn) Radio.log.apply(this, [
                channelName,
                name
            ].concat(args));
            // If the request isn't handled, log it in DEBUG mode and exit
            if (requests && (requests[name] || requests["default"])) {
                var handler = requests[name] || requests["default"];
                args = requests[name] ? args : arguments;
                return Radio._callHandler(handler.callback, handler.context, args);
            } else Radio.debugLog("An unhandled request was fired", name, channelName);
        },
        // Set up a handler for a request
        reply: function reply(name, callback, context) {
            if (Radio._eventsApi(this, "reply", name, [
                callback,
                context
            ])) return this;
            this._requests || (this._requests = {});
            if (this._requests[name]) Radio.debugLog("A request was overwritten", name, this.channelName);
            this._requests[name] = {
                callback: makeCallback(callback),
                context: context || this
            };
            return this;
        },
        // Set up a handler that can only be requested once
        replyOnce: function replyOnce(name, callback, context) {
            if (Radio._eventsApi(this, "replyOnce", name, [
                callback,
                context
            ])) return this;
            var self = this;
            var once = _.once(function() {
                self.stopReplying(name);
                return makeCallback(callback).apply(this, arguments);
            });
            return this.reply(name, once, context);
        },
        // Remove handler(s)
        stopReplying: function stopReplying(name, callback, context) {
            if (Radio._eventsApi(this, "stopReplying", name)) return this;
            // Remove everything if there are no arguments passed
            if (!name && !callback && !context) delete this._requests;
            else if (!removeHandlers(this._requests, name, callback, context)) Radio.debugLog("Attempted to remove the unregistered request", name, this.channelName);
            return this;
        }
    };
    /*
   * Backbone.Radio.channel
   * ----------------------
   * Get a reference to a channel by name.
   *
   */ Radio._channels = {};
    Radio.channel = function(channelName) {
        if (!channelName) throw new Error("You must provide a name for the channel.");
        if (Radio._channels[channelName]) return Radio._channels[channelName];
        else return Radio._channels[channelName] = new Radio.Channel(channelName);
    };
    /*
   * Backbone.Radio.Channel
   * ----------------------
   * A Channel is an object that extends from Backbone.Events,
   * and Radio.Requests.
   *
   */ Radio.Channel = function(channelName) {
        this.channelName = channelName;
    };
    _.extend(Radio.Channel.prototype, Backbone.Events, Radio.Requests, {
        // Remove all handlers from the messaging systems of this channel
        reset: function reset() {
            this.off();
            this.stopListening();
            this.stopReplying();
            return this;
        }
    });
    /*
   * Top-level API
   * -------------
   * Supplies the 'top-level API' for working with Channels directly
   * from Backbone.Radio.
   *
   */ var channel;
    var args;
    var systems = [
        Backbone.Events,
        Radio.Requests
    ];
    _.each(systems, function(system) {
        _.each(system, function(method, methodName) {
            Radio[methodName] = function(channelName) {
                args = _.toArray(arguments).slice(1);
                channel = this.channel(channelName);
                return channel[methodName].apply(channel, args);
            };
        });
    });
    Radio.reset = function(channelName) {
        var channels = !channelName ? this._channels : [
            this._channels[channelName]
        ];
        _.each(channels, function(channel) {
            channel.reset();
        });
    };
    return Radio;
});

});

parcelRegister("htgj6", function(module, exports) {

$parcel$export(module.exports, "loadCSS", () => $0348497919a5036f$export$5c4fe40904b85610);
$parcel$export(module.exports, "loadTemplates", () => $0348497919a5036f$export$103d7cd95c4d65d6);
$parcel$export(module.exports, "loadPrimaryFonts", () => $0348497919a5036f$export$ba9827050f34fda9);
$parcel$export(module.exports, "loadSMUFLFonts", () => $0348497919a5036f$export$892458f497a68a82);
$parcel$export(module.exports, "loadSupplementalFonts", () => $0348497919a5036f$export$76a39d7a02251d1b);
/**
 * Functions to load assets for the Delivery System.
 */ 
var $jtLqq = parcelRequire("jtLqq");

var $fdv5d = parcelRequire("fdv5d");
const $0348497919a5036f$var$configChannel = (0, (/*@__PURE__*/$parcel$interopDefault($jtLqq))).channel("config");
const $0348497919a5036f$var$loadChannel = (0, (/*@__PURE__*/$parcel$interopDefault($jtLqq))).channel("load");
const $0348497919a5036f$var$viewChannel = (0, (/*@__PURE__*/$parcel$interopDefault($jtLqq))).channel("view");
// Whereas the "app" request is not used any more, let's throw an Error.
$0348497919a5036f$var$loadChannel.reply("app", ()=>{
    throw new Error('ERR-EGC-31: "app" on "load" channel');
});
async function $0348497919a5036f$export$2cb99e4be0dc4646(url, attributes) {
    // Make sure it doesn't already exist; if it does, we don't need a new version
    url = $0348497919a5036f$var$convertToSafeURL(url);
    const existingNode = document.querySelector(`script[type="text/javascript"][src="${url}"]`);
    if (existingNode) return;
    // Append necessary attributes for this type
    if (!attributes) attributes = {};
    attributes.type = "text/javascript";
    attributes.src = url;
    // Create the el and pass off to common handler
    const script = document.createElement("script");
    return $0348497919a5036f$var$appendEl(script, attributes);
}
$0348497919a5036f$var$loadChannel.reply("script", $0348497919a5036f$export$2cb99e4be0dc4646);
async function $0348497919a5036f$export$5c4fe40904b85610(url, attributes) {
    // Make sure it doesn't already exist; if it does, we don't need a new version
    url = $0348497919a5036f$var$convertToSafeURL(url);
    const existingNode = document.querySelector(`link[rel="stylesheet"][href="${url}"]`);
    if (existingNode) return;
    // Append necessary attributes for this type
    if (!attributes) attributes = {};
    attributes.rel = "stylesheet";
    attributes.href = url;
    // Create the el and pass off to common handler
    const link = document.createElement("link");
    return $0348497919a5036f$var$appendEl(link, attributes);
}
$0348497919a5036f$var$loadChannel.reply("css", $0348497919a5036f$export$5c4fe40904b85610);
async function $0348497919a5036f$export$103d7cd95c4d65d6(url, templateID) {
    /* eslint-disable no-console */ // Note: This function uses console.error() directly so that we don't
    // have to import printDeveloperError() so early in the app initialization.
    const response = await fetch($0348497919a5036f$var$convertToSafeURL(url));
    if (!response.ok) {
        const msg = `ERR-EGC-11: loadTemplates() received HTTP ${response.status}`;
        console.error(msg);
        throw new Error(msg);
    } else {
        const contentType = response.headers.get("content-type");
        if (contentType.includes("application/json")) $0348497919a5036f$var$viewChannel.trigger("templates:register", await response.json());
        else if (contentType.includes("text/html")) {
            if (templateID) $0348497919a5036f$var$viewChannel.trigger("templates:register", {
                [templateID]: await response.text()
            });
            else {
                const msg = 'ERR-EGC-12: no "templateID"';
                console.error(msg);
                throw new Error(msg);
            }
        } else {
            const msg = `ERR-EGC-13 with content-type: "${contentType}"`;
            console.error(msg);
            throw new Error(msg);
        }
    }
/* eslint-enable */ }
$0348497919a5036f$var$loadChannel.reply("templates", $0348497919a5036f$export$103d7cd95c4d65d6);
/**
 * Complete an asset URL for Egret Delivery System expectations.
 *
 * @param {string} url - String with URL or pathname to load.
 * @returns {string} The "safe" (that is: Egret-proof) URL.
 *
 * This function does two things:
 * - If `window.testRoot` is defined and the "url" argument does not begin with
 *     "http" then the function assumes the argument is just the URL pathname,
 *     so the value of `window.root` is prepended. Among other things, this
 *     feature allows the Karma test harness to load assets more easily.
 * - Add the "v" search parameter to the end of the string, equal to the current
 *     Delivery System "version." This is a cache-busting mechanism.
 */ function $0348497919a5036f$var$convertToSafeURL(url) {
    // see loader-es6.js for `runningTests` documentation
    if (window.testRoot && !url.startsWith("http")) url = window.root + url;
    // Help avoid caching issues
    const rootController = $0348497919a5036f$var$viewChannel.request("controller", "rootController");
    let version;
    if (rootController && rootController.currentRelease) version = rootController.currentRelease;
    else if ($0348497919a5036f$var$configChannel.request("property", "version")) version = $0348497919a5036f$var$configChannel.request("property", "version");
    if (version) {
        const joinChar = url.indexOf("?") > -1 ? "&" : "?";
        url += joinChar + "v=" + version;
    }
    return url;
}
/**
 * Wait for an Element to trigger the "onload" or "onerror" function.
 *
 * @param {Element} el - To add to the DOM tree.
 * @param {Object} attributes - To add to the element.
 * @returns {Promise<void|Error>} - Resolves when the element successfully
 *     loads its linked content. Rejects with an Error when the element
 *     is not able to load its linked content.
 * @async
 */ function $0348497919a5036f$var$appendEl(el, attributes) {
    return new Promise(function(resolve, reject) {
        // IE
        if (el.readyState) el.onreadystatechange = function() {
            if (el.readyState === "loaded" || el.readyState === "complete") {
                el.onreadystatechange = null;
                resolve();
            }
        };
        else {
            el.onload = ()=>resolve();
            el.onerror = ()=>{
                // If the asset fails to load, we can provide a minimal failure message.
                const assetURL = typeof attributes.href === "string" ? attributes.href : attributes.src;
                const errMsg = typeof assetURL === "string" ? `Failed to load "${assetURL}".` : "Failed to load asset.";
                reject(new Error(errMsg));
            };
        }
        // Add on all necessary attributes
        if (attributes) Object.keys(attributes).map((attr)=>el.setAttribute(attr, attributes[attr]));
        const head = document.querySelector("head");
        if (head) head.appendChild(el);
        else reject(new Error('appendEl(): did not find "head" element'));
    });
}
/**
 * Create font face definitions and load them.
 *
 * @param {FontSpec[]} fontSpecs - Specifications for the fonts to load.
 * @param {boolean} [loadImmediately=true] - Whether to call load() on the
 *     FontFace instance, thereby requesting the browser to load the font
 *     file immediately. Defaults to true, and this should only be set to
 *     false for files we aren't sure will be needed (for example, BravuraText,
 *     or the Vietnamese glyphs of EB Garamond).
 * @returns {Promise<*>} An "all settled" promise for all the fonts requested.
 * @async
 *
 * @typedef {Object} FontSpec
 * @property {string} family - Name of the font family being defined.
 * @property {string} source - URL in a string (do not give an ArrayBuffer).
 * @property {Object} descriptors - Passed as-is to the FontFace constructor.
 */ async function $0348497919a5036f$var$loadFonts(fontSpecs, loadImmediately = true) {
    if (Array.isArray(fontSpecs)) return Promise.allSettled(fontSpecs.map((spec)=>{
        const thisFont = new FontFace(spec.family, `url("${spec.source}")`, spec.descriptors);
        document.fonts.add(thisFont);
        return loadImmediately === true ? thisFont.load() : Promise.resolve();
    }));
}
async function $0348497919a5036f$export$ba9827050f34fda9() {
    const site = $0348497919a5036f$var$configChannel.request("property", "site");
    const fontsToLoad = [];
    if (site === "MGG") fontsToLoad.push((0, $fdv5d.definitions).Skolar.primary[0]);
    if (site === "MGG" || site === "RME") fontsToLoad.push((0, $fdv5d.definitions).SkolarSans.primary[0]);
    if (site === "DEU") {
        fontsToLoad.push((0, $fdv5d.definitions).Garamond.primary[0]);
        fontsToLoad.push((0, $fdv5d.definitions).Metropolis.primary[0]);
    }
    return $0348497919a5036f$var$loadFonts(fontsToLoad);
}
async function $0348497919a5036f$export$a230ac2a0436e9() {
    const site = $0348497919a5036f$var$configChannel.request("property", "site");
    const fontsToLoad = [];
    // Load FontAwesome.
    if (site === "MGG" || site === "RME" || site === "DEU") fontsToLoad.push((0, $fdv5d.definitions).FontAwesome.secondary[0]);
    return $0348497919a5036f$var$loadFonts(fontsToLoad);
}
async function $0348497919a5036f$export$a5b386383336bc40() {
    const site = $0348497919a5036f$var$configChannel.request("property", "site");
    const fontsToLoad = [];
    if (site === "MGG") (0, $fdv5d.definitions).Skolar.tertiary.forEach((declaration)=>fontsToLoad.push(declaration));
    if (site === "MGG" || site === "RME") (0, $fdv5d.definitions).SkolarSans.tertiary.forEach((declaration)=>fontsToLoad.push(declaration));
    if (site === "DEU") {
        (0, $fdv5d.definitions).Garamond.tertiary.forEach((declaration)=>fontsToLoad.push(declaration));
        (0, $fdv5d.definitions).Metropolis.tertiary.forEach((declaration)=>fontsToLoad.push(declaration));
    }
    return $0348497919a5036f$var$loadFonts(fontsToLoad);
}
async function $0348497919a5036f$export$950b9fe71b41dfcf() {
    const site = $0348497919a5036f$var$configChannel.request("property", "site");
    // Set up "Bravura Text" for all sites.
    const fontsToLoad = [];
    // Set up additional Unicode ranges for EB Garamond on DEUMM.
    if (site === "DEU") (0, $fdv5d.definitions).Garamond.quaternary.forEach((declaration)=>fontsToLoad.push(declaration));
    return $0348497919a5036f$var$loadFonts(fontsToLoad, false);
}
$0348497919a5036f$var$loadChannel.reply("fonts:quaternary", $0348497919a5036f$export$950b9fe71b41dfcf);
async function $0348497919a5036f$export$892458f497a68a82() {
    return $0348497919a5036f$var$loadFonts((0, $fdv5d.definitions).BravuraText.quaternary);
}
$0348497919a5036f$var$loadChannel.reply("fonts:smufl", $0348497919a5036f$export$892458f497a68a82);
async function $0348497919a5036f$export$76a39d7a02251d1b() {
    // Note 1: Browsers avoid duplicating font-face declarations, so we don't
    //     need to check for that. Just try to load the font.
    // Note 2: Whereas all browsers that support the CSS Font Loading API also
    //     support WOFF2 font files, we don't need to use any fallbacks.
    // Double-check that the primary fonts have finished loading. If not, we
    // don't want to load any more fonts yet.
    await $0348497919a5036f$export$ba9827050f34fda9();
    // Secondary fonts: icons.
    await $0348497919a5036f$export$a230ac2a0436e9();
    // Tertiary fonts: variations on the core fonts.
    await $0348497919a5036f$export$a5b386383336bc40();
}

});
parcelRegister("fdv5d", function(module, exports) {

$parcel$export(module.exports, "definitions", () => $b1402e5e9910e159$export$d79264f26953ec1);
const $b1402e5e9910e159$export$d79264f26953ec1 = {
    BravuraText: {
        quaternary: [
            {
                family: "Bravura Text",
                source: "/fonts/BravuraText/BravuraText-1.393.woff2"
            }
        ]
    },
    FontAwesome: {
        secondary: [
            {
                family: "FontAwesome",
                source: "/fonts/FontAwesome/fontawesome-4.7.0.woff2"
            }
        ]
    },
    Skolar: {
        primary: [
            {
                family: "Skolar",
                source: "/fonts/Skolar/Skolar.woff2"
            }
        ],
        tertiary: [
            {
                family: "Skolar",
                source: "/fonts/Skolar/Skolar-Italic.woff2",
                descriptors: {
                    style: "italic"
                }
            },
            {
                family: "Skolar",
                source: "/fonts/Skolar/Skolar-Light.woff2",
                descriptors: {
                    weight: "300"
                }
            },
            {
                family: "Skolar",
                source: "/fonts/Skolar/Skolar-LightItalic.woff2",
                descriptors: {
                    style: "italic",
                    weight: "300"
                }
            },
            {
                family: "Skolar",
                source: "/fonts/Skolar/Skolar-Semibold.woff2",
                descriptors: {
                    weight: "bold"
                }
            },
            {
                family: "Skolar",
                source: "/fonts/Skolar/Skolar-Semibold-Italic.woff2",
                descriptors: {
                    style: "italic",
                    weight: "bold"
                }
            }
        ]
    },
    SkolarSans: {
        primary: [
            {
                family: "SkolarSans",
                source: "/fonts/SkolarSans/SkolarSans.woff2"
            }
        ],
        tertiary: [
            {
                family: "SkolarSans",
                source: "/fonts/SkolarSans/SkolarSans-Italic.woff2",
                descriptors: {
                    style: "italic"
                }
            },
            {
                family: "SkolarSans",
                source: "/fonts/SkolarSans/SkolarSans-Semibold.woff2",
                descriptors: {
                    weight: "bold"
                }
            },
            {
                family: "SkolarSans",
                source: "/fonts/SkolarSans/SkolarSans-Semibold-Italic.woff2",
                descriptors: {
                    style: "italic",
                    weight: "bold"
                }
            }
        ]
    },
    Metropolis: {
        primary: [
            {
                family: "Metropolis",
                source: "/fonts/Metropolis/Metropolis-Regular.woff2"
            }
        ],
        tertiary: [
            {
                family: "Metropolis",
                source: "/fonts/Metropolis/Metropolis-Bold.woff2",
                descriptors: {
                    weight: "700"
                }
            },
            {
                family: "Metropolis",
                source: "/fonts/Metropolis/Metropolis-BoldItalic.woff2",
                descriptors: {
                    weight: "700",
                    style: "italic"
                }
            },
            {
                family: "Metropolis",
                source: "/fonts/Metropolis/Metropolis-Medium.woff2",
                descriptors: {
                    weight: "500"
                }
            },
            {
                family: "Metropolis",
                source: "/fonts/Metropolis/Metropolis-MediumItalic.woff2",
                descriptors: {
                    weight: "500",
                    style: "italic"
                }
            },
            {
                family: "Metropolis",
                source: "/fonts/Metropolis/Metropolis-RegularItalic.woff2",
                descriptors: {
                    style: "400"
                }
            }
        ]
    },
    Garamond: {
        primary: [
            {
                family: "EB Garamond",
                source: "/fonts/EB_Garamond_v26/SlGUmQSNjdsmc35JDF1K5GR1SDk.woff2",
                descriptors: {
                    weight: "400",
                    unicodeRange: "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
                }
            }
        ],
        // There are a LOT of tertiary and quaternary files because Google Fonts
        // divided different Unicode ranges into different files, to reduce
        // loading time. For the Egret DS, we only definitely need the Latin and
        // Latin-extended character ranges, so we'll load them as tertiary.
        // The other character ranges are defined as quaternary, allowing the
        // browser to decide when to actually load the files.
        tertiary: [
            // latin
            {
                family: "EB Garamond",
                source: "/fonts/EB_Garamond_v26/SlGUmQSNjdsmc35JDF1K5GR1SDk.woff2",
                descriptors: {
                    style: "normal",
                    weight: "700",
                    unicodeRange: "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
                }
            },
            {
                family: "EB Garamond",
                source: "/fonts/EB_Garamond_v26/SlGWmQSNjdsmc35JDF1K5GRweDs1Zw.woff2",
                descriptors: {
                    style: "italic",
                    weight: "700",
                    unicodeRange: "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
                }
            },
            {
                family: "EB Garamond",
                source: "/fonts/EB_Garamond_v26/SlGWmQSNjdsmc35JDF1K5GRweDs1Zw.woff2",
                descriptors: {
                    style: "italic",
                    weight: "400",
                    unicodeRange: "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD"
                }
            },
            // latin-ext
            {
                family: "EB Garamond",
                source: "/fonts/EB_Garamond_v26/SlGUmQSNjdsmc35JDF1K5GR7SDktYw.woff2",
                descriptors: {
                    style: "normal",
                    weight: "700",
                    unicodeRange: "U+0100-02AF, U+0304, U+0308, U+0329, U+1E00-1E9F, U+1EF2-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF"
                }
            },
            {
                family: "EB Garamond",
                source: "/fonts/EB_Garamond_v26/SlGUmQSNjdsmc35JDF1K5GR7SDktYw.woff2",
                descriptors: {
                    style: "normal",
                    weight: "400",
                    unicodeRange: "U+0100-02AF, U+0304, U+0308, U+0329, U+1E00-1E9F, U+1EF2-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF"
                }
            },
            {
                family: "EB Garamond",
                source: "/fonts/EB_Garamond_v26/SlGWmQSNjdsmc35JDF1K5GRweDU1ZzPJ.woff2",
                descriptors: {
                    style: "italic",
                    weight: "700",
                    unicodeRange: "U+0100-02AF, U+0304, U+0308, U+0329, U+1E00-1E9F, U+1EF2-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF"
                }
            },
            {
                family: "EB Garamond",
                source: "/fonts/EB_Garamond_v26/SlGWmQSNjdsmc35JDF1K5GRweDU1ZzPJ.woff2",
                descriptors: {
                    style: "italic",
                    weight: "400",
                    unicodeRange: "U+0100-02AF, U+0304, U+0308, U+0329, U+1E00-1E9F, U+1EF2-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF"
                }
            }
        ],
        quaternary: [
            // cyrillic
            {
                family: "EB Garamond",
                source: "/fonts/EB_Garamond_v26/SlGWmQSNjdsmc35JDF1K5GRweD81ZzPJ.woff2",
                descriptors: {
                    style: "italic",
                    weight: "400",
                    unicodeRange: "U+0301, U+0400-045F, U+0490-0491, U+04B0-04B1, U+2116"
                }
            },
            {
                family: "EB Garamond",
                source: "/fonts/EB_Garamond_v26/SlGWmQSNjdsmc35JDF1K5GRweD81ZzPJ.woff2",
                descriptors: {
                    style: "italic",
                    weight: "700",
                    unicodeRange: "U+0301, U+0400-045F, U+0490-0491, U+04B0-04B1, U+2116"
                }
            },
            {
                family: "EB Garamond",
                source: "/fonts/EB_Garamond_v26/SlGUmQSNjdsmc35JDF1K5GRxSDktYw.woff2",
                descriptors: {
                    style: "normal",
                    weight: "400",
                    unicodeRange: "U+0301, U+0400-045F, U+0490-0491, U+04B0-04B1, U+2116"
                }
            },
            {
                family: "EB Garamond",
                source: "/fonts/EB_Garamond_v26/SlGUmQSNjdsmc35JDF1K5GRxSDktYw.woff2",
                descriptors: {
                    style: "normal",
                    weight: "700",
                    unicodeRange: "U+0301, U+0400-045F, U+0490-0491, U+04B0-04B1, U+2116"
                }
            },
            // cyrillic-ext
            {
                family: "EB Garamond",
                source: "/fonts/EB_Garamond_v26/SlGWmQSNjdsmc35JDF1K5GRweDY1ZzPJ.woff2",
                descriptors: {
                    style: "italic",
                    weight: "400",
                    unicodeRange: "U+0460-052F, U+1C80-1C88, U+20B4, U+2DE0-2DFF, U+A640-A69F, U+FE2E-FE2F"
                }
            },
            {
                family: "EB Garamond",
                source: "/fonts/EB_Garamond_v26/SlGWmQSNjdsmc35JDF1K5GRweDY1ZzPJ.woff2",
                descriptors: {
                    style: "italic",
                    weight: "700",
                    unicodeRange: "U+0460-052F, U+1C80-1C88, U+20B4, U+2DE0-2DFF, U+A640-A69F, U+FE2E-FE2F"
                }
            },
            {
                family: "EB Garamond",
                source: "/fonts/EB_Garamond_v26/SlGUmQSNjdsmc35JDF1K5GR4SDktYw.woff2",
                descriptors: {
                    style: "normal",
                    weight: "400",
                    unicodeRange: "U+0460-052F, U+1C80-1C88, U+20B4, U+2DE0-2DFF, U+A640-A69F, U+FE2E-FE2F"
                }
            },
            {
                family: "EB Garamond",
                source: "/fonts/EB_Garamond_v26/SlGUmQSNjdsmc35JDF1K5GR4SDktYw.woff2",
                descriptors: {
                    style: "normal",
                    weight: "700",
                    unicodeRange: "U+0460-052F, U+1C80-1C88, U+20B4, U+2DE0-2DFF, U+A640-A69F, U+FE2E-FE2F"
                }
            },
            // greek
            {
                family: "EB Garamond",
                source: "/fonts/EB_Garamond_v26/SlGWmQSNjdsmc35JDF1K5GRweDg1ZzPJ.woff2",
                descriptors: {
                    style: "italic",
                    weight: "400",
                    unicodeRange: "U+0370-03FF"
                }
            },
            {
                family: "EB Garamond",
                source: "/fonts/EB_Garamond_v26/SlGWmQSNjdsmc35JDF1K5GRweDg1ZzPJ.woff2",
                descriptors: {
                    style: "italic",
                    weight: "700",
                    unicodeRange: "U+0370-03FF"
                }
            },
            {
                family: "EB Garamond",
                source: "/fonts/EB_Garamond_v26/SlGUmQSNjdsmc35JDF1K5GR2SDktYw.woff2",
                descriptors: {
                    style: "normal",
                    weight: "400",
                    unicodeRange: "U+0370-03FF"
                }
            },
            {
                family: "EB Garamond",
                source: "/fonts/EB_Garamond_v26/SlGUmQSNjdsmc35JDF1K5GR2SDktYw.woff2",
                descriptors: {
                    style: "normal",
                    weight: "700",
                    unicodeRange: "U+0370-03FF"
                }
            },
            // greek-ext
            {
                family: "EB Garamond",
                source: "/fonts/EB_Garamond_v26/SlGWmQSNjdsmc35JDF1K5GRweDc1ZzPJ.woff2",
                descriptors: {
                    style: "italic",
                    weight: "400",
                    unicodeRange: "U+1F00-1FFF"
                }
            },
            {
                family: "EB Garamond",
                source: "/fonts/EB_Garamond_v26/SlGWmQSNjdsmc35JDF1K5GRweDc1ZzPJ.woff2",
                descriptors: {
                    style: "italic",
                    weight: "700",
                    unicodeRange: "U+1F00-1FFF"
                }
            },
            {
                family: "EB Garamond",
                source: "/fonts/EB_Garamond_v26/SlGUmQSNjdsmc35JDF1K5GR5SDktYw.woff2",
                descriptors: {
                    style: "normal",
                    weight: "400",
                    unicodeRange: "U+1F00-1FFF"
                }
            },
            {
                family: "EB Garamond",
                source: "/fonts/EB_Garamond_v26/SlGUmQSNjdsmc35JDF1K5GR5SDktYw.woff2",
                descriptors: {
                    style: "normal",
                    weight: "700",
                    unicodeRange: "U+1F00-1FFF"
                }
            },
            // vietnamese
            {
                family: "EB Garamond",
                source: "/fonts/EB_Garamond_v26/SlGWmQSNjdsmc35JDF1K5GRweDQ1ZzPJ.woff2",
                descriptors: {
                    style: "italic",
                    weight: "400",
                    unicodeRange: "U+0102-0103, U+0110-0111, U+0128-0129, U+0168-0169, U+01A0-01A1, U+01AF-01B0, U+0300-0301, U+0303-0304, U+0308-0309, U+0323, U+0329, U+1EA0-1EF9, U+20AB"
                }
            },
            {
                family: "EB Garamond",
                source: "/fonts/EB_Garamond_v26/SlGWmQSNjdsmc35JDF1K5GRweDQ1ZzPJ.woff2",
                descriptors: {
                    style: "italic",
                    weight: "700",
                    unicodeRange: "U+0102-0103, U+0110-0111, U+0128-0129, U+0168-0169, U+01A0-01A1, U+01AF-01B0, U+0300-0301, U+0303-0304, U+0308-0309, U+0323, U+0329, U+1EA0-1EF9, U+20AB"
                }
            },
            {
                family: "EB Garamond",
                source: "/fonts/EB_Garamond_v26/SlGUmQSNjdsmc35JDF1K5GR6SDktYw.woff2",
                descriptors: {
                    style: "normal",
                    weight: "400",
                    unicodeRange: "U+0102-0103, U+0110-0111, U+0128-0129, U+0168-0169, U+01A0-01A1, U+01AF-01B0, U+0300-0301, U+0303-0304, U+0308-0309, U+0323, U+0329, U+1EA0-1EF9, U+20AB"
                }
            },
            {
                family: "EB Garamond",
                source: "/fonts/EB_Garamond_v26/SlGUmQSNjdsmc35JDF1K5GR6SDktYw.woff2",
                descriptors: {
                    style: "normal",
                    weight: "700",
                    unicodeRange: "U+0102-0103, U+0110-0111, U+0128-0129, U+0168-0169, U+01A0-01A1, U+01AF-01B0, U+0300-0301, U+0303-0304, U+0308-0309, U+0323, U+0329, U+1EA0-1EF9, U+20AB"
                }
            }
        ]
    }
};

});


parcelRegister("1eLr4", function(module, exports) {



/**
* @license
* MarionetteJS (Backbone.Marionette)
* ----------------------------------
* v4.1.3
*
* Copyright (c)2020 Derick Bailey, Muted Solutions, LLC.
* Distributed under MIT license
*
* http://marionettejs.com
*/ (function(global, factory) {
    factory(module.exports, (parcelRequire("kL2Ep")), (parcelRequire("2q7Wm")), (parcelRequire("jtLqq")));
})(module.exports, function(exports1, Backbone, _, Radio) {
    "use strict";
    Backbone = Backbone && Backbone.hasOwnProperty("default") ? Backbone["default"] : Backbone;
    _ = _ && _.hasOwnProperty("default") ? _["default"] : _;
    Radio = Radio && Radio.hasOwnProperty("default") ? Radio["default"] : Radio;
    var version = "4.1.3";
    //Internal utility for creating context style global utils
    var proxy = function proxy(method) {
        return function(context) {
            for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
            return method.apply(context, args);
        };
    };
    // Marionette.extend
    var extend = Backbone.Model.extend;
    // ----------------------
    // Pass in a mapping of events => functions or function names
    // and return a mapping of events => functions
    var normalizeMethods = function normalizeMethods(hash) {
        var _this = this;
        if (!hash) return;
        return _.reduce(hash, function(normalizedHash, method, name) {
            if (!_.isFunction(method)) method = _this[method];
            if (method) normalizedHash[name] = method;
            return normalizedHash;
        }, {});
    };
    // Error
    var errorProps = [
        "description",
        "fileName",
        "lineNumber",
        "name",
        "message",
        "number",
        "url"
    ];
    var MarionetteError = extend.call(Error, {
        urlRoot: "http://marionettejs.com/docs/v".concat(version, "/"),
        url: "",
        constructor: function constructor(options) {
            var error = Error.call(this, options.message);
            _.extend(this, _.pick(error, errorProps), _.pick(options, errorProps));
            if (Error.captureStackTrace) this.captureStackTrace();
            this.url = this.urlRoot + this.url;
        },
        captureStackTrace: function captureStackTrace() {
            Error.captureStackTrace(this, MarionetteError);
        },
        toString: function toString() {
            return "".concat(this.name, ": ").concat(this.message, " See: ").concat(this.url);
        }
    });
    // Bind Entity Events & Unbind Entity Events
    function normalizeBindings(context, bindings) {
        if (!_.isObject(bindings)) throw new MarionetteError({
            message: "Bindings must be an object.",
            url: "common.html#bindevents"
        });
        return normalizeMethods.call(context, bindings);
    }
    function bindEvents(entity, bindings) {
        if (!entity || !bindings) return this;
        this.listenTo(entity, normalizeBindings(this, bindings));
        return this;
    }
    function unbindEvents(entity, bindings) {
        if (!entity) return this;
        if (!bindings) {
            this.stopListening(entity);
            return this;
        }
        this.stopListening(entity, normalizeBindings(this, bindings));
        return this;
    } // Export Public API
    // Bind/Unbind Radio Requests
    function normalizeBindings$1(context, bindings) {
        if (!_.isObject(bindings)) throw new MarionetteError({
            message: "Bindings must be an object.",
            url: "common.html#bindrequests"
        });
        return normalizeMethods.call(context, bindings);
    }
    function bindRequests(channel, bindings) {
        if (!channel || !bindings) return this;
        channel.reply(normalizeBindings$1(this, bindings), this);
        return this;
    }
    function unbindRequests(channel, bindings) {
        if (!channel) return this;
        if (!bindings) {
            channel.stopReplying(null, null, this);
            return this;
        }
        channel.stopReplying(normalizeBindings$1(this, bindings), this);
        return this;
    }
    // Marionette.getOption
    // --------------------
    // Retrieve an object, function or other value from the
    // object or its `options`, with `options` taking precedence.
    var getOption = function getOption(optionName) {
        if (!optionName) return;
        if (this.options && this.options[optionName] !== undefined) return this.options[optionName];
        else return this[optionName];
    };
    var mergeOptions = function mergeOptions(options, keys) {
        var _this = this;
        if (!options) return;
        _.each(keys, function(key) {
            var option = options[key];
            if (option !== undefined) _this[key] = option;
        });
    };
    // DOM Refresh
    function triggerMethodChildren(view, event, shouldTrigger) {
        if (!view._getImmediateChildren) return;
        _.each(view._getImmediateChildren(), function(child) {
            if (!shouldTrigger(child)) return;
            child.triggerMethod(event, child);
        });
    }
    function shouldTriggerAttach(view) {
        return !view._isAttached;
    }
    function shouldAttach(view) {
        if (!shouldTriggerAttach(view)) return false;
        view._isAttached = true;
        return true;
    }
    function shouldTriggerDetach(view) {
        return view._isAttached;
    }
    function shouldDetach(view) {
        view._isAttached = false;
        return true;
    }
    function triggerDOMRefresh(view) {
        if (view._isAttached && view._isRendered) view.triggerMethod("dom:refresh", view);
    }
    function triggerDOMRemove(view) {
        if (view._isAttached && view._isRendered) view.triggerMethod("dom:remove", view);
    }
    function handleBeforeAttach() {
        triggerMethodChildren(this, "before:attach", shouldTriggerAttach);
    }
    function handleAttach() {
        triggerMethodChildren(this, "attach", shouldAttach);
        triggerDOMRefresh(this);
    }
    function handleBeforeDetach() {
        triggerMethodChildren(this, "before:detach", shouldTriggerDetach);
        triggerDOMRemove(this);
    }
    function handleDetach() {
        triggerMethodChildren(this, "detach", shouldDetach);
    }
    function handleBeforeRender() {
        triggerDOMRemove(this);
    }
    function handleRender() {
        triggerDOMRefresh(this);
    } // Monitor a view's state, propagating attach/detach events to children and firing dom:refresh
    // whenever a rendered view is attached or an attached view is rendered.
    function monitorViewEvents(view) {
        if (view._areViewEventsMonitored || view.monitorViewEvents === false) return;
        view._areViewEventsMonitored = true;
        view.on({
            "before:attach": handleBeforeAttach,
            "attach": handleAttach,
            "before:detach": handleBeforeDetach,
            "detach": handleDetach,
            "before:render": handleBeforeRender,
            "render": handleRender
        });
    }
    // Trigger Method
    var splitter = /(^|:)(\w)/gi; // Only calc getOnMethodName once
    var methodCache = {}; // take the event section ("section1:section2:section3")
    // and turn it in to uppercase name onSection1Section2Section3
    function getEventName(match, prefix, eventName) {
        return eventName.toUpperCase();
    }
    var getOnMethodName = function getOnMethodName(event) {
        if (!methodCache[event]) methodCache[event] = "on" + event.replace(splitter, getEventName);
        return methodCache[event];
    }; // Trigger an event and/or a corresponding method name. Examples:
    //
    // `this.triggerMethod("foo")` will trigger the "foo" event and
    // call the "onFoo" method.
    //
    // `this.triggerMethod("foo:bar")` will trigger the "foo:bar" event and
    // call the "onFooBar" method.
    function triggerMethod(event) {
        // get the method name from the event name
        var methodName = getOnMethodName(event);
        var method = getOption.call(this, methodName);
        var result; // call the onMethodName if it exists
        if (_.isFunction(method)) // pass all args, except the event name
        result = method.apply(this, _.drop(arguments));
         // trigger the event
        this.trigger.apply(this, arguments);
        return result;
    }
    var Events = {
        triggerMethod: triggerMethod
    };
    var CommonMixin = {
        // Imports the "normalizeMethods" to transform hashes of
        // events=>function references/names to a hash of events=>function references
        normalizeMethods: normalizeMethods,
        _setOptions: function _setOptions(options, classOptions) {
            this.options = _.extend({}, _.result(this, "options"), options);
            this.mergeOptions(options, classOptions);
        },
        // A handy way to merge passed-in options onto the instance
        mergeOptions: mergeOptions,
        // Enable getting options from this or this.options by name.
        getOption: getOption,
        // Enable binding view's events from another entity.
        bindEvents: bindEvents,
        // Enable unbinding view's events from another entity.
        unbindEvents: unbindEvents,
        // Enable binding view's requests.
        bindRequests: bindRequests,
        // Enable unbinding view's requests.
        unbindRequests: unbindRequests,
        triggerMethod: triggerMethod
    };
    _.extend(CommonMixin, Backbone.Events);
    var DestroyMixin = {
        _isDestroyed: false,
        isDestroyed: function isDestroyed() {
            return this._isDestroyed;
        },
        destroy: function destroy(options) {
            if (this._isDestroyed) return this;
            this.triggerMethod("before:destroy", this, options);
            this._isDestroyed = true;
            this.triggerMethod("destroy", this, options);
            this.stopListening();
            return this;
        }
    };
    // - channelName
    // - radioEvents
    // - radioRequests
    var RadioMixin = {
        _initRadio: function _initRadio() {
            var channelName = _.result(this, "channelName");
            if (!channelName) return;
            /* istanbul ignore next */ if (!Radio) throw new MarionetteError({
                message: 'The dependency "backbone.radio" is missing.',
                url: "backbone.radio.html#marionette-integration"
            });
            var channel = this._channel = Radio.channel(channelName);
            var radioEvents = _.result(this, "radioEvents");
            this.bindEvents(channel, radioEvents);
            var radioRequests = _.result(this, "radioRequests");
            this.bindRequests(channel, radioRequests);
            this.on("destroy", this._destroyRadio);
        },
        _destroyRadio: function _destroyRadio() {
            this._channel.stopReplying(null, null, this);
        },
        getChannel: function getChannel() {
            return this._channel;
        }
    };
    // Object
    var ClassOptions = [
        "channelName",
        "radioEvents",
        "radioRequests"
    ]; // Object borrows many conventions and utilities from Backbone.
    var MarionetteObject = function MarionetteObject(options) {
        this._setOptions(options, ClassOptions);
        this.cid = _.uniqueId(this.cidPrefix);
        this._initRadio();
        this.initialize.apply(this, arguments);
    };
    MarionetteObject.extend = extend; // Object Methods
    // --------------
    _.extend(MarionetteObject.prototype, CommonMixin, DestroyMixin, RadioMixin, {
        cidPrefix: "mno",
        // This is a noop method intended to be overridden
        initialize: function initialize() {}
    });
    // Implementation of the invoke method (http://underscorejs.org/#invoke) with support for
    var _invoke = _.invokeMap || _.invoke;
    // - behaviors
    // Takes care of getting the behavior class
    // given options and a key.
    // If a user passes in options.behaviorClass
    // default to using that.
    // If a user passes in a Behavior Class directly, use that
    // Otherwise an error is thrown
    function getBehaviorClass(options) {
        if (options.behaviorClass) return {
            BehaviorClass: options.behaviorClass,
            options: options
        };
         //treat functions as a Behavior constructor
        if (_.isFunction(options)) return {
            BehaviorClass: options,
            options: {}
        };
        throw new MarionetteError({
            message: "Unable to get behavior class. A Behavior constructor should be passed directly or as behaviorClass property of options",
            url: "marionette.behavior.html#defining-and-attaching-behaviors"
        });
    } // Iterate over the behaviors object, for each behavior
    // instantiate it and get its grouped behaviors.
    // This accepts a list of behaviors in either an object or array form
    function parseBehaviors(view, behaviors, allBehaviors) {
        return _.reduce(behaviors, function(reducedBehaviors, behaviorDefiniton) {
            var _getBehaviorClass = getBehaviorClass(behaviorDefiniton), BehaviorClass = _getBehaviorClass.BehaviorClass, options = _getBehaviorClass.options;
            var behavior = new BehaviorClass(options, view);
            reducedBehaviors.push(behavior);
            return parseBehaviors(view, _.result(behavior, "behaviors"), reducedBehaviors);
        }, allBehaviors);
    }
    var BehaviorsMixin = {
        _initBehaviors: function _initBehaviors() {
            this._behaviors = parseBehaviors(this, _.result(this, "behaviors"), []);
        },
        _getBehaviorTriggers: function _getBehaviorTriggers() {
            var triggers = _invoke(this._behaviors, "_getTriggers");
            return _.reduce(triggers, function(memo, _triggers) {
                return _.extend(memo, _triggers);
            }, {});
        },
        _getBehaviorEvents: function _getBehaviorEvents() {
            var events = _invoke(this._behaviors, "_getEvents");
            return _.reduce(events, function(memo, _events) {
                return _.extend(memo, _events);
            }, {});
        },
        // proxy behavior $el to the view's $el.
        _proxyBehaviorViewProperties: function _proxyBehaviorViewProperties() {
            _invoke(this._behaviors, "proxyViewProperties");
        },
        // delegate modelEvents and collectionEvents
        _delegateBehaviorEntityEvents: function _delegateBehaviorEntityEvents() {
            _invoke(this._behaviors, "delegateEntityEvents");
        },
        // undelegate modelEvents and collectionEvents
        _undelegateBehaviorEntityEvents: function _undelegateBehaviorEntityEvents() {
            _invoke(this._behaviors, "undelegateEntityEvents");
        },
        _destroyBehaviors: function _destroyBehaviors(options) {
            // Call destroy on each behavior after
            // destroying the view.
            // This unbinds event listeners
            // that behaviors have registered for.
            _invoke(this._behaviors, "destroy", options);
        },
        // Remove a behavior
        _removeBehavior: function _removeBehavior(behavior) {
            // Don't worry about the clean up if the view is destroyed
            if (this._isDestroyed) return;
             // Remove behavior-only triggers and events
            this.undelegate(".trig".concat(behavior.cid, " .").concat(behavior.cid));
            this._behaviors = _.without(this._behaviors, behavior);
        },
        _bindBehaviorUIElements: function _bindBehaviorUIElements() {
            _invoke(this._behaviors, "bindUIElements");
        },
        _unbindBehaviorUIElements: function _unbindBehaviorUIElements() {
            _invoke(this._behaviors, "unbindUIElements");
        },
        _triggerEventOnBehaviors: function _triggerEventOnBehaviors(eventName, view, options) {
            _invoke(this._behaviors, "triggerMethod", eventName, view, options);
        }
    };
    // - collectionEvents
    // - modelEvents
    var DelegateEntityEventsMixin = {
        // Handle `modelEvents`, and `collectionEvents` configuration
        _delegateEntityEvents: function _delegateEntityEvents(model, collection) {
            if (model) {
                this._modelEvents = _.result(this, "modelEvents");
                this.bindEvents(model, this._modelEvents);
            }
            if (collection) {
                this._collectionEvents = _.result(this, "collectionEvents");
                this.bindEvents(collection, this._collectionEvents);
            }
        },
        // Remove any previously delegate entity events
        _undelegateEntityEvents: function _undelegateEntityEvents(model, collection) {
            if (this._modelEvents) {
                this.unbindEvents(model, this._modelEvents);
                delete this._modelEvents;
            }
            if (this._collectionEvents) {
                this.unbindEvents(collection, this._collectionEvents);
                delete this._collectionEvents;
            }
        },
        // Remove cached event handlers
        _deleteEntityEventHandlers: function _deleteEntityEventHandlers() {
            delete this._modelEvents;
            delete this._collectionEvents;
        }
    };
    // - template
    // - templateContext
    var TemplateRenderMixin = {
        // Internal method to render the template with the serialized data
        // and template context
        _renderTemplate: function _renderTemplate(template) {
            // Add in entity data and template context
            var data = this.mixinTemplateContext(this.serializeData()) || {}; // Render and add to el
            var html = this._renderHtml(template, data);
            if (typeof html !== "undefined") this.attachElContent(html);
        },
        // Get the template for this view instance.
        // You can set a `template` attribute in the view definition
        // or pass a `template: TemplateFunction` parameter in
        // to the constructor options.
        getTemplate: function getTemplate() {
            return this.template;
        },
        // Mix in template context methods. Looks for a
        // `templateContext` attribute, which can either be an
        // object literal, or a function that returns an object
        // literal. All methods and attributes from this object
        // are copies to the object passed in.
        mixinTemplateContext: function mixinTemplateContext(serializedData) {
            var templateContext = _.result(this, "templateContext");
            if (!templateContext) return serializedData;
            if (!serializedData) return templateContext;
            return _.extend({}, serializedData, templateContext);
        },
        // Serialize the view's model *or* collection, if
        // it exists, for the template
        serializeData: function serializeData() {
            // If we have a model, we serialize that
            if (this.model) return this.serializeModel();
             // Otherwise, we serialize the collection,
            // making it available under the `items` property
            if (this.collection) return {
                items: this.serializeCollection()
            };
        },
        // Prepares the special `model` property of a view
        // for being displayed in the template. Override this if
        // you need a custom transformation for your view's model
        serializeModel: function serializeModel() {
            return this.model.attributes;
        },
        // Serialize a collection
        serializeCollection: function serializeCollection() {
            return _.map(this.collection.models, function(model) {
                return model.attributes;
            });
        },
        // Renders the data into the template
        _renderHtml: function _renderHtml(template, data) {
            return template(data);
        },
        // Attaches the content of a given view.
        // This method can be overridden to optimize rendering,
        // or to render in a non standard way.
        //
        // For example, using `innerHTML` instead of `$el.html`
        //
        // ```js
        // attachElContent(html) {
        //   this.el.innerHTML = html;
        // }
        // ```
        attachElContent: function attachElContent(html) {
            this.Dom.setContents(this.el, html, this.$el);
        }
    };
    // Borrow event splitter from Backbone
    var delegateEventSplitter = /^(\S+)\s*(.*)$/; // Set event name to be namespaced using a unique index
    // to generate a non colliding event namespace
    // http://api.jquery.com/event.namespace/
    var getNamespacedEventName = function getNamespacedEventName(eventName, namespace) {
        var match = eventName.match(delegateEventSplitter);
        return "".concat(match[1], ".").concat(namespace, " ").concat(match[2]);
    };
    // Add Feature flags here
    // e.g. 'class' => false
    var FEATURES = {
        childViewEventPrefix: false,
        triggersStopPropagation: true,
        triggersPreventDefault: true,
        DEV_MODE: false
    };
    function isEnabled(name) {
        return !!FEATURES[name];
    }
    function setEnabled(name, state) {
        return FEATURES[name] = state;
    }
    // 'click:foo'
    function buildViewTrigger(view, triggerDef) {
        if (_.isString(triggerDef)) triggerDef = {
            event: triggerDef
        };
        var eventName = triggerDef.event;
        var shouldPreventDefault = !!triggerDef.preventDefault;
        if (isEnabled("triggersPreventDefault")) shouldPreventDefault = triggerDef.preventDefault !== false;
        var shouldStopPropagation = !!triggerDef.stopPropagation;
        if (isEnabled("triggersStopPropagation")) shouldStopPropagation = triggerDef.stopPropagation !== false;
        return function(event) {
            if (shouldPreventDefault) event.preventDefault();
            if (shouldStopPropagation) event.stopPropagation();
            for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
            view.triggerMethod.apply(view, [
                eventName,
                view,
                event
            ].concat(args));
        };
    }
    var TriggersMixin = {
        // Configure `triggers` to forward DOM events to view
        // events. `triggers: {"click .foo": "do:foo"}`
        _getViewTriggers: function _getViewTriggers(view, triggers) {
            var _this = this;
            // Configure the triggers, prevent default
            // action and stop propagation of DOM events
            return _.reduce(triggers, function(events, value, key) {
                key = getNamespacedEventName(key, "trig".concat(_this.cid));
                events[key] = buildViewTrigger(view, value);
                return events;
            }, {});
        }
    };
    // a given key for triggers and events
    // swaps the @ui with the associated selector.
    // Returns a new, non-mutated, parsed events hash.
    var _normalizeUIKeys = function normalizeUIKeys(hash, ui) {
        return _.reduce(hash, function(memo, val, key) {
            var normalizedKey = _normalizeUIString(key, ui);
            memo[normalizedKey] = val;
            return memo;
        }, {});
    };
    var uiRegEx = /@ui\.[a-zA-Z-_$0-9]*/g; // utility method for parsing @ui. syntax strings
    // into associated selector
    var _normalizeUIString = function normalizeUIString(uiString, ui) {
        return uiString.replace(uiRegEx, function(r) {
            return ui[r.slice(4)];
        });
    }; // allows for the use of the @ui. syntax within
    // a given value for regions
    // swaps the @ui with the associated selector
    var _normalizeUIValues = function normalizeUIValues(hash, ui, property) {
        _.each(hash, function(val, key) {
            if (_.isString(val)) hash[key] = _normalizeUIString(val, ui);
            else if (val) {
                var propertyVal = val[property];
                if (_.isString(propertyVal)) val[property] = _normalizeUIString(propertyVal, ui);
            }
        });
        return hash;
    };
    var UIMixin = {
        // normalize the keys of passed hash with the views `ui` selectors.
        // `{"@ui.foo": "bar"}`
        normalizeUIKeys: function normalizeUIKeys(hash) {
            var uiBindings = this._getUIBindings();
            return _normalizeUIKeys(hash, uiBindings);
        },
        // normalize the passed string with the views `ui` selectors.
        // `"@ui.bar"`
        normalizeUIString: function normalizeUIString(uiString) {
            var uiBindings = this._getUIBindings();
            return _normalizeUIString(uiString, uiBindings);
        },
        // normalize the values of passed hash with the views `ui` selectors.
        // `{foo: "@ui.bar"}`
        normalizeUIValues: function normalizeUIValues(hash, property) {
            var uiBindings = this._getUIBindings();
            return _normalizeUIValues(hash, uiBindings, property);
        },
        _getUIBindings: function _getUIBindings() {
            var uiBindings = _.result(this, "_uiBindings");
            return uiBindings || _.result(this, "ui");
        },
        // This method binds the elements specified in the "ui" hash inside the view's code with
        // the associated jQuery selectors.
        _bindUIElements: function _bindUIElements() {
            var _this = this;
            if (!this.ui) return;
             // store the ui hash in _uiBindings so they can be reset later
            // and so re-rendering the view will be able to find the bindings
            if (!this._uiBindings) this._uiBindings = this.ui;
             // get the bindings result, as a function or otherwise
            var bindings = _.result(this, "_uiBindings"); // empty the ui so we don't have anything to start with
            this._ui = {}; // bind each of the selectors
            _.each(bindings, function(selector, key) {
                _this._ui[key] = _this.$(selector);
            });
            this.ui = this._ui;
        },
        _unbindUIElements: function _unbindUIElements() {
            var _this2 = this;
            if (!this.ui || !this._uiBindings) return;
             // delete all of the existing ui bindings
            _.each(this.ui, function($el, name) {
                delete _this2.ui[name];
            }); // reset the ui element to the original bindings configuration
            this.ui = this._uiBindings;
            delete this._uiBindings;
            delete this._ui;
        },
        _getUI: function _getUI(name) {
            return this._ui[name];
        }
    };
    // DomApi
    function _getEl(el) {
        return el instanceof Backbone.$ ? el : Backbone.$(el);
    } // Static setter
    function setDomApi(mixin) {
        this.prototype.Dom = _.extend({}, this.prototype.Dom, mixin);
        return this;
    }
    var DomApi = {
        // Returns a new HTML DOM node instance
        createBuffer: function createBuffer() {
            return document.createDocumentFragment();
        },
        // Returns the document element for a given DOM element
        getDocumentEl: function getDocumentEl(el) {
            return el.ownerDocument.documentElement;
        },
        // Lookup the `selector` string
        // Selector may also be a DOM element
        // Returns an array-like object of nodes
        getEl: function getEl(selector) {
            return _getEl(selector);
        },
        // Finds the `selector` string with the el
        // Returns an array-like object of nodes
        findEl: function findEl(el, selector) {
            return _getEl(el).find(selector);
        },
        // Returns true if the el contains the node childEl
        hasEl: function hasEl(el, childEl) {
            return el.contains(childEl && childEl.parentNode);
        },
        // Detach `el` from the DOM without removing listeners
        detachEl: function detachEl(el) {
            var _$el = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _getEl(el);
            _$el.detach();
        },
        // Remove `oldEl` from the DOM and put `newEl` in its place
        replaceEl: function replaceEl(newEl, oldEl) {
            if (newEl === oldEl) return;
            var parent = oldEl.parentNode;
            if (!parent) return;
            parent.replaceChild(newEl, oldEl);
        },
        // Swaps the location of `el1` and `el2` in the DOM
        swapEl: function swapEl(el1, el2) {
            if (el1 === el2) return;
            var parent1 = el1.parentNode;
            var parent2 = el2.parentNode;
            if (!parent1 || !parent2) return;
            var next1 = el1.nextSibling;
            var next2 = el2.nextSibling;
            parent1.insertBefore(el2, next1);
            parent2.insertBefore(el1, next2);
        },
        // Replace the contents of `el` with the HTML string of `html`
        setContents: function setContents(el, html) {
            var _$el = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _getEl(el);
            _$el.html(html);
        },
        // Takes the DOM node `el` and appends the DOM node `contents`
        // to the end of the element's contents.
        appendContents: function appendContents(el, contents) {
            var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {}, _ref$_$el = _ref._$el, _$el = _ref$_$el === void 0 ? _getEl(el) : _ref$_$el, _ref$_$contents = _ref._$contents, _$contents = _ref$_$contents === void 0 ? _getEl(contents) : _ref$_$contents;
            _$el.append(_$contents);
        },
        // Does the el have child nodes
        hasContents: function hasContents(el) {
            return !!el && el.hasChildNodes();
        },
        // Remove the inner contents of `el` from the DOM while leaving
        // `el` itself in the DOM.
        detachContents: function detachContents(el) {
            var _$el = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _getEl(el);
            _$el.contents().detach();
        }
    };
    // ViewMixin
    // - behaviors
    // - childViewEventPrefix
    // - childViewEvents
    // - childViewTriggers
    // - collectionEvents
    // - modelEvents
    // - triggers
    // - ui
    var ViewMixin = {
        Dom: DomApi,
        _isElAttached: function _isElAttached() {
            return !!this.el && this.Dom.hasEl(this.Dom.getDocumentEl(this.el), this.el);
        },
        supportsRenderLifecycle: true,
        supportsDestroyLifecycle: true,
        _isDestroyed: false,
        isDestroyed: function isDestroyed() {
            return !!this._isDestroyed;
        },
        _isRendered: false,
        isRendered: function isRendered() {
            return !!this._isRendered;
        },
        _isAttached: false,
        isAttached: function isAttached() {
            return !!this._isAttached;
        },
        // Overriding Backbone.View's `delegateEvents` to handle
        // `events` and `triggers`
        delegateEvents: function delegateEvents(events) {
            this._proxyBehaviorViewProperties();
            this._buildEventProxies();
            var combinedEvents = _.extend({}, this._getBehaviorEvents(), this._getEvents(events), this._getBehaviorTriggers(), this._getTriggers());
            Backbone.View.prototype.delegateEvents.call(this, combinedEvents);
            return this;
        },
        // Allows Backbone.View events to utilize `@ui.` selectors
        _getEvents: function _getEvents(events) {
            if (events) return this.normalizeUIKeys(events);
            if (!this.events) return;
            return this.normalizeUIKeys(_.result(this, "events"));
        },
        // Configure `triggers` to forward DOM events to view
        // events. `triggers: {"click .foo": "do:foo"}`
        _getTriggers: function _getTriggers() {
            if (!this.triggers) return;
             // Allow `triggers` to be configured as a function
            var triggers = this.normalizeUIKeys(_.result(this, "triggers")); // Configure the triggers, prevent default
            // action and stop propagation of DOM events
            return this._getViewTriggers(this, triggers);
        },
        // Handle `modelEvents`, and `collectionEvents` configuration
        delegateEntityEvents: function delegateEntityEvents() {
            this._delegateEntityEvents(this.model, this.collection); // bind each behaviors model and collection events
            this._delegateBehaviorEntityEvents();
            return this;
        },
        // Handle unbinding `modelEvents`, and `collectionEvents` configuration
        undelegateEntityEvents: function undelegateEntityEvents() {
            this._undelegateEntityEvents(this.model, this.collection); // unbind each behaviors model and collection events
            this._undelegateBehaviorEntityEvents();
            return this;
        },
        // Handle destroying the view and its children.
        destroy: function destroy(options) {
            if (this._isDestroyed || this._isDestroying) return this;
            this._isDestroying = true;
            var shouldTriggerDetach = this._isAttached && !this._disableDetachEvents;
            this.triggerMethod("before:destroy", this, options);
            if (shouldTriggerDetach) this.triggerMethod("before:detach", this);
             // unbind UI elements
            this.unbindUIElements(); // remove the view from the DOM
            this._removeElement();
            if (shouldTriggerDetach) {
                this._isAttached = false;
                this.triggerMethod("detach", this);
            } // remove children after the remove to prevent extra paints
            this._removeChildren();
            this._isDestroyed = true;
            this._isRendered = false; // Destroy behaviors after _isDestroyed flag
            this._destroyBehaviors(options);
            this._deleteEntityEventHandlers();
            this.triggerMethod("destroy", this, options);
            this._triggerEventOnBehaviors("destroy", this, options);
            this.stopListening();
            return this;
        },
        // Equates to this.$el.remove
        _removeElement: function _removeElement() {
            this.$el.off().removeData();
            this.Dom.detachEl(this.el, this.$el);
        },
        // This method binds the elements specified in the "ui" hash
        bindUIElements: function bindUIElements() {
            this._bindUIElements();
            this._bindBehaviorUIElements();
            return this;
        },
        // This method unbinds the elements specified in the "ui" hash
        unbindUIElements: function unbindUIElements() {
            this._unbindUIElements();
            this._unbindBehaviorUIElements();
            return this;
        },
        getUI: function getUI(name) {
            return this._getUI(name);
        },
        // Cache `childViewEvents` and `childViewTriggers`
        _buildEventProxies: function _buildEventProxies() {
            this._childViewEvents = this.normalizeMethods(_.result(this, "childViewEvents"));
            this._childViewTriggers = _.result(this, "childViewTriggers");
            this._eventPrefix = this._getEventPrefix();
        },
        _getEventPrefix: function _getEventPrefix() {
            var defaultPrefix = isEnabled("childViewEventPrefix") ? "childview" : false;
            var prefix = _.result(this, "childViewEventPrefix", defaultPrefix);
            return prefix === false ? prefix : prefix + ":";
        },
        _proxyChildViewEvents: function _proxyChildViewEvents(view) {
            if (this._childViewEvents || this._childViewTriggers || this._eventPrefix) this.listenTo(view, "all", this._childViewEventHandler);
        },
        _childViewEventHandler: function _childViewEventHandler(eventName) {
            var childViewEvents = this._childViewEvents; // call collectionView childViewEvent if defined
            for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
            if (childViewEvents && childViewEvents[eventName]) childViewEvents[eventName].apply(this, args);
             // use the parent view's proxyEvent handlers
            var childViewTriggers = this._childViewTriggers; // Call the event with the proxy name on the parent layout
            if (childViewTriggers && childViewTriggers[eventName]) this.triggerMethod.apply(this, [
                childViewTriggers[eventName]
            ].concat(args));
            if (this._eventPrefix) this.triggerMethod.apply(this, [
                this._eventPrefix + eventName
            ].concat(args));
        }
    };
    _.extend(ViewMixin, BehaviorsMixin, CommonMixin, DelegateEntityEventsMixin, TemplateRenderMixin, TriggersMixin, UIMixin);
    function renderView(view) {
        if (view._isRendered) return;
        if (!view.supportsRenderLifecycle) view.triggerMethod("before:render", view);
        view.render();
        view._isRendered = true;
        if (!view.supportsRenderLifecycle) view.triggerMethod("render", view);
    }
    function destroyView(view, disableDetachEvents) {
        if (view.destroy) {
            // Attach flag for public destroy function internal check
            view._disableDetachEvents = disableDetachEvents;
            view.destroy();
            return;
        } // Destroy for non-Marionette Views
        if (!view.supportsDestroyLifecycle) view.triggerMethod("before:destroy", view);
        var shouldTriggerDetach = view._isAttached && !disableDetachEvents;
        if (shouldTriggerDetach) view.triggerMethod("before:detach", view);
        view.remove();
        if (shouldTriggerDetach) {
            view._isAttached = false;
            view.triggerMethod("detach", view);
        }
        view._isDestroyed = true;
        if (!view.supportsDestroyLifecycle) view.triggerMethod("destroy", view);
    }
    // Region
    var classErrorName = "RegionError";
    var ClassOptions$1 = [
        "allowMissingEl",
        "parentEl",
        "replaceElement"
    ];
    var Region = function Region(options) {
        this._setOptions(options, ClassOptions$1);
        this.cid = _.uniqueId(this.cidPrefix); // getOption necessary because options.el may be passed as undefined
        this._initEl = this.el = this.getOption("el"); // Handle when this.el is passed in as a $ wrapped element.
        this.el = this.el instanceof Backbone.$ ? this.el[0] : this.el;
        this.$el = this._getEl(this.el);
        this.initialize.apply(this, arguments);
    };
    Region.extend = extend;
    Region.setDomApi = setDomApi; // Region Methods
    // --------------
    _.extend(Region.prototype, CommonMixin, {
        Dom: DomApi,
        cidPrefix: "mnr",
        replaceElement: false,
        _isReplaced: false,
        _isSwappingView: false,
        // This is a noop method intended to be overridden
        initialize: function initialize() {},
        // Displays a view instance inside of the region. If necessary handles calling the `render`
        // method for you. Reads content directly from the `el` attribute.
        show: function show(view, options) {
            if (!this._ensureElement(options)) return;
            view = this._getView(view, options);
            if (view === this.currentView) return this;
            if (view._isShown) throw new MarionetteError({
                name: classErrorName,
                message: "View is already shown in a Region or CollectionView",
                url: "marionette.region.html#showing-a-view"
            });
            this._isSwappingView = !!this.currentView;
            this.triggerMethod("before:show", this, view, options); // Assume an attached view is already in the region for pre-existing DOM
            if (this.currentView || !view._isAttached) this.empty(options);
            this._setupChildView(view);
            this.currentView = view;
            renderView(view);
            this._attachView(view, options);
            this.triggerMethod("show", this, view, options);
            this._isSwappingView = false;
            return this;
        },
        _getEl: function _getEl(el) {
            if (!el) throw new MarionetteError({
                name: classErrorName,
                message: 'An "el" must be specified for a region.',
                url: "marionette.region.html#additional-options"
            });
            return this.getEl(el);
        },
        _setEl: function _setEl() {
            this.$el = this._getEl(this.el);
            if (this.$el.length) this.el = this.$el[0];
             // Make sure the $el contains only the el
            if (this.$el.length > 1) this.$el = this.Dom.getEl(this.el);
        },
        // Set the `el` of the region and move any current view to the new `el`.
        _setElement: function _setElement(el) {
            if (el === this.el) return this;
            var shouldReplace = this._isReplaced;
            this._restoreEl();
            this.el = el;
            this._setEl();
            if (this.currentView) {
                var view = this.currentView;
                if (shouldReplace) this._replaceEl(view);
                else this.attachHtml(view);
            }
            return this;
        },
        _setupChildView: function _setupChildView(view) {
            monitorViewEvents(view);
            this._proxyChildViewEvents(view); // We need to listen for if a view is destroyed in a way other than through the region.
            // If this happens we need to remove the reference to the currentView since once a view
            // has been destroyed we can not reuse it.
            view.on("destroy", this._empty, this);
        },
        _proxyChildViewEvents: function _proxyChildViewEvents(view) {
            var parentView = this._parentView;
            if (!parentView) return;
            parentView._proxyChildViewEvents(view);
        },
        // If the regions parent view is not monitoring its attach/detach events
        _shouldDisableMonitoring: function _shouldDisableMonitoring() {
            return this._parentView && this._parentView.monitorViewEvents === false;
        },
        _isElAttached: function _isElAttached() {
            return this.Dom.hasEl(this.Dom.getDocumentEl(this.el), this.el);
        },
        _attachView: function _attachView(view) {
            var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {}, replaceElement = _ref.replaceElement;
            var shouldTriggerAttach = !view._isAttached && this._isElAttached() && !this._shouldDisableMonitoring();
            var shouldReplaceEl = typeof replaceElement === "undefined" ? !!_.result(this, "replaceElement") : !!replaceElement;
            if (shouldTriggerAttach) view.triggerMethod("before:attach", view);
            if (shouldReplaceEl) this._replaceEl(view);
            else this.attachHtml(view);
            if (shouldTriggerAttach) {
                view._isAttached = true;
                view.triggerMethod("attach", view);
            } // Corresponds that view is shown in a marionette Region or CollectionView
            view._isShown = true;
        },
        _ensureElement: function _ensureElement() {
            var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            if (!_.isObject(this.el)) this._setEl();
            if (!this.$el || this.$el.length === 0) {
                var allowMissingEl = typeof options.allowMissingEl === "undefined" ? !!_.result(this, "allowMissingEl") : !!options.allowMissingEl;
                if (allowMissingEl) return false;
                else throw new MarionetteError({
                    name: classErrorName,
                    message: 'An "el" must exist in DOM for this region '.concat(this.cid),
                    url: "marionette.region.html#additional-options"
                });
            }
            return true;
        },
        _getView: function _getView(view) {
            if (!view) throw new MarionetteError({
                name: classErrorName,
                message: "The view passed is undefined and therefore invalid. You must pass a view instance to show.",
                url: "marionette.region.html#showing-a-view"
            });
            if (view._isDestroyed) throw new MarionetteError({
                name: classErrorName,
                message: 'View (cid: "'.concat(view.cid, '") has already been destroyed and cannot be used.'),
                url: "marionette.region.html#showing-a-view"
            });
            if (view instanceof Backbone.View) return view;
            var viewOptions = this._getViewOptions(view);
            return new View(viewOptions);
        },
        // This allows for a template or a static string to be
        // used as a template
        _getViewOptions: function _getViewOptions(viewOptions) {
            if (_.isFunction(viewOptions)) return {
                template: viewOptions
            };
            if (_.isObject(viewOptions)) return viewOptions;
            var template = function template() {
                return viewOptions;
            };
            return {
                template: template
            };
        },
        // Override this method to change how the region finds the DOM element that it manages. Return
        // a jQuery selector object scoped to a provided parent el or the document if none exists.
        getEl: function getEl(el) {
            var context = _.result(this, "parentEl");
            if (context && _.isString(el)) return this.Dom.findEl(context, el);
            return this.Dom.getEl(el);
        },
        _replaceEl: function _replaceEl(view) {
            // Always restore the el to ensure the regions el is present before replacing
            this._restoreEl();
            view.on("before:destroy", this._restoreEl, this);
            this.Dom.replaceEl(view.el, this.el);
            this._isReplaced = true;
        },
        // Restore the region's element in the DOM.
        _restoreEl: function _restoreEl() {
            // There is nothing to replace
            if (!this._isReplaced) return;
            var view = this.currentView;
            if (!view) return;
            this._detachView(view);
            this._isReplaced = false;
        },
        // Check to see if the region's el was replaced.
        isReplaced: function isReplaced() {
            return !!this._isReplaced;
        },
        // Check to see if a view is being swapped by another
        isSwappingView: function isSwappingView() {
            return !!this._isSwappingView;
        },
        // Override this method to change how the new view is appended to the `$el` that the
        // region is managing
        attachHtml: function attachHtml(view) {
            this.Dom.appendContents(this.el, view.el, {
                _$el: this.$el,
                _$contents: view.$el
            });
        },
        // Destroy the current view, if there is one. If there is no current view,
        // it will detach any html inside the region's `el`.
        empty: function empty() {
            var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
                allowMissingEl: true
            };
            var view = this.currentView; // If there is no view in the region we should only detach current html
            if (!view) {
                if (this._ensureElement(options)) this.detachHtml();
                return this;
            }
            this._empty(view, true);
            return this;
        },
        _empty: function _empty(view, shouldDestroy) {
            view.off("destroy", this._empty, this);
            this.triggerMethod("before:empty", this, view);
            this._restoreEl();
            delete this.currentView;
            if (!view._isDestroyed) {
                if (shouldDestroy) this.removeView(view);
                else this._detachView(view);
                view._isShown = false;
                this._stopChildViewEvents(view);
            }
            this.triggerMethod("empty", this, view);
        },
        _stopChildViewEvents: function _stopChildViewEvents(view) {
            var parentView = this._parentView;
            if (!parentView) return;
            this._parentView.stopListening(view);
        },
        // Non-Marionette safe view.destroy
        destroyView: function destroyView$1(view) {
            if (view._isDestroyed) return view;
            destroyView(view, this._shouldDisableMonitoring());
            return view;
        },
        // Override this method to determine what happens when the view
        // is removed from the region when the view is not being detached
        removeView: function removeView(view) {
            this.destroyView(view);
        },
        // Empties the Region without destroying the view
        // Returns the detached view
        detachView: function detachView() {
            var view = this.currentView;
            if (!view) return;
            this._empty(view);
            return view;
        },
        _detachView: function _detachView(view) {
            var shouldTriggerDetach = view._isAttached && !this._shouldDisableMonitoring();
            var shouldRestoreEl = this._isReplaced;
            if (shouldTriggerDetach) view.triggerMethod("before:detach", view);
            if (shouldRestoreEl) this.Dom.replaceEl(this.el, view.el);
            else this.detachHtml();
            if (shouldTriggerDetach) {
                view._isAttached = false;
                view.triggerMethod("detach", view);
            }
        },
        // Override this method to change how the region detaches current content
        detachHtml: function detachHtml() {
            this.Dom.detachContents(this.el, this.$el);
        },
        // Checks whether a view is currently present within the region. Returns `true` if there is
        // and `false` if no view is present.
        hasView: function hasView() {
            return !!this.currentView;
        },
        // Reset the region by destroying any existing view and clearing out the cached `$el`.
        // The next time a view is shown via this region, the region will re-query the DOM for
        // the region's `el`.
        reset: function reset(options) {
            this.empty(options);
            this.el = this._initEl;
            delete this.$el;
            return this;
        },
        _isDestroyed: false,
        isDestroyed: function isDestroyed() {
            return this._isDestroyed;
        },
        // Destroy the region, remove any child view
        // and remove the region from any associated view
        destroy: function destroy(options) {
            if (this._isDestroyed) return this;
            this.triggerMethod("before:destroy", this, options);
            this._isDestroyed = true;
            this.reset(options);
            if (this._name) this._parentView._removeReferences(this._name);
            delete this._parentView;
            delete this._name;
            this.triggerMethod("destroy", this, options);
            this.stopListening();
            return this;
        }
    });
    function buildRegion(definition, defaults) {
        if (definition instanceof Region) return definition;
        if (_.isString(definition)) return buildRegionFromObject(defaults, {
            el: definition
        });
        if (_.isFunction(definition)) return buildRegionFromObject(defaults, {
            regionClass: definition
        });
        if (_.isObject(definition)) return buildRegionFromObject(defaults, definition);
        throw new MarionetteError({
            message: "Improper region configuration type.",
            url: "marionette.region.html#defining-regions"
        });
    }
    function buildRegionFromObject(defaults, definition) {
        var options = _.extend({}, defaults, definition);
        var RegionClass = options.regionClass;
        delete options.regionClass;
        return new RegionClass(options);
    }
    // - regions
    // - regionClass
    var RegionsMixin = {
        regionClass: Region,
        // Internal method to initialize the regions that have been defined in a
        // `regions` attribute on this View.
        _initRegions: function _initRegions() {
            // init regions hash
            this.regions = this.regions || {};
            this._regions = {};
            this.addRegions(_.result(this, "regions"));
        },
        // Internal method to re-initialize all of the regions by updating
        // the `el` that they point to
        _reInitRegions: function _reInitRegions() {
            _invoke(this._regions, "reset");
        },
        // Add a single region, by name, to the View
        addRegion: function addRegion(name, definition) {
            var regions = {};
            regions[name] = definition;
            return this.addRegions(regions)[name];
        },
        // Add multiple regions as a {name: definition, name2: def2} object literal
        addRegions: function addRegions(regions) {
            // If there's nothing to add, stop here.
            if (_.isEmpty(regions)) return;
             // Normalize region selectors hash to allow
            // a user to use the @ui. syntax.
            regions = this.normalizeUIValues(regions, "el"); // Add the regions definitions to the regions property
            this.regions = _.extend({}, this.regions, regions);
            return this._addRegions(regions);
        },
        // internal method to build and add regions
        _addRegions: function _addRegions(regionDefinitions) {
            var _this = this;
            var defaults = {
                regionClass: this.regionClass,
                parentEl: _.partial(_.result, this, "el")
            };
            return _.reduce(regionDefinitions, function(regions, definition, name) {
                regions[name] = buildRegion(definition, defaults);
                _this._addRegion(regions[name], name);
                return regions;
            }, {});
        },
        _addRegion: function _addRegion(region, name) {
            this.triggerMethod("before:add:region", this, name, region);
            region._parentView = this;
            region._name = name;
            this._regions[name] = region;
            this.triggerMethod("add:region", this, name, region);
        },
        // Remove a single region from the View, by name
        removeRegion: function removeRegion(name) {
            var region = this._regions[name];
            this._removeRegion(region, name);
            return region;
        },
        // Remove all regions from the View
        removeRegions: function removeRegions() {
            var regions = this._getRegions();
            _.each(this._regions, this._removeRegion.bind(this));
            return regions;
        },
        _removeRegion: function _removeRegion(region, name) {
            this.triggerMethod("before:remove:region", this, name, region);
            region.destroy();
            this.triggerMethod("remove:region", this, name, region);
        },
        // Called in a region's destroy
        _removeReferences: function _removeReferences(name) {
            delete this.regions[name];
            delete this._regions[name];
        },
        // Empty all regions in the region manager, but
        // leave them attached
        emptyRegions: function emptyRegions() {
            var regions = this.getRegions();
            _invoke(regions, "empty");
            return regions;
        },
        // Checks to see if view contains region
        // Accepts the region name
        // hasRegion('main')
        hasRegion: function hasRegion(name) {
            return !!this.getRegion(name);
        },
        // Provides access to regions
        // Accepts the region name
        // getRegion('main')
        getRegion: function getRegion(name) {
            if (!this._isRendered) this.render();
            return this._regions[name];
        },
        _getRegions: function _getRegions() {
            return _.clone(this._regions);
        },
        // Get all regions
        getRegions: function getRegions() {
            if (!this._isRendered) this.render();
            return this._getRegions();
        },
        showChildView: function showChildView(name, view, options) {
            var region = this.getRegion(name);
            region.show(view, options);
            return view;
        },
        detachChildView: function detachChildView(name) {
            return this.getRegion(name).detachView();
        },
        getChildView: function getChildView(name) {
            return this.getRegion(name).currentView;
        }
    };
    // Static setter for the renderer
    function setRenderer(renderer) {
        this.prototype._renderHtml = renderer;
        return this;
    }
    // View
    var ClassOptions$2 = [
        "behaviors",
        "childViewEventPrefix",
        "childViewEvents",
        "childViewTriggers",
        "collectionEvents",
        "events",
        "modelEvents",
        "regionClass",
        "regions",
        "template",
        "templateContext",
        "triggers",
        "ui"
    ]; // Used by _getImmediateChildren
    function childReducer(children, region) {
        if (region.currentView) children.push(region.currentView);
        return children;
    } // The standard view. Includes view events, automatic rendering
    // templates, nested views, and more.
    var View = Backbone.View.extend({
        constructor: function constructor(options) {
            this._setOptions(options, ClassOptions$2);
            monitorViewEvents(this);
            this._initBehaviors();
            this._initRegions();
            Backbone.View.prototype.constructor.apply(this, arguments);
            this.delegateEntityEvents();
            this._triggerEventOnBehaviors("initialize", this, options);
        },
        // Overriding Backbone.View's `setElement` to handle
        // if an el was previously defined. If so, the view might be
        // rendered or attached on setElement.
        setElement: function setElement() {
            Backbone.View.prototype.setElement.apply(this, arguments);
            this._isRendered = this.Dom.hasContents(this.el);
            this._isAttached = this._isElAttached();
            if (this._isRendered) this.bindUIElements();
            return this;
        },
        // If a template is available, renders it into the view's `el`
        // Re-inits regions and binds UI.
        render: function render() {
            var template = this.getTemplate();
            if (template === false || this._isDestroyed) return this;
            this.triggerMethod("before:render", this); // If this is not the first render call, then we need to
            // re-initialize the `el` for each region
            if (this._isRendered) this._reInitRegions();
            this._renderTemplate(template);
            this.bindUIElements();
            this._isRendered = true;
            this.triggerMethod("render", this);
            return this;
        },
        // called by ViewMixin destroy
        _removeChildren: function _removeChildren() {
            this.removeRegions();
        },
        _getImmediateChildren: function _getImmediateChildren() {
            return _.reduce(this._regions, childReducer, []);
        }
    }, {
        setRenderer: setRenderer,
        setDomApi: setDomApi
    });
    _.extend(View.prototype, ViewMixin, RegionsMixin);
    // shut down child views.
    var Container = function Container() {
        this._init();
    }; // Mix in methods from Underscore, for iteration, and other
    // collection related features.
    // Borrowing this code from Backbone.Collection:
    // https://github.com/jashkenas/backbone/blob/1.1.2/backbone.js#L962
    var methods = [
        "forEach",
        "each",
        "map",
        "find",
        "detect",
        "filter",
        "select",
        "reject",
        "every",
        "all",
        "some",
        "any",
        "include",
        "contains",
        "invoke",
        "toArray",
        "first",
        "initial",
        "rest",
        "last",
        "without",
        "isEmpty",
        "pluck",
        "reduce",
        "partition"
    ];
    _.each(methods, function(method) {
        Container.prototype[method] = function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            return _[method].apply(_, [
                this._views
            ].concat(args));
        };
    });
    function stringComparator(comparator, view) {
        return view.model && view.model.get(comparator);
    } // Container Methods
    // -----------------
    _.extend(Container.prototype, {
        // Initializes an empty container
        _init: function _init() {
            this._views = [];
            this._viewsByCid = {};
            this._indexByModel = {};
            this._updateLength();
        },
        // Add a view to this container. Stores the view
        // by `cid` and makes it searchable by the model
        // cid (and model itself). Additionally it stores
        // the view by index in the _views array
        _add: function _add(view) {
            var index = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this._views.length;
            this._addViewIndexes(view); // add to end by default
            this._views.splice(index, 0, view);
            this._updateLength();
        },
        _addViewIndexes: function _addViewIndexes(view) {
            // store the view
            this._viewsByCid[view.cid] = view; // index it by model
            if (view.model) this._indexByModel[view.model.cid] = view;
        },
        // Sort (mutate) and return the array of the child views.
        _sort: function _sort(comparator, context) {
            if (typeof comparator === "string") {
                comparator = _.partial(stringComparator, comparator);
                return this._sortBy(comparator);
            }
            if (comparator.length === 1) return this._sortBy(comparator.bind(context));
            return this._views.sort(comparator.bind(context));
        },
        // Makes `_.sortBy` mutate the array to match `this._views.sort`
        _sortBy: function _sortBy(comparator) {
            var sortedViews = _.sortBy(this._views, comparator);
            this._set(sortedViews);
            return sortedViews;
        },
        // Replace array contents without overwriting the reference.
        // Should not add/remove views
        _set: function _set(views, shouldReset) {
            this._views.length = 0;
            this._views.push.apply(this._views, views.slice(0));
            if (shouldReset) {
                this._viewsByCid = {};
                this._indexByModel = {};
                _.each(views, this._addViewIndexes.bind(this));
                this._updateLength();
            }
        },
        // Swap views by index
        _swap: function _swap(view1, view2) {
            var view1Index = this.findIndexByView(view1);
            var view2Index = this.findIndexByView(view2);
            if (view1Index === -1 || view2Index === -1) return;
            var swapView = this._views[view1Index];
            this._views[view1Index] = this._views[view2Index];
            this._views[view2Index] = swapView;
        },
        // Find a view by the model that was attached to it.
        // Uses the model's `cid` to find it.
        findByModel: function findByModel(model) {
            return this.findByModelCid(model.cid);
        },
        // Find a view by the `cid` of the model that was attached to it.
        findByModelCid: function findByModelCid(modelCid) {
            return this._indexByModel[modelCid];
        },
        // Find a view by index.
        findByIndex: function findByIndex(index) {
            return this._views[index];
        },
        // Find the index of a view instance
        findIndexByView: function findIndexByView(view) {
            return this._views.indexOf(view);
        },
        // Retrieve a view by its `cid` directly
        findByCid: function findByCid(cid) {
            return this._viewsByCid[cid];
        },
        hasView: function hasView(view) {
            return !!this.findByCid(view.cid);
        },
        // Remove a view and clean up index references.
        _remove: function _remove(view) {
            if (!this._viewsByCid[view.cid]) return;
             // delete model index
            if (view.model) delete this._indexByModel[view.model.cid];
             // remove the view from the container
            delete this._viewsByCid[view.cid];
            var index = this.findIndexByView(view);
            this._views.splice(index, 1);
            this._updateLength();
        },
        // Update the `.length` attribute on this container
        _updateLength: function _updateLength() {
            this.length = this._views.length;
        }
    });
    // Collection View
    var classErrorName$1 = "CollectionViewError";
    var ClassOptions$3 = [
        "behaviors",
        "childView",
        "childViewContainer",
        "childViewEventPrefix",
        "childViewEvents",
        "childViewOptions",
        "childViewTriggers",
        "collectionEvents",
        "emptyView",
        "emptyViewOptions",
        "events",
        "modelEvents",
        "sortWithCollection",
        "template",
        "templateContext",
        "triggers",
        "ui",
        "viewComparator",
        "viewFilter"
    ]; // A view that iterates over a Backbone.Collection
    // and renders an individual child view for each model.
    var CollectionView = Backbone.View.extend({
        // flag for maintaining the sorted order of the collection
        sortWithCollection: true,
        // constructor
        constructor: function constructor(options) {
            this._setOptions(options, ClassOptions$3);
            monitorViewEvents(this);
            this._initChildViewStorage();
            this._initBehaviors();
            Backbone.View.prototype.constructor.apply(this, arguments); // Init empty region
            this.getEmptyRegion();
            this.delegateEntityEvents();
            this._triggerEventOnBehaviors("initialize", this, options);
        },
        // Internal method to set up the `children` object for storing all of the child views
        // `_children` represents all child views
        // `children` represents only views filtered to be shown
        _initChildViewStorage: function _initChildViewStorage() {
            this._children = new Container();
            this.children = new Container();
        },
        // Create an region to show the emptyView
        getEmptyRegion: function getEmptyRegion() {
            var $emptyEl = this.$container || this.$el;
            if (this._emptyRegion && !this._emptyRegion.isDestroyed()) {
                this._emptyRegion._setElement($emptyEl[0]);
                return this._emptyRegion;
            }
            this._emptyRegion = new Region({
                el: $emptyEl[0],
                replaceElement: false
            });
            this._emptyRegion._parentView = this;
            return this._emptyRegion;
        },
        // Configured the initial events that the collection view binds to.
        _initialEvents: function _initialEvents() {
            if (this._isRendered) return;
            this.listenTo(this.collection, {
                "sort": this._onCollectionSort,
                "reset": this._onCollectionReset,
                "update": this._onCollectionUpdate
            });
        },
        // Internal method. This checks for any changes in the order of the collection.
        // If the index of any view doesn't match, it will re-sort.
        _onCollectionSort: function _onCollectionSort(collection, _ref) {
            var add = _ref.add, merge = _ref.merge, remove = _ref.remove;
            if (!this.sortWithCollection || this.viewComparator === false) return;
             // If the data is changing we will handle the sort later in `_onCollectionUpdate`
            if (add || remove || merge) return;
             // If the only thing happening here is sorting, sort.
            this.sort();
        },
        _onCollectionReset: function _onCollectionReset() {
            this._destroyChildren();
            this._addChildModels(this.collection.models);
            this.sort();
        },
        // Handle collection update model additions and  removals
        _onCollectionUpdate: function _onCollectionUpdate(collection, options) {
            var changes = options.changes; // Remove first since it'll be a shorter array lookup.
            var removedViews = changes.removed.length && this._removeChildModels(changes.removed);
            this._addedViews = changes.added.length && this._addChildModels(changes.added);
            this._detachChildren(removedViews);
            this.sort(); // Destroy removed child views after all of the render is complete
            this._removeChildViews(removedViews);
        },
        _removeChildModels: function _removeChildModels(models) {
            var _this = this;
            return _.reduce(models, function(views, model) {
                var removeView = _this._removeChildModel(model);
                if (removeView) views.push(removeView);
                return views;
            }, []);
        },
        _removeChildModel: function _removeChildModel(model) {
            var view = this._children.findByModel(model);
            if (view) this._removeChild(view);
            return view;
        },
        _removeChild: function _removeChild(view) {
            this.triggerMethod("before:remove:child", this, view);
            this.children._remove(view);
            this._children._remove(view);
            this.triggerMethod("remove:child", this, view);
        },
        // Added views are returned for consistency with _removeChildModels
        _addChildModels: function _addChildModels(models) {
            return _.map(models, this._addChildModel.bind(this));
        },
        _addChildModel: function _addChildModel(model) {
            var view = this._createChildView(model);
            this._addChild(view);
            return view;
        },
        _createChildView: function _createChildView(model) {
            var ChildView = this._getChildView(model);
            var childViewOptions = this._getChildViewOptions(model);
            var view = this.buildChildView(model, ChildView, childViewOptions);
            return view;
        },
        _addChild: function _addChild(view, index) {
            this.triggerMethod("before:add:child", this, view);
            this._setupChildView(view);
            this._children._add(view, index);
            this.children._add(view, index);
            this.triggerMethod("add:child", this, view);
        },
        // Retrieve the `childView` class
        // The `childView` property can be either a view class or a function that
        // returns a view class. If it is a function, it will receive the model that
        // will be passed to the view instance (created from the returned view class)
        _getChildView: function _getChildView(child) {
            var childView = this.childView;
            if (!childView) throw new MarionetteError({
                name: classErrorName$1,
                message: 'A "childView" must be specified',
                url: "marionette.collectionview.html#collectionviews-childview"
            });
            childView = this._getView(childView, child);
            if (!childView) throw new MarionetteError({
                name: classErrorName$1,
                message: '"childView" must be a view class or a function that returns a view class',
                url: "marionette.collectionview.html#collectionviews-childview"
            });
            return childView;
        },
        // First check if the `view` is a view class (the common case)
        // Then check if it's a function (which we assume that returns a view class)
        _getView: function _getView(view, child) {
            if (view.prototype instanceof Backbone.View || view === Backbone.View) return view;
            else if (_.isFunction(view)) return view.call(this, child);
        },
        _getChildViewOptions: function _getChildViewOptions(child) {
            if (_.isFunction(this.childViewOptions)) return this.childViewOptions(child);
            return this.childViewOptions;
        },
        // Build a `childView` for a model in the collection.
        // Override to customize the build
        buildChildView: function buildChildView(child, ChildViewClass, childViewOptions) {
            var options = _.extend({
                model: child
            }, childViewOptions);
            return new ChildViewClass(options);
        },
        _setupChildView: function _setupChildView(view) {
            monitorViewEvents(view); // We need to listen for if a view is destroyed in a way other
            // than through the CollectionView.
            // If this happens we need to remove the reference to the view
            // since once a view has been destroyed we can not reuse it.
            view.on("destroy", this.removeChildView, this); // set up the child view event forwarding
            this._proxyChildViewEvents(view);
        },
        // used by ViewMixin's `_childViewEventHandler`
        _getImmediateChildren: function _getImmediateChildren() {
            return this.children._views;
        },
        // Overriding Backbone.View's `setElement` to handle
        // if an el was previously defined. If so, the view might be
        // attached on setElement.
        setElement: function setElement() {
            Backbone.View.prototype.setElement.apply(this, arguments);
            this._isAttached = this._isElAttached();
            return this;
        },
        // Render children views.
        render: function render() {
            if (this._isDestroyed) return this;
            this.triggerMethod("before:render", this);
            this._destroyChildren();
            if (this.collection) {
                this._addChildModels(this.collection.models);
                this._initialEvents();
            }
            var template = this.getTemplate();
            if (template) {
                this._renderTemplate(template);
                this.bindUIElements();
            }
            this._getChildViewContainer();
            this.sort();
            this._isRendered = true;
            this.triggerMethod("render", this);
            return this;
        },
        // Get a container within the template to add the children within
        _getChildViewContainer: function _getChildViewContainer() {
            var childViewContainer = _.result(this, "childViewContainer");
            this.$container = childViewContainer ? this.$(childViewContainer) : this.$el;
            if (!this.$container.length) throw new MarionetteError({
                name: classErrorName$1,
                message: 'The specified "childViewContainer" was not found: '.concat(childViewContainer),
                url: "marionette.collectionview.html#defining-the-childviewcontainer"
            });
        },
        // Sorts the children then filters and renders the results.
        sort: function sort() {
            this._sortChildren();
            this.filter();
            return this;
        },
        // Sorts views by viewComparator and sets the children to the new order
        _sortChildren: function _sortChildren() {
            if (!this._children.length) return;
            var viewComparator = this.getComparator();
            if (!viewComparator) return;
             // If children are sorted prevent added to end perf
            delete this._addedViews;
            this.triggerMethod("before:sort", this);
            this._children._sort(viewComparator, this);
            this.triggerMethod("sort", this);
        },
        // Sets the view's `viewComparator` and applies the sort if the view is ready.
        // To prevent the render pass `{ preventRender: true }` as the 2nd argument.
        setComparator: function setComparator(comparator) {
            var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {}, preventRender = _ref2.preventRender;
            var comparatorChanged = this.viewComparator !== comparator;
            var shouldSort = comparatorChanged && !preventRender;
            this.viewComparator = comparator;
            if (shouldSort) this.sort();
            return this;
        },
        // Clears the `viewComparator` and follows the same rules for rendering as `setComparator`.
        removeComparator: function removeComparator(options) {
            return this.setComparator(null, options);
        },
        // If viewComparator is overridden it will be returned here.
        // Additionally override this function to provide custom
        // viewComparator logic
        getComparator: function getComparator() {
            if (this.viewComparator) return this.viewComparator;
            if (!this.sortWithCollection || this.viewComparator === false || !this.collection) return false;
            return this._viewComparator;
        },
        // Default internal view comparator that order the views by
        // the order of the collection
        _viewComparator: function _viewComparator(view) {
            return this.collection.indexOf(view.model);
        },
        // This method filters the children views and renders the results
        filter: function filter() {
            if (this._isDestroyed) return this;
            this._filterChildren();
            this._renderChildren();
            return this;
        },
        _filterChildren: function _filterChildren() {
            var _this2 = this;
            if (!this._children.length) return;
            var viewFilter = this._getFilter();
            if (!viewFilter) {
                var shouldReset = this.children.length !== this._children.length;
                this.children._set(this._children._views, shouldReset);
                return;
            } // If children are filtered prevent added to end perf
            delete this._addedViews;
            this.triggerMethod("before:filter", this);
            var attachViews = [];
            var detachViews = [];
            _.each(this._children._views, function(view, key, children) {
                (viewFilter.call(_this2, view, key, children) ? attachViews : detachViews).push(view);
            });
            this._detachChildren(detachViews); // reset children
            this.children._set(attachViews, true);
            this.triggerMethod("filter", this, attachViews, detachViews);
        },
        // This method returns a function for the viewFilter
        _getFilter: function _getFilter() {
            var viewFilter = this.getFilter();
            if (!viewFilter) return false;
            if (_.isFunction(viewFilter)) return viewFilter;
             // Support filter predicates `{ fooFlag: true }`
            if (_.isObject(viewFilter)) {
                var matcher = _.matches(viewFilter);
                return function(view) {
                    return matcher(view.model && view.model.attributes);
                };
            } // Filter by model attribute
            if (_.isString(viewFilter)) return function(view) {
                return view.model && view.model.get(viewFilter);
            };
            throw new MarionetteError({
                name: classErrorName$1,
                message: '"viewFilter" must be a function, predicate object literal, a string indicating a model attribute, or falsy',
                url: "marionette.collectionview.html#defining-the-viewfilter"
            });
        },
        // Override this function to provide custom
        // viewFilter logic
        getFilter: function getFilter() {
            return this.viewFilter;
        },
        // Sets the view's `viewFilter` and applies the filter if the view is ready.
        // To prevent the render pass `{ preventRender: true }` as the 2nd argument.
        setFilter: function setFilter(filter) {
            var _ref3 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {}, preventRender = _ref3.preventRender;
            var filterChanged = this.viewFilter !== filter;
            var shouldRender = filterChanged && !preventRender;
            this.viewFilter = filter;
            if (shouldRender) this.filter();
            return this;
        },
        // Clears the `viewFilter` and follows the same rules for rendering as `setFilter`.
        removeFilter: function removeFilter(options) {
            return this.setFilter(null, options);
        },
        _detachChildren: function _detachChildren(detachingViews) {
            _.each(detachingViews, this._detachChildView.bind(this));
        },
        _detachChildView: function _detachChildView(view) {
            var shouldTriggerDetach = view._isAttached && this.monitorViewEvents !== false;
            if (shouldTriggerDetach) view.triggerMethod("before:detach", view);
            this.detachHtml(view);
            if (shouldTriggerDetach) {
                view._isAttached = false;
                view.triggerMethod("detach", view);
            }
            view._isShown = false;
        },
        // Override this method to change how the collectionView detaches a child view
        detachHtml: function detachHtml(view) {
            this.Dom.detachEl(view.el, view.$el);
        },
        _renderChildren: function _renderChildren() {
            // If there are unrendered views prevent add to end perf
            if (this._hasUnrenderedViews) {
                delete this._addedViews;
                delete this._hasUnrenderedViews;
            }
            var views = this._addedViews || this.children._views;
            this.triggerMethod("before:render:children", this, views);
            if (this.isEmpty()) this._showEmptyView();
            else {
                this._destroyEmptyView();
                var els = this._getBuffer(views);
                this._attachChildren(els, views);
            }
            delete this._addedViews;
            this.triggerMethod("render:children", this, views);
        },
        // Renders each view and creates a fragment buffer from them
        _getBuffer: function _getBuffer(views) {
            var _this3 = this;
            var elBuffer = this.Dom.createBuffer();
            _.each(views, function(view) {
                renderView(view); // corresponds that view is shown in a Region or CollectionView
                view._isShown = true;
                _this3.Dom.appendContents(elBuffer, view.el, {
                    _$contents: view.$el
                });
            });
            return elBuffer;
        },
        _attachChildren: function _attachChildren(els, views) {
            var shouldTriggerAttach = this._isAttached && this.monitorViewEvents !== false;
            views = shouldTriggerAttach ? views : [];
            _.each(views, function(view) {
                if (view._isAttached) return;
                view.triggerMethod("before:attach", view);
            });
            this.attachHtml(els, this.$container);
            _.each(views, function(view) {
                if (view._isAttached) return;
                view._isAttached = true;
                view.triggerMethod("attach", view);
            });
        },
        // Override this method to do something other than `.append`.
        // You can attach any HTML at this point including the els.
        attachHtml: function attachHtml(els, $container) {
            this.Dom.appendContents($container[0], els, {
                _$el: $container
            });
        },
        isEmpty: function isEmpty() {
            return !this.children.length;
        },
        _showEmptyView: function _showEmptyView() {
            var EmptyView = this._getEmptyView();
            if (!EmptyView) return;
            var options = this._getEmptyViewOptions();
            var emptyRegion = this.getEmptyRegion();
            emptyRegion.show(new EmptyView(options));
        },
        // Retrieve the empty view class
        _getEmptyView: function _getEmptyView() {
            var emptyView = this.emptyView;
            if (!emptyView) return;
            return this._getView(emptyView);
        },
        // Remove the emptyView
        _destroyEmptyView: function _destroyEmptyView() {
            var emptyRegion = this.getEmptyRegion(); // Only empty if a view is show so the region
            // doesn't detach any other unrelated HTML
            if (emptyRegion.hasView()) emptyRegion.empty();
        },
        //
        _getEmptyViewOptions: function _getEmptyViewOptions() {
            var emptyViewOptions = this.emptyViewOptions || this.childViewOptions;
            if (_.isFunction(emptyViewOptions)) return emptyViewOptions.call(this);
            return emptyViewOptions;
        },
        swapChildViews: function swapChildViews(view1, view2) {
            if (!this._children.hasView(view1) || !this._children.hasView(view2)) throw new MarionetteError({
                name: classErrorName$1,
                message: "Both views must be children of the collection view to swap.",
                url: "marionette.collectionview.html#swapping-child-views"
            });
            this._children._swap(view1, view2);
            this.Dom.swapEl(view1.el, view2.el); // If the views are not filtered the same, refilter
            if (this.children.hasView(view1) !== this.children.hasView(view2)) this.filter();
            else this.children._swap(view1, view2);
            return this;
        },
        // Render the child's view and add it to the HTML for the collection view at a given index, based on the current sort
        addChildView: function addChildView(view, index) {
            var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
            if (!view || view._isDestroyed) return view;
            if (view._isShown) throw new MarionetteError({
                name: classErrorName$1,
                message: "View is already shown in a Region or CollectionView",
                url: "marionette.region.html#showing-a-view"
            });
            if (_.isObject(index)) options = index;
             // If options has defined index we should use it
            if (options.index != null) index = options.index;
            if (!this._isRendered) this.render();
            this._addChild(view, index);
            if (options.preventRender) {
                this._hasUnrenderedViews = true;
                return view;
            }
            var hasIndex = typeof index !== "undefined";
            var isAddedToEnd = !hasIndex || index >= this._children.length; // Only cache views if added to the end and there is no unrendered views
            if (isAddedToEnd && !this._hasUnrenderedViews) this._addedViews = [
                view
            ];
            if (hasIndex) this._renderChildren();
            else this.sort();
            return view;
        },
        // Detach a view from the children.  Best used when adding a
        // childView from `addChildView`
        detachChildView: function detachChildView(view) {
            this.removeChildView(view, {
                shouldDetach: true
            });
            return view;
        },
        // Remove the child view and destroy it.  Best used when adding a
        // childView from `addChildView`
        // The options argument is for internal use only
        removeChildView: function removeChildView(view, options) {
            if (!view) return view;
            this._removeChildView(view, options);
            this._removeChild(view);
            if (this.isEmpty()) this._showEmptyView();
            return view;
        },
        _removeChildViews: function _removeChildViews(views) {
            _.each(views, this._removeChildView.bind(this));
        },
        _removeChildView: function _removeChildView(view) {
            var _ref4 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {}, shouldDetach = _ref4.shouldDetach;
            view.off("destroy", this.removeChildView, this);
            if (shouldDetach) this._detachChildView(view);
            else this._destroyChildView(view);
            this.stopListening(view);
        },
        _destroyChildView: function _destroyChildView(view) {
            if (view._isDestroyed) return;
            var shouldDisableEvents = this.monitorViewEvents === false;
            destroyView(view, shouldDisableEvents);
        },
        // called by ViewMixin destroy
        _removeChildren: function _removeChildren() {
            this._destroyChildren();
            var emptyRegion = this.getEmptyRegion();
            emptyRegion.destroy();
            delete this._addedViews;
        },
        // Destroy the child views that this collection view is holding on to, if any
        _destroyChildren: function _destroyChildren() {
            if (!this._children.length) return;
            this.triggerMethod("before:destroy:children", this);
            if (this.monitorViewEvents === false) this.Dom.detachContents(this.el, this.$el);
            this._removeChildViews(this._children._views); // After all children have been destroyed re-init the container
            this._children._init();
            this.children._init();
            this.triggerMethod("destroy:children", this);
        }
    }, {
        setDomApi: setDomApi,
        setRenderer: setRenderer
    });
    _.extend(CollectionView.prototype, ViewMixin);
    // Behavior
    var ClassOptions$4 = [
        "collectionEvents",
        "events",
        "modelEvents",
        "triggers",
        "ui"
    ];
    var Behavior = function Behavior(options, view) {
        // Setup reference to the view.
        // this comes in handle when a behavior
        // wants to directly talk up the chain
        // to the view.
        this.view = view;
        this._setOptions(options, ClassOptions$4);
        this.cid = _.uniqueId(this.cidPrefix); // Construct an internal UI hash using the behaviors UI
        // hash combined and overridden by the view UI hash.
        // This allows the user to use UI hash elements defined
        // in the parent view as well as those defined in the behavior.
        // This order will help the reuse and share of a behavior
        // between multiple views, while letting a view override
        // a selector under an UI key.
        this.ui = _.extend({}, _.result(this, "ui"), _.result(view, "ui")); // Proxy view triggers
        this.listenTo(view, "all", this.triggerMethod);
        this.initialize.apply(this, arguments);
    };
    Behavior.extend = extend; // Behavior Methods
    // --------------
    _.extend(Behavior.prototype, CommonMixin, DelegateEntityEventsMixin, TriggersMixin, UIMixin, {
        cidPrefix: "mnb",
        // This is a noop method intended to be overridden
        initialize: function initialize() {},
        // proxy behavior $ method to the view
        // this is useful for doing jquery DOM lookups
        // scoped to behaviors view.
        $: function $() {
            return this.view.$.apply(this.view, arguments);
        },
        // Stops the behavior from listening to events.
        destroy: function destroy() {
            this.stopListening();
            this.view._removeBehavior(this);
            this._deleteEntityEventHandlers();
            return this;
        },
        proxyViewProperties: function proxyViewProperties() {
            this.$el = this.view.$el;
            this.el = this.view.el;
            return this;
        },
        bindUIElements: function bindUIElements() {
            this._bindUIElements();
            return this;
        },
        unbindUIElements: function unbindUIElements() {
            this._unbindUIElements();
            return this;
        },
        getUI: function getUI(name) {
            return this._getUI(name);
        },
        // Handle `modelEvents`, and `collectionEvents` configuration
        delegateEntityEvents: function delegateEntityEvents() {
            this._delegateEntityEvents(this.view.model, this.view.collection);
            return this;
        },
        undelegateEntityEvents: function undelegateEntityEvents() {
            this._undelegateEntityEvents(this.view.model, this.view.collection);
            return this;
        },
        _getEvents: function _getEvents() {
            var _this = this;
            if (!this.events) return;
             // Normalize behavior events hash to allow
            // a user to use the @ui. syntax.
            var behaviorEvents = this.normalizeUIKeys(_.result(this, "events")); // binds the handler to the behavior and builds a unique eventName
            return _.reduce(behaviorEvents, function(events, behaviorHandler, key) {
                if (!_.isFunction(behaviorHandler)) behaviorHandler = _this[behaviorHandler];
                if (!behaviorHandler) return events;
                key = getNamespacedEventName(key, _this.cid);
                events[key] = behaviorHandler.bind(_this);
                return events;
            }, {});
        },
        // Internal method to build all trigger handlers for a given behavior
        _getTriggers: function _getTriggers() {
            if (!this.triggers) return;
             // Normalize behavior triggers hash to allow
            // a user to use the @ui. syntax.
            var behaviorTriggers = this.normalizeUIKeys(_.result(this, "triggers"));
            return this._getViewTriggers(this.view, behaviorTriggers);
        }
    });
    // Application
    var ClassOptions$5 = [
        "channelName",
        "radioEvents",
        "radioRequests",
        "region",
        "regionClass"
    ];
    var Application = function Application(options) {
        this._setOptions(options, ClassOptions$5);
        this.cid = _.uniqueId(this.cidPrefix);
        this._initRegion();
        this._initRadio();
        this.initialize.apply(this, arguments);
    };
    Application.extend = extend; // Application Methods
    // --------------
    _.extend(Application.prototype, CommonMixin, DestroyMixin, RadioMixin, {
        cidPrefix: "mna",
        // This is a noop method intended to be overridden
        initialize: function initialize() {},
        // Kick off all of the application's processes.
        start: function start(options) {
            this.triggerMethod("before:start", this, options);
            this.triggerMethod("start", this, options);
            return this;
        },
        regionClass: Region,
        _initRegion: function _initRegion() {
            var region = this.region;
            if (!region) return;
            var defaults = {
                regionClass: this.regionClass
            };
            this._region = buildRegion(region, defaults);
        },
        getRegion: function getRegion() {
            return this._region;
        },
        showView: function showView(view) {
            var region = this.getRegion();
            for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
            region.show.apply(region, [
                view
            ].concat(args));
            return view;
        },
        getView: function getView() {
            return this.getRegion().currentView;
        }
    });
    var bindEvents$1 = proxy(bindEvents);
    var unbindEvents$1 = proxy(unbindEvents);
    var bindRequests$1 = proxy(bindRequests);
    var unbindRequests$1 = proxy(unbindRequests);
    var mergeOptions$1 = proxy(mergeOptions);
    var getOption$1 = proxy(getOption);
    var normalizeMethods$1 = proxy(normalizeMethods);
    var triggerMethod$1 = proxy(triggerMethod); // Configuration
    var setDomApi$1 = function setDomApi(mixin) {
        CollectionView.setDomApi(mixin);
        Region.setDomApi(mixin);
        View.setDomApi(mixin);
    };
    var setRenderer$1 = function setRenderer(renderer) {
        CollectionView.setRenderer(renderer);
        View.setRenderer(renderer);
    };
    var backbone_marionette = {
        View: View,
        CollectionView: CollectionView,
        MnObject: MarionetteObject,
        Object: MarionetteObject,
        Region: Region,
        Behavior: Behavior,
        Application: Application,
        isEnabled: isEnabled,
        setEnabled: setEnabled,
        monitorViewEvents: monitorViewEvents,
        Events: Events,
        extend: extend,
        DomApi: DomApi,
        VERSION: version
    };
    exports1.Application = Application;
    exports1.Behavior = Behavior;
    exports1.CollectionView = CollectionView;
    exports1.DomApi = DomApi;
    exports1.Events = Events;
    exports1.MnObject = MarionetteObject;
    exports1.Region = Region;
    exports1.VERSION = version;
    exports1.View = View;
    exports1.bindEvents = bindEvents$1;
    exports1.bindRequests = bindRequests$1;
    exports1.default = backbone_marionette;
    exports1.extend = extend;
    exports1.getOption = getOption$1;
    exports1.isEnabled = isEnabled;
    exports1.mergeOptions = mergeOptions$1;
    exports1.monitorViewEvents = monitorViewEvents;
    exports1.normalizeMethods = normalizeMethods$1;
    exports1.setDomApi = setDomApi$1;
    exports1.setEnabled = setEnabled;
    exports1.setRenderer = setRenderer$1;
    exports1.triggerMethod = triggerMethod$1;
    exports1.unbindEvents = unbindEvents$1;
    exports1.unbindRequests = unbindRequests$1;
    Object.defineProperty(exports1, "__esModule", {
        value: true
    });
});
module.exports && module.exports.Marionette && (module.exports.Mn = module.exports.Marionette);

});

parcelRegister("7U7mg", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");


module.exports = Promise.all([
    (parcelRequire("fFMZG"))((parcelRequire("27Lyk")).resolve("ds918")),
    $Gr8vk("8hbxc")
]).then(()=>parcelRequire("6P28v"));

});
parcelRegister("Gr8vk", function(module, exports) {
"use strict";

function $07f8f9093a769793$var$load(id) {
    // eslint-disable-next-line no-undef
    return import((parcelRequire("27Lyk")).resolve(id));
}
module.exports = $07f8f9093a769793$var$load;

});

parcelRegister("fFMZG", function(module, exports) {
"use strict";

var $lovBw = parcelRequire("lovBw");
module.exports = $lovBw(function(bundle) {
    return new Promise(function(resolve, reject) {
        // Don't insert the same link element twice (e.g. if it was already in the HTML)
        var existingLinks = document.getElementsByTagName("link");
        if ([].concat(existingLinks).some(function isCurrentBundle(link) {
            return link.href === bundle && link.rel.indexOf("stylesheet") > -1;
        })) {
            resolve();
            return;
        }
        var link = document.createElement("link");
        link.rel = "stylesheet";
        link.href = bundle;
        link.onerror = function(e) {
            link.onerror = link.onload = null;
            link.remove();
            reject(e);
        };
        link.onload = function() {
            link.onerror = link.onload = null;
            resolve();
        };
        document.getElementsByTagName("head")[0].appendChild(link);
    });
});

});
parcelRegister("lovBw", function(module, exports) {
"use strict";
var $f9345ad2c034f768$var$cachedBundles = {};
var $f9345ad2c034f768$var$cachedPreloads = {};
var $f9345ad2c034f768$var$cachedPrefetches = {};
function $f9345ad2c034f768$var$getCache(type) {
    switch(type){
        case "preload":
            return $f9345ad2c034f768$var$cachedPreloads;
        case "prefetch":
            return $f9345ad2c034f768$var$cachedPrefetches;
        default:
            return $f9345ad2c034f768$var$cachedBundles;
    }
}
module.exports = function(loader, type) {
    return function(bundle) {
        var cache = $f9345ad2c034f768$var$getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments).catch(function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

});



var $32d47542368019fc$exports = {};

(parcelRequire("27Lyk")).register(new URL("", import.meta.url).toString(), JSON.parse('["4lOKS","loader.js","8hbxc","EgretClient.21562fc3.js","lulKe","Index.760a85f9.js","hzdx0","Index.fff91726.js","hL1iR","Index.8980c337.js","2qmOj","View.89d0bfab.js","fo77D","standalone.64084b31.js","ejOhG","GOTransitRoute.ee7994e8.js","fDRMO","QueryRoute.a0cef2ab.js","jclcz","TerminalDatesRoute.17729031.js","lAWnt","RecentlyUpdatedRoute.cec2ec76.js","ds918","EgretClient.eabecfe8.css"]'));

/* global loadConfigData,loadFeatureFlags,require */ // ARH 2020-06: This file initializes the load process by setting up all
// the config listeners, loading data that index.xqy preloaded into a
// JavaScript element, and triggering the actual load of the base site code.

var $kL2Ep = parcelRequire("kL2Ep");

var $jtLqq = parcelRequire("jtLqq");
/**
 * Manages server configuration properties.

    ServerConfigManager tracks loadConfigData/loadUserData properties. The latter can change on each
    call to /db/postlogin; the former should not change.

    FeatureFlagManager tracks loadFeatureFlag properties. These should not change, and thus no
    `:register` event is available.
 */ 
var $kL2Ep = parcelRequire("kL2Ep");

var $jtLqq = parcelRequire("jtLqq");
const $bcee8aa069008bec$var$configChannel = (0, (/*@__PURE__*/$parcel$interopDefault($jtLqq))).channel("config");
/**
 * This came about as part of #2136, where we needed to ensure that specific strings were formatted
    in a specific way, depending on language. Right now, the only property used in this config object
    is `withClass`; if this is set to true and the third param to `configChannel.request('property')`
    is set to true, an HTML element will wrap around the value to ensure correct display.
 */ const $bcee8aa069008bec$var$configConfig = Object.freeze({
    fullTitle: {
        withClass: true
    },
    site: {
        withClass: true
    },
    siteTitle: {
        withClass: true
    }
});
class $bcee8aa069008bec$export$bac638ac9cd035e2 extends (0, (/*@__PURE__*/$parcel$interopDefault($kL2Ep))).Model {
    constructor(data, options){
        super(data, options);
        // Proxy to `set`
        $bcee8aa069008bec$var$configChannel.on("property:register", this.registerProperty, this);
        // Proxy to `get`
        $bcee8aa069008bec$var$configChannel.reply("property", this.getProperty, this);
        // Track initial load time; used to pass data back and forth between the server
        this.set("initLoad", new Date().getTime().toString());
        const ogDesc = document.querySelector('meta[property="og:description"]');
        if (ogDesc) this.set("ogDescription", ogDesc.getAttribute("content"));
    }
    registerProperty(name, value) {
        return this.set(name, value);
    }
    getProperty(name, asHTML) {
        let value = this.get(name);
        if (asHTML !== true) return value;
        // if there's no config object to return, there's no formatting to add
        const configObject = $bcee8aa069008bec$var$configConfig[name];
        if (!configObject) return value;
        // Get all the classes we should tack on to the wrapping element
        let parentElClasses = [];
        if (configObject.withClass) parentElClasses.push("config-" + name);
        // Always tack on a `notranslate`, because we want the literal value here, no matter what
        return `<span class="notranslate ${parentElClasses.join(" ")}">${value}</span>`;
    }
}
class $bcee8aa069008bec$export$1e4f29b39fbf1131 extends (0, (/*@__PURE__*/$parcel$interopDefault($kL2Ep))).Model {
    constructor(data, options){
        super(data, options);
        // Proxy to `get`
        $bcee8aa069008bec$var$configChannel.reply("flag", this.get, this);
    }
}



var $htgj6 = parcelRequire("htgj6");
window.Backbone = (0, (/*@__PURE__*/$parcel$interopDefault($kL2Ep)));
window.Backbone.Radio = (0, (/*@__PURE__*/$parcel$interopDefault($jtLqq)));
// Ensure the function defined in `/sjs_server/index.xqy` is present here
if (typeof window.loadConfigData !== "function") throw new Error("loader.js: loadConfigData function not available!");
// Grab references to what we'll need later
const $c3f61a2bbe936ffc$var$configChannel = (0, (/*@__PURE__*/$parcel$interopDefault($jtLqq))).channel("config");
// If we're running tests, there'll be a variable imported from /test/config/test-config to tell us
// where to actually load things from.
window.root = window.testRoot || window.location.origin;
// Unpack the server config data and delete the element it was stored in (for cleanliness)
const $c3f61a2bbe936ffc$var$configData = loadConfigData();
const $c3f61a2bbe936ffc$var$sm = new (0, $bcee8aa069008bec$export$bac638ac9cd035e2)($c3f61a2bbe936ffc$var$configData);
const $c3f61a2bbe936ffc$var$featureFlags = loadFeatureFlags();
const $c3f61a2bbe936ffc$var$fm = new (0, $bcee8aa069008bec$export$1e4f29b39fbf1131)($c3f61a2bbe936ffc$var$featureFlags);
// Make sure the primary fonts are loading. Hopefully this will have started
// already with "preload." Use "void" because we really don't need the
// Promise returned here.
(0, $htgj6.loadPrimaryFonts)();
/**
 * Marionette template loading polyfill.
 *
 * Because the Marionette version 3-to-4 upgrade broke the way we were
 * loading templates, this module basically allows us to keep using
 * the old way. And it's a little faster.
 *
 * Requires `window.Backbone` to be available.
 */ 
var $1eLr4 = parcelRequire("1eLr4");

var $jtLqq = parcelRequire("jtLqq");
parcelRequire("2q7Wm");
var $g1NQe = parcelRequire("g1NQe");
const $03c17c155ec86bf8$var$viewChannel = (0, (/*@__PURE__*/$parcel$interopDefault($jtLqq))).channel("view");
// Cache of all templates the client knows about.
// - Initial values are strings as imported from the "template.json" files.
// - Once accessed for the first time, values are saved as `_.template()` functions.
// - This is seeded with an "empty" template that returns an empty string to allow both
//     Marionette.View and CollectionView to be overridden.
const $03c17c155ec86bf8$var$templateCache = {
    null: ()=>""
};
$03c17c155ec86bf8$var$viewChannel.reply("templateCache", ()=>$03c17c155ec86bf8$var$templateCache);
// Returns the requested template, and converts from string to Underscore if that has not yet been done
$03c17c155ec86bf8$var$viewChannel.reply("template", (selector)=>{
    // There are legitimate cases where the template would not exist; return null in those cases
    if (!(selector in $03c17c155ec86bf8$var$templateCache)) return null;
    // If it's still a string, convert it to an underscore template
    if (typeof $03c17c155ec86bf8$var$templateCache[selector] === "string") $03c17c155ec86bf8$var$templateCache[selector] = (0, $g1NQe.default).template($03c17c155ec86bf8$var$templateCache[selector]);
    // Otherwise, it's already cached as Underscore, return that
    return $03c17c155ec86bf8$var$templateCache[selector];
});
// Registers a series of templates in the cache; keys are IDs passed into `request.template`
$03c17c155ec86bf8$var$viewChannel.on("templates:register", (templates)=>{
    Object.assign($03c17c155ec86bf8$var$templateCache, templates);
    $03c17c155ec86bf8$var$viewChannel.trigger("templates:changed");
});
// Unregisters a series of templates; ids is a single template ID or an array of them
$03c17c155ec86bf8$var$viewChannel.on("templates:unregister", (ids)=>{
    if (!Array.isArray(ids)) ids = [
        ids
    ];
    for (const id of ids)delete $03c17c155ec86bf8$var$templateCache[id];
    $03c17c155ec86bf8$var$viewChannel.trigger("templates:changed");
});
// Patch for Marionette 3-to-4 upgrade removing `templateCache`
function $03c17c155ec86bf8$var$newGetTemplate() {
    if (typeof this.template === "function") // A template is simply a function, so if we already have a
    // function then we can return it right away.
    return this.template;
    else // Otherwise request the template from the view channel.
    return $03c17c155ec86bf8$var$viewChannel.request("template", this.template);
}
(0, (/*@__PURE__*/$parcel$interopDefault($1eLr4))).View.prototype.getTemplate = $03c17c155ec86bf8$var$newGetTemplate;
(0, (/*@__PURE__*/$parcel$interopDefault($1eLr4))).CollectionView.prototype.getTemplate = $03c17c155ec86bf8$var$newGetTemplate;


// Unpack the API address now that it's set
window.api_address = `${window.root}/${$c3f61a2bbe936ffc$var$configChannel.request("property", "siteIDPrefix")}`; // eslint-disable-line camelcase
// Start the dots blinking
const $c3f61a2bbe936ffc$var$ellipsisInterval = window.setInterval(function() {
    const dots = document.querySelectorAll(".loading-dot");
    const inactiveLength = document.querySelectorAll(".loading-dot.inactive").length;
    if (inactiveLength === 0) for(let dIdx = 1; dIdx < dots.length; dIdx++)dots[dIdx].className = "loading-dot inactive";
    else dots[dots.length - inactiveLength].className = "loading-dot";
}, 500);
const $c3f61a2bbe936ffc$var$preloadTimeout = window.setTimeout(function() {
    const preloadTextElem = document.getElementById("preload-text");
    if (preloadTextElem) preloadTextElem.textContent = "The site is taking a while to load. You may want to try reloading the page, or you can keep waiting";
}, 20000);

// Trigger the primary load and clear intervals when we're done
window.loadComplete = (async function() {
    // First load the TEI base CSS. This must happen before any other CSS
    // is loaded because of legacy reasons.
    await (0, $htgj6.loadCSS)("/css/tei/tei_html.css");
    // Load the Egret base app.
    const stylesAndTemplates = Promise.all([
        (0, $htgj6.loadCSS)(`/css/sites/${$c3f61a2bbe936ffc$var$configChannel.request("property", "siteIDPrefix").toUpperCase()}/main.css`),
        (0, $htgj6.loadTemplates)(`/templates/main-${$c3f61a2bbe936ffc$var$configChannel.request("property", "siteIDPrefix")}.json`)
    ]);
    const clientModule = await (parcelRequire("7U7mg"));
    await stylesAndTemplates;
    await clientModule.init();
    window.clearInterval($c3f61a2bbe936ffc$var$ellipsisInterval);
    window.clearTimeout($c3f61a2bbe936ffc$var$preloadTimeout);
    // Load less important fonts.
    await (0, $htgj6.loadSupplementalFonts)();
})().catch((err)=>{
    window.clearInterval($c3f61a2bbe936ffc$var$ellipsisInterval);
    console.error(err); // eslint-disable-line no-console
    // Show a default error to the user
    const statusEl = document.querySelector(".preload-status");
    if (statusEl) statusEl.innerHTML = "The site is currently unavailable due to scheduled downtime or upgrades; please check back in five minutes.";
});
// Add a few browser recognition classes - https://stackoverflow.com/questions/9847580
const $c3f61a2bbe936ffc$var$appEl = document.getElementById("app");
// Internet Explorer 6-11
if (!!document.documentMode) $c3f61a2bbe936ffc$var$appEl.classList.add("is-IE");
// Safari 3.0+ "[object HTMLElementConstructor]"
if (/constructor/i.test(window.HTMLElement) || function(p) {
    return p.toString() === "[object SafariRemoteNotification]";
}(!window["safari"] || typeof safari !== "undefined" && safari.pushNotification)) $c3f61a2bbe936ffc$var$appEl.classList.add("is-Safari");
// any iPhone or iPod Touch browser
if (/(iPhone)/.test(navigator && navigator.userAgent || "")) $c3f61a2bbe936ffc$var$appEl.classList.add("is-iOS");


//# sourceMappingURL=loader.js.map
